var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __multiDecorate = (this && this.__multiDecorate) || function(map) {
    var keys = Object.keys(map);
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var obj = map[key];
        __decorate(obj.decorators, obj.target, key, obj.desc);
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
/*!
 * Platform.js
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */
;(function() {
  'use strict';

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used as a reference to the global object. */
  var root = (objectTypes[typeof window] && window) || this;

  /** Backup possible global object. */
  var oldRoot = root;

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
    root = freeGlobal;
  }

  /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */
  var maxSafeInteger = Math.pow(2, 53) - 1;

  /** Regular expression to detect Opera. */
  var reOpera = /\bOpera/;

  /** Possible global object. */
  var thisBinding = this;

  /** Used for native method references. */
  var objectProto = Object.prototype;

  /** Used to check for own properties of an object. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to resolve the internal `[[Class]]` of values. */
  var toString = objectProto.toString;

  /*--------------------------------------------------------------------------*/

  /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */
  function capitalize(string) {
    string = String(string);
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */
  function cleanupOS(os, pattern, label) {
    // Platform tokens are defined at:
    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    var data = {
      '10.0': '10',
      '6.4':  '10 Technical Preview',
      '6.3':  '8.1',
      '6.2':  '8',
      '6.1':  'Server 2008 R2 / 7',
      '6.0':  'Server 2008 / Vista',
      '5.2':  'Server 2003 / XP 64-bit',
      '5.1':  'XP',
      '5.01': '2000 SP1',
      '5.0':  '2000',
      '4.0':  'NT',
      '4.90': 'ME'
    };
    // Detect Windows version from platform tokens.
    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) &&
        (data = data[/[\d.]+$/.exec(os)])) {
      os = 'Windows ' + data;
    }
    // Correct character case and cleanup string.
    os = String(os);

    if (pattern && label) {
      os = os.replace(RegExp(pattern, 'i'), label);
    }

    os = format(
      os.replace(/ ce$/i, ' CE')
        .replace(/\bhpw/i, 'web')
        .replace(/\bMacintosh\b/, 'Mac OS')
        .replace(/_PowerPC\b/i, ' OS')
        .replace(/\b(OS X) [^ \d]+/i, '$1')
        .replace(/\bMac (OS X)\b/, '$1')
        .replace(/\/(\d)/, ' $1')
        .replace(/_/g, '.')
        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
        .replace(/\bx86\.64\b/gi, 'x86_64')
        .replace(/\b(Windows Phone) OS\b/, '$1')
        .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
        .split(' on ')[0]
    );

    return os;
  }

  /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */
  function each(object, callback) {
    var index = -1,
        length = object ? object.length : 0;

    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
      while (++index < length) {
        callback(object[index], index, object);
      }
    } else {
      forOwn(object, callback);
    }
  }

  /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */
  function format(string) {
    string = trim(string);
    return /^(?:webOS|i(?:OS|P))/.test(string)
      ? string
      : capitalize(string);
  }

  /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */
  function forOwn(object, callback) {
    for (var key in object) {
      if (hasOwnProperty.call(object, key)) {
        callback(object[key], key, object);
      }
    }
  }

  /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */
  function getClassOf(value) {
    return value == null
      ? capitalize(value)
      : toString.call(value).slice(8, -1);
  }

  /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */
  function isHostType(object, property) {
    var type = object != null ? typeof object[property] : 'number';
    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
      (type == 'object' ? !!object[property] : true);
  }

  /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */
  function qualify(string) {
    return String(string).replace(/([ -])(?!$)/g, '$1?');
  }

  /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */
  function reduce(array, callback) {
    var accumulator = null;
    each(array, function(value, index) {
      accumulator = callback(accumulator, value, index, array);
    });
    return accumulator;
  }

  /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */
  function trim(string) {
    return String(string).replace(/^ +| +$/g, '');
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */
  function parse(ua) {

    /** The environment context object. */
    var context = root;

    /** Used to flag when a custom context is provided. */
    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';

    // Juggle arguments.
    if (isCustomContext) {
      context = ua;
      ua = null;
    }

    /** Browser navigator object. */
    var nav = context.navigator || {};

    /** Browser user agent string. */
    var userAgent = nav.userAgent || '';

    ua || (ua = userAgent);

    /** Used to flag when `thisBinding` is the [ModuleScope]. */
    var isModuleScope = isCustomContext || thisBinding == oldRoot;

    /** Used to detect if browser is like Chrome. */
    var likeChrome = isCustomContext
      ? !!nav.likeChrome
      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());

    /** Internal `[[Class]]` value shortcuts. */
    var objectClass = 'Object',
        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
        enviroClass = isCustomContext ? objectClass : 'Environment',
        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';

    /** Detect Java environments. */
    var java = /\bJava/.test(javaClass) && context.java;

    /** Detect Rhino. */
    var rhino = java && getClassOf(context.environment) == enviroClass;

    /** A character to represent alpha. */
    var alpha = java ? 'a' : '\u03b1';

    /** A character to represent beta. */
    var beta = java ? 'b' : '\u03b2';

    /** Browser document object. */
    var doc = context.document || {};

    /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */
    var opera = context.operamini || context.opera;

    /** Opera `[[Class]]`. */
    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
      ? operaClass
      : (opera = null);

    /*------------------------------------------------------------------------*/

    /** Temporary variable used over the script's lifetime. */
    var data;

    /** The CPU architecture. */
    var arch = ua;

    /** Platform description array. */
    var description = [];

    /** Platform alpha/beta indicator. */
    var prerelease = null;

    /** A flag to indicate that environment features should be used to resolve the platform. */
    var useFeatures = ua == userAgent;

    /** The browser/environment version. */
    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();

    /** A flag to indicate if the OS ends with "/ Version" */
    var isSpecialCasedOS;

    /* Detectable layout engines (order is important). */
    var layout = getLayout([
      { 'label': 'EdgeHTML', 'pattern': 'Edge' },
      'Trident',
      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
      'iCab',
      'Presto',
      'NetFront',
      'Tasman',
      'KHTML',
      'Gecko'
    ]);

    /* Detectable browser names (order is important). */
    var name = getName([
      'Adobe AIR',
      'Arora',
      'Avant Browser',
      'Breach',
      'Camino',
      'Electron',
      'Epiphany',
      'Fennec',
      'Flock',
      'Galeon',
      'GreenBrowser',
      'iCab',
      'Iceweasel',
      'K-Meleon',
      'Konqueror',
      'Lunascape',
      'Maxthon',
      { 'label': 'Microsoft Edge', 'pattern': '(?:Edge|Edg|EdgA|EdgiOS)' },
      'Midori',
      'Nook Browser',
      'PaleMoon',
      'PhantomJS',
      'Raven',
      'Rekonq',
      'RockMelt',
      { 'label': 'Samsung Internet', 'pattern': 'SamsungBrowser' },
      'SeaMonkey',
      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Sleipnir',
      'SlimBrowser',
      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
      'Sunrise',
      'Swiftfox',
      'Vivaldi',
      'Waterfox',
      'WebPositive',
      { 'label': 'Yandex Browser', 'pattern': 'YaBrowser' },
      { 'label': 'UC Browser', 'pattern': 'UCBrowser' },
      'Opera Mini',
      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
      'Opera',
      { 'label': 'Opera', 'pattern': 'OPR' },
      'Chromium',
      'Chrome',
      { 'label': 'Chrome', 'pattern': '(?:HeadlessChrome)' },
      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
      { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' },
      { 'label': 'IE', 'pattern': 'IEMobile' },
      { 'label': 'IE', 'pattern': 'MSIE' },
      'Safari'
    ]);

    /* Detectable products (order is important). */
    var product = getProduct([
      { 'label': 'BlackBerry', 'pattern': 'BB10' },
      'BlackBerry',
      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
      { 'label': 'Galaxy S5', 'pattern': 'SM-G900' },
      { 'label': 'Galaxy S6', 'pattern': 'SM-G920' },
      { 'label': 'Galaxy S6 Edge', 'pattern': 'SM-G925' },
      { 'label': 'Galaxy S7', 'pattern': 'SM-G930' },
      { 'label': 'Galaxy S7 Edge', 'pattern': 'SM-G935' },
      'Google TV',
      'Lumia',
      'iPad',
      'iPod',
      'iPhone',
      'Kindle',
      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Nexus',
      'Nook',
      'PlayBook',
      'PlayStation Vita',
      'PlayStation',
      'TouchPad',
      'Transformer',
      { 'label': 'Wii U', 'pattern': 'WiiU' },
      'Wii',
      'Xbox One',
      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
      'Xoom'
    ]);

    /* Detectable manufacturers. */
    var manufacturer = getManufacturer({
      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
      'Alcatel': {},
      'Archos': {},
      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
      'Asus': { 'Transformer': 1 },
      'Barnes & Noble': { 'Nook': 1 },
      'BlackBerry': { 'PlayBook': 1 },
      'Google': { 'Google TV': 1, 'Nexus': 1 },
      'HP': { 'TouchPad': 1 },
      'HTC': {},
      'Huawei': {},
      'Lenovo': {},
      'LG': {},
      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
      'Motorola': { 'Xoom': 1 },
      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
      'Nokia': { 'Lumia': 1 },
      'Oppo': {},
      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
      'Sony': { 'PlayStation': 1, 'PlayStation Vita': 1 },
      'Xiaomi': { 'Mi': 1, 'Redmi': 1 }
    });

    /* Detectable operating systems (order is important). */
    var os = getOS([
      'Windows Phone',
      'KaiOS',
      'Android',
      'CentOS',
      { 'label': 'Chrome OS', 'pattern': 'CrOS' },
      'Debian',
      { 'label': 'DragonFly BSD', 'pattern': 'DragonFly' },
      'Fedora',
      'FreeBSD',
      'Gentoo',
      'Haiku',
      'Kubuntu',
      'Linux Mint',
      'OpenBSD',
      'Red Hat',
      'SuSE',
      'Ubuntu',
      'Xubuntu',
      'Cygwin',
      'Symbian OS',
      'hpwOS',
      'webOS ',
      'webOS',
      'Tablet OS',
      'Tizen',
      'Linux',
      'Mac OS X',
      'Macintosh',
      'Mac',
      'Windows 98;',
      'Windows '
    ]);

    /*------------------------------------------------------------------------*/

    /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */
    function getLayout(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */
    function getManufacturer(guesses) {
      return reduce(guesses, function(result, value, key) {
        // Lookup the manufacturer by product or scan the UA for the manufacturer.
        return result || (
          value[product] ||
          value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
        ) && key;
      });
    }

    /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */
    function getName(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */
    function getOS(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
            )) {
          result = cleanupOS(result, pattern, guess.label || guess);
        }
        return result;
      });
    }

    /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */
    function getProduct(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
              RegExp('\\b' + pattern + ' *\\w+-[\\w]*', 'i').exec(ua) ||
              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
            )) {
          // Split by forward slash and append product version if needed.
          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
            result[0] += ' ' + result[1];
          }
          // Correct character case and cleanup string.
          guess = guess.label || guess;
          result = format(result[0]
            .replace(RegExp(pattern, 'i'), guess)
            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
        }
        return result;
      });
    }

    /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */
    function getVersion(patterns) {
      return reduce(patterns, function(result, pattern) {
        return result || (RegExp(pattern +
          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
      });
    }

    /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */
    function toStringPlatform() {
      return this.description || '';
    }

    /*------------------------------------------------------------------------*/

    // Convert layout to an array so we can add extra details.
    layout && (layout = [layout]);

    // Detect Android products.
    // Browsers on Android devices typically provide their product IDS after "Android;"
    // up to "Build" or ") AppleWebKit".
    // Example:
    // "Mozilla/5.0 (Linux; Android 8.1.0; Moto G (5) Plus) AppleWebKit/537.36
    // (KHTML, like Gecko) Chrome/70.0.3538.80 Mobile Safari/537.36"
    if (/\bAndroid\b/.test(os) && !product &&
        (data = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua))) {
      product = trim(data[1])
        // Replace any language codes (eg. "en-US").
        .replace(/^[a-z]{2}-[a-z]{2};\s*/i, '')
        || null;
    }
    // Detect product names that contain their manufacturer's name.
    if (manufacturer && !product) {
      product = getProduct([manufacturer]);
    } else if (manufacturer && product) {
      product = product
        .replace(RegExp('^(' + qualify(manufacturer) + ')[-_.\\s]', 'i'), manufacturer + ' ')
        .replace(RegExp('^(' + qualify(manufacturer) + ')[-_.]?(\\w)', 'i'), manufacturer + ' $2');
    }
    // Clean up Google TV.
    if ((data = /\bGoogle TV\b/.exec(product))) {
      product = data[0];
    }
    // Detect simulators.
    if (/\bSimulator\b/i.test(ua)) {
      product = (product ? product + ' ' : '') + 'Simulator';
    }
    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
      description.push('running in Turbo/Uncompressed mode');
    }
    // Detect IE Mobile 11.
    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
      data = parse(ua.replace(/like iPhone OS/, ''));
      manufacturer = data.manufacturer;
      product = data.product;
    }
    // Detect iOS.
    else if (/^iP/.test(product)) {
      name || (name = 'Safari');
      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
        ? ' ' + data[1].replace(/_/g, '.')
        : '');
    }
    // Detect Kubuntu.
    else if (name == 'Konqueror' && /^Linux\b/i.test(os)) {
      os = 'Kubuntu';
    }
    // Detect Android browsers.
    else if ((manufacturer && manufacturer != 'Google' &&
        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) ||
        (/\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua))) {
      name = 'Android Browser';
      os = /\bAndroid\b/.test(os) ? os : 'Android';
    }
    // Detect Silk desktop/accelerated modes.
    else if (name == 'Silk') {
      if (!/\bMobi/i.test(ua)) {
        os = 'Android';
        description.unshift('desktop mode');
      }
      if (/Accelerated *= *true/i.test(ua)) {
        description.unshift('accelerated');
      }
    }
    // Detect UC Browser speed mode.
    else if (name == 'UC Browser' && /\bUCWEB\b/.test(ua)) {
      description.push('speed mode');
    }
    // Detect PaleMoon identifying as Firefox.
    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
      description.push('identifying as Firefox ' + data[1]);
    }
    // Detect Firefox OS and products running Firefox.
    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
      os || (os = 'Firefox OS');
      product || (product = data[1]);
    }
    // Detect false positives for Firefox/Safari.
    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
      // Escape the `/` for Firefox 1.
      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
        // Clear name of false positives.
        name = null;
      }
      // Reassign a generic name.
      if ((data = product || manufacturer || os) &&
          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
      }
    }
    // Add Chrome version to description for Electron.
    else if (name == 'Electron' && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) {
      description.push('Chromium ' + data);
    }
    // Detect non-Opera (Presto-based) versions (order is important).
    if (!version) {
      version = getVersion([
        '(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)',
        'Version',
        qualify(name),
        '(?:Firefox|Minefield|NetFront)'
      ]);
    }
    // Detect stubborn layout engines.
    if ((data =
          layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' ||
          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' ||
          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') ||
          layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront'
        )) {
      layout = [data];
    }
    // Detect Windows Phone 7 desktop mode.
    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
      name += ' Mobile';
      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
      description.unshift('desktop mode');
    }
    // Detect Windows Phone 8.x desktop mode.
    else if (/\bWPDesktop\b/i.test(ua)) {
      name = 'IE Mobile';
      os = 'Windows Phone 8.x';
      description.unshift('desktop mode');
      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
    }
    // Detect IE 11 identifying as other browsers.
    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
      if (name) {
        description.push('identifying as ' + name + (version ? ' ' + version : ''));
      }
      name = 'IE';
      version = data[1];
    }
    // Leverage environment features.
    if (useFeatures) {
      // Detect server-side environments.
      // Rhino has a global function while others have a global object.
      if (isHostType(context, 'global')) {
        if (java) {
          data = java.lang.System;
          arch = data.getProperty('os.arch');
          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
        }
        if (rhino) {
          try {
            version = context.require('ringo/engine').version.join('.');
            name = 'RingoJS';
          } catch(e) {
            if ((data = context.system) && data.global.system == context.system) {
              name = 'Narwhal';
              os || (os = data[0].os || null);
            }
          }
          if (!name) {
            name = 'Rhino';
          }
        }
        else if (
          typeof context.process == 'object' && !context.process.browser &&
          (data = context.process)
        ) {
          if (typeof data.versions == 'object') {
            if (typeof data.versions.electron == 'string') {
              description.push('Node ' + data.versions.node);
              name = 'Electron';
              version = data.versions.electron;
            } else if (typeof data.versions.nw == 'string') {
              description.push('Chromium ' + version, 'Node ' + data.versions.node);
              name = 'NW.js';
              version = data.versions.nw;
            }
          }
          if (!name) {
            name = 'Node.js';
            arch = data.arch;
            os = data.platform;
            version = /[\d.]+/.exec(data.version);
            version = version ? version[0] : null;
          }
        }
      }
      // Detect Adobe AIR.
      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
        name = 'Adobe AIR';
        os = data.flash.system.Capabilities.os;
      }
      // Detect PhantomJS.
      else if (getClassOf((data = context.phantom)) == phantomClass) {
        name = 'PhantomJS';
        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
      }
      // Detect IE compatibility modes.
      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
        // We're in compatibility mode when the Trident version + 4 doesn't
        // equal the document mode.
        version = [version, doc.documentMode];
        if ((data = +data[1] + 4) != version[1]) {
          description.push('IE ' + version[1] + ' mode');
          layout && (layout[1] = '');
          version[1] = data;
        }
        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
      }
      // Detect IE 11 masking as other browsers.
      else if (typeof doc.documentMode == 'number' && /^(?:Chrome|Firefox)\b/.test(name)) {
        description.push('masking as ' + name + ' ' + version);
        name = 'IE';
        version = '11.0';
        layout = ['Trident'];
        os = 'Windows';
      }
      os = os && format(os);
    }
    // Detect prerelease phases.
    if (version && (data =
          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
          /\bMinefield\b/i.test(ua) && 'a'
        )) {
      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
      version = version.replace(RegExp(data + '\\+?$'), '') +
        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
    }
    // Detect Firefox Mobile.
    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os)) {
      name = 'Firefox Mobile';
    }
    // Obscure Maxthon's unreliable version.
    else if (name == 'Maxthon' && version) {
      version = version.replace(/\.[\d.]+/, '.x');
    }
    // Detect Xbox 360 and Xbox One.
    else if (/\bXbox\b/i.test(product)) {
      if (product == 'Xbox 360') {
        os = null;
      }
      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
        description.unshift('mobile mode');
      }
    }
    // Add mobile postfix.
    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
        (os == 'Windows CE' || /Mobi/i.test(ua))) {
      name += ' Mobile';
    }
    // Detect IE platform preview.
    else if (name == 'IE' && useFeatures) {
      try {
        if (context.external === null) {
          description.unshift('platform preview');
        }
      } catch(e) {
        description.unshift('embedded');
      }
    }
    // Detect BlackBerry OS version.
    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
          version
        )) {
      data = [data, /BB10/.test(ua)];
      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
      version = null;
    }
    // Detect Opera identifying/masking itself as another browser.
    // http://www.opera.com/support/kb/view/843/
    else if (this != forOwn && product != 'Wii' && (
          (useFeatures && opera) ||
          (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
          (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
          (name == 'IE' && (
            (os && !/^Win/.test(os) && version > 5.5) ||
            /\bWindows XP\b/.test(os) && version > 8 ||
            version == 8 && !/\bTrident\b/.test(ua)
          ))
        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {
      // When "identifying", the UA contains both Opera and the other browser's name.
      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
      if (reOpera.test(name)) {
        if (/\bIE\b/.test(data) && os == 'Mac OS') {
          os = null;
        }
        data = 'identify' + data;
      }
      // When "masking", the UA contains only the other browser's name.
      else {
        data = 'mask' + data;
        if (operaClass) {
          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
        } else {
          name = 'Opera';
        }
        if (/\bIE\b/.test(data)) {
          os = null;
        }
        if (!useFeatures) {
          version = null;
        }
      }
      layout = ['Presto'];
      description.push(data);
    }
    // Detect WebKit Nightly and approximate Chrome/Safari versions.
    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
      // Correct build number for numeric comparison.
      // (e.g. "532.5" becomes "532.05")
      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
      // Nightly builds are postfixed with a "+".
      if (name == 'Safari' && data[1].slice(-1) == '+') {
        name = 'WebKit Nightly';
        prerelease = 'alpha';
        version = data[1].slice(0, -1);
      }
      // Clear incorrect browser versions.
      else if (version == data[1] ||
          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
        version = null;
      }
      // Use the full Chrome version when available.
      data[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1];
      // Detect Blink layout engine.
      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
        layout = ['Blink'];
      }
      // Detect JavaScriptCore.
      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
      if (!useFeatures || (!likeChrome && !data[1])) {
        layout && (layout[1] = 'like Safari');
        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : data < 602 ? 9 : data < 604 ? 10 : data < 606 ? 11 : data < 608 ? 12 : '12');
      } else {
        layout && (layout[1] = 'like Chrome');
        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
      }
      // Add the postfix of ".x" or "+" for approximate versions.
      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
      // Obscure version for some Safari 1-2 releases.
      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
        version = data;
      } else if (name == 'Chrome' && /\bHeadlessChrome/i.test(ua)) {
        description.unshift('headless');
      }
    }
    // Detect Opera desktop modes.
    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
      name += ' ';
      description.unshift('desktop mode');
      if (data == 'zvav') {
        name += 'Mini';
        version = null;
      } else {
        name += 'Mobile';
      }
      os = os.replace(RegExp(' *' + data + '$'), '');
    }
    // Detect Chrome desktop mode.
    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
      description.unshift('desktop mode');
      name = 'Chrome Mobile';
      version = null;

      if (/\bOS X\b/.test(os)) {
        manufacturer = 'Apple';
        os = 'iOS 4.3+';
      } else {
        os = null;
      }
    }
    // Newer versions of SRWare Iron uses the Chrome tag to indicate its version number.
    else if (/\bSRWare Iron\b/.test(name) && !version) {
      version = getVersion('Chrome');
    }
    // Strip incorrect OS versions.
    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
        ua.indexOf('/' + data + '-') > -1) {
      os = trim(os.replace(data, ''));
    }
    // Ensure OS does not include the browser name.
    if (os && os.indexOf(name) != -1 && !RegExp(name + ' OS').test(os)) {
      os = os.replace(RegExp(' *' + qualify(name) + ' *'), '');
    }
    // Add layout engine.
    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
        /Browser|Lunascape|Maxthon/.test(name) ||
        name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) ||
        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name) && layout[1])) {
      // Don't add layout details to description if they are falsey.
      (data = layout[layout.length - 1]) && description.push(data);
    }
    // Combine contextual information.
    if (description.length) {
      description = ['(' + description.join('; ') + ')'];
    }
    // Append manufacturer to description.
    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
      description.push('on ' + manufacturer);
    }
    // Append product to description.
    if (product) {
      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
    }
    // Parse the OS into an object.
    if (os) {
      data = / ([\d.+]+)$/.exec(os);
      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
      os = {
        'architecture': 32,
        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
        'version': data ? data[1] : null,
        'toString': function() {
          var version = this.version;
          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
        }
      };
    }
    // Add browser/OS architecture.
    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
      if (os) {
        os.architecture = 64;
        os.family = os.family.replace(RegExp(' *' + data), '');
      }
      if (
          name && (/\bWOW64\b/i.test(ua) ||
          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
      ) {
        description.unshift('32-bit');
      }
    }
    // Chrome 39 and above on OS X is always 64-bit.
    else if (
        os && /^OS X/.test(os.family) &&
        name == 'Chrome' && parseFloat(version) >= 39
    ) {
      os.architecture = 64;
    }

    ua || (ua = null);

    /*------------------------------------------------------------------------*/

    /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */
    var platform = {};

    /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.description = ua;

    /**
     * The name of the browser's layout engine.
     *
     * The list of common layout engines include:
     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.layout = layout && layout[0];

    /**
     * The name of the product's manufacturer.
     *
     * The list of manufacturers include:
     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
     * "Nokia", "Samsung" and "Sony"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.manufacturer = manufacturer;

    /**
     * The name of the browser/environment.
     *
     * The list of common browser names include:
     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
     * "Opera Mini" and "Opera"
     *
     * Mobile versions of some browsers have "Mobile" appended to their name:
     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.name = name;

    /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.prerelease = prerelease;

    /**
     * The name of the product hosting the browser.
     *
     * The list of common products include:
     *
     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.product = product;

    /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.ua = ua;

    /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.version = name && version;

    /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */
    platform.os = os || {

      /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */
      'architecture': null,

      /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
       * "SuSE", "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */
      'family': null,

      /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */
      'version': null,

      /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */
      'toString': function() { return 'null'; }
    };

    platform.parse = parse;
    platform.toString = toStringPlatform;

    if (platform.version) {
      description.unshift(version);
    }
    if (platform.name) {
      description.unshift(name);
    }
    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
      description.push(product ? '(' + os + ')' : 'on ' + os);
    }
    if (description.length) {
      platform.description = description.join(' ');
    }
    return platform;
  }

  /*--------------------------------------------------------------------------*/

  // Export platform.
  var platform = parse();

  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose platform on the global object to prevent errors when platform is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    root.platform = platform;

    // Define as an anonymous module so platform can be aliased through path mapping.
    define(function() {
      return platform;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for CommonJS support.
    forOwn(platform, function(value, key) {
      freeExports[key] = value;
    });
  }
  else {
    // Export to the global object.
    root.platform = platform;
  }
}.call(this));
var RS;
(function (RS) {
    var ArrayUtils;
    (function (ArrayUtils) {
        /**
         * Copies all items from "from" and appends them to "to".
         * @param from
         * @param to
         */
        function copy(from, to) {
            var start = to.length;
            to.length += from.length;
            for (var i = 0, l = from.length; i < l; ++i) {
                to[start + i] = from[i];
            }
        }
        ArrayUtils.copy = copy;
        /**
         * Removes all duplicates from the specified array.
         * Preserves order.
         * @param arr
         */
        function removeDuplicates(arr, equals) {
            for (var i = arr.length - 1; i > 0; --i) {
                for (var j = i - 1; j >= 0; --j) {
                    if (equals ? equals(arr[i], arr[j]) : arr[i] === arr[j]) {
                        arr.splice(i, 1);
                        break;
                    }
                }
            }
        }
        ArrayUtils.removeDuplicates = removeDuplicates;
        /**
         * Removes an item from the specified array by shifting the last item onto it.
         * Faster than splice as following indices do not need to be shifted, but does not preserve order.
         * @param arr
         * @param index
         */
        function fastRemove(arr, index) {
            if (index < 0 || index >= arr.length) {
                return;
            }
            if (index < arr.length - 1) {
                arr[index] = arr[arr.length - 1];
            }
            --arr.length;
        }
        ArrayUtils.fastRemove = fastRemove;
        /**
         * Removes all items from an array that don't pass the predicate.
         * @param arr
         * @param predicate
         */
        function filterInPlace(arr, predicate, preserveOrder) {
            for (var i = arr.length - 1; i >= 0; --i) {
                if (!predicate(arr[i])) {
                    if (preserveOrder) {
                        arr.splice(i, 1);
                    }
                    else {
                        fastRemove(arr, i);
                    }
                }
            }
        }
        ArrayUtils.filterInPlace = filterInPlace;
        /**
         * Gets if the array contains at least one of the specified item.
         * @param arr
         * @param item
         * @param equals
         */
        function contains(arr, item, equals) {
            for (var i = 0, l = arr.length; i < l; ++i) {
                if (equals ? equals(arr[i], item) : arr[i] === item) {
                    return true;
                }
            }
            return false;
        }
        ArrayUtils.contains = contains;
    })(ArrayUtils = RS.ArrayUtils || (RS.ArrayUtils = {}));
})(RS || (RS = {}));
/** Contains common type guards. */
var RS;
(function (RS) {
    var Is;
    (function (Is) {
        /**
         * Gets if the specified value is a number. \
         * Returns false for NaN.
         * Returns true for Infinity and -Infinity.
         * @param value The value to test
         */
        function number(value) {
            return value != null && !isNaN(value) && (typeof value === "number" || value instanceof Number);
        }
        Is.number = number;
        /**
         * Gets if the specified value is an integer. \
         * Does not type-guard, as integer type currently impossible. \
         * Returns false for NaN, Infinity and -Infinity.
         * @param value The value to test
         */
        function integer(value) {
            return Is.number(value) && (value % 1) === 0;
        }
        Is.integer = integer;
        /**
         * Gets if the specified value is a string.
         * @param value The value to test
         */
        function string(value) {
            return value != null && (typeof value === "string" || value instanceof String);
        }
        Is.string = string;
        /**
         * Gets if the specified value is an array.
         * @param value The value to test
         */
        function array(value) {
            return value != null && Array.isArray(value);
        }
        Is.array = array;
        /**
         * Gets if the specified value is an array of a specific type.
         * @param value The value to test
         */
        function arrayOf(value, innerTester) {
            return value != null && Is.array(value) && value.every(function (el) { return innerTester(el); });
        }
        Is.arrayOf = arrayOf;
        /**
         * Gets if the specified value is a read-only array.
         * Equivalent to Is.array at runtime.
         * @param value The value to test
         */
        function readonlyArray(value) {
            return array(value);
        }
        Is.readonlyArray = readonlyArray;
        /**
         * Gets if the specified value is an array of a specific type.
         * Equivalent to Is.arrayOf at runtime.
         * @param value The value to test
         */
        function readonlyArrayOf(value, innerTester) {
            return arrayOf(value, innerTester);
        }
        Is.readonlyArrayOf = readonlyArrayOf;
        /**
         * Gets if the specified value is an object but NOT an array.
         * @param value The value to test
         */
        function object(value) {
            return value != null && typeof value === "object" && !Array.isArray(value);
        }
        Is.object = object;
        /**
         * Gets if the specified value is an empty object
         * @param value  The value to test
         */
        function emptyObject(value) {
            return object(value) && Object.keys(value).length === 0;
        }
        Is.emptyObject = emptyObject;
        /**
         * Gets if the specified value is a function.
         * @param value The value to test
         */
        function func(value) {
            return value != null && (typeof value === "function" || value instanceof Function);
        }
        Is.func = func;
        /**
         * Gets if the specified value is a boolean.
         * @param value The value to test
         */
        function boolean(value) {
            return value === true || value === false;
        }
        Is.boolean = boolean;
        /**
         * Gets if the specified value is a primitive.
         * @param value
         */
        function primitive(value) {
            return Is.number(value) || Is.boolean(value) || Is.string(value);
        }
        Is.primitive = primitive;
        /**
         * Gets if the specified value is a non-primitive.
         * @param value
         */
        function nonPrimitive(value) {
            return value != null && !Is.primitive(value);
        }
        Is.nonPrimitive = nonPrimitive;
    })(Is = RS.Is || (RS.Is = {}));
})(RS || (RS = {}));
(function (RS) {
    function as(value, guard, defaultValue) {
        if (defaultValue === void 0) { defaultValue = null; }
        if (guard(value)) {
            return value;
        }
        return defaultValue;
    }
    RS.as = as;
})(RS || (RS = {}));
/// <reference path="Is.ts"/>
/** Contains functions for reading strings as various types of value. */
var RS;
(function (RS) {
    var Read;
    (function (Read) {
        var truthy = ["true", "1", "y", "yes"];
        var falsy = ["false", "0", "n", "no"];
        /**
         * Parses the given string as an boolean.
         * @return a boolean (or null if defaultValue = null and value is not a boolean)
         */
        function boolean(value, defaultVal) {
            if (defaultVal === void 0) { defaultVal = null; }
            var lower = value.toLowerCase();
            if (truthy.indexOf(lower) !== -1) {
                return true;
            }
            if (falsy.indexOf(lower) !== -1) {
                return false;
            }
            return defaultVal;
        }
        Read.boolean = boolean;
        /**
         * Parses the given string as an integer.
         * @return a number (or null if defaultValue = null and value is not an integer)
         */
        function integer(value, defaultVal) {
            if (defaultVal === void 0) { defaultVal = null; }
            if (value == "") {
                return defaultVal;
            }
            var parsed = Number(value);
            return RS.as(parsed, RS.Is.integer, defaultVal);
        }
        Read.integer = integer;
        /**
         * Parses the given string as a number.
         * @return a number (or null if defaultValue = null and value is not a number)
         */
        function number(value, defaultVal) {
            if (defaultVal === void 0) { defaultVal = null; }
            if (value == "") {
                return defaultVal;
            }
            var parsed = Number(value);
            return RS.as(parsed, RS.Is.number, defaultVal);
        }
        Read.number = number;
        /**
         * Parses the given string as an object.
         * @return an object or null
         */
        function object(value) {
            var parsed = null;
            try {
                parsed = JSON.parse(value);
            }
            catch ( /* Do nothing, we'll return null. */_a) { /* Do nothing, we'll return null. */ }
            return RS.as(parsed, RS.Is.object);
        }
        Read.object = object;
        /**
         * Parses the given string as an array of a specific type.
         * @return an array of T and null values
         */
        function arrayOf(value, innerReader, delimiter) {
            if (delimiter === void 0) { delimiter = ","; }
            var strings = value.split(delimiter);
            return strings.map(function (str) { return innerReader(str); });
        }
        Read.arrayOf = arrayOf;
        /**
         * Parses the given string as a value of the given enum.
         * @param enumObj The enum to read the string as
         * @param caseSensitive If true, the given string must match the case of an enum key. Defaults to false.
         */
        function enumVal(enumObj, value, defaultVal, caseSensitive) {
            if (defaultVal === void 0) { defaultVal = null; }
            if (caseSensitive === void 0) { caseSensitive = false; }
            var int = integer(value);
            if (int != null) {
                return (int in enumObj) ? int : defaultVal;
            }
            for (var key in enumObj) {
                // Numeric enum, break
                if (RS.Is.number(Number(key))) {
                    break;
                }
                var enumValue = enumObj[key];
                if (enumValue === value) {
                    return enumValue;
                }
            }
            var mappedVal = enumObj[value];
            if (mappedVal != null) {
                return mappedVal;
            }
            if (!caseSensitive) {
                var valueLower = value.toLowerCase();
                for (var key in enumObj) {
                    if (key.toLowerCase() === valueLower) {
                        return enumObj[key];
                    }
                }
            }
            return defaultVal;
        }
        Read.enumVal = enumVal;
    })(Read = RS.Read || (RS.Read = {}));
})(RS || (RS = {}));
/// <reference path="Read.ts"/>
var RS;
(function (RS) {
    var URL;
    (function (URL) {
        var urlSearchParams = URLSearchParams ? new URLSearchParams(location.search) : null;
        function exists(p1, retry, useHead) {
            if (retry === void 0) { retry = false; }
            if (useHead === void 0) { useHead = true; }
            return __awaiter(this, void 0, void 0, function () {
                var settings, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (RS.Is.string(p1)) {
                                settings = { url: p1 };
                                settings.method = useHead ? "HEAD" : "GET";
                            }
                            else {
                                settings = p1;
                                if (!settings.method) {
                                    settings.method = "HEAD";
                                }
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, RS.Request.ajax(settings, RS.Request.AJAXResponseType.Text)];
                        case 2:
                            _a.sent();
                            return [2 /*return*/, true];
                        case 3:
                            error_1 = _a.sent();
                            if (error_1 instanceof RS.Request.ResponseError) {
                                if (error_1.code === 404) {
                                    return [2 /*return*/, false];
                                }
                                if (error_1.code === 405) {
                                    if (settings.method === "HEAD") {
                                        return [2 /*return*/, exists(__assign(__assign({}, settings), { method: "GET" }), retry)];
                                    }
                                    // Apparently even GET is not allowed to that URL
                                    // Rather than error out, we can say it actually doesn't exist
                                    // Since it kinda doesn't if it's not GET-accessible
                                    RS.Log.warn("[URL] GET was not allowed to ".concat(settings.url));
                                    return [2 /*return*/, false];
                                }
                            }
                            else {
                                // DNS not resolved or other unknown error; return false
                                RS.Log.warn("[URL] Failed to access ".concat(settings.url));
                                return [2 /*return*/, false];
                            }
                            if (retry) {
                                return [2 /*return*/, exists(settings)];
                            }
                            throw error_1;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        URL.exists = exists;
        var Decoders;
        (function (Decoders) {
            Decoders.URI = decodeURI;
            Decoders.Unicode = function (value) { return value.split("%").map(function (ch) { return ch.charCodeAt(0); }).join(""); };
        })(Decoders = URL.Decoders || (URL.Decoders = {}));
        var Encoders;
        (function (Encoders) {
            Encoders.URI = encodeURI;
            Encoders.Unicode = function (value) { return value.split("").map(function (ch) { return "%".concat(ch.charCodeAt(0)); }).join(""); };
        })(Encoders = URL.Encoders || (URL.Encoders = {}));
        /**
         * Gets a URL parameter from the current window URL.
         * @param name       Name of the URL parameter to extract
         * @param defaultVal Default value to return if parameter not found. Defaults to null.
         * @param decoder    Decoder to use to parse the string
         * @returns          The decoded URL parameter
         */
        function getParameter(name, defaultVal, decoder) {
            if (defaultVal === void 0) { defaultVal = null; }
            if (decoder === void 0) { decoder = Decoders.URI; }
            var paramString;
            if (urlSearchParams) {
                // can't just null check urlSearchParams.get(name) since it returns "null" instead of null if it doesn't exist..
                paramString = urlSearchParams.has(name) ? decoder(urlSearchParams.get(name)) : defaultVal;
            }
            else {
                /**
                 * fallback to regex method in case URLSearchParams don't exist (IE and older versions of browsers)
                 * [?&]+ one of more ? or &
                 * ${name}= key to search for plus an =
                 * ([^&]*) capture group of everything until an & is reached
                 * visual: https://regexper.com/#%2F%5B%3F%26%5D%2B%28%5B%5E%3D%26%5D%2B%29%3D%28%5B%5E%26%5D*%29%2F
                 */
                var match = RegExp("[?&]+".concat(name, "=([^&]*)")).exec(location.search);
                paramString = match ? decoder(match[1]) : defaultVal;
            }
            if (paramString) {
                // these characters could be unsafe so we replace them
                // using the regex just so every instance can be replaced at once
                paramString = paramString.replace(RegExp('&', 'g'), '&amp');
                paramString = paramString.replace(RegExp('<', 'g'), '&lt');
                paramString = paramString.replace(RegExp('>', 'g'), '&gt');
                paramString = paramString.replace(RegExp('"', 'g'), '&quot');
                paramString = paramString.replace(RegExp('\'', 'g'), '&#x27');
            }
            return paramString;
        }
        URL.getParameter = getParameter;
        /**
         * Gets a boolean URL parameter from the current window URL.
         * @param name       Name of the URL parameter to extract
         * @param defaultVal Default value to return if parameter not found. Defaults to false.
         * @param decoder    Decoder to use to parse the string
         * @returns          The decoded URL parameter
         */
        function getParameterAsBool(name, defaultVal, decoder) {
            if (defaultVal === void 0) { defaultVal = false; }
            var val = getParameter(name, "", decoder);
            return RS.Read.boolean(val, defaultVal);
        }
        URL.getParameterAsBool = getParameterAsBool;
        /**
         * Gets a numeric URL parameter from the current window URL.
         * @param name       Name of the URL parameter to extract
         * @param defaultVal Default value to return if parameter not found. Defaults to 0.
         * @param decoder    Decoder to use to parse the string
         * @returns          The decoded URL parameter
         */
        function getParameterAsNumber(name, defaultVal, decoder) {
            if (defaultVal === void 0) { defaultVal = 0; }
            var val = getParameter(name, "", decoder);
            return RS.Read.number(val, defaultVal);
        }
        URL.getParameterAsNumber = getParameterAsNumber;
        /**
         * Gets a URL object parameter from the current window URL.
         * @param name       Name of the URL parameter to extract
         * @param decoder    Decoder to use to parse the string
         * @returns          The decoded URL parameter
         */
        function getParameterAsObject(name, decoder) {
            var val = getParameter(name, "", decoder);
            return readObject(val);
        }
        URL.getParameterAsObject = getParameterAsObject;
        /**
         * Gets an enum URL parameter from the current window URL.
         * @param enumObj    Enum to read the parameter as
         * @param name       Name of the URL parameter to extract
         * @param defaultVal Default value to return if parameter not found. Defaults to null.
         * @param decoder    Decoder to use to parse the string
         * @returns          The decoded URL parameter
         */
        function getParameterAsEnumVal(enumObj, name, defaultVal, decoder) {
            if (defaultVal === void 0) { defaultVal = null; }
            var val = getParameter(name, "", decoder);
            var enumVal = RS.Read.enumVal(enumObj, val, null);
            if (val && enumVal == null) {
                RS.Log.warn("Invalid enum value '".concat(val, "'; valid values are ").concat(Object.keys(enumObj).join(", ")));
            }
            return enumVal == null ? defaultVal : enumVal;
        }
        URL.getParameterAsEnumVal = getParameterAsEnumVal;
        /**
         * Removes the given parameters from a URL.
         *
         * @param params    The names of parameters to be removed
         * @param url       The optional URL to modify (defaults to the current window URL)
         * @returns         The modified URL
         */
        function removeParameters(params, url) {
            if (url === void 0) { url = location.href; }
            for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
                var param = params_1[_i];
                var regExp = "((\\?|\\&)".concat(param, "=(?:[^\\&]*))");
                var results = new RegExp(regExp).exec(url);
                if (results) {
                    var removeFrom = results.index;
                    var removeLen = results[0].length;
                    var leftSide = url.slice(0, removeFrom);
                    var rightSide = url.slice(removeFrom + removeLen);
                    if (results[2] == "?" && rightSide.length > 0) {
                        rightSide = "?" + rightSide.slice(1);
                    }
                    url = leftSide + rightSide;
                }
            }
            return url;
        }
        URL.removeParameters = removeParameters;
        /**
         * Sets the given URL parameters in a URL.
         *
         * @param params    An object containing parameter names and values to be set
         * @param url       The optional URL to modify (defaults to the current window URL)
         * @returns         The modified URL
         */
        function setParameters(params, url, encoder) {
            if (url === void 0) { url = location.href; }
            if (encoder === void 0) { encoder = Encoders.URI; }
            url = removeParameters(Object.keys(params), url);
            var delimiter = url.indexOf("?") > -1 ? "&" : "?";
            for (var name_1 in params) {
                var value = params[name_1];
                var stringValue = RS.Is.string(value) ? value : stringify(value);
                var encodedValue = encoder(stringValue);
                url += "".concat(delimiter).concat(name_1, "=").concat(encodedValue);
                if (delimiter === "?") {
                    delimiter = "&";
                }
            }
            return url;
        }
        URL.setParameters = setParameters;
        var objectMarker = "$";
        var objectDelimiter = "!";
        function read(str) {
            if (str[0] === "'" && str[str.length - 1] === "'") {
                return str.substr(1, str.length - 2);
            }
            if (str === "true") {
                return true;
            }
            if (str === "false") {
                return false;
            }
            if (str === "null") {
                return null;
            }
            if (str === "undefined") {
                return undefined;
            }
            var number = RS.Read.number(str);
            if (number) {
                return number;
            }
            throw new Error("Could not read value ".concat(str));
        }
        function readObject(str) {
            if (str[0] !== objectMarker) {
                return null;
            }
            str = str.substr(1);
            var delimiter = objectDelimiter;
            var parts = str.split(delimiter);
            var obj = {};
            for (var i = 0; i < parts.length; i += 2) {
                var key = parts[i];
                var value = parts[i + 1];
                obj[key] = read(value);
            }
            return obj;
        }
        function stringify(val) {
            if (RS.Is.number(val) || RS.Is.boolean(val) || val == null) {
                return "".concat(val);
            }
            if (RS.Is.string(val)) {
                return "'".concat(val, "'");
            }
            if (RS.Is.object(val)) {
                return stringifyObject(val);
            }
            throw new Error("Could not URI-serialise value ".concat(val));
        }
        function stringifyObject(obj) {
            var delimiter = objectDelimiter;
            var addDelimiter = false;
            var parts = ["$"];
            for (var key in obj) {
                var value = obj[key];
                var valueString = stringify(value);
                if (addDelimiter) {
                    parts.push(delimiter);
                }
                parts.push(key, delimiter, valueString);
                addDelimiter = true;
            }
            return parts.join("");
        }
        function download(p1, blob) {
            if (!RS.Is.string(p1)) {
                blob = p1;
            }
            // create download picture link
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style.cssText = "display: none";
            var url = window.URL.createObjectURL(blob); // createObjectURL() will leak memory.
            a.href = url;
            if (RS.Is.string(p1)) {
                a.download = p1;
            }
            // click link to download picture
            a.click();
            window.URL.revokeObjectURL(url);
            a.parentNode.removeChild(a);
        }
        URL.download = download;
    })(URL = RS.URL || (RS.URL = {}));
})(RS || (RS = {}));
/// <reference path="URL.ts"/>
var RS;
(function (RS) {
    var Async;
    (function (Async) {
        /**
         * Returns a promise that resolves when ALL sub-promises have resolved.
         * If one promise rejects, all will reject.
         * @param promises
         */
        function multiple(promises) {
            return new Promise(function (resolve, reject) {
                if (promises.length === 0) {
                    resolve([]);
                    return;
                }
                var resolved = false;
                var pendingCount = promises.length;
                var results = new Array(pendingCount);
                var _loop_1 = function (i, l) {
                    promises[i].then(function (result) {
                        if (resolved) {
                            return;
                        }
                        results[i] = result;
                        pendingCount--;
                        if (pendingCount === 0) {
                            resolved = true;
                            resolve(results);
                        }
                    }, function (reason) {
                        if (resolved) {
                            return;
                        }
                        resolved = true;
                        reject(reason);
                    });
                };
                for (var i = 0, l = promises.length; i < l; ++i) {
                    _loop_1(i, l);
                }
            });
        }
        Async.multiple = multiple;
        /**
         * Returns a promise that never resolves.
         */
        function never() {
            return new Promise(function (resolve, reject) { return; });
        }
        Async.never = never;
        // Promise debugging.
        var oldPromise = window["Promise"];
        var DebugPromise = /** @class */ (function () {
            function DebugPromise(_executor) {
                this._executor = _executor;
                this._done = false;
                DebugPromise._activeInstances.push(this);
                this.stack = RS.Util.getStackTrace();
                this._promise = new oldPromise(this.execute.bind(this));
                this.then = oldPromise.prototype.then.bind(this._promise);
                this.catch = oldPromise.prototype.catch.bind(this._promise);
                if (!DebugPromise._logged) {
                    RS.Log.info("[Promise] Debugging active. To see all open Promises and their stacks, call the global function rspromises().");
                    DebugPromise._logged = true;
                }
            }
            var _propObj = {};

            _propObj.activeInstances = {
                get: function () { return this._activeInstances; },
                enumerable: false,
                configurable: true
            };

            Object.defineProperties(DebugPromise, _propObj);
            var _propObj = {};

            _propObj.source = {
                get: function () {
                    var awaiter = Object.keys({ __awaiter: true })[0];
                    var stack = this.stack.split("\n");
                    for (var _i = 0, stack_1 = stack; _i < stack_1.length; _i++) {
                        var str = stack_1[_i];
                        if (str.indexOf(awaiter) === -1) {
                            return str;
                        }
                    }
                    return stack[0];
                },
                enumerable: false,
                configurable: true
            };

            Object.defineProperties(DebugPromise.prototype, _propObj);
            DebugPromise.prototype.execute = function (resolve, reject) {
                var _this = this;
                var newResolve = function (v) {
                    if (_this._done) {
                        return;
                    }
                    _this.cleanup();
                    resolve(v);
                    _this._done = true;
                };
                var newReject = function (r) {
                    if (_this._done) {
                        return;
                    }
                    _this.cleanup();
                    reject(r);
                    _this._done = true;
                };
                this._executor(newResolve, newReject);
            };
            DebugPromise.prototype.cleanup = function () {
                var _this = this;
                RS.Find.remove(DebugPromise._activeInstances, function (p) { return p === _this; });
            };
            DebugPromise._logged = false;
            DebugPromise._activeInstances = [];
            return DebugPromise;
        }());
        Async.DebugPromise = DebugPromise;
        (function (DebugPromise) {
            DebugPromise.all = Promise.all, DebugPromise.race = Promise.race, DebugPromise.reject = Promise.reject, DebugPromise.resolve = Promise.resolve;
        })(DebugPromise = Async.DebugPromise || (Async.DebugPromise = {}));
        if (RS.URL.getParameterAsBool("promisedebug")) {
            var commandName = "rspromises";
            Promise = DebugPromise;
            window[commandName] = function () {
                DebugPromise.activeInstances.forEach(function (inst) { return console.log(inst.source); });
                return DebugPromise.activeInstances;
            };
        }
    })(Async = RS.Async || (RS.Async = {}));
})(RS || (RS = {}));
/// <reference path="URL.ts" />
var RS;
(function (RS) {
    var Capabilities;
    (function (Capabilities) {
        var Audio;
        (function (Audio) {
            var _a;
            var FORMATS = Object.freeze((_a = {},
                _a["mp4"] = ["mp4a.40.2"],
                _a["mpeg"] = ["mp3"],
                _a["ogg"] = [
                    "opus",
                    "vorbis",
                ],
                _a["webm"] = [
                    "opus",
                    "vorbis",
                ],
                _a["x-caf"] = ["opus"],
                _a));
            var instance = null;
            Audio.get = function () {
                return instance !== null && instance !== void 0 ? instance : (instance = getInternal());
            };
            var getInternal = function () {
                // Browsers reporting can be quite inconsistent and contradictory to the spec
                // https://www.iana.org/assignments/media-types/media-types.xhtml
                var audio = document.createElement("audio");
                var result = {};
                for (var container in FORMATS) {
                    var containerType = "audio/".concat(container);
                    result[containerType] = audio.canPlayType(containerType);
                    for (var _i = 0, _a = FORMATS[container]; _i < _a.length; _i++) {
                        var codec = _a[_i];
                        var codecType = "".concat(containerType, "; codecs=").concat(codec);
                        result[codecType] = audio.canPlayType(codecType);
                    }
                }
                return result;
            };
        })(Audio = Capabilities.Audio || (Capabilities.Audio = {}));
        var WebGL;
        (function (WebGL) {
            var cachedInfo = null;
            var cachedRenderer = null;
            /**
             * Queries WebGL capabilities on the current device.
             */
            function get() {
                return cachedInfo || (cachedInfo = getInternal());
            }
            WebGL.get = get;
            /**
             * Returns the device's GPU, or if using the canvas renderer, a string specifying so.
             */
            function getRenderer() {
                if (cachedRenderer != null) {
                    return cachedRenderer;
                }
                var canvas = document.createElement("canvas");
                canvas.width = 1;
                canvas.height = 1;
                var context = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
                if (!context) {
                    return RS.Performance.DeviceRenderer.Canvas;
                }
                var info = context.getExtension("WEBGL_debug_renderer_info");
                cachedRenderer = info
                    ? context.getParameter(info.UNMASKED_RENDERER_WEBGL)
                    : RS.Performance.DeviceRenderer.Canvas;
                var loseContext = context.getExtension("WEBGL_lose_context");
                if (loseContext) {
                    loseContext.loseContext();
                }
                return cachedRenderer;
            }
            WebGL.getRenderer = getRenderer;
            /**
             * Tries to read the given string-or-undefined using a given string-reader.
             * Returns null if the string is null or invalid.
             */
            function tryTo(read, str) {
                if (str == null) {
                    return null;
                }
                return read(str, null);
            }
            /**
             * Applies capability overrides from the URL to the given info object.
             * Example of syntax: forcecaps=gl:1,s3tc:0
             */
            function applyOverrides(info) {
                var forceCaps = RS.URL.getParameter("forcecaps");
                if (forceCaps) {
                    var map = {};
                    for (var _i = 0, _a = forceCaps.split(","); _i < _a.length; _i++) {
                        var lrRaw = _a[_i];
                        var _b = lrRaw.split(":"), key = _b[0], value = _b[1];
                        map[key] = value;
                    }
                    var gl = map.gl, s3tc = map.s3tc, pvrtc = map.pvrtc, highp = map.highp, texd = map.texd, srgb = map.srgb;
                    info.available = tryTo(RS.Read.boolean, gl);
                    info.supportsS3TC = tryTo(RS.Read.boolean, s3tc);
                    info.supportsPVRTC = tryTo(RS.Read.boolean, pvrtc);
                    info.supportsHighPrecisionFragmentShaders = tryTo(RS.Read.boolean, highp);
                    info.maxTextureSize = tryTo(RS.Read.integer, texd);
                    info.supportsSRGB = tryTo(RS.Read.boolean, srgb);
                }
            }
            /** Queries WebGL capabilities, ignoring the cache. */
            function getInternal() {
                var caps = { available: null, supportsPVRTC: null, supportsS3TC: null, supportsHighPrecisionFragmentShaders: null, maxTextureSize: null, supportsSRGB: null };
                applyOverrides(caps);
                var canvas = document.createElement("canvas");
                canvas.width = 1;
                canvas.height = 1;
                var context = canvas.getContext("webgl");
                if (!context) {
                    // No WebGL so incapable of everything; set non-overridden properties to false.
                    if (caps.available == null) {
                        caps.available = false;
                    }
                    if (caps.supportsS3TC == null) {
                        caps.supportsS3TC = false;
                    }
                    if (caps.supportsPVRTC == null) {
                        caps.supportsPVRTC = false;
                    }
                    if (caps.supportsHighPrecisionFragmentShaders == null) {
                        caps.supportsHighPrecisionFragmentShaders = false;
                    }
                    if (caps.supportsSRGB == null) {
                        caps.supportsSRGB = false;
                    }
                    return caps;
                }
                // Set non-overridden properties accordingly.
                var extensions = context.getSupportedExtensions();
                if (caps.available == null) {
                    caps.available = true;
                }
                if (caps.supportsPVRTC == null) {
                    caps.supportsPVRTC = extensions.indexOf("WEBGL_compressed_texture_pvrtc") !== -1 || extensions.indexOf("WEBKIT_WEBGL_compressed_texture_pvrtc") !== -1;
                }
                if (caps.supportsS3TC == null) {
                    caps.supportsS3TC = extensions.indexOf("WEBGL_compressed_texture_s3tc") !== -1 || extensions.indexOf("WEBKIT_WEBGL_compressed_texture_s3tc") !== -1;
                }
                if (caps.supportsHighPrecisionFragmentShaders == null) {
                    caps.supportsHighPrecisionFragmentShaders = context.getShaderPrecisionFormat(context.FRAGMENT_SHADER, context.HIGH_FLOAT) != null && context.getShaderPrecisionFormat(context.FRAGMENT_SHADER, context.HIGH_INT) != null;
                }
                if (caps.maxTextureSize == null) {
                    caps.maxTextureSize = context.getParameter(context.MAX_TEXTURE_SIZE);
                }
                if (caps.supportsSRGB == null) {
                    caps.supportsSRGB = extensions.indexOf("EXT_sRGB") !== -1;
                }
                var loseContext = context.getExtension("WEBGL_lose_context");
                if (loseContext) {
                    loseContext.loseContext();
                }
                return caps;
            }
        })(WebGL = Capabilities.WebGL || (Capabilities.WebGL = {}));
    })(Capabilities = RS.Capabilities || (RS.Capabilities = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Clipboard;
    (function (Clipboard) {
        // https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
        function fallbackCopyTextToClipboard(text) {
            var textArea = document.createElement("textarea");
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                var successful = document.execCommand('copy');
                if (!successful) {
                    throw new Error("Copy command failed");
                }
            }
            finally {
                document.body.removeChild(textArea);
            }
        }
        function writeText(text) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!navigator["clipboard"]) {
                                fallbackCopyTextToClipboard(text);
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, navigator["clipboard"]["writeText"](text)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        Clipboard.writeText = writeText;
    })(Clipboard = RS.Clipboard || (RS.Clipboard = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Is;
    (function (Is) {
        /**
         * Gets if the specified value implements ICloneable
         * @param value
         */
        function cloneable(value) {
            return Is.func(value.clone) && Is.nonPrimitive(value);
        }
        Is.cloneable = cloneable;
    })(Is = RS.Is || (RS.Is = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    /** @internal */
    var __eventObjectHash = Math.random();
    var Is;
    (function (Is) {
        function event(value) {
            return value != null &&
                Is.func(value.once) &&
                Is.func(value.off) &&
                Is.func(value.has) &&
                value.__isObjectFunction &&
                value.__eventObjectHash === __eventObjectHash;
        }
        Is.event = event;
    })(Is = RS.Is || (RS.Is = {}));
    var Event;
    (function (Event) {
        /** Creates an event that is published when any of the given events is published. */
        function any(events) {
            var result = createEvent();
            var listeners = events.map(function (ev, index) {
                return ev(function (data) { return result.publish({ index: index, data: data }); });
            });
            var oldDispose = result.dispose;
            result.dispose = function () {
                if (this.isDisposed) {
                    return;
                }
                listeners.forEach(function (l) { return l.dispose(); });
                oldDispose();
            };
            return result;
        }
        Event.any = any;
    })(Event = RS.Event || (RS.Event = {}));
    function createEvent(watched, async) {
        return createEventInternal(watched, async);
    }
    RS.createEvent = createEvent;
    function createSimpleEvent(watched, async) {
        return createEventInternal(watched, async);
    }
    RS.createSimpleEvent = createSimpleEvent;
    function createEventInternal(watched, async) {
        var baseEvent;
        if (watched) {
            baseEvent = new WatchedEvent();
        }
        else {
            baseEvent = new InternalEvent();
        }
        var func = baseEvent.on.bind(baseEvent);
        func._event = baseEvent;
        func.once = baseEvent.once.bind(baseEvent);
        func.off = baseEvent.off.bind(baseEvent);
        func.has = baseEvent.has.bind(baseEvent);
        func.publish = async ? baseEvent.publishAsync.bind(baseEvent) : baseEvent.publish.bind(baseEvent);
        func.then = baseEvent.then.bind(baseEvent);
        func.dispose = baseEvent.dispose.bind(baseEvent);
        func.clone = baseEvent.clone.bind(baseEvent);
        Object.defineProperties(func, {
            public: { value: func },
            isDisposed: { get: function () { return baseEvent.isDisposed; } },
            __isObjectFunction: { value: true },
            __eventObjectHash: { value: __eventObjectHash }
        });
        if (watched) {
            Object.defineProperties(func, { listenerCount: { value: baseEvent.listenerCount } });
        }
        return func;
    }
    var EventListener = /** @class */ (function () {
        function EventListener(_event, _callback) {
            this._event = _event;
            this._callback = _callback;
        }
        var _propObj = {};

        _propObj.isDisposed = {
            get: function () { return this._event.isDisposed || !this._event.has(this._callback); },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(EventListener.prototype, _propObj);
        EventListener.prototype.dispose = function () { if (this._event.isDisposed) {
            return;
        } this._event.off(this._callback); };
        return EventListener;
    }());
    var InternalEvent = /** @class */ (function () {
        function InternalEvent() {
            this._inPublish = 0;
            this._handlers = [];
            this._isDisposed = false;
        }
        var _propObj = {};

        _propObj.isDisposed = {
            get: function () { return this._isDisposed; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(InternalEvent.prototype, _propObj);
        InternalEvent.prototype.clone = function () {
            return createEvent();
        };
        InternalEvent.prototype.dispose = function () {
            if (this._isDisposed) {
                return;
            }
            this._handlers.length = 0;
            this._handlers = null;
            this._isDisposed = true;
        };
        /**
         * Adds a listener to this event that only fires once.
         * @param handler
         */
        InternalEvent.prototype.once = function (handler) {
            return this.on(handler, true);
        };
        /**
         * Adds a listener to this event.
         * @param handler
         */
        InternalEvent.prototype.on = function (handler, once) {
            if (once === void 0) { once = false; }
            if (this._isDisposed) {
                throw new Error("Attempt to add handler when event was disposed");
            }
            this._handlers.push({ handler: handler, once: once });
            return new EventListener(this, handler);
        };
        /**
         * Removes a listener from this event.
         * @param handler
         */
        InternalEvent.prototype.off = function (handler) {
            for (var i = 0, l = this._handlers.length; i < l; ++i) {
                if (this._handlers[i] != null && this._handlers[i].handler === handler) {
                    if (this._inPublish > 0) {
                        this._handlers[i] = null;
                    }
                    else {
                        this._handlers.splice(i, 1);
                    }
                    break;
                }
            }
        };
        /**
         * Gets if the specified callback is a listener of this event.
         */
        InternalEvent.prototype.has = function (handler) {
            for (var i = 0, l = this._handlers.length; i < l; ++i) {
                if (this._handlers[i] != null && this._handlers[i].handler === handler) {
                    return true;
                }
            }
            return false;
        };
        /**
         * Schedules this event to be published.
         * @param data
         */
        InternalEvent.prototype.publishAsync = function (data) {
            setTimeout(this.publish.bind(this, data), 0);
        };
        /**
         * Triggers this event.
         * @param data
         */
        InternalEvent.prototype.publish = function (data) {
            if (this._isDisposed) {
                throw new Error("Attempt to publish event when event was disposed");
            }
            // Early out; avoid loop overheads etc.
            if (this._handlers.length === 0) {
                return;
            }
            ++this._inPublish;
            for (var i = 0, l = this._handlers.length; i < l; ++i) {
                var handlerData = this._handlers[i];
                if (handlerData != null) {
                    handlerData.handler(data);
                    // Return if handler dispos
                    if (this._isDisposed) {
                        return;
                    }
                    if (handlerData.once) {
                        this.off(handlerData.handler);
                    }
                }
            }
            --this._inPublish;
            if (this._inPublish === 0) {
                for (var i = this._handlers.length - 1; i >= 0; --i) {
                    if (this._handlers[i] == null) {
                        this._handlers.splice(i, 1);
                    }
                }
            }
        };
        /**
         * Attaches callbacks for the resolution and/or rejection of the Promise.
         * @param onfulfilled The callback to execute when the Promise is resolved.
         * @param onrejected The callback to execute when the Promise is rejected.
         * @returns A Promise for the completion of which ever callback is executed.
         */
        InternalEvent.prototype.then = function (onfulfilled, onrejected) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                if (_this.isDisposed) {
                    resolve(null);
                    return;
                }
                _this.once(function (data) {
                    onfulfilled(data);
                    resolve(null);
                });
            });
        };
        return InternalEvent;
    }());
    var WatchedEvent = /** @class */ (function (_super) {
        __extends(WatchedEvent, _super);
        function WatchedEvent() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.listenerCount = new RS.Observable(0);
            return _this;
        }
        WatchedEvent.prototype.clone = function () {
            return createEvent(true);
        };
        WatchedEvent.prototype.dispose = function () {
            if (this._isDisposed) {
                return;
            }
            this.listenerCount.dispose();
            _super.prototype.dispose.call(this);
        };
        /**
         * Adds a listener to this event.
         * @param handler
         */
        WatchedEvent.prototype.on = function (handler, once) {
            if (once === void 0) { once = false; }
            var listener = _super.prototype.on.call(this, handler, once);
            this.updateListenerCount();
            return listener;
        };
        /**
         * Removes a listener from this event.
         * @param handler
         */
        WatchedEvent.prototype.off = function (handler) {
            _super.prototype.off.call(this, handler);
            this.updateListenerCount();
        };
        WatchedEvent.prototype.updateListenerCount = function () {
            this.listenerCount.value = this._handlers.reduce(function (a, b) { return b != null ? a + 1 : a; }, 0);
        };
        return WatchedEvent;
    }(InternalEvent));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Logging;
    (function (Logging) {
        /**
         * Defines the available logging levels.
         */
        var LogLevel;
        (function (LogLevel) {
            /** Used to show debug information. */
            LogLevel[LogLevel.Debug = 0] = "Debug";
            /** Used to show general information. */
            LogLevel[LogLevel.Info = 1] = "Info";
            /** Used to show a warning. */
            LogLevel[LogLevel.Warn = 2] = "Warn";
            /** Used to show an error. */
            LogLevel[LogLevel.Error = 3] = "Error";
            /** Used to show a fatal error. */
            LogLevel[LogLevel.Fatal = 4] = "Fatal";
            /** Use with setLogLevel to turn logging off altogether. */
            LogLevel[LogLevel.None = 5] = "None";
        })(LogLevel = Logging.LogLevel || (Logging.LogLevel = {}));
        (function (LogLevel) {
            LogLevel.Default = LogLevel.Info;
            LogLevel.DefaultMinimum = LogLevel.Info;
        })(LogLevel = Logging.LogLevel || (Logging.LogLevel = {}));
    })(Logging = RS.Logging || (RS.Logging = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Strategy;
    (function (Strategy) {
        function declare(type, suppressErrors, allowOverrides, extensions) {
            if (type === void 0) { type = Type.Instance; }
            if (suppressErrors === void 0) { suppressErrors = false; }
            if (allowOverrides === void 0) { allowOverrides = false; }
            if (RS.Is.boolean(allowOverrides)) {
                allowOverrides = allowOverrides ? Overridable.Always : Overridable.Never;
            }
            switch (type) {
                case Type.Instance:
                    return new FactoryProvider(!suppressErrors, allowOverrides, extensions);
                case Type.Singleton:
                    return new SingletonProvider(!suppressErrors, allowOverrides, extensions);
                default:
                    return null;
            }
        }
        Strategy.declare = declare;
        /**
         * Defines the type of a strategy.
         */
        var Type;
        (function (Type) {
            /** Strategies are independent instances. */
            Type[Type.Instance = 0] = "Instance";
            /** Strategies are a single shared instance. */
            Type[Type.Singleton = 1] = "Singleton";
        })(Type = Strategy.Type || (Strategy.Type = {}));
        var Overridable;
        (function (Overridable) {
            /** Disallow overriding entirely. */
            Overridable[Overridable.Never = 0] = "Never";
            /** Allow overriding only if get() has not yet been called. */
            Overridable[Overridable.BeforeUse = 1] = "BeforeUse";
            /** Allow overriding at any time. */
            Overridable[Overridable.Always = 2] = "Always";
        })(Overridable = Strategy.Overridable || (Strategy.Overridable = {}));
        // Private implementation //
        var BaseProvider = /** @class */ (function () {
            function BaseProvider(errorIfNull, overridable, extensions) {
                this._class = null;
                this._errorIfNull = errorIfNull;
                this._overridable = overridable;
                this._extensions = extensions;
                this._hasBeenUsed = false;
                this._isClassDefault = false;
            }
            BaseProvider.prototype.register = function (cl, asDefault) {
                if (asDefault === void 0) { asDefault = false; }
                if (cl == null) {
                    throw new Error("Tried to register null concrete implementation for strategy");
                }
                if (cl === this._baseClass) {
                    return;
                }
                if (asDefault) {
                    if (this._class) {
                        if (this._isClassDefault) {
                            throw new Error("Tried to register default concrete implementation for strategy when one was already registered");
                        }
                        else {
                            throw new Error("Tried to register default concrete implementation for strategy after a non-default implementation was registered");
                        }
                    }
                }
                else {
                    if (this._class != null) {
                        switch (this._overridable) {
                            case Overridable.Never:
                                {
                                    if (!this._isClassDefault) {
                                        throw new Error("Tried to register concrete implementation for strategy when one was already registered");
                                    }
                                    // Fall through to Overridable.BeforeUse behaviour if set to default
                                }
                            case Overridable.BeforeUse:
                                {
                                    if (this._hasBeenUsed) {
                                        throw new Error("Tried to register concrete implementation for strategy which had already been accessed");
                                    }
                                }
                        }
                    }
                }
                this._isClassDefault = asDefault;
                this._baseClass = cl;
                this._class = this._extensions ? this.applyExtensions(cl) : cl;
            };
            BaseProvider.prototype.get = function () {
                if (this._class == null) {
                    if (!this._errorIfNull) {
                        return null;
                    }
                    throw new Error("Tried to instantiate strategy which is not backed by a concrete implementation");
                }
                var inst = this.getInstance();
                this._hasBeenUsed = true;
                return inst;
            };
            BaseProvider.prototype.applyExtensions = function (target) {
                var BaseClass = target;
                var ExtendedClass = /** @class */ (function (_super) {
                    __extends(ExtendedClass, _super);
                    function ExtendedClass() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    return ExtendedClass;
                }(BaseClass));
                var extensions = this._extensions;
                for (var key in extensions) {
                    var extension = extensions[key];
                    if (RS.Is.func(extension)) {
                        ExtendedClass.prototype[key] = extension;
                    }
                    else {
                        var desc = {};
                        if (extension.get) {
                            desc.get = extension.get;
                        }
                        if (extension.set) {
                            desc.set = extension.set;
                        }
                        if (extension.value) {
                            desc.set = extension.value;
                        }
                        Object.defineProperty(ExtendedClass.prototype, key, desc);
                    }
                }
                return ExtendedClass;
            };
            return BaseProvider;
        }());
        var FactoryProvider = /** @class */ (function (_super) {
            __extends(FactoryProvider, _super);
            function FactoryProvider() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            FactoryProvider.prototype.getInstance = function () {
                return new this._class();
            };
            return FactoryProvider;
        }(BaseProvider));
        var SingletonProvider = /** @class */ (function (_super) {
            __extends(SingletonProvider, _super);
            function SingletonProvider() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this._instance = null;
                return _this;
            }
            SingletonProvider.prototype.getInstance = function () {
                return this._instance || (this._instance = new this._class());
            };
            /** Registers the specified class as a concrete class of this factory. */
            SingletonProvider.prototype.register = function (cl, asDefault) {
                _super.prototype.register.call(this, cl, asDefault);
                if (this._instance) {
                    if (RS.Is.disposable(this._instance)) {
                        this._instance.dispose();
                    }
                    this._instance = null;
                }
            };
            return SingletonProvider;
        }(BaseProvider));
    })(Strategy = RS.Strategy || (RS.Strategy = {}));
})(RS || (RS = {}));
/// <reference path="LogLevel.ts" />
/// <reference path="../Strategy.ts" />
var RS;
(function (RS) {
    var Logging;
    (function (Logging) {
        var extensions = {
            /** Short-hand for log(message, LogLevel.Warn). */
            warn: function (message) {
                this.log(message, Logging.LogLevel.Warn);
            },
            /** Short-hand for log(message, LogLevel.Info). */
            info: function (message) {
                this.log(message, Logging.LogLevel.Info);
            },
            /** Short-hand for log(message, LogLevel.Debug). */
            debug: function (message) {
                this.log(message, Logging.LogLevel.Debug);
            },
            /** Short-hand for log(message, LogLevel.Error). */
            error: function (p2, nestedError) {
                if (nestedError != null) {
                    // Get stack trace
                    var stack = nestedError && RS.Is.string(nestedError.stack) ? nestedError.stack.replace(/(.*)\n/, "") : RS.Util.getStackTrace(1);
                    var stackLines = stack ? "\n".concat(stack) : stack;
                    // Get nested message
                    var nestedMessage = RS.Util.getErrorMessage(nestedError);
                    var message = nestedMessage ? "".concat(p2, ": ").concat(nestedMessage).concat(stackLines) : "".concat(p2).concat(stackLines);
                    this.log(message, Logging.LogLevel.Error, true);
                }
                else {
                    // Get stack trace (excluding this call)
                    var stack = RS.Util.getStackTrace(1);
                    var stackLines = stack ? "\n".concat(stack) : stack;
                    this.log("".concat(p2).concat(stackLines), Logging.LogLevel.Error, true);
                }
            }
        };
        Logging.ILogger = RS.Strategy.declare(RS.Strategy.Type.Singleton, undefined, true, extensions);
        Logging.IContextualLogger = RS.Strategy.declare(RS.Strategy.Type.Instance, undefined, true, extensions);
        function getContext() {
            var names = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                names[_i] = arguments[_i];
            }
            var context = Logging.ILogger.get();
            for (var _a = 0, names_1 = names; _a < names_1.length; _a++) {
                var name_2 = names_1[_a];
                context = context.getContext(name_2);
                if (!context) {
                    return null;
                }
            }
            return context;
        }
        Logging.getContext = getContext;
    })(Logging = RS.Logging || (RS.Logging = {}));
})(RS || (RS = {}));
(function (RS) {
    RS.ILogger = RS.Logging.ILogger;
})(RS || (RS = {}));
/// <reference path="ILogger.ts" />
/**
 * Easy-access methods for logging.
 */
var RS;
(function (RS) {
    var Log;
    (function (Log) {
        /**
         * Logs a debug message.
         * @param message
         */
        function debug(message) {
            RS.Logging.ILogger.get().debug(message);
        }
        Log.debug = debug;
        /**
         * Logs an informative message.
         * @param message
         */
        function info(message) {
            RS.Logging.ILogger.get().info(message);
        }
        Log.info = info;
        /**
         * Logs an warning message.
         * @param message
         */
        function warn(message) {
            RS.Logging.ILogger.get().warn(message);
        }
        Log.warn = warn;
        function error(p1, p2) {
            if (RS.Is.string(p1)) {
                RS.Logging.ILogger.get().error(p1, p2);
            }
            else {
                RS.Logging.ILogger.get().error(p1);
            }
        }
        Log.error = error;
    })(Log = RS.Log || (RS.Log = {}));
})(RS || (RS = {}));
/// <reference path="logging/Log.ts" />
var RS;
(function (RS) {
    var initQueue = [];
    /**
     * Specifies that the decorated method should be called once the document is ready.
     */
    function Init(settings) {
        return function (target, key, descriptor) {
            if (descriptor == null) {
                descriptor = Object.getOwnPropertyDescriptor(target, key);
            }
            var holder = target.constructor === Function ? target : target.constructor.prototype;
            // initQueue.push({ func: <()=>void>holder[key], target: holder, after: (settings && settings.after) || [] });
            initQueue.push({
                func: function () {
                    if (settings && settings.bindCallbacks !== false) {
                        RS.bindCallbacks(holder, RS.Decorators.MemberType.Static);
                    }
                    holder[key]();
                },
                target: holder
            });
        };
    }
    RS.Init = Init;
    /**
     * Adds a callback to be called when inits are triggered.
     * @param func
     * @param settings
     */
    function addInitCallback(func, settings) {
        initQueue.push({
            func: func,
            target: null
        });
    }
    RS.addInitCallback = addInitCallback;
    /**
     * Calls all pending inits (methods marked with the @Init decorator).
     */
    function triggerInits() {
        while (initQueue.length > 0) {
            try {
                var item = initQueue.shift();
                item.func.call(item.target || window);
            }
            catch (err) {
                RS.Log.error(err);
            }
        }
    }
    RS.triggerInits = triggerInits;
    /**
     * Gets the number of pending inits (methods marked with the @Init decorator).
     */
    function getPendingInitCount() {
        return initQueue.length;
    }
    RS.getPendingInitCount = getPendingInitCount;
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Decorators;
    (function (Decorators) {
        /**
         * Creates new empty metadata.
         */
        function createMetadata() {
            return {
                tags: [],
                methods: {},
                properties: {},
                staticMethods: {},
                staticProperties: {}
            };
        }
        /**
         * Gets, or creates if not found, blank metadata for the specified class or class instance.
         * Does NOT consider inheritance.
         * @param target
         */
        function getMetadata(target, createIfNotFound) {
            if (createIfNotFound === void 0) { createIfNotFound = true; }
            if (RS.Is.func(target)) {
                var baseClass = Object.getPrototypeOf(target);
                var targetEx = target;
                if (targetEx._metadata == null || targetEx._metadata === baseClass._metadata) {
                    if (!createIfNotFound) {
                        return null;
                    }
                    targetEx._metadata = createMetadata();
                }
                return targetEx._metadata;
            }
            else {
                var ctor = Object.getPrototypeOf(target).constructor;
                if (RS.Is.func(ctor)) {
                    return getMetadata(ctor, createIfNotFound);
                }
                else {
                    return null;
                }
            }
        }
        Decorators.getMetadata = getMetadata;
        /**
         * Reads metadata for the given class or class instance.
         * Considers inheritance and flattens inherited metadata.
         * @param target
         */
        function readMetadata(target) {
            if (RS.Is.func(target)) {
                var newMetadata = createMetadata();
                var chain = RS.Util.getInheritanceChain(target, true);
                for (var _i = 0, chain_1 = chain; _i < chain_1.length; _i++) {
                    var ctor = chain_1[_i];
                    var metadata = getMetadata(ctor, false);
                    if (metadata != null) {
                        mergeTags(metadata.tags, newMetadata.tags);
                        for (var methodName in metadata.methods) {
                            if (newMetadata.methods[methodName] == null) {
                                newMetadata.methods[methodName] = { tags: [], parameters: [] };
                            }
                            mergeTags(metadata.methods[methodName].tags, newMetadata.methods[methodName].tags);
                            mergeParams(metadata.methods[methodName].parameters, newMetadata.methods[methodName].parameters);
                        }
                        for (var propertyName in metadata.properties) {
                            if (newMetadata.properties[propertyName] == null) {
                                newMetadata.properties[propertyName] = { tags: [] };
                            }
                            mergeTags(metadata.properties[propertyName].tags, newMetadata.properties[propertyName].tags);
                        }
                        for (var methodName in metadata.staticMethods) {
                            if (newMetadata.staticMethods[methodName] == null) {
                                newMetadata.staticMethods[methodName] = { tags: [], parameters: [] };
                            }
                            mergeTags(metadata.staticMethods[methodName].tags, newMetadata.staticMethods[methodName].tags);
                            mergeParams(metadata.staticMethods[methodName].parameters, newMetadata.staticMethods[methodName].parameters);
                        }
                        for (var propertyName in metadata.staticProperties) {
                            if (newMetadata.staticProperties[propertyName] == null) {
                                newMetadata.staticProperties[propertyName] = { tags: [] };
                            }
                            mergeTags(metadata.staticProperties[propertyName].tags, newMetadata.staticProperties[propertyName].tags);
                        }
                    }
                }
                return newMetadata;
            }
            else {
                var ctor = Object.getPrototypeOf(target).constructor;
                if (RS.Is.func(ctor)) {
                    return readMetadata(ctor);
                }
                else {
                    return null;
                }
            }
        }
        Decorators.readMetadata = readMetadata;
        /**
         * Merges src params into dst params, taking care not to override any.
         * @param src
         * @param dst
         */
        function mergeParams(src, dst) {
            for (var paramIndex in src) {
                if (!src[paramIndex]) {
                    continue;
                }
                if (!dst[paramIndex]) {
                    dst[paramIndex] = [];
                }
                mergeTags(src[paramIndex], dst[paramIndex]);
            }
        }
        /**
         * Merges src tags into dst tags, taking care not to override any.
         * @param src
         * @param dst
         */
        function mergeTags(src, dst) {
            for (var i = 0, l = src.length; i < l; ++i) {
                if (dst[i] == null) {
                    dst[i] = src[i];
                }
            }
        }
    })(Decorators = RS.Decorators || (RS.Decorators = {}));
})(RS || (RS = {}));
/// <reference path="Metadata.ts" />
var RS;
(function (RS) {
    var Decorators;
    (function (Decorators) {
        var TagKind;
        (function (TagKind) {
            TagKind[TagKind.Class = 0] = "Class";
            TagKind[TagKind.Method = 1] = "Method";
            TagKind[TagKind.Property = 2] = "Property";
            TagKind[TagKind.Parameter = 3] = "Parameter";
        })(TagKind = Decorators.TagKind || (Decorators.TagKind = {}));
        var MemberType;
        (function (MemberType) {
            MemberType[MemberType.Static = 0] = "Static";
            MemberType[MemberType.Instance = 1] = "Instance";
        })(MemberType = Decorators.MemberType || (Decorators.MemberType = {}));
        var Tag;
        (function (Tag) {
            var _a;
            var nextTagID = (_a = {},
                _a[TagKind.Class] = 0,
                _a[TagKind.Method] = 0,
                _a[TagKind.Property] = 0,
                _a[TagKind.Parameter] = 0,
                _a);
            /**
             * Creates a new tag.
             */
            function create(kind, ctorModifier) {
                var tagID = nextTagID[kind]++;
                switch (kind) {
                    case TagKind.Class:
                        {
                            var appliedInitial_1 = RS.createEvent();
                            var applied_1 = RS.createEvent();
                            var decorator_1 = function (value) {
                                return function (target) {
                                    // target is the constructor of the class
                                    var metadata = Decorators.getMetadata(target, true);
                                    metadata.tags[tagID] = value;
                                    if (ctorModifier) {
                                        target = ctorModifier(target) || target;
                                    }
                                    if (decorator_1.classes.indexOf(target) === -1) {
                                        decorator_1.classes.push(target);
                                        appliedInitial_1.publish(target);
                                    }
                                    applied_1.publish({ target: target, cl: target, val: value });
                                    return target;
                                };
                            };
                            decorator_1.kind = kind;
                            decorator_1.get = function (obj) {
                                var metadata = Decorators.readMetadata(obj);
                                return metadata.tags[tagID];
                            };
                            decorator_1.classes = [];
                            decorator_1.getClassesWithTag = function (value) {
                                return this.classes.filter(function (c) { return decorator_1.get(c) === value; });
                            };
                            decorator_1.onAppliedInitial = appliedInitial_1.public;
                            decorator_1.onApplied = applied_1.public;
                            decorator_1.withData = true;
                            return decorator_1;
                        }
                    case TagKind.Method:
                        {
                            var appliedInitial_2 = RS.createEvent();
                            var applied_2 = RS.createEvent();
                            var decorator_2 = function (value) {
                                return function (target, propertyKey, descriptor) {
                                    if (RS.Is.func(target)) {
                                        // STATIC METHOD: target is the constructor of the class
                                        // Update metadata
                                        var metadata = Decorators.getMetadata(target, true);
                                        if (metadata.staticMethods[propertyKey] == null) {
                                            metadata.staticMethods[propertyKey] = { tags: [], parameters: [] };
                                        }
                                        metadata.staticMethods[propertyKey].tags[tagID] = value;
                                        // Update decorator
                                        if (decorator_2.classes.indexOf(target) === -1) {
                                            decorator_2.classes.push(target);
                                            appliedInitial_2.publish(target);
                                        }
                                        applied_2.publish({ target: target, cl: target, func: target[propertyKey], key: propertyKey, val: value });
                                    }
                                    else {
                                        // INSTANCE METHOD: target is the prototype of the class
                                        // Update metadata
                                        var metadata = Decorators.getMetadata(target.constructor, true);
                                        if (metadata.methods[propertyKey] == null) {
                                            metadata.methods[propertyKey] = { tags: [], parameters: [] };
                                        }
                                        metadata.methods[propertyKey].tags[tagID] = value;
                                        // Update decorator
                                        if (decorator_2.classes.indexOf(target.constructor) === -1) {
                                            decorator_2.classes.push(target.constructor);
                                            appliedInitial_2.publish(target.constructor);
                                        }
                                        applied_2.publish({ target: target, cl: target.constructor, func: target[propertyKey], key: propertyKey, val: value });
                                    }
                                    // In case the property descriptor was updated.
                                    return Object.getOwnPropertyDescriptor(target, propertyKey);
                                };
                            };
                            decorator_2.kind = kind;
                            // Metadata getter
                            decorator_2.get = function (obj, type) {
                                var metadata = Decorators.readMetadata(obj);
                                var result = {};
                                var src = type === MemberType.Instance ? metadata.methods : metadata.staticMethods;
                                for (var methodName in src) {
                                    if (src[methodName] != null) {
                                        var tagValue = src[methodName].tags[tagID];
                                        if (tagValue != null) {
                                            result[methodName] = tagValue;
                                        }
                                    }
                                }
                                return result;
                            };
                            decorator_2.classes = [];
                            decorator_2.onAppliedInitial = appliedInitial_2.public;
                            decorator_2.onApplied = applied_2.public;
                            decorator_2.withData = true;
                            return decorator_2;
                        }
                    case TagKind.Property:
                        {
                            var appliedInitial_3 = RS.createEvent();
                            var applied_3 = RS.createEvent();
                            var decorator_3 = function (value) {
                                return function (target, propertyKey) {
                                    if (RS.Is.func(target)) {
                                        // STATIC METHOD: target is the constructor of the class
                                        // Update metadata
                                        var metadata = Decorators.getMetadata(target, true);
                                        if (metadata.staticProperties[propertyKey] == null) {
                                            metadata.staticProperties[propertyKey] = { tags: [] };
                                        }
                                        metadata.staticProperties[propertyKey].tags[tagID] = value;
                                        // Update decorator
                                        if (decorator_3.classes.indexOf(target) === -1) {
                                            decorator_3.classes.push(target);
                                            appliedInitial_3.publish(target);
                                        }
                                        applied_3.publish({ target: target, cl: target, prop: Object.getOwnPropertyDescriptor(target, propertyKey), key: propertyKey, val: value });
                                    }
                                    else {
                                        // INSTANCE METHOD: target is the prototype of the class
                                        // Update metadata
                                        var metadata = Decorators.getMetadata(target.constructor, true);
                                        if (metadata.properties[propertyKey] == null) {
                                            metadata.properties[propertyKey] = { tags: [] };
                                        }
                                        metadata.properties[propertyKey].tags[tagID] = value;
                                        // Update decorator
                                        if (decorator_3.classes.indexOf(target.constructor) === -1) {
                                            decorator_3.classes.push(target.constructor);
                                            appliedInitial_3.publish(target.constructor);
                                        }
                                        applied_3.publish({ target: target, cl: target.constructor, prop: Object.getOwnPropertyDescriptor(target.constructor, propertyKey), key: propertyKey, val: value });
                                    }
                                    // In case the property descriptor was updated.
                                    return Object.getOwnPropertyDescriptor(target, propertyKey);
                                };
                            };
                            decorator_3.kind = kind;
                            // Metadata getter
                            decorator_3.get = function (obj, type) {
                                var metadata = Decorators.readMetadata(obj);
                                var result = {};
                                var src = type === MemberType.Instance ? metadata.properties : metadata.staticProperties;
                                for (var propertyName in src) {
                                    if (src[propertyName] != null) {
                                        var tagValue = src[propertyName].tags[tagID];
                                        if (tagValue != null) {
                                            result[propertyName] = tagValue;
                                        }
                                    }
                                }
                                return result;
                            };
                            decorator_3.classes = [];
                            decorator_3.onAppliedInitial = appliedInitial_3.public;
                            decorator_3.onApplied = applied_3.public;
                            decorator_3.withData = true;
                            return decorator_3;
                        }
                    case TagKind.Parameter:
                        {
                            var appliedInitial_4 = RS.createEvent();
                            var applied_4 = RS.createEvent();
                            var decorator_4 = function (value) {
                                return function (target, propertyKey, parameterIndex) {
                                    if (RS.Is.func(target)) {
                                        // STATIC METHOD: target is the constructor of the class
                                        // Update metadata
                                        var metadata = Decorators.getMetadata(target, true);
                                        if (metadata.staticMethods[propertyKey] == null) {
                                            metadata.staticMethods[propertyKey] = { tags: [], parameters: [] };
                                        }
                                        if (metadata.staticMethods[propertyKey].parameters[parameterIndex] == null) {
                                            metadata.staticMethods[propertyKey].parameters[parameterIndex] = [];
                                        }
                                        metadata.staticMethods[propertyKey].parameters[parameterIndex][tagID] = value;
                                        // Update decorator
                                        if (decorator_4.classes.indexOf(target) === -1) {
                                            decorator_4.classes.push(target);
                                            appliedInitial_4.publish(target);
                                        }
                                        applied_4.publish({ target: target, cl: target, func: target[propertyKey], key: propertyKey, index: parameterIndex, val: value });
                                    }
                                    else {
                                        // INSTANCE METHOD: target is the prototype of the class
                                        // Update metadata
                                        var metadata = Decorators.getMetadata(target.constructor, true);
                                        if (metadata.methods[propertyKey] == null) {
                                            metadata.methods[propertyKey] = { tags: [], parameters: [] };
                                        }
                                        if (metadata.methods[propertyKey].parameters[parameterIndex] == null) {
                                            metadata.methods[propertyKey].parameters[parameterIndex] = [];
                                        }
                                        metadata.methods[propertyKey].parameters[parameterIndex][tagID] = value;
                                        // Update decorator
                                        if (decorator_4.classes.indexOf(target.constructor) === -1) {
                                            decorator_4.classes.push(target.constructor);
                                            appliedInitial_4.publish(target.constructor);
                                        }
                                        applied_4.publish({ target: target, cl: target.constructor, func: target[propertyKey], key: propertyKey, index: parameterIndex, val: value });
                                    }
                                    // In case the property descriptor was updated.
                                    return Object.getOwnPropertyDescriptor(target, propertyKey);
                                };
                            };
                            decorator_4.kind = kind;
                            // Metadata getter
                            decorator_4.get = function (obj, type, methodName) {
                                var metadata = Decorators.readMetadata(obj);
                                var result = {};
                                var src = type === MemberType.Instance ? metadata.methods : metadata.staticMethods;
                                if (src[methodName] != null) {
                                    for (var parameterIndex in src[methodName].parameters) {
                                        if (src[methodName].parameters[parameterIndex] != null) {
                                            var tagValue = src[methodName].parameters[parameterIndex][tagID];
                                            if (tagValue != null) {
                                                result[parameterIndex] = tagValue;
                                            }
                                        }
                                    }
                                }
                                return result;
                            };
                            decorator_4.classes = [];
                            decorator_4.onAppliedInitial = appliedInitial_4.public;
                            decorator_4.onApplied = applied_4.public;
                            decorator_4.withData = true;
                            return decorator_4;
                        }
                    default:
                        throw new Error("Invalid or unhandled tag kind '".concat(kind, "'"));
                }
            }
            Tag.create = create;
            /**
             * Creates a new dataless tag.
             */
            function createDataless(kind, ctorModifier) {
                var baseTag = kind === TagKind.Class ? create(kind, ctorModifier) : create(kind);
                switch (baseTag.kind) {
                    case TagKind.Class:
                        {
                            var decorator = function (target) {
                                return baseTag(true)(target);
                            };
                            decorator.kind = baseTag.kind;
                            decorator.get = function (obj) {
                                return baseTag.get(obj) || false;
                            };
                            decorator.classes = baseTag.classes;
                            decorator.onAppliedInitial = baseTag.onAppliedInitial;
                            decorator.onApplied = baseTag.onApplied;
                            decorator.withData = false;
                            return decorator;
                        }
                    case TagKind.Method:
                        {
                            var decorator = function (target, propertyKey, descriptor) {
                                return baseTag(true)(target, propertyKey, descriptor);
                            };
                            decorator.kind = baseTag.kind;
                            decorator.get = function (obj, type) {
                                var dataMap = baseTag.get(obj, type);
                                return Object.keys(dataMap);
                            };
                            decorator.classes = baseTag.classes;
                            decorator.onAppliedInitial = baseTag.onAppliedInitial;
                            decorator.onApplied = baseTag.onApplied;
                            decorator.withData = false;
                            return decorator;
                        }
                    case TagKind.Property:
                        {
                            var decorator = function (target, propertyKey) {
                                return baseTag(true)(target, propertyKey);
                            };
                            decorator.kind = baseTag.kind;
                            decorator.get = function (obj, type) {
                                var dataMap = baseTag.get(obj, type);
                                return Object.keys(dataMap);
                            };
                            decorator.classes = baseTag.classes;
                            decorator.onAppliedInitial = baseTag.onAppliedInitial;
                            decorator.onApplied = baseTag.onApplied;
                            decorator.withData = false;
                            return decorator;
                        }
                    case TagKind.Parameter:
                        {
                            var decorator = function (target, propertyKey, parameterIndex) {
                                return baseTag(true)(target, propertyKey, parameterIndex);
                            };
                            decorator.kind = baseTag.kind;
                            decorator.get = function (obj, type, method) {
                                var dataMap = baseTag.get(obj, type, method);
                                return Object.keys(dataMap)
                                    .map(function (key) { return parseInt(key); });
                            };
                            decorator.classes = baseTag.classes;
                            decorator.onAppliedInitial = baseTag.onAppliedInitial;
                            decorator.onApplied = baseTag.onApplied;
                            decorator.withData = false;
                            return decorator;
                        }
                    default: return null;
                }
            }
            Tag.createDataless = createDataless;
        })(Tag = Decorators.Tag || (Decorators.Tag = {}));
    })(Decorators = RS.Decorators || (RS.Decorators = {}));
})(RS || (RS = {}));
/// <reference path="decorators/Tag.ts" />
/// <reference path="Is.ts" />
var RS;
(function (RS) {
    var Is;
    (function (Is) {
        /**
         * Gets if the specified value implements IDisposable.
         * @param value
         */
        function disposable(value) {
            return (Is.object(value) || Is.func(value)) && Is.func(value.dispose) && Is.boolean(value.isDisposed);
        }
        Is.disposable = disposable;
    })(Is = RS.Is || (RS.Is = {}));
    /**
     * Specifies that the specified property or method should cause an error if set/get/called when the instance is disposed.
     * @param target
     * @param propertyKey
     */
    function CheckDisposed(target, propertyKey, propertyDescriptor) {
        if (target.dispose == null) {
            RS.Log.warn("CheckDisposed applied to a property or method within a class that doesn't implement IDisposable");
            return;
        }
        if (propertyDescriptor != null) {
            if (propertyDescriptor.get != null) {
                var oldGet_1 = propertyDescriptor.get;
                propertyDescriptor.get = function () {
                    if (this.isDisposed) {
                        throw new Error("Attempt to get property '".concat(propertyKey, "' when instance was disposed"));
                    }
                    return oldGet_1.call(this);
                };
            }
            if (propertyDescriptor.set != null) {
                var oldSet_1 = propertyDescriptor.set;
                propertyDescriptor.set = function (value) {
                    if (this.isDisposed) {
                        throw new Error("Attempt to set property '".concat(propertyKey, "' when instance was disposed"));
                    }
                    oldSet_1.call(this, value);
                };
            }
            if (propertyDescriptor.value != null && Is.func(propertyDescriptor.value)) {
                var oldFunc_1 = propertyDescriptor.value;
                propertyDescriptor.value = function () {
                    if (this.isDisposed) {
                        throw new Error("Attempt to call method '".concat(propertyKey, "' when instance was disposed"));
                    }
                    return oldFunc_1.apply(this, arguments);
                };
            }
            Object.defineProperty(target, propertyKey, propertyDescriptor);
        }
        else {
            RS.Log.warn("CheckDisposed applied to an invalid property");
        }
    }
    RS.CheckDisposed = CheckDisposed;
    var Disposable;
    (function (Disposable) {
        var key = Object.keys({ __boundDisposables: true })[0];
        /** Binds 'child' to 'parent', such that when parent is disposed, child is also disposed. */
        function bind(child, parent) {
            if (child == null) {
                RS.Log.warn("Cannot dispose null");
                return;
            }
            if (parent.isDisposed) {
                // Immediately dispose child.
                child.dispose();
                return;
            }
            if (parent.__boundDisposables) {
                if (parent.__boundDisposables.indexOf(child) !== -1) {
                    return;
                }
                parent.__boundDisposables.push(child);
            }
            else {
                parent.__boundDisposables = [child];
                if (Is.func(parent)) {
                    // Events etc. We need to capture its dispose and apply it directly to the instance
                    var oldDispose_1 = parent.dispose;
                    parent.dispose = function () {
                        if (this.isDisposed) {
                            return;
                        }
                        oldDispose_1.call(this);
                        var val = this.__boundDisposables;
                        for (var i = 0, l = val.length; i < l; ++i) {
                            var item = val[i];
                            item.dispose();
                            val[i] = null;
                        }
                        val.length = 0;
                        this[key] = null;
                    };
                }
                else {
                    if (parent == null) {
                        throw new Error("Cannot bind disposable to null");
                    }
                    // Apply AutoDispose
                    var decoratedProps = RS.AutoDispose.get(parent, RS.Decorators.MemberType.Instance);
                    if (decoratedProps.indexOf(key) === -1) {
                        var target = parent.constructor.prototype;
                        RS.AutoDispose(target, key);
                    }
                }
            }
        }
        Disposable.bind = bind;
    })(Disposable = RS.Disposable || (RS.Disposable = {}));
    function doAutoDispose(cl) {
        var oldDispose = cl.prototype.dispose;
        cl.prototype.dispose = function () {
            if (!this.isDisposed) {
                oldDispose.call(this);
                for (var _i = 0, _a = RS.AutoDispose.get(this, RS.Decorators.MemberType.Instance); _i < _a.length; _i++) {
                    var key = _a[_i];
                    var val = this[key];
                    if (Is.disposable(val)) {
                        val.dispose();
                        this[key] = null;
                    }
                    if (Is.array(val)) {
                        for (var i = 0, l = val.length; i < l; ++i) {
                            var item = val[i];
                            if (Is.disposable(item)) {
                                item.dispose();
                                val[i] = null;
                            }
                        }
                        val.length = 0;
                        this[key] = null;
                    }
                }
            }
        };
    }
    /**
     * Specifies that the value of the property should be automatically disposed when the owner instance is disposed.
     * For flow elements, will call dispose on all children when disposed.
     * For Arrays, will call dispose on all array elements.
     */
    RS.AutoDispose = RS.Decorators.Tag.createDataless(RS.Decorators.TagKind.Property);
    RS.AutoDispose.onAppliedInitial(doAutoDispose);
    var getAutoDispose = RS.AutoDispose.get;
    RS.AutoDispose.get = function (obj, type) {
        var autoDispose = getAutoDispose(obj, type);
        var autoDisposeOnSet = RS.AutoDisposeOnSet.get(obj, type);
        return autoDispose.concat(autoDisposeOnSet);
    };
    /**
     * Specifies that the value of the property should be automatically disposed when the owner instance is disposed or object reference is changed.
     * For flow elements, will call dispose on all children when disposed.
     * For Arrays, will call dispose on all array elements not shared by the new array.
     */
    RS.AutoDisposeOnSet = RS.Decorators.Tag.createDataless(RS.Decorators.TagKind.Property);
    RS.AutoDisposeOnSet.onAppliedInitial(doAutoDispose);
    RS.AutoDisposeOnSet.onApplied(function (data) {
        var propertyDescriptor = Object.getOwnPropertyDescriptor(data.target, data.key);
        if (propertyDescriptor && !("value" in propertyDescriptor)) {
            // Don't do disposal-on-set for getter-only properties.
            if (!propertyDescriptor.set) {
                return;
            }
            // Getter/setter property.
            if (!propertyDescriptor.get) {
                RS.Log.warn("Attempted to apply AutoDispose to a property without a getter.");
                return;
            }
            var oldSet_2 = propertyDescriptor.set;
            propertyDescriptor.set = function (value) {
                var current = this[data.key];
                if (current === value) {
                    return;
                }
                if (Is.disposable(current) && !current.isDisposed) {
                    current.dispose();
                }
                oldSet_2.call(this, value);
            };
            Object.defineProperty(data.target, data.key, propertyDescriptor);
        }
        else {
            // Normal property, use a closure getter.
            var newPropertyDescriptor = { enumerable: true, configurable: true };
            newPropertyDescriptor.set = function (newValue) {
                var currentValue = this[data.key];
                if (newValue === currentValue) {
                    return;
                }
                if (Is.array(newValue)) {
                    if (Is.disposable(currentValue) && newValue.indexOf(currentValue) === -1) {
                        currentValue.dispose();
                    }
                    if (Is.array(currentValue)) {
                        for (var _i = 0, currentValue_1 = currentValue; _i < currentValue_1.length; _i++) {
                            var member = currentValue_1[_i];
                            if (newValue.indexOf(member) !== -1) {
                                continue;
                            }
                            if (Is.disposable(member)) {
                                member.dispose();
                            }
                        }
                    }
                }
                else {
                    if (Is.disposable(currentValue)) {
                        currentValue.dispose();
                    }
                    if (Is.array(currentValue)) {
                        for (var _a = 0, currentValue_2 = currentValue; _a < currentValue_2.length; _a++) {
                            var member = currentValue_2[_a];
                            if (newValue === member) {
                                continue;
                            }
                            if (Is.disposable(member)) {
                                member.dispose();
                            }
                        }
                    }
                }
                var thisDescriptor = Object.getOwnPropertyDescriptor(data.target, data.key);
                thisDescriptor.get = function () { return newValue; };
                Object.defineProperty(this, data.key, thisDescriptor);
            };
            Object.defineProperty(data.target, data.key, newPropertyDescriptor);
        }
    });
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Util;
    (function (Util) {
        /**
         * Returns a number that can be used to sort two strings.
         * Returns a number greater than 0 if a > b.
         * Returns a number less than 0 if a < b.
         * Returns 0 if a == b.
         */
        function stringCompare(a, b) {
            // We currently return 1, 0 or -1, but this shouldn't be relied upon in general.
            if (a === b) {
                return 0;
            }
            if (a > b) {
                return 1;
            }
            return -1;
        }
        Util.stringCompare = stringCompare;
        /** Sets the prototype of target to prototype. */
        function setPrototypeOf(target, prototype) {
            if (Object.setPrototypeOf) {
                Object.setPrototypeOf(target, prototype);
            }
            else {
                target.__proto__ = prototype;
            }
        }
        Util.setPrototypeOf = setPrototypeOf;
        /** Binds the given function to the given target whilst maintaining type safety. */
        function bind(fn, target) {
            return fn.bind(target);
        }
        Util.bind = bind;
        function call(fn, ctx) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            return fn.apply(ctx, args);
        }
        Util.call = call;
        /** Invokes the given function in the given context using an array of arguments whilst maintaining type safety to the extent possible. */
        function apply(fn, ctx, args) {
            return fn.apply(ctx, args);
        }
        Util.apply = apply;
        /**
         * Tests if the code has been closure compiled.
         * @returns  True if the code has been closure compiled.
         */
        function isClosureCompiled() {
            return RS.Util["isClosureCompiled"] == null;
        }
        Util.isClosureCompiled = isClosureCompiled;
        /**
         * Gets a stack trace of the caller of this function. \
         * NOTE: cannot be relied upon across browsers - use only for debug output.
         *
         * @param startDepth optional depth offset into the stack trace
         * @returns     The stack trace
         */
        function getStackTrace(startDepth) {
            var error = new Error();
            // Limit startDepth to 0, ensure valid, and offset by 3
            startDepth = Math.max((startDepth || 0), 0) + 3;
            // Get stack trace
            var str = error.stack;
            // Remove top 3 items + startDepth
            var arr = str.split("\n");
            startDepth = Math.min(arr.length, startDepth);
            for (var i = 0; i < startDepth; i++) {
                arr.shift();
            }
            // Return it
            return arr.join("\n");
        }
        Util.getStackTrace = getStackTrace;
        /**
         * Converts a thrown value to a string.
         * @param err A thrown value. May be any type, including null or undefined.
         */
        function getErrorMessage(err) {
            if (!err) {
                return "";
            }
            // Can we just get message?
            if (RS.Is.string(err.message)) {
                return err.message;
            }
            // Try to strip any 'error:' prefix.
            var str = "".concat(err);
            var match = str.match(/(error:)(.+)/i);
            if (match) {
                return match[1];
            }
            // Give up and stringify it.
            return str === "[object Object]" ? RS.Dump.stringify(err) : str;
        }
        Util.getErrorMessage = getErrorMessage;
        /** Copies the given constructor, applying a hook function. */
        function hookClass(oldCtor, newCtor) {
            // Create hooked ctor clone with matching name
            var namedCtor = renameFunction(newCtor, oldCtor["name"] || "Object");
            namedCtor.prototype = oldCtor.prototype;
            // Copy static properties/methods
            var oldProps = Object.getOwnPropertyNames(oldCtor);
            for (var _i = 0, oldProps_1 = oldProps; _i < oldProps_1.length; _i++) {
                var propName = oldProps_1[_i];
                if (!(propName in namedCtor)) {
                    var descriptor = Object.getOwnPropertyDescriptor(oldCtor, propName);
                    if (descriptor) {
                        Object.defineProperty(namedCtor, propName, descriptor);
                    }
                    else {
                        namedCtor[propName] = oldCtor[propName];
                    }
                }
            }
            return namedCtor;
        }
        Util.hookClass = hookClass;
        /**
         * Gets the class name of the specified instance. \
         * May be obfuscated if closure compiled. \
         */
        function getClassName(obj) {
            var ctor = obj.constructor;
            return getFunctionName(ctor);
        }
        Util.getClassName = getClassName;
        /**
         * Gets the name of the specified function. \
         * May be obfuscated if closure compiled. \
         * Returns "" for anonymous functions.
         */
        function getFunctionName(fn) {
            var str = fn.toString();
            var match = str.match(/function\s+([^\(\s]*)\(/);
            return match ? match[1] : "";
        }
        Util.getFunctionName = getFunctionName;
        /**
         * Gets the chain of classes that the specified class derives.
         */
        function getInheritanceChain(obj, includeSelf) {
            if (includeSelf === void 0) { includeSelf = false; }
            var result = [];
            var proto = obj.prototype;
            if (includeSelf) {
                result.push(obj);
            }
            while ((proto = Object.getPrototypeOf(proto)) != null && proto !== Function.prototype) {
                result.push(proto.constructor);
            }
            return result;
        }
        Util.getInheritanceChain = getInheritanceChain;
        /**
         * Gathers all properties for the specified class.
         * Considers derived properties from the prototype chain.
         * Will NOT include or traverse further than ignoreBase when considering prototype chain.
         */
        function gatherProperties(obj, ignoreBase) {
            var map = {};
            var inheritanceChain = this.getInheritanceChain(obj);
            inheritanceChain.unshift(obj);
            for (var _i = 0, inheritanceChain_1 = inheritanceChain; _i < inheritanceChain_1.length; _i++) {
                var classObj = inheritanceChain_1[_i];
                if (classObj == ignoreBase) {
                    break;
                }
                var propNames = Object.getOwnPropertyNames(classObj.prototype);
                for (var _a = 0, propNames_1 = propNames; _a < propNames_1.length; _a++) {
                    var key = propNames_1[_a];
                    if (map[key] == null) {
                        var prop = Object.getOwnPropertyDescriptor(classObj.prototype, key);
                        if (prop != null) {
                            map[key] = prop;
                        }
                    }
                }
            }
            return map;
        }
        Util.gatherProperties = gatherProperties;
        /**
         * Creates a copy of function fn with the specified name.
         * @param fn
         * @param name
         */
        function renameFunction(fn, name) {
            return (new Function("return function (call) { return function ".concat(name, "() { return call(this, arguments) }; };"))())(Function.apply.bind(fn));
        }
        Util.renameFunction = renameFunction;
        function assign(from, to, deep) {
            for (var key in from) {
                var val = from[key];
                if (deep && RS.Is.nonPrimitive(val)) {
                    if (RS.Is.cloneable(val)) {
                        // clone should handle recursive assigning of that
                        to[key] = val.clone();
                    }
                    else if (!RS.Is.func(val)) {
                        if (to[key] == null) {
                            var ctor = val.constructor;
                            to[key] = new ctor();
                        }
                        assign(val, to[key], true);
                    }
                    else {
                        // Uncloneable function
                        throw new Error("Unclonable function. Implement a clone() function for key: ".concat(key, "."));
                    }
                }
                else {
                    to[key] = val;
                }
            }
            return to;
        }
        Util.assign = assign;
        /**
         * Returns a clone of "obj".
         * @param obj
         * @param deep
         */
        function clone(obj, deep) {
            if (obj == null || RS.Is.primitive(obj) || RS.Is.func(obj)) {
                return obj;
            }
            var newObj;
            if (RS.Is.cloneable(obj)) {
                newObj = obj.clone();
                return newObj;
            }
            else if (!RS.Is.func(obj)) {
                var ctor = obj.constructor;
                newObj = new ctor();
            }
            else {
                newObj = Object.create(Object.getPrototypeOf(obj));
            }
            return deep ? assign(obj, newObj, true) : assign(obj, newObj, false);
        }
        Util.clone = clone;
        /**
         * Returns all matches of the specified regex within a string.
         * @param regex
         * @param text
         */
        function matchAll(regex, text) {
            var result = [];
            var match;
            if (regex.global) {
                while (match = regex.exec(text)) {
                    result.push(match);
                }
            }
            else {
                match = regex.exec(text);
                if (match) {
                    result.push(match);
                }
            }
            return result;
        }
        Util.matchAll = matchAll;
        var formatCache = {};
        function compileFormat(format) {
            var _a = format.split("."), left = _a[0], right = _a[1];
            var leftDigits = 0;
            for (var i = left.length - 1; i >= 0; --i) {
                if (left[i] === "0") {
                    ++leftDigits;
                }
                else {
                    break;
                }
            }
            var rightDigits = 0;
            if (right != null) {
                for (var _i = 0, right_1 = right; _i < right_1.length; _i++) {
                    var rDigit = right_1[_i];
                    if (rDigit === "0") {
                        ++rightDigits;
                    }
                    else {
                        break;
                    }
                }
            }
            var prepend = left.substr(0, left.length - leftDigits);
            var append = right && right.substr(rightDigits) || "";
            var radix = 10;
            if (prepend.length >= 2 && prepend.substr(prepend.length - 2) === "0x") {
                radix = 16;
                prepend = prepend.substr(0, prepend.length - 2);
            }
            return {
                prepend: prepend,
                append: append,
                leftDigits: leftDigits,
                rightDigits: rightDigits,
                radix: radix,
                decimal: "."
            };
        }
        var tmpStrArr = [];
        /**
         * Repeats a string the specified number of times.
         * @param str
         * @param reps
         */
        function repeat(str, reps) {
            if (reps <= 0) {
                return "";
            }
            tmpStrArr.length = reps;
            for (var i = reps - 1; i >= 0; --i) {
                tmpStrArr[i] = str;
            }
            return tmpStrArr.join("");
        }
        Util.repeat = repeat;
        /**
         * Pads a string by prepending characters until the length of the whole string matches the desired length.
         * @param str
         * @param char
         * @param length
         */
        function padLeft(str, char, length) {
            return "".concat(repeat(char, (length - str.length) / char.length)).concat(str);
        }
        Util.padLeft = padLeft;
        /**
         * Pads a string by appending characters until the length of the whole string matches the desired length.
         * @param str
         * @param char
         * @param length
         */
        function padRight(str, char, length) {
            return "".concat(str).concat(repeat(char, (length - str.length) / char.length));
        }
        Util.padRight = padRight;
        /**
         * Formats a numeric value according to the specified format string.
         * A format string should use '0' to indicate digit and '.' to indicate decimal place.
         *
         * For example, the number 12.34 would format as:
         * - "00.0" => "12.3"
         * - "000.000" => "012.340"
         * - "0" => "12"
         *
         * Special formats are as follows:
         * - "N" => natural format
         * - "0x..." => base 16
         *
         * @param value
         * @param format
         */
        function formatNumber(value, format) {
            if (format === "N") {
                return Number.prototype.toString.call(value);
            }
            var settings = formatCache[format] || (formatCache[format] = compileFormat(format));
            var whole = value | 0;
            var wholeStr;
            if (whole < 0) {
                wholeStr = "-".concat(padLeft(Math.abs(whole).toString(settings.radix), "0", settings.leftDigits));
            }
            else {
                wholeStr = padLeft(whole.toString(settings.radix), "0", settings.leftDigits);
            }
            if (settings.rightDigits === 0) {
                tmpStrArr.length = 3;
                tmpStrArr[0] = settings.prepend;
                tmpStrArr[1] = wholeStr;
                tmpStrArr[2] = settings.append;
            }
            else {
                var decimal = Math.abs(value - whole);
                var decimalStr = void 0;
                if (settings.radix === 10) {
                    decimalStr = Math.round(decimal * Math.pow(10, settings.rightDigits)).toString();
                }
                else {
                    decimalStr = decimal.toString(settings.radix).substr(2);
                }
                decimalStr = padRight(decimalStr, "0", settings.rightDigits);
                tmpStrArr.length = 5;
                tmpStrArr[0] = settings.prepend;
                tmpStrArr[1] = wholeStr;
                tmpStrArr[2] = settings.decimal;
                if (decimalStr.length > settings.rightDigits) {
                    tmpStrArr[3] = decimalStr.substr(0, settings.rightDigits);
                }
                else {
                    tmpStrArr[3] = decimalStr;
                }
                tmpStrArr[4] = settings.append;
            }
            return tmpStrArr.join("");
        }
        Util.formatNumber = formatNumber;
        /**
         * Gets a transposed version of the specified 2D array.
         * The array may be jagged but this will result in some undefined entries.
         * Does not modify the array - instead returns a new one.
         * @param array
         */
        function transpose2DArray(array) {
            var newArray = [];
            for (var i = 0, iL = array.length; i < iL; ++i) {
                var inner = array[i];
                for (var j = 0, jL = inner.length; j < jL; ++j) {
                    var value = inner[j];
                    if (newArray[j] == null) {
                        newArray[j] = [];
                    }
                    newArray[j][i] = value;
                }
            }
            return newArray;
        }
        Util.transpose2DArray = transpose2DArray;
        /**
         * Performs a binary search through an array for an item, returning the index of it if found, or -1 if not.
         * The array MUST be sorted.
         * @param array the array to search
         * @param item the item to search for
         * @param comparer a comparer function that returns 1 if a > b, -1 if a < b, and 0 if a == b
         * @param exactMatch instead of returning -1 if not found, returns the closest index to a matching item
         */
        function binarySearch(array, item, comparer, exactMatch) {
            if (exactMatch === void 0) { exactMatch = true; }
            if (array.length === 0) {
                return exactMatch ? -1 : 0;
            }
            var mid;
            var first = 0, last = array.length - 1;
            while (first <= last) {
                mid = (first + last) >> 1;
                var compare = comparer(array[mid], item);
                if (compare === 0) {
                    return mid;
                }
                else if (compare > 0) {
                    last = mid - 1;
                }
                else {
                    first = mid + 1;
                }
            }
            if (exactMatch) {
                return -1;
            }
            if (first >= array.length || comparer(array[first], item) > 0) {
                return first;
            }
            else {
                return first + 1;
            }
        }
        Util.binarySearch = binarySearch;
        function indexOf(search, array, comparator) {
            if (comparator === void 0) { comparator = function (x, y) { return x === y; }; }
            for (var i = 0; i < array.length; i++) {
                if (comparator(array[i], search)) {
                    return i;
                }
            }
            return -1;
        }
        Util.indexOf = indexOf;
        function lastIndexOf(search, array, comparator) {
            if (comparator === void 0) { comparator = function (x, y) { return x === y; }; }
            for (var i = array.length - 1; i >= 0; i--) {
                if (comparator(array[i], search)) {
                    return i;
                }
            }
            return -1;
        }
        Util.lastIndexOf = lastIndexOf;
        function defaultComparatorFunc(candidate, item) {
            return item < candidate ? -1 : 0;
        }
        /**
         * Performs a sorted insertion into an array using a comparator function and returns
         * the index at which the item was placed. If the comparator never returns true, the
         * item will be inserted at the end of the array.
         *
         * @param item object to insert
         * @param array array to insert into
         * @param comparator function to test candidates, returns 0 not to insert or a number to insert x places to the left/right
         */
        function insert(item, array, comparator) {
            if (comparator === void 0) { comparator = defaultComparatorFunc; }
            for (var i = 0; i < array.length; i++) {
                var comp = comparator(array[i], item, i);
                if (comp) {
                    var insertAt = comp > 0 ? i + comp : i + comp + 1;
                    array.splice(insertAt, 0, item);
                    return insertAt;
                }
            }
            return array.push(item) - 1;
        }
        Util.insert = insert;
        /**
         * Compares two arrays for equality.
         * @param arr1 the first array for comparison
         * @param arr2 the second array for comparison
         * @param comparer function to compare individual array items
         */
        function arraysEqual(arr1, arr2, comparer) {
            if (comparer === void 0) { comparer = function (a, b) { return a === b; }; }
            if (arr1.length !== arr2.length) {
                return false;
            }
            for (var i = 0, l = arr1.length; i < l; ++i) {
                if (!comparer(arr1[i], arr2[i])) {
                    return false;
                }
            }
            return true;
        }
        Util.arraysEqual = arraysEqual;
        function hasOwnKeys(obj, keyMap) {
            var ownKeys = Object.getOwnPropertyNames(obj);
            var fullMatch = true;
            for (var key in keyMap) {
                var match = keyMap[key] = ownKeys.indexOf(key) !== -1;
                fullMatch = fullMatch && match;
            }
            return fullMatch;
        }
        Util.hasOwnKeys = hasOwnKeys;
        function mirror(master, slave, p3) {
            if (RS.Is.string(p3)) {
                var key_1 = p3;
                var oldDescriptor_1 = Object.getOwnPropertyDescriptor(master, key_1);
                /** Encloses the old value. */
                var outerValue_1 = master[key_1];
                Object.defineProperty(master, key_1, {
                    // Use the old getter. If there was no getter but a setter, don't create getter. Otherwise create custom getter.
                    get: (!oldDescriptor_1 || (!oldDescriptor_1.get && !oldDescriptor_1.set)) ? function () { return outerValue_1; } : oldDescriptor_1.get,
                    set: function (value) {
                        if (oldDescriptor_1 && oldDescriptor_1.set) {
                            oldDescriptor_1.set.call(this, value);
                        }
                        else if (!oldDescriptor_1 || !oldDescriptor_1.get) {
                            // Only set outerValue if we created a custom getter.
                            outerValue_1 = value;
                        }
                        // Finally, update slave.
                        slave[key_1] = master[key_1];
                    },
                    configurable: true,
                    enumerable: true
                });
            }
            else if (RS.Is.object(p3)) {
                var props = p3;
                var keys = Object.keys(props);
                for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                    var key = keys_1[_i];
                    mirror(master, slave, key);
                }
            }
            else {
                // Use the keys common to both master and slave.
                for (var slaveKey in slave) {
                    for (var masterKey in master) {
                        if (masterKey === slaveKey) {
                            mirror(master, slave, masterKey);
                        }
                    }
                }
            }
        }
        Util.mirror = mirror;
        /** Returns the property descriptor of the given key. */
        function getPropertyDescriptor(object, property) {
            var key = Object.keys(property)[0];
            do {
                var descriptor = Object.getOwnPropertyDescriptor(object, key);
                if (descriptor) {
                    return descriptor;
                }
            } while (object = Object.getPrototypeOf(object));
        }
        Util.getPropertyDescriptor = getPropertyDescriptor;
        /** Invokes a given callback when a given property is changed. NOTE: not reversible. */
        function observe(object, property, callback) {
            var key = Object.keys(property)[0];
            var oldDescriptor = getPropertyDescriptor(object, property);
            var lastValue;
            var newDescriptor;
            if (oldDescriptor && Object.keys(oldDescriptor).indexOf("value") === -1) {
                newDescriptor = __assign(__assign({}, oldDescriptor), { set: function (value) {
                        oldDescriptor.set.call(this, value);
                        if (lastValue !== value) {
                            callback(value);
                        }
                        lastValue = value;
                    } });
            }
            else {
                var innerValue_1 = object[key];
                newDescriptor =
                    {
                        get: function () { return innerValue_1; },
                        set: function (value) {
                            innerValue_1 = value;
                            if (lastValue !== value) {
                                callback(value);
                            }
                            lastValue = value;
                        },
                        configurable: true,
                        enumerable: true
                    };
            }
            Object.defineProperty(object, key, newDescriptor);
        }
        Util.observe = observe;
        /** Encodes a character code as a UTF-8 character sequence. */
        function encodeUTF8(code) {
            var first = (code >> 16);
            var second = (code >> 12) & 0x3f;
            var third = (code >> 6) & 0x3f;
            var forth = (code & 0x3f) + 0x80;
            // Check for 4 character codes these are formatted 11110xxx 10xxxxxx 10xxxxxx 10xxxxxx
            if (code >= 0x10000) {
                return String.fromCharCode(first + 0xf0, second + 0x80, third + 0x80, forth);
            }
            // Otherwise over 0x07ff are formatted 1110xxxx 10xxxxxx 10xxxxxx
            else if (code >= 0x0800) {
                return String.fromCharCode(second + 0xe0, third + 0x80, forth);
            }
            // Otherwise over 0x80 are formatted 110xxxxx 10xxxxxx
            else if (code >= 0x80) {
                return String.fromCharCode(third + 0xc0, forth);
            }
            // Otherwise they're just normal ASCII characters
            else {
                return String.fromCharCode(code);
            }
        }
        Util.encodeUTF8 = encodeUTF8;
        /** Converts a unicode encoded string into a UTF-8 encoded string */
        function encodeUTF8String(value) {
            return value.split("").map(function (ch) { return encodeUTF8(ch.charCodeAt(0)); }).join("");
        }
        Util.encodeUTF8String = encodeUTF8String;
        function generateUUID() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (char) {
                // Thanks https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
                var random = Math.random() * 16 | 0;
                var value = char === "x" ? random : (random & 0x3 | 0x8);
                return value.toString(16);
            });
        }
        Util.generateUUID = generateUUID;
    })(Util = RS.Util || (RS.Util = {}));
})(RS || (RS = {}));
/// <reference path="Tag.ts" />
/// <reference path="../Util.ts" />
var RS;
(function (RS) {
    /**
     * Marks the specified class as as having callbacks.
     * Note that this only works for non-static members of classes.
     */
    RS.HasCallbacks = RS.Decorators.Tag.createDataless(RS.Decorators.TagKind.Class, function (oldCtor) {
        return RS.Util.hookClass(oldCtor, function () {
            bindCallbacks(this, RS.Decorators.MemberType.Instance);
            oldCtor.apply(this, arguments);
        });
    });
    /**
     * Marks the specified method as a callback, allowing it to be passed directly into Event.on.
     * The owner class must be marked with HasCallbacks, if this is applied to an instance member.
     */
    RS.Callback = RS.Decorators.Tag.createDataless(RS.Decorators.TagKind.Method);
    /**
     * Binds all @Callback marked methods to this on the specified object.
     * Should not be required to call this manually unless working with static classes.
     */
    function bindCallbacks(target, type) {
        var callbacks = RS.Callback.get(target, type);
        if (callbacks != null) {
            for (var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++) {
                var methodName = callbacks_1[_i];
                target[methodName] = target[methodName].bind(target);
            }
        }
    }
    RS.bindCallbacks = bindCallbacks;
})(RS || (RS = {}));
/// <reference path="IObservable.ts" />
/// <reference path="../Disposable.ts" />
/// <reference path="../decorators/Callbacks.ts" />
var RS;
(function (RS) {
    /**
     * Encapsulates a single mutable value.
     */
    var Observable = /** @class */ (function () {
        function Observable(initialValue) {
            this._isDisposed = false;
            this._resolves = [];
            this._globalResolves = [];
            this._onChanged = RS.createEvent();
            /** Published when the state has changed. */
            this.onChanged = this._onChanged.public;
            this.valueToString = function (value) { return "".concat(value); };
            this._value = initialValue;
        }
        var _propObj = {};

        _propObj.isDisposed = {
            /** Gets if this observable has been disposed. */
            get: function () { return this._isDisposed; },
            enumerable: false,
            configurable: true
        };

        _propObj.value = {
            /**
             * Gets or sets the value of this observable.
             */
            get: function () { return this._value; },
            set: function (newValue) {
                if (newValue === this._value) {
                    return;
                }
                this._value = newValue;
                this._onChanged.publish(newValue);
                for (var i = 0; i < this._resolves.length; i++) {
                    var resolveData = this._resolves[i];
                    if (RS.Is.array(resolveData.value) ? resolveData.value.indexOf(newValue) !== -1 : resolveData.value === newValue) {
                        resolveData.resolve();
                        this._resolves.splice(i, 1);
                        i--;
                    }
                }
                for (var _i = 0, _a = this._globalResolves; _i < _a.length; _i++) {
                    var globalResolve = _a[_i];
                    globalResolve.resolve(newValue);
                }
                this._globalResolves.length = 0;
            },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(Observable.prototype, _propObj);
        Observable.prototype.toString = function () {
            return "[Observable: ".concat(this.valueToString(this._value), "]");
        };
        /**
         * Attaches callbacks for the resolution and/or rejection of the Promise.
         * @param onfulfilled The callback to execute when the Promise is resolved.
         * @param onrejected The callback to execute when the Promise is rejected.
         * @returns A Promise for the completion of which ever callback is executed.
         */
        Observable.prototype.then = function (onfulfilled, onrejected) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this._globalResolves.push({ resolve: function () {
                        onfulfilled(_this._value);
                        resolve(null);
                    },
                    reject: function (reason) {
                        onrejected(reason);
                        reject(reason);
                    }
                });
            });
        };
        /**
         * Returns a promise that resolves when this observable's value has changed to the specified value.
         * @param value
         */
        Observable.prototype.for = function (value) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                if (_this._value === value) {
                    resolve();
                }
                else {
                    _this._resolves.push({ value: value, resolve: resolve, reject: reject });
                }
            });
        };
        /**
         * Disposes this observable.
         */
        Observable.prototype.dispose = function () {
            if (this._isDisposed) {
                return;
            }
            this._onChanged.dispose();
            for (var _i = 0, _a = this._resolves; _i < _a.length; _i++) {
                var resolve = _a[_i];
                resolve.reject("disposed");
            }
            for (var _b = 0, _c = this._globalResolves; _b < _c.length; _b++) {
                var globalResolve = _c[_b];
                globalResolve.reject("disposed");
            }
            this._isDisposed = true;
        };
        /**
         * Creates a new observable that maps to this one through a transform function.
         * @param func
         */
        Observable.prototype.map = function (mapFunc) {
            return new MappedObservable(this, mapFunc);
        };
        return Observable;
    }());
    RS.Observable = Observable;
    var MappedObservable = /** @class */ (function (_super) {
        __extends(MappedObservable, _super);
        function MappedObservable(baseObservable, mapFunc) {
            var _this = _super.call(this, mapFunc(baseObservable.value)) || this;
            _this.baseObservable = baseObservable;
            _this.mapFunc = mapFunc;
            _this._baseObservableChangeHandler = baseObservable.onChanged(_this.handleBaseObservableValueChange.bind(_this));
            return _this;
        }
        MappedObservable.prototype.dispose = function () {
            if (this._isDisposed) {
                return;
            }
            if (this._baseObservableChangeHandler) {
                this._baseObservableChangeHandler.dispose();
                this._baseObservableChangeHandler = null;
            }
            _super.prototype.dispose.call(this);
        };
        MappedObservable.prototype.handleBaseObservableValueChange = function () {
            this.value = this.mapFunc(this.baseObservable.value);
        };
        return MappedObservable;
    }(Observable));
    var ReducedObservable = /** @class */ (function (_super) {
        __extends(ReducedObservable, _super);
        function ReducedObservable(baseObservables, reduceFunc) {
            var _this = _super.call(this, baseObservables.map(function (o) { return o.value; }).reduce(reduceFunc)) || this;
            _this.baseObservables = baseObservables;
            _this.reduceFunc = reduceFunc;
            _this._baseObservableChangeHandlers = [];
            for (var _i = 0, baseObservables_1 = baseObservables; _i < baseObservables_1.length; _i++) {
                var o = baseObservables_1[_i];
                _this._baseObservableChangeHandlers.push(o.onChanged(_this.handleBaseObservableValueChange.bind(_this)));
            }
            return _this;
        }
        ReducedObservable.prototype.dispose = function () {
            if (this._isDisposed) {
                return;
            }
            if (this._baseObservableChangeHandlers) {
                for (var _i = 0, _a = this._baseObservableChangeHandlers; _i < _a.length; _i++) {
                    var handler = _a[_i];
                    handler.dispose();
                }
                this._baseObservableChangeHandlers.length = 0;
                this._baseObservableChangeHandlers = null;
            }
            _super.prototype.dispose.call(this);
        };
        ReducedObservable.prototype.handleBaseObservableValueChange = function () {
            this.value = this.baseObservables
                .map(function (o) { return o.value; })
                .reduce(this.reduceFunc);
        };
        return ReducedObservable;
    }(Observable));
    var BaseLink = /** @class */ (function () {
        function BaseLink(left, right) {
            this._leftChangeHandle = null;
            this._left = null;
            this._right = null;
            this._changeInProgress = false;
            this._left = left;
            this._right = right;
        }
        var _propObj = {};

        _propObj.isDisposed = {
            get: function () { return this._left == null || this._left.isDisposed || this._right == null || this._right.isDisposed; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(BaseLink.prototype, _propObj);
        BaseLink.prototype.dispose = function () {
            this._left = null;
            this._right = null;
        };
        BaseLink.prototype.handleLeftChanged = function (newValue) {
            if (this.isDisposed || this._changeInProgress) {
                return;
            }
            this._changeInProgress = true;
            try {
                this._right.value = newValue;
            }
            finally {
                this._changeInProgress = false;
            }
        };
        var _decObj = {};

        _decObj._leftChangeHandle = {
            decorators: [RS.AutoDisposeOnSet],
            target: BaseLink.prototype,
            desc: void 0
        };

        _decObj.handleLeftChanged = {
            decorators: [RS.Callback],
            target: BaseLink.prototype,
            desc: null
        };

        __multiDecorate(_decObj);
        BaseLink = __decorate([
            RS.HasCallbacks
        ], BaseLink);
        return BaseLink;
    }());
    var SimplexLink = /** @class */ (function (_super) {
        __extends(SimplexLink, _super);
        function SimplexLink(left, right) {
            var _this = _super.call(this, left, right) || this;
            _this._leftChangeHandle = left.onChanged(_this.handleLeftChanged);
            _this._changeInProgress = true;
            try {
                right.value = left.value;
            }
            finally {
                _this._changeInProgress = false;
            }
            return _this;
        }
        SimplexLink = __decorate([
            RS.HasCallbacks
        ], SimplexLink);
        return SimplexLink;
    }(BaseLink));
    var DuplexLink = /** @class */ (function (_super) {
        __extends(DuplexLink, _super);
        function DuplexLink(left, right) {
            var _this = _super.call(this, left, right) || this;
            _this._leftChangeHandle = null;
            _this._rightChangeHandle = null;
            _this._leftChangeHandle = left.onChanged(_this.handleLeftChanged);
            _this._rightChangeHandle = right.onChanged(_this.handleRightChanged);
            _this._changeInProgress = true;
            try {
                right.value = left.value;
            }
            finally {
                _this._changeInProgress = false;
            }
            return _this;
        }
        DuplexLink.prototype.handleRightChanged = function (newValue) {
            if (this.isDisposed || this._changeInProgress) {
                return;
            }
            this._changeInProgress = true;
            try {
                this._left.value = newValue;
            }
            finally {
                this._changeInProgress = false;
            }
        };
        var _decObj = {};

        _decObj._leftChangeHandle = {
            decorators: [RS.AutoDisposeOnSet],
            target: DuplexLink.prototype,
            desc: void 0
        };

        _decObj._rightChangeHandle = {
            decorators: [RS.AutoDisposeOnSet],
            target: DuplexLink.prototype,
            desc: void 0
        };

        _decObj.handleRightChanged = {
            decorators: [RS.Callback],
            target: DuplexLink.prototype,
            desc: null
        };

        __multiDecorate(_decObj);
        DuplexLink = __decorate([
            RS.HasCallbacks
        ], DuplexLink);
        return DuplexLink;
    }(BaseLink));
    (function (Observable) {
        /**
         * Creates a new observable that encapsulates the reduced value of an array of observables.
         * @param observables
         * @param reductionFunc
         */
        function reduce(observables, reductionFunc) {
            return new ReducedObservable(observables, reductionFunc);
        }
        Observable.reduce = reduce;
        /**
         * Specifies the duplicity of an observable link.
         */
        var LinkDirection;
        (function (LinkDirection) {
            /** Updating the left observable will push the change to the right observable but not vice versa. */
            LinkDirection[LinkDirection.LeftToRight = 0] = "LeftToRight";
            /** Updating the right observable will push the change to the left observable but not vice versa. */
            LinkDirection[LinkDirection.RightToLeft = 1] = "RightToLeft";
            /**
             * Updating one observable will push the change to the other.
             * The left will take priority if the values are out of sync when the link is created.
             */
            LinkDirection[LinkDirection.Duplex = 2] = "Duplex";
        })(LinkDirection = Observable.LinkDirection || (Observable.LinkDirection = {}));
        function link(left, right, direction) {
            switch (direction) {
                case LinkDirection.LeftToRight: return new SimplexLink(left, right);
                case LinkDirection.RightToLeft: return new SimplexLink(right, left);
                case LinkDirection.Duplex: return new DuplexLink(left, right);
            }
        }
        Observable.link = link;
    })(Observable = RS.Observable || (RS.Observable = {}));
})(RS || (RS = {}));
/// <reference path="Event.ts" />
/// <reference path="Init.ts" />
/// <reference path="helpers/Observable.ts" />
var RS;
(function (RS) {
    /**
     * Connection utilities.
     */
    var Connection = /** @class */ (function () {
        function Connection() {
        }
        /**
         * Initialises the ConnectionUtils class.
         */
        Connection.init = function () {
            var _this = this;
            this._checkInterval = window.setInterval(function () {
                _this.checkConnectivity();
            }, 100);
        };
        /**
         * Checks the current connectivity of the app and publishes events if the connection state has changed.
         */
        Connection.checkConnectivity = function () {
            this.connected.value = this.connectedOverride != null ? this.connectedOverride : navigator.onLine;
        };
        Connection._checkInterval = -1;
        /** Set to true or false to force a connection status. */
        Connection.connectedOverride = null;
        /** Whether or not we are connected to the internet. */
        Connection.connected = new RS.Observable(navigator.onLine);
        var _decObj = {};

        _decObj.init = {
            decorators: [RS.Init()],
            target: Connection,
            desc: null
        };

        __multiDecorate(_decObj);
        return Connection;
    }());
    RS.Connection = Connection;
})(RS || (RS = {}));
var RS;
(function (RS) {
    /** A base error class which can be extended for custom instance-checkable errors and which supports error nesting. */
    var BaseError = /** @class */ (function (_super) {
        __extends(BaseError, _super);
        function BaseError(message, innerError) {
            var _newTarget = this.constructor;
            var _this = _super.call(this, BaseError.getMessage(message, innerError)) || this;
            _this.cause = innerError;
            RS.Util.setPrototypeOf(_this, _newTarget.prototype);
            return _this;
        }
        BaseError.getMessage = function (message, innerError) {
            if (innerError) {
                var innerMessage = RS.Util.getErrorMessage(innerError);
                if (innerMessage) {
                    if (message) {
                        return "".concat(message, ": ").concat(innerMessage);
                    }
                    return innerMessage;
                }
            }
            return message;
        };
        return BaseError;
    }(Error));
    RS.BaseError = BaseError;
    /** A generic nested error. */
    var NestedError = /** @class */ (function (_super) {
        __extends(NestedError, _super);
        function NestedError(message, innerError) {
            return _super.call(this, message, innerError) || this;
        }
        return NestedError;
    }(BaseError));
    RS.NestedError = NestedError;
})(RS || (RS = {}));
/// <reference path="helpers/Error.ts"/>
var RS;
(function (RS) {
    function assert(condition, message) {
        if (!condition) {
            throw new AssertionError(message);
        }
    }
    RS.assert = assert;
    function hope(condition, message) {
        if (!condition) {
            RS.Log.warn("AssertionWarning: ".concat(message));
        }
    }
    RS.hope = hope;
    var AssertionError = /** @class */ (function (_super) {
        __extends(AssertionError, _super);
        function AssertionError(message) {
            return _super.call(this, "AssertionError: ".concat(message)) || this;
        }
        return AssertionError;
    }(RS.BaseError));
    RS.AssertionError = AssertionError;
})(RS || (RS = {}));
/// <reference path="Is.ts" />
var RS;
(function (RS) {
    /** Provides utility functions for manipulating cookies. */
    var Cookie = /** @class */ (function () {
        function Cookie() {
            throw new TypeError("Illegal constructor");
        }
        var _propObj = {};

        _propObj.enabled = {
            /**
             * Whether or not cookies are supported and enabled. \
             * NOTE: simply accessing this may attempt to write to document.cookie.
             */
            get: function () {
                if (this.__enabledCache == null) {
                    this.__enabledCache = this.areEnabled();
                }
                return this.__enabledCache;
            },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(Cookie, _propObj);
        /**
         * Gets the value of the specified cookie, or null if it doesn"t exist.
         * @param key
         */
        Cookie.get = function (key) {
            if (this.__cachedDocumentCookie !== document.cookie) {
                this.renewCache();
            }
            var value = this.__cache["".concat(this.__cacheKeyPrefix).concat(key)];
            return value == null ? null : decodeURIComponent(value);
        };
        /**
         * Sets the value of the specified cookie.
         * @param key
         * @param value
         * @param options
         */
        Cookie.set = function (key, value, options) {
            if (options != null) {
                options = __assign(__assign({}, this.__defaultOptions), options);
            }
            else {
                options = __assign({}, this.__defaultOptions);
            }
            document.cookie = this.generateCookieString(key, value, options);
        };
        /**
         * Expires the specified cookie.
         * @param key
         * @param options
         */
        Cookie.expire = function (key, options) {
            this.set(key, "", options ? __assign({ expires: this.__autoExpireDate }, options) : { expires: this.__autoExpireDate });
        };
        Cookie.isValidDate = function (date) {
            return date != null && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date.getTime());
        };
        Cookie.getExpiresDate = function (expires, now) {
            now = now || new Date();
            if (RS.Is.number(expires)) {
                expires = expires === Infinity ? this.__maxExpireDate : new Date(now.getTime() + expires * 1000);
            }
            else if (RS.Is.string(expires)) {
                expires = new Date(expires);
            }
            else if (!this.isValidDate(expires)) {
                throw new Error("'expires' parameter cannot be converted to a valid Date instance");
            }
            return expires;
        };
        Cookie.generateCookieString = function (key, value, options) {
            key = key.replace(/[^#$&+\^`|]/g, encodeURIComponent);
            key = key.replace(/\(/g, "%28").replace(/\)/g, "%29");
            value = (value + "").replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
            var cookieString = key + "=" + value;
            if (options) {
                cookieString += options.path ? ";path=" + options.path : "";
                cookieString += options.domain ? ";domain=" + options.domain : "";
                cookieString += options.expires ? ";expires=" + this.getExpiresDate(options.expires).toUTCString() : "";
                cookieString += options.secure ? ";secure" : "";
            }
            return cookieString;
        };
        Cookie.getCacheFromString = function (documentCookie) {
            var cookieCache = {};
            var cookiesArray = documentCookie ? documentCookie.split("; ") : [];
            for (var _i = 0, cookiesArray_1 = cookiesArray; _i < cookiesArray_1.length; _i++) {
                var cookie = cookiesArray_1[_i];
                var cookieKvp = this.getKeyValuePairFromCookieString(cookie);
                if (cookieCache["".concat(this.__cacheKeyPrefix).concat(cookieKvp.key)] == null) {
                    cookieCache["".concat(this.__cacheKeyPrefix).concat(cookieKvp.key)] = cookieKvp.value;
                }
            }
            return cookieCache;
        };
        Cookie.getKeyValuePairFromCookieString = function (cookieString) {
            // "=" is a valid character in a cookie value according to RFC6265, so cannot `split("=")`
            var separatorIndex = cookieString.indexOf("=");
            // IE omits the "=" when the cookie value is an empty string
            separatorIndex = separatorIndex < 0 ? cookieString.length : separatorIndex;
            var key = cookieString.substr(0, separatorIndex);
            var decodedKey;
            try {
                decodedKey = decodeURIComponent(key);
            }
            catch (e) {
                RS.Log.error("Could not decode cookie with key \"".concat(key, "\""));
                RS.Log.error(e);
            }
            return {
                key: decodedKey,
                value: cookieString.substr(separatorIndex + 1) // Defer decoding value until accessed
            };
        };
        Cookie.renewCache = function () {
            this.__cache = this.getCacheFromString(document.cookie);
            this.__cachedDocumentCookie = document.cookie;
        };
        Cookie.areEnabled = function () {
            var testKey = "Synergy";
            this.set(testKey, 1);
            var isEnabled = this.get(testKey) === "1";
            this.expire(testKey);
            return isEnabled;
        };
        // https://github.com/ScottHamper/Cookies
        // Used to ensure cookie keys do not collide with
        // built-in `Object` properties
        Cookie.__cacheKeyPrefix = "cookey."; // Hurr hurr, :)
        Cookie.__maxExpireDate = new Date("Fri, 31 Dec 9999 23:59:59 UTC");
        Cookie.__autoExpireDate = new Date(0);
        Cookie.__defaultOptions = {
            path: "/",
            secure: false
        };
        Cookie.__cache = {};
        return Cookie;
    }());
    RS.Cookie = Cookie;
})(RS || (RS = {}));
var RS;
(function (RS) {
    /**
     * A type of touch event.
     */
    var TouchEventType;
    (function (TouchEventType) {
        TouchEventType[TouchEventType.Click = 0] = "Click";
        TouchEventType[TouchEventType.Tap = 1] = "Tap";
        TouchEventType[TouchEventType.TouchStart = 2] = "TouchStart";
        TouchEventType[TouchEventType.MouseDown = 3] = "MouseDown";
        TouchEventType[TouchEventType.TouchEnd = 4] = "TouchEnd";
        TouchEventType[TouchEventType.MouseUp = 5] = "MouseUp";
    })(TouchEventType = RS.TouchEventType || (RS.TouchEventType = {}));
    /**
     * A type of browser.
     */
    var Browser;
    (function (Browser) {
        Browser.Chrome = "Chrome";
        Browser.ChromeMobile = "Chrome Mobile";
        Browser.IE = "IE";
        Browser.Edge = "Microsoft Edge";
        Browser.Safari = "Safari";
        Browser.Firefox = "Firefox";
    })(Browser = RS.Browser || (RS.Browser = {}));
    /**
     * Convenience methods for accessing device specific modes and events.
     */
    var Device = /** @class */ (function () {
        function Device() {
        }
        var _propObj = {};

        _propObj.isiOS14Safari = {
            // TODO: Proper ipad mobile detection
            // Hacky fix for ipads being shown as desktop devices on iOS14+. This could potentially catch some desktop tablets running Safari
            get: function () { return platform.name === Browser.Safari && navigator.maxTouchPoints === 5; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(Device, _propObj);
        /**
         * Convenience function to return the supported event for click / tap across any device
         * Example usage: $(button).bind(RS.Device.getSupportedEvent(TouchEventType.Click), () => {  });
         * @param eventType
         * @returns                Event name to use in jQuery bind or javascript addEventListener
         */
        Device.getSupportedClickEvent = function (eventType) {
            switch (eventType) {
                case TouchEventType.Click:
                case TouchEventType.Tap:
                    return this.isTouchDevice ? "touchend" : "click";
                case TouchEventType.TouchStart:
                case TouchEventType.MouseDown:
                    return this.isTouchDevice ? "touchstart" : "mousedown";
                case TouchEventType.TouchEnd:
                case TouchEventType.MouseUp:
                    return this.isTouchDevice ? "touchend" : "mouseup";
                default:
                    return null;
            }
        };
        var _propObj = {};

        _propObj.isAppleDevice = {
            /**
             * Gets if the current device is an iOS Device.
             */
            get: function () { return this.deviceProperties.isAppleDevice; },
            enumerable: false,
            configurable: true
        };

        _propObj.isIOS14 = {
            /**
             * Gets if the current os version is iOS 14
             * will also return true for any ipads with safari
             * (because we can't differentiate ios versions there, if you can then please help here)
             */
            get: function () {
                if (this.operatingSystem.os == 'OS X') {
                    return this.isiOS14Safari;
                }
                return this.isAppleDevice &&
                    (this.operatingSystem.version.split(".")[0] === "14");
            },
            enumerable: false,
            configurable: true
        };

        _propObj.isMobileDevice = {
            /**
             * Gets if the current device is a mobile device.
             */
            get: function () { return this.deviceProperties.isMobileDevice; },
            enumerable: false,
            configurable: true
        };

        _propObj.isTouchDevice = {
            /**
             * Gets if the current device supports touch (could be a laptop with a touch screen).
             */
            get: function () { return this.deviceProperties.isTouchDevice; },
            enumerable: false,
            configurable: true
        };

        _propObj.isDesktopDevice = {
            /**
             * Gets if the current device is NOT a mobile device.
             */
            get: function () { return !this.deviceProperties.isMobileDevice; },
            enumerable: false,
            configurable: true
        };

        _propObj.isHandsetDevice = {
            /**
             * Gets if the current device is a handset device (mobile but not tablet).
             */
            get: function () { return this.deviceProperties.isHandsetDevice; },
            enumerable: false,
            configurable: true
        };

        _propObj.isTabletDevice = {
            /**
             * Gets if the current device is a tablet device.
             */
            get: function () { return this.deviceProperties.isTabletDevice; },
            enumerable: false,
            configurable: true
        };

        _propObj.isSamsungGalaxyS8 = {
            /**
             * Gets if the current device is a Samsung Galaxy S8 or S8+.
             * NOTE: If you're using this because shaders aren't working, check that your shader uses ALL varyings, including vTextureId.
             */
            get: function () { return this.deviceProperties.isSamsungGalaxyS8; },
            enumerable: false,
            configurable: true
        };

        _propObj.isIOSApp = {
            /**
             * Gets if the current "device" is the iOS app
             */
            get: function () {
                // Safari version 11.x seems specific to the iOS app
                // Apart from UTH for some reason which reports 8+. So check for either .x or +
                // platform.js adds .x or + onto the end of a version its approximating
                return this.isAppleDevice &&
                    this.browser === Browser.Safari &&
                    platform.version.match(/(\.x|\+)/) != null;
            },
            enumerable: false,
            configurable: true
        };

        _propObj.deviceDetails = {
            /**
             * Gets the current device type.
             */
            get: function () { return platform.product; },
            enumerable: false,
            configurable: true
        };

        _propObj.operatingSystem = {
            /**
             * Gets the current device Operating System.
             */
            get: function () {
                return {
                    os: platform.os.family,
                    version: platform.os.version
                };
            },
            enumerable: false,
            configurable: true
        };

        _propObj.browser = {
            /**
             * Gets the current the browser type.
             */
            get: function () { return platform.name; },
            enumerable: false,
            configurable: true
        };

        _propObj.summary = {
            /**
             * Gets a summary of the device.
             */
            get: function () { return "".concat(platform, " (renderer: ").concat(RS.Capabilities.WebGL.getRenderer(), ")"); },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(Device, _propObj);
        /**
         * Precomputed device properties for the current platform.
         */
        Device.deviceProperties = {
            isMobileDevice: /Android|HTC|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) || Device.isiOS14Safari,
            isTouchDevice: ("ontouchstart" in document.documentElement) || ("ontouchstart" in document),
            isAppleDevice: /iPhone|iPad|iPod/i.test(navigator.userAgent) || Device.isiOS14Safari,
            isHandsetDevice: window.matchMedia("only screen and (max-width: 760px)").matches,
            isTabletDevice: window.matchMedia("only screen and (max-width: 760px)").matches,
            isSamsungGalaxyS8: /SM-G(950|955|55|892)[A-Z]/i.test(navigator.userAgent)
        };
        return Device;
    }());
    RS.Device = Device;
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Factory;
    (function (Factory) {
        /** Array of all registered factories. */
        var factories = [];
        /**
         * Registers a factory.
         */
        function register(info) {
            factories.push(info);
        }
        Factory.register = register;
        /**
         * Finds all factories that create the specified object type.
         */
        function find(type, searchInheritanceChain) {
            if (searchInheritanceChain === void 0) { searchInheritanceChain = true; }
            return factories.filter(function (i) { return i.type === type || (searchInheritanceChain && type.prototype instanceof i.type); });
        }
        Factory.find = find;
        /**
         * Applies all factory modifies to the specified object.
         */
        function applyModifiers(obj) {
            if (obj == null) {
                return 0;
            }
            var facts = find(obj.constructor, false);
            var cnt = 0;
            for (var _i = 0, facts_1 = facts; _i < facts_1.length; _i++) {
                var info = facts_1[_i];
                for (var _a = 0, _b = info.modifiers; _a < _b.length; _a++) {
                    var modifier = _b[_a];
                    modifier(obj);
                    cnt++;
                }
            }
            return cnt;
        }
        Factory.applyModifiers = applyModifiers;
        /**
         * Registers a factory modifier for the specified object type.
         */
        function registerModifier(type, modifier) {
            var facts = find(type, false);
            for (var _i = 0, facts_2 = facts; _i < facts_2.length; _i++) {
                var fact = facts_2[_i];
                fact.modifiers.push(modifier);
            }
        }
        Factory.registerModifier = registerModifier;
    })(Factory = RS.Factory || (RS.Factory = {}));
})(RS || (RS = {}));
/** Contains functions for reducing arrays to single items. */
var RS;
(function (RS) {
    var Find;
    (function (Find) {
        var ScoreComparers;
        (function (ScoreComparers) {
            ScoreComparers.Higher = function (a, b) { return a > b; };
            ScoreComparers.Lower = function (a, b) { return a < b; };
            ScoreComparers.CloserToZero = function (a, b) { return ScoreComparers.Lower(Math.abs(a), Math.abs(b)); };
            ScoreComparers.FartherFromZero = function (a, b) { return ScoreComparers.Higher(Math.abs(a), Math.abs(b)); };
        })(ScoreComparers = Find.ScoreComparers || (Find.ScoreComparers = {}));
        var defaultScorer = function (a) { return a; };
        /**
         * Find the item from the specified array with the best score.
         * @param from Array to pick from.
         * @param scorer Function to convert items to numeric values.
         * @param scoreIsBetter Is a better than b?
         */
        function best(from, scorer, scoreIsBetter) {
            if (from.length === 0) {
                return null;
            }
            var bestItem = from[0];
            var bestScore = scorer(bestItem);
            for (var i = 1, l = from.length; i < l; ++i) {
                var item = from[i];
                var score = scorer(item);
                if (scoreIsBetter(score, bestScore)) {
                    bestItem = item;
                    bestScore = score;
                }
            }
            return bestItem;
        }
        Find.best = best;
        /**
         * Find the item from the specified array with the worst score.
         * @param from Array to pick from.
         * @param scorer Function to convert items to numeric values.
         * @param scoreIsBetter Is a better than b?
         */
        function worst(from, scorer, scoreIsBetter) {
            return best(from, scorer, function (a, b) { return scoreIsBetter(b, a); });
        }
        Find.worst = worst;
        function highest(from, scorer) {
            if (scorer === void 0) { scorer = defaultScorer; }
            return best(from, scorer, ScoreComparers.Higher);
        }
        Find.highest = highest;
        function lowest(from, scorer) {
            if (scorer === void 0) { scorer = defaultScorer; }
            return best(from, scorer, ScoreComparers.Lower);
        }
        Find.lowest = lowest;
        function closestToZero(from, scorer) {
            if (scorer === void 0) { scorer = defaultScorer; }
            return best(from, scorer, ScoreComparers.CloserToZero);
        }
        Find.closestToZero = closestToZero;
        function farthestFromZero(from, scorer) {
            if (scorer === void 0) { scorer = defaultScorer; }
            return best(from, scorer, ScoreComparers.FartherFromZero);
        }
        Find.farthestFromZero = farthestFromZero;
        function ceiling(from, p2, p3) {
            var value;
            var scorer;
            if (RS.Is.number(p2)) {
                value = p2;
                scorer = defaultScorer;
            }
            else {
                scorer = p2;
                value = p3;
            }
            var total = 0;
            for (var i = 0, l = from.length; i < l; i++) {
                var item = from[i];
                total += scorer(item);
                if (total > value) {
                    return from[i];
                }
            }
            return null;
        }
        Find.ceiling = ceiling;
        function sum(array, scorer) {
            if (scorer === void 0) { scorer = defaultScorer; }
            var total = 0;
            for (var i = 0, l = array.length; i < l; ++i) {
                var item = array[i];
                total += scorer(item);
            }
            return total;
        }
        Find.sum = sum;
        /**
         * Finds an index in a sorted array using a given director function.
         * The resulting index will either point to an exact match, or to where an exact match would be if there was one.
         * Can therefore be used both for searching and inserting. Useful for preventing duplicates when adding to an array.
         * Returns the leftmost match, so when removing, you can keep removing until there are no more matches at the returned index.
         * Current implementation involves a binary search.
         * NOTE: if the input array is not sorted, then the resulting index will not be either.
         * @param sortedArray Sorted array to find index into.
         * @param directFn Comparable to compareFn in Array.sort(). If negative or zero, moves left; if positive, moves right.
         */
        function sortedIndex(sortedArray, directFn) {
            if (sortedArray.length === 0) {
                return 0;
            }
            var left = 0, right = sortedArray.length, index = Math.floor((right + left) * 0.5);
            while ((right - left) > 1) {
                var direction = directFn(sortedArray[index], index, sortedArray);
                if (direction > 0) {
                    // Move to right half
                    left = index;
                }
                else {
                    // Move to left half
                    right = index;
                }
                index = Math.floor((right + left) * 0.5);
            }
            var finalDirection = directFn(sortedArray[index], index, sortedArray);
            return finalDirection > 0 ? index + 1 : index;
        }
        Find.sortedIndex = sortedIndex;
        /**
         * Find the item from the specified array matching the given predicate.
         * @param from Array to find a matching item from.
         * @param predicate Function returning whether the given item is a match.
         */
        function matching(from, predicate) {
            for (var i = 0, l = from.length; i < l; ++i) {
                var item = from[i];
                if (predicate(item)) {
                    return item;
                }
            }
            return null;
        }
        Find.matching = matching;
        /**
         * Removes any instance of a specific item from the specified array
         * @param from the specified array
         * @param predicate
         */
        function remove(from, predicate) {
            for (var i = 0; i < from.length; ++i) {
                var item = from[i];
                if (predicate(item)) {
                    from.splice(i, 1);
                    --i;
                }
            }
            return from;
        }
        Find.remove = remove;
    })(Find = RS.Find || (RS.Find = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Util;
    (function (Util) {
        // Used to generate new hotkeys and alias as keycodes
        var keyMap = {};
        /**
         * Based on .key value as described here
         * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
         */
        Util.KeyConstants = {
            BACKSPACE: keyMap["BACKSPACE"] = "Backspace",
            TAB: keyMap["TAB"] = "Tab",
            ENTER: keyMap["ENTER"] = "Enter",
            PAUSE: keyMap["PAUSE"] = "Pause",
            CAPSLOCK: keyMap["CAPSLOCK"] = "CapsLock",
            ESCAPE: keyMap["ESCAPE"] = "Escape",
            SPACE: keyMap["SPACE"] = "Space",
            PAGE_UP: keyMap["PAGE_UP"] = "PageUp",
            PAGE_DOWN: keyMap["PAGE_DOWN"] = "PageDown",
            END: keyMap["END"] = "End",
            HOME: keyMap["HOME"] = "Home",
            LEFT: keyMap["LEFT"] = "ArrowLeft",
            UP: keyMap["UP"] = "ArrowUp   ",
            RIGHT: keyMap["RIGHT"] = "ArrowRight",
            DOWN: keyMap["DOWN"] = "ArrowDown",
            PRINT_SCREEN: keyMap["PRINT_SCREEN"] = "PrintScreen",
            INSERT: keyMap["INSERT"] = "Insert",
            DELETE: keyMap["DELETE"] = "Delete",
            A: keyMap["A"] = "a",
            B: keyMap["B"] = "b",
            C: keyMap["C"] = "c",
            D: keyMap["D"] = "d",
            E: keyMap["E"] = "e",
            F: keyMap["F"] = "f",
            G: keyMap["G"] = "g",
            H: keyMap["H"] = "h",
            I: keyMap["I"] = "i",
            J: keyMap["J"] = "j",
            K: keyMap["K"] = "k",
            L: keyMap["L"] = "l",
            M: keyMap["M"] = "m",
            N: keyMap["N"] = "n",
            O: keyMap["O"] = "o",
            P: keyMap["P"] = "p",
            Q: keyMap["Q"] = "q",
            R: keyMap["R"] = "r",
            S: keyMap["S"] = "s",
            T: keyMap["T"] = "t",
            U: keyMap["U"] = "u",
            V: keyMap["V"] = "v",
            W: keyMap["W"] = "w",
            X: keyMap["X"] = "x",
            Y: keyMap["Y"] = "y",
            Z: keyMap["Z"] = "z",
            F1: keyMap["F1"] = "F1",
            F2: keyMap["F2"] = "F2",
            F3: keyMap["F3"] = "F3",
            F4: keyMap["F4"] = "F4",
            F5: keyMap["F5"] = "F5",
            F6: keyMap["F6"] = "F6",
            F7: keyMap["F7"] = "F7",
            F8: keyMap["F8"] = "F8",
            F9: keyMap["F9"] = "F9",
            F10: keyMap["F10"] = "F10",
            F11: keyMap["F11"] = "F11",
            F12: keyMap["F12"] = "F12"
        };
        var KeyPressType;
        (function (KeyPressType) {
            KeyPressType[KeyPressType.KeyPressed = 0] = "KeyPressed";
            KeyPressType[KeyPressType.KeyDown = 1] = "KeyDown";
            KeyPressType[KeyPressType.KeyUp = 2] = "KeyUp";
        })(KeyPressType = Util.KeyPressType || (Util.KeyPressType = {}));
        var HotKey = /** @class */ (function () {
            function HotKey(keyCode, callback, needVisibility, alt, ctrl, cmd) {
                if (needVisibility === void 0) { needVisibility = false; }
                if (alt === void 0) { alt = false; }
                if (ctrl === void 0) { ctrl = false; }
                if (cmd === void 0) { cmd = false; }
                this.keyCode = keyCode;
                this.callback = callback;
                this.needVisibility = needVisibility;
                this.alt = alt;
                this.ctrl = ctrl;
                this.cmd = cmd;
            }
            /**
             * Check if this hot key matched a dom event
             * @param keyboardEvent Event from DOM to match
             */
            HotKey.prototype.shouldHitHotKey = function (keyboardEvent) {
                var matchedKey = (keyboardEvent.key === this.keyCode || keyboardEvent.code === this.keyCode);
                var notMatchedAlt = keyboardEvent.altKey != this.alt;
                var notMatchedCtrl = keyboardEvent.ctrlKey != this.ctrl;
                var notMatchedCmd = keyboardEvent.metaKey != this.cmd;
                var height = document.documentElement.clientHeight;
                var width = document.documentElement.clientWidth;
                var currentElement = document.elementFromPoint((width / 2), (height / 2));
                var notMatchedVisibility = this.needVisibility && !(currentElement && currentElement.classList.contains("rs-cmp") && !currentElement.classList.contains("rs-cover"));
                // Fail if we wanted to match alt/ctrl/cmd/visibility but didnt
                if (notMatchedCtrl || notMatchedAlt || notMatchedCmd || notMatchedVisibility) {
                    return false;
                }
                return matchedKey;
            };
            /**
             * Clone this object with optional new params
             * @param callback Optional clone wiht new callback
             * @param alt Optional clone wiht alt value
             * @param ctrl Optional clone wiht ctrl value
             */
            HotKey.prototype.cloneWith = function (callback, needVisibility, alt, ctrl, cmd) {
                return new HotKey(this.keyCode, callback !== undefined ? callback : this.callback, needVisibility !== undefined ? needVisibility : this.needVisibility, alt !== undefined ? alt : this.alt, ctrl !== undefined ? ctrl : this.ctrl, cmd !== undefined ? cmd : this.cmd);
            };
            return HotKey;
        }());
        Util.HotKey = HotKey;
        function mapObject(obj, f) {
            var tmp = {};
            for (var key in obj) {
                tmp[key] = f(obj[key]);
            }
            return tmp;
        }
        Util.KeyCodes = mapObject(Util.KeyConstants, function (key) { return new HotKey(key, null, true); });
    })(Util = RS.Util || (RS.Util = {}));
})(RS || (RS = {}));
/**
 * Path manipulation utilities.
 */
var RS;
(function (RS) {
    var Path;
    (function (Path) {
        var pathSeperator = "/";
        var urlProtocolRegex = /([a-z]+):\/\//i;
        var IntermediatePath;
        (function (IntermediatePath) {
            function parse(str) {
                var protocol = urlProtocolRegex.exec(str);
                if (protocol) {
                    return {
                        protocol: protocol[1],
                        segments: str.substr(protocol[0].length).split(pathSeperator)
                    };
                }
                else {
                    return { segments: str.split(pathSeperator) };
                }
            }
            IntermediatePath.parse = parse;
            function clean(path) {
                path.segments = path.segments
                    .map(function (seg) { return seg.trim(); })
                    .filter(function (seg) { return seg !== ""; });
            }
            IntermediatePath.clean = clean;
            function stringify(path) {
                if (path.protocol) {
                    return "".concat(path.protocol, "://").concat(path.segments.join("/"));
                }
                else {
                    return path.segments.join("/");
                }
            }
            IntermediatePath.stringify = stringify;
        })(IntermediatePath || (IntermediatePath = {}));
        /**
         * Combines multiple path segments into one.
         * @param segments
         */
        function combine() {
            var segments = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                segments[_i] = arguments[_i];
            }
            var ip = IntermediatePath.parse(segments.join(pathSeperator));
            IntermediatePath.clean(ip);
            return IntermediatePath.stringify(ip);
        }
        Path.combine = combine;
        /**
         * Gets the file name of the specified path (e.g. "my/test/file.txt" => "file.txt").
         * @param path
         */
        function fileName(path) {
            var ip = IntermediatePath.parse(path);
            return ip.segments[ip.segments.length - 1];
        }
        Path.fileName = fileName;
        /**
         * Gets the directory name of the specified path (e.g. "my/test/file.txt" => "my/test").
         * @param path
         */
        function directoryName(path) {
            var ip = IntermediatePath.parse(path);
            if (ip.segments.length > 0) {
                ip.segments.pop();
            }
            return IntermediatePath.stringify(ip);
        }
        Path.directoryName = directoryName;
        /**
         * Resolves any "." and ".." segments of the specified path.
         * @param path
         */
        function normalise(path) {
            var ip = IntermediatePath.parse(path);
            var curPath = [];
            for (var _i = 0, _a = ip.segments; _i < _a.length; _i++) {
                var seg = _a[_i];
                if (seg === "..") {
                    if (curPath.length > 0) {
                        curPath.pop();
                    }
                    else {
                        curPath.push(seg);
                    }
                }
                else if (seg !== ".") {
                    curPath.push(seg);
                }
            }
            return IntermediatePath.stringify({ protocol: ip.protocol, segments: curPath });
        }
        Path.normalise = normalise;
        /**
         * Gets the path from "from" to "to".
         * @param from
         * @param to
         */
        function relative(from, to) {
            var fromIP = IntermediatePath.parse(from);
            var toIP = IntermediatePath.parse(to);
            if (fromIP.protocol !== toIP.protocol) {
                throw new Error("Tried to get relative path with mismatching protocols");
            }
            var equalUntil = 0;
            for (var i = 0, l = Math.min(fromIP.segments.length, toIP.segments.length); i < l; ++i) {
                var fromSeg = fromIP.segments[i];
                var toSeg = toIP.segments[i];
                if (fromSeg !== toSeg) {
                    break;
                }
                equalUntil++;
            }
            if (equalUntil === fromIP.segments.length) {
                // e.g. "foo/bar" -> "foo/bar/other/thing.txt"
                // equalUntil = 2
                return IntermediatePath.stringify({
                    protocol: toIP.protocol,
                    segments: toIP.segments
                        .slice(equalUntil)
                });
            }
            else {
                // e.g. "foo/lol" -> foo/bar/other/thing.txt"
                // equalUntil = 1
                var arr = [];
                for (var i = 0, l = fromIP.segments.length - equalUntil; i < l; ++i) {
                    arr.push("..");
                }
                return IntermediatePath.stringify({
                    protocol: toIP.protocol,
                    segments: arr
                        .concat(toIP.segments.slice(equalUntil))
                });
            }
        }
        Path.relative = relative;
        /**
         * Finds the extension of the given file path (e.g. "my/test/file.txt" => ".txt").
         * @param path
         */
        function extension(path) {
            var matchResult = /(\.[a-zA-Z0-9]+)$/g.exec(path);
            if (!matchResult || matchResult.length <= 1) {
                return "";
            }
            return matchResult[1];
        }
        Path.extension = extension;
        /**
         * Replaces the extension of the given file path (e.g. "my/test/file.txt" => "my/test/file.json" with newExt = ".json").
         * @param path
         * @param newExt
         */
        function replaceExtension(path, newExt) {
            return path.replace(/(\.[a-zA-Z0-9]+)$/g, newExt);
        }
        Path.replaceExtension = replaceExtension;
    })(Path = RS.Path || (RS.Path = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Performance;
    (function (Performance) {
        var DeviceRenderer;
        (function (DeviceRenderer) {
            DeviceRenderer.Canvas = "Canvas";
            DeviceRenderer.WebGL = "WebGL";
        })(DeviceRenderer = Performance.DeviceRenderer || (Performance.DeviceRenderer = {}));
        var Level;
        (function (Level) {
            Level[Level.Poor = 0] = "Poor";
            Level[Level.Low = 1] = "Low";
            Level[Level.Medium = 2] = "Medium";
            Level[Level.High = 3] = "High";
            Level[Level.Uncertain = 4] = "Uncertain";
        })(Level = Performance.Level || (Performance.Level = {}));
        /**
         * List of Apple GPUs as of 24th October 2018
         */
        var AppleGPUs;
        (function (AppleGPUs) {
            /**
             * iPhone 6
             */
            AppleGPUs.Generic = "Apple GPU";
            /**
             * Used in -
             * iPad 1st Gen,
             * iPhone 4,
             * iPod Touch 4th Gen,
             * Apple TV 2nd Gen
             */
            AppleGPUs.A4 = "Apple A4 GPU";
            /**
             * Used in -
             * iPad 2,
             * iPhone 4S,
             * Apple TV 3rd Gen,
             * iPod Touch 5th Gen,
             * iPad Mini 1st Gen
             */
            AppleGPUs.A5 = "Apple A5 GPU";
            /**
             * Used in -
             * iPad 3rd Gen
             */
            AppleGPUs.A5X = "Apple A5X GPU";
            /**
             * Used in -
             * iPhone 5,
             * iPhone 5C
             */
            AppleGPUs.A6 = "Apple A6 GPU";
            /**
             * Used in -
             * iPad 4th Gen
             */
            AppleGPUs.A6X = "Apple A6X GPU";
            /**
             * Used in -
             * iPhone 5S,
             * iPad Mini 2,
             * iPad Mini 3,
             * iPad Air 1st Gen
             */
            AppleGPUs.A7 = "Apple A7 GPU";
            /**
             * Used in -
             * iPhone 6,
             * iPhone 6 Plus,
             * iPod Touch 6th Gen,
             * iPad Mini 4,
             * Apple TV 4th Gen,
             * HomePod
             */
            AppleGPUs.A8 = "Apple A8 GPU";
            /**
             * Used in -
             * iPad Air 2
             */
            AppleGPUs.A8X = "Apple A8X GPU";
            /**
             * Used in -
             * iPhone 6S,
             * iPhone 6S Plus,
             * iPhone SE,
             * iPad 2017
             */
            AppleGPUs.A9 = "Apple A9 GPU";
            /**
             * Used in -
             * iPad Pro 1st Gen
             */
            AppleGPUs.A9X = "Apple A9X GPU";
            /**
             * Used in -
             * iPhone 7,
             * iPhone 7 Plus,
             * iPad 2018
             */
            AppleGPUs.A10 = "Apple A10 GPU";
            /**
             * Used in -
             * iPad Pro 2nd Gen,
             * Apple TV 4K
             */
            AppleGPUs.A10X = "Apple A10X GPU";
            /**
             * Used in -
             * iPhone 8,
             * iPhone 8 Plus,
             * iPhone X
             */
            AppleGPUs.A11 = "Apple A11 GPU";
            /**
             * Used in -
             * iPhone XS,
             * iPhone XS Max,
             * iPhone XR
             */
            AppleGPUs.A12 = "Apple A12 GPU";
            /**
             * Alternative name for older devices
             */
            AppleGPUs.PowerVR535 = "PowerVR SGX 535";
            /**
             * Alternative name for older devices
             */
            AppleGPUs.PowerVR543 = "PowerVR SGX 543";
            /**
             * Alternative name for older devices
             */
            AppleGPUs.PowerVR554 = "PowerVR SGX 554";
        })(AppleGPUs = Performance.AppleGPUs || (Performance.AppleGPUs = {}));
        /**
         * List of ARM GPUs based off the supported devices list as of 24th October 2018
         */
        var ARMGPUs;
        (function (ARMGPUs) {
            /**
             * Used in -
             * Samsung Galaxy S6
             */
            ARMGPUs.MaliT760 = "Mali-T760";
            /**
             * Used in -
             * Samsung Galaxy S7 Edge (G935FD, G935F, G935W8)
             */
            ARMGPUs.MaliT880 = "Mali-T880";
            /**
             * Used in -
             * Samsung Galaxy S8 (EMEA)
             */
            ARMGPUs.MaliG71 = "Mali-G71";
            /**
             * Used in -
             * Samsung Galaxy S9 (EMEA)
             */
            ARMGPUs.MaliG72 = "Mali-G72";
            /**
             * Used in -
             * Samsung Galaxy S10
             */
            ARMGPUs.MaliG76 = "Mali-G76";
        })(ARMGPUs = Performance.ARMGPUs || (Performance.ARMGPUs = {}));
        /**
         * List of Qualcomm GPUs based off the supported devices list as of 24th October 2018
         */
        var QualcommGPUs;
        (function (QualcommGPUs) {
            /**
             * Used in -
             * GALAXY TAB A
             */
            QualcommGPUs.Adreno306 = "Adreno (TM) 306";
            /**
             * Used in -
             * Nexus 7
             */
            QualcommGPUs.Adreno320 = "Adreno (TM) 320";
            /**
             * Used in -
             * HTC One M8,
             * Sony Xperia Z3,
             * Samsung Galaxy S5
             */
            QualcommGPUs.Adreno330 = "Adreno (TM) 330";
            /**
             * Used in -
             * Galaxy C5
             */
            QualcommGPUs.Adreno405 = "Adreno (TM) 405";
            /**
             * Used in -
             * Samsung Galaxy S7 Edge (G9350)
             */
            QualcommGPUs.Adreno530 = "Adreno (TM) 530";
            /**
             * Used in -
             * Samsung Galaxy S8 (USA & China)
             */
            QualcommGPUs.Adreno540 = "Adreno (TM) 540";
            /**
             * Used in -
             * Samsung Galaxy S9 (USA/LATAM & China)
             */
            QualcommGPUs.Adreno630 = "Adreno (TM) 630";
            /**
             * Used in -
             * Samsung Galaxy S10
             */
            QualcommGPUs.Adreno640 = "Adreno (TM) 640";
        })(QualcommGPUs = Performance.QualcommGPUs || (Performance.QualcommGPUs = {}));
        /** Curated list of really low performance GPUs */
        Performance.superLowPerformanceDevices = [
            QualcommGPUs.Adreno306,
            QualcommGPUs.Adreno320,
            QualcommGPUs.Adreno330,
            AppleGPUs.A4,
            AppleGPUs.A5,
            AppleGPUs.A5X,
            AppleGPUs.A6,
            AppleGPUs.A6X,
            AppleGPUs.A7,
            AppleGPUs.PowerVR535,
            AppleGPUs.PowerVR543,
            AppleGPUs.PowerVR554,
        ];
        /**
         * Curated list of low performance GPUs
         */
        Performance.defaultLowPerformanceGPUs = [
            AppleGPUs.A8,
            AppleGPUs.A8X,
            QualcommGPUs.Adreno405,
        ];
        /**
         * Curated list of medium performance GPUs
         */
        Performance.defaultMediumPerformanceGPUs = [
            AppleGPUs.A9,
            AppleGPUs.A9X,
            AppleGPUs.A10,
            AppleGPUs.A10X,
            ARMGPUs.MaliT760,
            ARMGPUs.MaliT880,
            QualcommGPUs.Adreno530
        ];
        /**
         * Curated list of high performance GPUs
         */
        Performance.defaultHighPerformanceGPUs = [
            AppleGPUs.A11,
            AppleGPUs.A12,
            ARMGPUs.MaliG71,
            ARMGPUs.MaliG72,
            ARMGPUs.MaliG76,
            QualcommGPUs.Adreno540,
            QualcommGPUs.Adreno630,
            QualcommGPUs.Adreno640
        ];
        /** Current Performance Level */
        var performanceLevel = null;
        /**
         * The name given to all GPUs on iOS12.2+
         */
        var defaultIOS12_2GPUName = AppleGPUs.Generic;
        /**
         * Default performance levels of different groups of iPhones for when we're uncertain of the exact model.
         */
        /** Devices that run iOS 13+ should be good enough to give good performance. */
        var uncertainAppleDeviceIOS13_plus = Level.High;
        /** Devices that are from the 10 range and above should be good enough to give good performance. */
        var uncertainAppleDeviceModel10_and_above = Level.High;
        /** Devices that are anywhere from and between the 5 to 8 range can have very varying performance
        they could have 1gb Ram and crash on load, or 2gb and run okay.
        therefore set to uncertain and allow devs to decide. */
        var uncertainAppleDeviceModel5_to_8 = Level.Uncertain;
        /** Devices that are from the 4 range and below are not supported and have poor performance. */
        var uncertainAppleDeviceModel4S_and_below = Level.Poor;
        /**
        * Returns the performance of the device. Covers all Apple devices and all other
        * devices specified on the supported devices list as of 2nd September 2019.
        * If the device is using a canvas renderer then we will assume it has bad
        * performance since IE and older devices such as the iPhone 5s mainly use it.
        * Otherwise it will return a value based off its location in a curated list of
        * device GPUs, or if it is not present in one of those lists then it will default
        * to high performance for desktop, and medium for mobile devices.  This is a
        * generalisation, but for the most part will give a good representation of how
        * the device can perform, particularly for Apple and officially supported devices.
        *
        * @returns Performance level of the device.
        */
        function getDevicePerformance() {
            // Set Performance Level
            if (performanceLevel === null) {
                var forcedLevel = RS.URL.getParameterAsEnumVal(Level, "forceperflevel");
                if (forcedLevel != null) {
                    performanceLevel = forcedLevel;
                }
                else {
                    var deviceRenderer_1 = RS.Capabilities.WebGL.getRenderer();
                    // Find performance value based upon which group the GPU is in
                    var level = [Performance.superLowPerformanceDevices, Performance.defaultLowPerformanceGPUs, Performance.defaultMediumPerformanceGPUs, Performance.defaultHighPerformanceGPUs]
                        .map(function (value, index, array) { return getLevel(value, index, array, deviceRenderer_1); });
                    if (Math.max.apply(Math, level) > -1) {
                        performanceLevel = Math.max.apply(Math, level);
                    }
                    else if (deviceRenderer_1 === DeviceRenderer.Canvas) {
                        performanceLevel = RS.Device.isAppleDevice ? Level.Poor : Level.Low;
                    }
                    // All desktop devices should be level.high
                    else if (RS.Device.isDesktopDevice) {
                        performanceLevel = Level.High;
                    }
                    // Get edge case iOS performance Levels
                    if (performanceLevel == null) {
                        // Check if the gpu is the Apple Generic GPU that is always reported in iOS 12.2+
                        // If it's generic GPU, it's either really old, or post iOS 12.2
                        if (deviceRenderer_1 === defaultIOS12_2GPUName) {
                            var operatingSystemVersion = RS.Device.operatingSystem.version.split(".");
                            // If running iOS 13 it's a decent device and should manage high settings
                            if (parseInt(operatingSystemVersion[0]) >= 13) {
                                performanceLevel = uncertainAppleDeviceIOS13_plus;
                            }
                            // If running iOS 12.2 -> 13 it's potentially anything between
                            else if ((operatingSystemVersion[0] == "12") && (parseInt(operatingSystemVersion[1]) >= 2)) {
                                // Check if the screen resolution gives any clues
                                performanceLevel = getIphoneGroupFromResolution();
                            }
                            // If we get to here without triggering either of the above if statements, device is running < iOS 12.2
                            // and has Apple Generic GPU it's ancient and probably haunted. Therefore the performance value calculated
                            // earlier based upon which group the GPU is in is accurate.
                        }
                    }
                    // If we've gotten this far then we'll assume that we're not able to determine the performance level of this GPU
                    // so we'll use the lowest performance level
                    if (performanceLevel == null) {
                        performanceLevel = Level.High;
                    }
                }
                RS.Log.debug("Performance - Renderer: " + RS.Capabilities.WebGL.getRenderer());
                RS.Log.debug("Performance - Device Level: " + Level[performanceLevel]);
            }
            // Else return set value
            return performanceLevel;
        }
        Performance.getDevicePerformance = getDevicePerformance;
        function getLevel(listOfDevices, index, array, device) {
            if (listOfDevices.indexOf(device) > -1) {
                return index;
            }
            else {
                return -1;
            }
        }
        function isPoor() {
            return getDevicePerformance() === Level.Poor;
        }
        Performance.isPoor = isPoor;
        function isLow() {
            return getDevicePerformance() === Level.Low;
        }
        Performance.isLow = isLow;
        function isMedium() {
            return getDevicePerformance() === Level.Medium;
        }
        Performance.isMedium = isMedium;
        function isHigh() {
            return getDevicePerformance() === Level.High;
        }
        Performance.isHigh = isHigh;
        /**
         * A function to decide the device performance based upon the aspect ratio and devicePixelRatio.
         * Although we can't narrow it down to specific devices, we can calculate a rough range.
         */
        function getIphoneGroupFromResolution() {
            var aspectRatio = (Math.max(window.screen.height, window.screen.width) / Math.min(window.screen.height, window.screen.width));
            var devicePixelRatio = window.devicePixelRatio;
            if ((aspectRatio == 1.5 && devicePixelRatio == 2) || devicePixelRatio == 1) {
                // Device is anything from iPhone 1 line to iPhone 4S line, all screen sizes included. Not supported
                return uncertainAppleDeviceModel4S_and_below;
            }
            else {
                // Device is a higher tier (>8) iPhone
                return uncertainAppleDeviceModel10_and_above;
            }
        }
        /**
         * Benchmarks the given function, returning the average time the function took to run.
         * @param func
         * @param size Sample size; number of times func is called.
         */
        function benchmark(func, size) {
            if (size === void 0) { size = 1000000; }
            var start = Date.now();
            for (var i = 0; i < size; i++) {
                func();
            }
            var time = Date.now() - start;
            return time / size;
        }
        Performance.benchmark = benchmark;
    })(Performance = RS.Performance || (RS.Performance = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Reflect;
    (function (Reflect) {
        // TODO es6/2015 deprecate these functions or at least re-evaluate all calls; they only really exist because super.get and super.set aren't transpiled to es5
        // TS AST transformer could also be used to implement super.get/set?
        function getValueUsingDescriptor(target, descriptor) {
            if (descriptor.get) {
                return descriptor.get.call(target);
            }
            if (descriptor.value) {
                return descriptor.value;
            }
            return undefined;
        }
        Reflect.getValueUsingDescriptor = getValueUsingDescriptor;
        function setValueUsingDescriptor(target, descriptor, value) {
            if (descriptor.writable === false) {
                RS.Log.warn("Tried to set an unwritable property");
                return;
            }
            if (descriptor.set) {
                return descriptor.set.call(target, value);
            }
            if (descriptor.value) {
                descriptor.value = value;
            }
        }
        Reflect.setValueUsingDescriptor = setValueUsingDescriptor;
    })(Reflect = RS.Reflect || (RS.Reflect = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    /**
     * Implements a local storage class, this allows the game to load and save information from the localStorage object.
     */
    var Storage = /** @class */ (function () {
        function Storage() {
        }
        var _propObj = {};

        _propObj.initialised = {
            get: function () { return this._initialised; },
            enumerable: false,
            configurable: true
        };

        _propObj.onInitialised = {
            get: function () { return this._onInitialised.public; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(Storage, _propObj);
        /**
         * Initialise the localStorage object, specify a game name to ensure we write to storage for our game.
         */
        Storage.init = function (gameName, version) {
            if (!Storage._defaultInit && Storage._initialised) {
                RS.Log.warn("RS.Storage initialised twice");
            }
            Storage._gameName = gameName;
            Storage._version = version;
            Storage._defaultInit = false;
            Storage._initialised = true;
            Storage._onInitialised.publish();
        };
        /**
         * Saves a value to local storage. Objects will be converted to a JSON string before being stored.
         */
        Storage.save = function (key, value, core) {
            if (core === void 0) { core = false; }
            var saveValue = JSON.stringify(value);
            Storage.try(function () { return localStorage.setItem(Storage.getKey(key, core), saveValue); });
        };
        /**
         * Deletes a value from local storage.
         */
        Storage.delete = function (key, core) {
            if (core === void 0) { core = false; }
            Storage.try(function () { return localStorage.removeItem(Storage.getKey(key, core)); });
        };
        /**
         * Loads a value from local storage.
         */
        Storage.load = function (key, defaultValue, core) {
            if (core === void 0) { core = false; }
            var value = Storage.try(function () { return localStorage.getItem(Storage.getKey(key, core)); });
            if (value == null) {
                return defaultValue;
            }
            try {
                return JSON.parse(value);
            }
            catch (err) {
                return defaultValue;
            }
        };
        Storage.getKey = function (key, core) {
            if (core === void 0) { core = false; }
            if (core) {
                return "sgd/synergy/".concat(key);
            }
            Storage.checkInit();
            return "sgd/".concat(Storage._gameName, "/").concat(Storage._version, "/").concat(key);
        };
        /**
         * Checks if initialised and initialises with defaults if not
         * Throws error if no defaults
         */
        Storage.checkInit = function () {
            if (!Storage._initialised) {
                if (Storage.DefaultGameName == null || Storage.DefaultVersion == null) {
                    throw new Error("RS.Storage.getKey: Accessing Local Storage without initialising RS.Storage and without any default values set");
                }
                Storage.init(Storage.DefaultGameName, Storage.DefaultVersion);
                Storage._defaultInit = true;
            }
        };
        /**
         * Tries to perform given localStorage function, returns null if it errors out
         */
        Storage.try = function (fn) {
            try {
                return fn();
            }
            catch (_a) {
                RS.Log.warn("Unable to access LocalStorage due to browser settings");
                return null;
            }
        };
        Storage._initialised = false;
        Storage._onInitialised = RS.createSimpleEvent();
        /** Default version to init with if not initialised before trying to access a key */
        Storage.DefaultVersion = "1.0.2";
        /** Indicates if the default init was used so we don't log a warning unless we have to */
        Storage._defaultInit = false;
        return Storage;
    }());
    RS.Storage = Storage;
})(RS || (RS = {}));
var RS;
(function (RS) {
    var OneOrMany;
    (function (OneOrMany) {
        /**
         * If array, loop through the OneOrMany object and call given function on each one
         * otherwise just call func on the OneOrMany object itself
         * @param oneOrMany
         * @param func function to apply
         * @returns OneOrMany<R>
         */
        function apply(oneOrMany, func) {
            var params = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                params[_i - 2] = arguments[_i];
            }
            return RS.Is.array(oneOrMany) ?
                oneOrMany.map(function (single) { return func.apply(void 0, __spreadArray([single], params, false)); }) : func.apply(void 0, __spreadArray([oneOrMany], params, false));
        }
        OneOrMany.apply = apply;
    })(OneOrMany = RS.OneOrMany || (RS.OneOrMany = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var isArray = Array.isArray;
    function stringifyArg(arg) {
        if (arg == null) {
            return "".concat(arg);
        }
        if (RS.Is.func(arg)) {
            return "".concat(arg);
        }
        if (RS.Is.object(arg)) {
            var stringVal = arg.toString();
            if (stringVal !== "[object Object]") {
                return stringVal;
            }
        }
        // Deep stringify arrays and simple object args using JSON.stringify
        return RS.Dump.stringify(arg, function () { return true; });
    }
    function ValidateNotEmpty(value) {
        if (value == null) {
            return null;
        }
        if (value.length === 0) {
            return "must not be empty";
        }
        return null;
    }
    function ArgIs(validators, name, error) {
        if (validators == null) {
            throw new Error("ArgIs requires 1 or more validators");
        }
        if (RS.Is.array(validators)) {
            if (validators.length === 0) {
                throw new Error("ArgIs requires 1 or more validators");
            }
            var validator = validators.length === 1 ? validators[0] : Validate.AllOf.apply(Validate, __spreadArray([validators[0], validators[1]], validators.slice(2), false));
            return Validate.Argument({ validator: validator, name: name, error: error });
        }
        else {
            var validator = validators;
            return Validate.Argument({ validator: validator, name: name, error: error });
        }
    }
    RS.ArgIs = ArgIs;
    /** Contains validation decorators. See RS.Validation */
    var Validate;
    (function (Validate) {
        /** Applies validation to an argument according to certain settings. The method must also be decorated with Validate.Method. */
        Validate.Argument = RS.Decorators.Tag.create(RS.Decorators.TagKind.Parameter);
        /** Applies validation for a method according to certain settings. One or more parameters should also be decorated with Validate.Argument. */
        function Method(settings) {
            if (settings === void 0) { settings = {}; }
            return function (target, key, descriptor) {
                return __assign(__assign({}, descriptor), { value: function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        var settingsMap = Validate.Argument.get(this, RS.Is.func(target) ? RS.Decorators.MemberType.Static : RS.Decorators.MemberType.Instance, key);
                        for (var i = 0; i < args.length; i++) {
                            var validationSettings = settingsMap[i];
                            if (!validationSettings) {
                                continue;
                            }
                            var arg = args[i];
                            var method = settings.name || key;
                            var param = validationSettings.name || "parameter ".concat(i);
                            var err = void 0;
                            try {
                                err = validationSettings.validator.validate(arg);
                            }
                            catch (error) {
                                throw new Error("".concat(method, ": ").concat(param, " validator threw an error for argument ").concat(stringifyArg(arg), ":\n").concat(error));
                            }
                            if (!err) {
                                continue;
                            }
                            var failedBecause = validationSettings.error || err;
                            throw new Error("".concat(method, ": ").concat(param, " ").concat(failedBecause, " (got ").concat(stringifyArg(arg), ")"));
                        }
                        return descriptor.value.apply(this, args);
                    } });
            };
        }
        Validate.Method = Method;
        function AllOf() {
            var validators = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                validators[_i] = arguments[_i];
            }
            if (validators.some(function (validator) { return validator == null; })) {
                throw new Error("AllOf validators must not be null");
            }
            if (validators.length === 0) {
                throw new Error("AllOf requires 1 or more validators");
            }
            return {
                validate: function (value) {
                    for (var _i = 0, validators_1 = validators; _i < validators_1.length; _i++) {
                        var validator = validators_1[_i];
                        var err = validator.validate(value);
                        if (err) {
                            return err;
                        }
                    }
                    return null;
                }
            };
        }
        Validate.AllOf = AllOf;
        function AnyOf() {
            var validators = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                validators[_i] = arguments[_i];
            }
            if (validators.some(function (validator) { return validator == null; })) {
                throw new Error("AnyOf validators must not be null");
            }
            if (validators.length === 0) {
                throw new Error("AnyOf requires 1 or more validators");
            }
            return {
                validate: function (value) {
                    var errs;
                    for (var _i = 0, validators_2 = validators; _i < validators_2.length; _i++) {
                        var validator = validators_2[_i];
                        var err = validator.validate(value);
                        if (!err) {
                            return null;
                        }
                        if (errs) {
                            errs += " or ".concat(err);
                        }
                        else {
                            errs = err;
                        }
                    }
                    return errs;
                }
            };
        }
        Validate.AnyOf = AnyOf;
        function OneOf() {
            var values = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                values[_i] = arguments[_i];
            }
            if (values.length === 0) {
                throw new Error("OneOf requires 1 or more validators");
            }
            return {
                validate: function (value) {
                    if (value == null) {
                        return null;
                    }
                    if (values.indexOf(value) === -1) {
                        return "must be ".concat(values.join(" or "));
                    }
                    return null;
                }
            };
        }
        Validate.OneOf = OneOf;
        /** Validates that a value is not null or undefined. */
        Validate.NotNull = {
            validate: function (value) {
                if (value == null) {
                    return "must not be null";
                }
                return null;
            }
        };
        /** Validates that a value is a non-NaN number. Contains additional numeric validators. Does not require that the value not be null. */
        Validate.Number = {
            validate: function (value) {
                if (value == null) {
                    return null;
                }
                if (!RS.Is.number(value)) {
                    return "must be a number";
                }
                return null;
            },
            /** Validates that a number is greater than or equal to min and less than or equal to max. */
            InRange: function (min, max) {
                return {
                    validate: function (value) {
                        if (value < min) {
                            return "must be at least ".concat(min);
                        }
                        if (max < value) {
                            return "must not be greater than ".concat(max);
                        }
                        return null;
                    }
                };
            }
        };
        /** Validates that a value is a non-NaN whole number. Does not require that the value not be null. */
        Validate.Integer = {
            validate: function (value) {
                if (value == null) {
                    return null;
                }
                if (!RS.Is.integer(value)) {
                    return "must be an integer";
                }
                return null;
            }
        };
        /** Validates that a value is a string. Contains additional text validators. Does not require that the value not be null. */
        Validate.String = {
            validate: function (value) {
                if (value == null) {
                    return null;
                }
                if (typeof value !== "string") {
                    return "must be a string";
                }
                return null;
            },
            /** Validates that a string is not empty. Does not validate that the value is a string. */
            NotEmpty: {
                validate: ValidateNotEmpty
            },
            /** Validates that a string matches the given regular expression. Does not validate that the value is a string. */
            Match: function (regExp) {
                return {
                    validate: function (value) {
                        if (value == null) {
                            return null;
                        }
                        if (!regExp.test(value)) {
                            return "must match ".concat(regExp);
                        }
                        return null;
                    }
                };
            }
        };
        /** Validates that a value is a boolean. Does not require that the value not be null. */
        Validate.Boolean = {
            validate: function (value) {
                if (value == null) {
                    return null;
                }
                if (value !== true && value !== false) {
                    return "must be a boolean";
                }
                return null;
            }
        };
        /** Validates that a value is a function. Does not require that the value not be null. */
        Validate.Func = {
            validate: function (value) {
                if (value == null) {
                    return null;
                }
                if (typeof value !== "function") {
                    return "must be a function";
                }
                return null;
            }
        };
        /** Validates that a value is an array. Does not require that the value not be null. */
        Validate.Array = {
            validate: function (value) {
                if (value == null) {
                    return null;
                }
                if (!isArray(value)) {
                    return "must be an array";
                }
                return null;
            },
            /** Validates that an array is not empty. Does not validate that the value is an array. */
            NotEmpty: {
                validate: ValidateNotEmpty
            }
        };
        /** Validates that a value is an array, whose elements all pass a given inner validator. Does not require that the value not be null. */
        function ArrayOf(validator) {
            return {
                validate: function (value) {
                    if (value == null) {
                        return null;
                    }
                    if (!isArray(value)) {
                        return "must be an array";
                    }
                    for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
                        var member = value_1[_i];
                        var err = validator.validate(member);
                        if (err) {
                            return "members ".concat(err);
                        }
                    }
                    return null;
                }
            };
        }
        Validate.ArrayOf = ArrayOf;
        /** Validates that a value is an object. Does not match arrays. Does not require that the value not be null. */
        Validate.Object = {
            validate: function (value) {
                if (value == null) {
                    return null;
                }
                if (typeof value !== "object" || isArray(value)) {
                    return "must be an object";
                }
                return null;
            }
        };
    })(Validate = RS.Validate || (RS.Validate = {}));
})(RS || (RS = {}));
/// <reference path="../Strategy.ts" />
var RS;
(function (RS) {
    var Controllers;
    (function (Controllers) {
        /**
         * Declares a controller of the specified type.
         * @param type
         */
        function declare(type, allowOverrides) {
            if (type === void 0) { type = RS.Strategy.Type.Instance; }
            if (allowOverrides === void 0) { allowOverrides = RS.Strategy.Overridable.Never; }
            return RS.Strategy.declare(type, false, allowOverrides);
        }
        Controllers.declare = declare;
    })(Controllers = RS.Controllers || (RS.Controllers = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    function stringifyArg(arg) {
        if (arg == null) {
            return "".concat(arg);
        }
        if (RS.Is.func(arg)) {
            return "".concat(arg);
        }
        if (RS.Is.object(arg)) {
            var stringVal = arg.toString();
            if (stringVal !== "[object Object]") {
                return stringVal;
            }
        }
        // Deep stringify arrays and simple object args using JSON.stringify
        return RS.Dump.stringify(arg, function () { return true; });
    }
    function DebugLog(context, messageIn, p2, p3) {
        var logger = RS.Is.string(context) ? RS.Logging.ILogger.get().getContext(context) : context;
        var messageOut, includeArgs;
        if (RS.Is.boolean(p2)) {
            includeArgs = p2;
        }
        else {
            messageOut = p2;
            includeArgs = p3 == null ? messageIn == null : p3;
        }
        return function (target, propertyKey, propertyDescriptor) {
            if (!propertyDescriptor) {
                RS.Log.warn("DebugLog decorator applied to an invalid method");
                return;
            }
            var propMessageIn = messageIn || propertyKey;
            var oldFunc = propertyDescriptor.value;
            propertyDescriptor.value = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var prefixMessage = includeArgs
                    ? "".concat(propMessageIn, "(").concat(args.map(function (a) { return stringifyArg(a); }).join(", "), ")")
                    : "".concat(propMessageIn);
                logger.log(prefixMessage, RS.Logging.LogLevel.Debug);
                var retVal = oldFunc.apply(this, args);
                if (messageOut) {
                    logger.log("".concat(messageOut), RS.Logging.LogLevel.Debug);
                }
                return retVal;
            };
            Object.defineProperty(target, propertyKey, propertyDescriptor);
        };
    }
    RS.DebugLog = DebugLog;
})(RS || (RS = {}));
var RS;
(function (RS) {
    /** Used to avoid creating a big object unless it's actually going to be used. */
    function Lazy(generator) {
        return function (target, key) {
            // Normal property, use a closure getter.
            return {
                get: function () {
                    var val = generator(this);
                    var replacementDescriptor = {
                        get: function () { return val; },
                        enumerable: true,
                        configurable: true
                    };
                    Object.defineProperty(this, key, replacementDescriptor);
                    return val;
                },
                enumerable: true,
                configurable: true
            };
        };
    }
    RS.Lazy = Lazy;
})(RS || (RS = {}));
var RS;
(function (RS) {
    var shouldExposeCommand = true;
    var commandName = "rsdump";
    RS.IDump = RS.Strategy.declare(RS.Strategy.Type.Singleton, false, true);
    if (shouldExposeCommand) {
        window[commandName] = function () {
            return __awaiter(this, void 0, void 0, function () {
                var dump;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            dump = RS.IDump.get();
                            return [4 /*yield*/, dump.save()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
    }
    window.addEventListener("error", function (ev) {
        var dump = RS.IDump.get();
        if (!dump.enabled) {
            return;
        }
        var subDump = dump.getSubDump("UncaughtErrors");
        var date = new Date();
        var datetime = RS.Dump.getTimestamp(date);
        var timestamp = date.getTime();
        subDump.add({ "error": ev.error, "datetime": datetime, "timestamp": timestamp, "promise": false });
    });
    window.addEventListener("unhandledrejection", function (ev) {
        var dump = RS.IDump.get();
        if (!dump.enabled) {
            return;
        }
        var subDump = dump.getSubDump("UncaughtErrors");
        var date = new Date();
        var datetime = RS.Dump.getTimestamp(date);
        var timestamp = date.getTime();
        subDump.add({ "error": ev.reason, "datetime": datetime, "timestamp": timestamp, "promise": true });
    });
})(RS || (RS = {}));
/// <reference path="IDump.ts"/>
var RS;
(function (RS) {
    var FileDump = /** @class */ (function () {
        function FileDump() {
            this.enabled = false;
            this.onPreSave = RS.createEvent();
            this._subDumps = {};
            this._isDisposed = false;
        }
        var _propObj = {};

        _propObj.isDisposed = {
            get: function () { return this._isDisposed; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(FileDump.prototype, _propObj);
        FileDump.prototype.getSubDump = function (name) {
            return this._subDumps[name] || (this._subDumps[name] = new SubDump(this));
        };
        FileDump.prototype.clear = function () {
            for (var subDumpName in this._subDumps) {
                var subDump = this._subDumps[subDumpName];
                subDump.clear();
            }
        };
        FileDump.prototype.save = function () {
            var map = {};
            try {
                this.onPreSave.publish(this);
            }
            catch (e) {
                // We don't want a bad dump handler to lose us the rest of the dump.
                // Save error to the dump and continue.
                var errArr = map["DumpError"] || (map["DumpError"] = []);
                errArr.push("Dump.onPreSave encountered an error during publish: ".concat(e instanceof Error ? e.stack : e));
            }
            var subDumpNames = Object.keys(this._subDumps).sort();
            for (var _i = 0, subDumpNames_1 = subDumpNames; _i < subDumpNames_1.length; _i++) {
                var subDumpName = subDumpNames_1[_i];
                var subDump = this._subDumps[subDumpName];
                map[subDumpName] = subDump.data;
            }
            var text = RS.Dump.stringify(map);
            var curTime = RS.Dump.getTimestamp();
            var blob = new Blob([text], { type: "application/octet-stream" });
            RS.URL.download("dump-".concat(curTime, ".json"), blob);
            for (var subDumpName in this._subDumps) {
                var subDump = this._subDumps[subDumpName];
                if (subDump.clearOnSave) {
                    subDump.clear();
                }
            }
        };
        FileDump.prototype.dispose = function () {
            if (this._isDisposed) {
                return;
            }
            this.clear();
            this._isDisposed = true;
        };
        FileDump.prototype.undeclare = function (subDump) {
            for (var key in this._subDumps) {
                var thisSubDump = this._subDumps[key];
                if (thisSubDump === subDump) {
                    delete this._subDumps[key];
                }
            }
        };
        var _decObj = {};

        _decObj.onPreSave = {
            decorators: [RS.AutoDispose],
            target: FileDump.prototype,
            desc: void 0
        };

        __multiDecorate(_decObj);
        return FileDump;
    }());
    RS.FileDump = FileDump;
    var SubDump = /** @class */ (function () {
        function SubDump(_dump) {
            this._dump = _dump;
            this.clearOnSave = false;
            this._data = [];
            this._isDisposed = false;
        }
        var _propObj = {};

        _propObj.data = {
            get: function () { return this._data; },
            enumerable: false,
            configurable: true
        };

        _propObj.isDisposed = {
            get: function () { return this._isDisposed; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(SubDump.prototype, _propObj);
        SubDump.prototype.dispose = function () {
            if (this._isDisposed) {
                return;
            }
            this._dump.undeclare(this);
            this._isDisposed = true;
        };
        SubDump.prototype.add = function (data, p2) {
            var whitelistFn = RS.Is.func(p2) ? p2 : function () { return p2; };
            if (!this._dump.enabled) {
                return;
            }
            try {
                var prepared = RS.Is.primitive(data) ? data : RS.Dump.prepare(data, whitelistFn);
                this._data.push(prepared);
            }
            catch (err) {
                this._data.push("SubDump.add() failed: ".concat(err instanceof Error ? err.stack : err));
                RS.Log.error("SubDump.add() failed", err);
            }
        };
        SubDump.prototype.clear = function () {
            this._data.length = 0;
        };
        return SubDump;
    }());
    RS.SubDump = SubDump;
    RS.IDump.register(FileDump);
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Dump;
    (function (Dump) {
        /** Gets a human-readable timestamp from the given date. */
        function getTimestamp(date) {
            if (date === void 0) { date = new Date(); }
            if (RS.Is.number(date)) {
                date = new Date(date);
            }
            var year = "".concat(date.getFullYear());
            // Month is 0 based so we need to add 1
            var month = RS.Util.padLeft("".concat(date.getMonth() + 1), "0", 2);
            // getDate actually returns the day of the month
            var day = RS.Util.padLeft("".concat(date.getDate()), "0", 2);
            var hours = RS.Util.padLeft("".concat(date.getHours()), "0", 2);
            var minutes = RS.Util.padLeft("".concat(date.getMinutes()), "0", 2);
            return "".concat(year, "_").concat(month, "_").concat(day, "-").concat(hours, "_").concat(minutes);
        }
        Dump.getTimestamp = getTimestamp;
        /** Stringifies an object using the given whitelist function. */
        function stringify(target, whitelistFn) {
            return RS.Is.primitive(target) ? JSON.stringify(target) : JSON.stringify(target, getObjectReplacer(target, whitelistFn));
        }
        Dump.stringify = stringify;
        /** Prepares an object for dumping using the given whitelist function. */
        function prepare(object, whitelistFn) {
            var replacer = getObjectReplacer(object, whitelistFn);
            return prepareInternal(object, replacer);
        }
        Dump.prepare = prepare;
        /** Returns true if the given object has members which are also objects. */
        function isDeepObject(value) {
            for (var key in value) {
                var propValue = accessObjectPropertySafe(value, key);
                if (RS.Is.object(propValue)) {
                    return true;
                }
            }
            return false;
        }
        /** Tag added to prepared objects to ensure they are not toString()'d. */
        var preserveTag = "___dumpPreserve";
        /** Constructor name tag. */
        var ctorTag = "__ctor";
        /** toString tag. */
        var strTag = "__str";
        var defaultStr = Object.prototype.toString();
        function prepareInternal(object, replacer) {
            var out = RS.Is.array(object) ? [] : {};
            // Don't stringify this object
            out[preserveTag] = true;
            // Add ctor name to the dump.
            if (object.constructor !== Object && object.constructor !== Array) {
                out[ctorTag] = RS.Util.getClassName(object);
            }
            // Add toString() value to the dump.
            var strVal = stringifyValueSafe(object);
            if (strVal != defaultStr) {
                out[strTag] = strVal;
            }
            // Add the object key-value pairs to the dump
            var ownPropertyNames = Object.getOwnPropertyNames(object);
            for (var _i = 0, ownPropertyNames_1 = ownPropertyNames; _i < ownPropertyNames_1.length; _i++) {
                var key = ownPropertyNames_1[_i];
                var oldValue = accessObjectPropertySafe(object, key);
                if (RS.Is.func(oldValue)) {
                    continue;
                }
                var replacedValue = replacer.call(object, key, oldValue);
                var newValue = (RS.Is.object(replacedValue) || RS.Is.array(replacedValue))
                    ? prepareInternal(replacedValue, replacer)
                    : replacedValue;
                out[key] = newValue;
            }
            return out;
        }
        /** Safely accesses an object property. If the object has an accessor that throws an error, we don't lose the dump. */
        function accessObjectPropertySafe(object, key) {
            try {
                return object[key];
            }
            catch (e) {
                // The error itself could be a rogue custom class and throw an error on toString(), so let's be careful with that too
                return stringifyValueSafe(e);
            }
        }
        /** Safely stringifies a value. If an object has a custom toString() that throws an error, we don't lose the dump. */
        function stringifyValueSafe(value) {
            try {
                return "".concat(value);
            }
            catch (e) {
                // The error itself could be a rogue custom class and throw an error on toString(), so let's be careful with that too
                return stringifyValueSafe(e);
            }
        }
        /** Gets a single-use replacer function. */
        function getObjectReplacer(target, whitelistFn) {
            if (whitelistFn === void 0) { whitelistFn = function () { return false; }; }
            var visited = [];
            return function replacer(key, value) {
                // Discard preserve tags.
                if (key === preserveTag) {
                    return;
                }
                // Keep all non-object values.
                if (!RS.Is.object(value)) {
                    return value;
                }
                // Each object only appears once to prevent infinite looping or circular structur errors as well as keep the dump size down.
                if (visited.indexOf(value) !== -1) {
                    return stringifyValueSafe(value);
                }
                // Flatten objects which contain other objects, unless either the target, tagged as preserve or whitelisted.
                if (isDeepObject(value) && value !== target && !value[preserveTag] && !whitelistFn.call(this, key, value)) {
                    var whitelisted = false;
                    try {
                        whitelisted = whitelistFn.call(this, key, value);
                    }
                    catch (e) {
                        // Whitelist function threw an error, let's just treat it as not whitelisted and carry on.
                        RS.Log.warn("Error in whitelist function: ".concat(e));
                    }
                    if (!whitelisted) {
                        return stringifyValueSafe(value);
                    }
                }
                // Track object.
                visited.push(value);
                return value;
            };
        }
    })(Dump = RS.Dump || (RS.Dump = {}));
})(RS || (RS = {}));
/// <reference path="../Disposable.ts" />
/// <reference path="IObservable.ts" />
var RS;
(function (RS) {
    var Is;
    (function (Is) {
        /**
         * Determines if the given arbiter resolver is a simple arbiter resolver or not.
         * @param value The arbiter resolver.
         */
        function simpleArbiterResolver(value) {
            // Simple resolvers take 2 parameters, complex resolvers take 1 parameter (array of values)
            return value != null && value.length === 2;
        }
        Is.simpleArbiterResolver = simpleArbiterResolver;
    })(Is = RS.Is || (RS.Is = {}));
})(RS || (RS = {}));
/// <reference path="IArbiter.ts" />
var RS;
(function (RS) {
    /**
     * Represents an active declaration on a Arbiter.
     */
    var ArbiterHandle = /** @class */ (function () {
        function ArbiterHandle(arbiter, value) {
            this._arbiter = arbiter;
            this._value = value;
        }
        var _propObj = {};

        _propObj.arbiter = {
            /** The arbiter to which this handle is associated with. */
            get: function () { return this._arbiter; },
            enumerable: false,
            configurable: true
        };

        _propObj.value = {
            /** The state that this handle is trying to enforce. */
            get: function () { return this._value; },
            enumerable: false,
            configurable: true
        };

        _propObj.isDisposed = {
            /** Gets if this handle has been disposed or not. */
            get: function () { return this._arbiter == null; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(ArbiterHandle.prototype, _propObj);
        /**
         * Removes this handle from the Arbiter.
         */
        ArbiterHandle.prototype.dispose = function () {
            if (this._arbiter == null) {
                return;
            }
            this._arbiter.undeclare(this);
            this._arbiter = null;
            this._value = null;
        };
        return ArbiterHandle;
    }());
    RS.ArbiterHandle = ArbiterHandle;
    /**
     * An object encapsulating a single unit of state.
     * - Subscribers can request to be notified when the state of the Arbiter has updated.
     * - Users can declare a modification to the Arbiter's state which is resolved alongside other requests.
     * - Users can release their declaration at any time.
     */
    var Arbiter = /** @class */ (function (_super) {
        __extends(Arbiter, _super);
        function Arbiter(resolver, defaultState) {
            var _this = _super.call(this, defaultState) || this;
            _this._handles = [];
            _this._resolver = resolver;
            _this._defaultValue = defaultState;
            _this.resolveState();
            return _this;
        }
        /**
         * Makes a declaration to modify this Arbiter's state.
         */
        Arbiter.prototype.declare = function (state) {
            var arbiterHandle = new ArbiterHandle(this, state);
            this._handles.push(arbiterHandle);
            this.resolveState();
            return arbiterHandle;
        };
        /**
         * Removes a previously declared handle.
         * Don't use this - call handle.dispose() instead.
         */
        Arbiter.prototype.undeclare = function (handle) {
            var idx = this._handles.indexOf(handle);
            if (idx !== -1) {
                this._handles.splice(idx, 1);
                this.resolveState();
            }
        };
        Arbiter.prototype.toString = function () {
            return "[Arbiter: ".concat(this.valueToString(this._value), "]");
        };
        Arbiter.prototype.resolveState = function () {
            var oldState = this._value;
            var newState = this._handles.length ? this._handles[0].value : this._defaultValue;
            if (RS.Is.simpleArbiterResolver(this._resolver)) {
                for (var i = 1; i < this._handles.length; i++) {
                    newState = this._resolver(newState, this._handles[i].value);
                }
            }
            else if (this._handles.length > 0) {
                var values = this._handles.map(function (e) { return e.value; });
                newState = this._resolver(values);
            }
            if (newState !== oldState) {
                this.value = newState;
            }
        };
        return Arbiter;
    }(RS.Observable));
    RS.Arbiter = Arbiter;
    (function (Arbiter) {
        Arbiter.OrResolver = function (a, b) { return a || b; };
        Arbiter.AndResolver = function (a, b) { return a && b; };
        Arbiter.MaxResolver = function (a, b) { return Math.max(a, b); };
        Arbiter.MinResolver = function (a, b) { return Math.min(a, b); };
        /** Resolver that returns the most recent value, causing the arbiter to behave like a stack. */
        Arbiter.StackResolver = function (a, b) { return b; };
        /**
         * Resolver that returns true if there are more true values than false values.
         * In case of ties, returns true.
         */
        Arbiter.ConsensusResolver = function (values) {
            var trueCount = 0;
            var falseCount = 0;
            for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
                var val = values_1[_i];
                val ? ++trueCount : ++falseCount;
            }
            return trueCount >= falseCount;
        };
        /**
         * Resolver that returns the average value of all declared values.
         */
        Arbiter.AverageResolver = function (values) {
            var sum = values.reduce(function (curr, prev) { return curr + prev; }, 0);
            if (values.length > 0) {
                return sum / values.length;
            }
            else {
                RS.Log.warn("Attempt to divide by 0, returning 0 instead.");
                return 0;
            }
        };
        /**
         * Resolver that returns the sum of all declared values.
         */
        Arbiter.SumResolver = function (a, b) { return a + b; };
    })(Arbiter = RS.Arbiter || (RS.Arbiter = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    /**
     * A generic fixed-size 2D array.
     */
    var Array2D = /** @class */ (function () {
        function Array2D(columns, rows, initialValue) {
            this._cols = columns;
            this._rows = rows;
            this._data = new Array(columns * rows);
            if (initialValue !== undefined) {
                this.set(initialValue);
            }
        }
        var _propObj = {};

        _propObj.columns = {
            /** Gets the number of columns in this array. */
            get: function () { return this._cols; },
            enumerable: false,
            configurable: true
        };

        _propObj.rows = {
            /** Gets the number of rows in this array. */
            get: function () { return this._rows; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(Array2D.prototype, _propObj);
        Array2D.prototype.set = function (colIndexOrValue, rowIndex, value) {
            if (rowIndex != null) {
                var colIndex = colIndexOrValue;
                if (colIndex < 0 || colIndex >= this._cols) {
                    throw new Error("colIndex out of bounds");
                }
                if (rowIndex < 0 || rowIndex >= this._rows) {
                    throw new Error("rowIndex out of bounds");
                }
                this._data[rowIndex * this._cols + colIndex] = value;
            }
            else {
                for (var i = 0; i < this._data.length; i++) {
                    this._data[i] = colIndexOrValue;
                }
            }
        };
        /**
         * Gets the value of the specified cell.
         */
        Array2D.prototype.get = function (colIndex, rowIndex) {
            if (colIndex < 0 || colIndex >= this._cols) {
                throw new Error("colIndex out of bounds");
            }
            if (rowIndex < 0 || rowIndex >= this._rows) {
                throw new Error("rowIndex out of bounds");
            }
            return this._data[rowIndex * this._cols + colIndex];
        };
        /**
         * Creates a copy of this array.
         */
        Array2D.prototype.clone = function () {
            var obj = Object.create(Array2D.prototype);
            obj._cols = this._cols;
            obj._rows = this._rows;
            obj._data = __spreadArray([], this._data, true);
            return obj;
        };
        /**
         * Gets if the content of this array is equal to the other.
         */
        Array2D.prototype.equals = function (other) {
            if (other.columns !== this.columns || other.rows !== this.rows) {
                return false;
            }
            for (var i = 0; i < other._data.length; i++) {
                if (other._data[i] !== this._data[i]) {
                    return false;
                }
            }
            return true;
        };
        /**
         * Returns a copy of the specified column.
         */
        Array2D.prototype.getColumn = function (colIndex) {
            if (colIndex < 0 || colIndex >= this._cols) {
                throw new Error("colIndex out of bounds");
            }
            var arr = new Array(this._rows);
            for (var rowIndex = 0; rowIndex < arr.length; rowIndex++) {
                arr[rowIndex] = this.get(colIndex, rowIndex);
            }
            return arr;
        };
        /**
         * Sets the specified column of this array.
         */
        Array2D.prototype.setColumn = function (colIndex, arr) {
            if (colIndex < 0 || colIndex >= this._cols) {
                throw new Error("colIndex out of bounds");
            }
            for (var rowIndex = 0; rowIndex < Math.min(arr.length, this._rows); rowIndex++) {
                this.set(colIndex, rowIndex, arr[rowIndex]);
            }
        };
        /**
         * Returns a copy of the specified row.
         */
        Array2D.prototype.getRow = function (rowIndex) {
            if (rowIndex < 0 || rowIndex >= this._rows) {
                throw new Error("rowIndex out of bounds");
            }
            return this._data.slice(rowIndex * this._cols, (rowIndex + 1) * this._cols);
        };
        /**
         * Sets the specified row of this array.
         */
        Array2D.prototype.setRow = function (rowIndex, arr) {
            if (rowIndex < 0 || rowIndex >= this._rows) {
                throw new Error("rowIndex out of bounds");
            }
            for (var colIndex = 0; colIndex < Math.min(arr.length, this._cols); colIndex++) {
                this.set(colIndex, rowIndex, arr[colIndex]);
            }
        };
        /**
         * Converts this array into a native 2D array.
         */
        Array2D.prototype.toNative = function () {
            var cols = new Array(this._cols);
            for (var colIndex = 0; colIndex < this._cols; colIndex++) {
                cols[colIndex] = this.getColumn(colIndex);
            }
            return cols;
        };
        /**
         * Creates a new boolean array.
         * For each cell in the new array:
         * - true: the value of the cell is equivalent
         * - false: the value of the cell is NOT equivalent
         * Returns null if the dimensions do not match.
         */
        Array2D.prototype.diff = function (other) {
            if (this.rows !== other.rows || this.columns !== other.columns) {
                return null;
            }
            var tmp = new Array2D(this._cols, this._rows);
            for (var rowIndex = 0; rowIndex < this._rows; rowIndex++) {
                for (var colIndex = 0; colIndex < this._cols; colIndex++) {
                    tmp.set(colIndex, rowIndex, this.get(colIndex, rowIndex) === other.get(colIndex, rowIndex));
                }
            }
            return tmp;
        };
        /**
         * Gets an array of all positions with the specified value.
         */
        Array2D.prototype.getPositions = function (value) {
            var positions = [];
            for (var colIndex = 0; colIndex < this._cols; colIndex++) {
                for (var rowIndex = 0; rowIndex < this._rows; rowIndex++) {
                    if (this.get(colIndex, rowIndex) === value) {
                        positions.push({ colIndex: colIndex, rowIndex: rowIndex });
                    }
                }
            }
            return positions;
        };
        return Array2D;
    }());
    RS.Array2D = Array2D;
})(RS || (RS = {}));
var RS;
(function (RS) {
    function argless(cb) {
        return function () { return cb(undefined); };
    }
    /**
     * Encapsulates an object that can be awaited on.
     */
    var Awaitable = /** @class */ (function () {
        function Awaitable() {
            this.__awaitableCallbacks = null;
            this.__awaitableResult = null;
        }
        /**
         * Attaches callbacks for the resolution and/or rejection of the Promise.
         * @param onFulfilled The callback to execute when the Promise is resolved.
         * @param onRejected The callback to execute when the Promise is rejected.
         * @returns A Promise for the completion of which ever callback is executed.
         */
        Awaitable.prototype.then = function (onFulfilled, onRejected) {
            /*
                From promisejs.org:

                this.then = function (onFulfilled, onRejected) {
                var self = this;
                return new Promise(function (resolve, reject) {
                    return self.done(function (result) {
                    if (typeof onFulfilled === 'function') {
                        try {
                        return resolve(onFulfilled(result));
                        } catch (ex) {
                        return reject(ex);
                        }
                    } else {
                        return resolve(result);
                    }
                    }, function (error) {
                    if (typeof onRejected === 'function') {
                        try {
                        return resolve(onRejected(error));
                        } catch (ex) {
                        return reject(ex);
                        }
                    } else {
                        return reject(error);
                    }
                    });
                });
                }
            */
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this.thenInternal(function (data) {
                    if (RS.Is.func(onFulfilled)) {
                        try {
                            resolve(onFulfilled(data));
                        }
                        catch (err) {
                            reject(err);
                        }
                    }
                    else {
                        resolve(null);
                    }
                }, function (reason) {
                    if (RS.Is.func(onRejected)) {
                        try {
                            resolve(onRejected(reason));
                        }
                        catch (err) {
                            reject(err);
                        }
                    }
                    else {
                        reject(reason);
                    }
                });
            });
        };
        /**
         * The finally() method returns a Promise. When the promise is settled, i.e either fulfilled or rejected, the specified callback function is executed. This provides a way for code to be run whether the promise was fulfilled successfully or rejected once the Promise has been dealt with.
         *
         * This helps to avoid duplicating code in both the promise's then() and catch() handlers.
         * @param onFinally The callback to execute when the Promise is resolved or rejected.
         */
        Awaitable.prototype.finally = function (onFinally) {
            var cb = RS.Is.func(onFinally) ? argless(onFinally) : undefined;
            return this.then(cb, cb);
        };
        /**
         * Attaches a callback for only the rejection of the Promise.
         * @param onrejected The callback to execute when the Promise is rejected.
         * @returns A Promise for the completion of the callback.
         */
        Awaitable.prototype.catch = function (onRejected) {
            return this.then(undefined, onRejected);
        };
        Awaitable.prototype.resolve = function (result) {
            if (this.__awaitableResult) {
                return;
            }
            if (this.__awaitableCallbacks) {
                for (var _i = 0, _a = this.__awaitableCallbacks; _i < _a.length; _i++) {
                    var promiseCallback = _a[_i];
                    if (promiseCallback.resolve) {
                        promiseCallback.resolve(result);
                    }
                }
                this.__awaitableCallbacks = null;
            }
            this.__awaitableResult = { type: "resolution", result: result };
        };
        Awaitable.prototype.reject = function (reason) {
            if (this.__awaitableResult) {
                return;
            }
            if (this.__awaitableCallbacks) {
                for (var _i = 0, _a = this.__awaitableCallbacks; _i < _a.length; _i++) {
                    var promiseCallback = _a[_i];
                    if (promiseCallback.reject) {
                        promiseCallback.reject(reason);
                    }
                }
                this.__awaitableCallbacks = null;
            }
            this.__awaitableResult = { type: "rejection", reason: reason };
        };
        Awaitable.prototype.clearAwaitableResult = function () {
            this.__awaitableResult = null;
        };
        Awaitable.prototype.thenInternal = function (resolve, reject) {
            if (this.__awaitableResult) {
                switch (this.__awaitableResult.type) {
                    case "rejection":
                        {
                            reject(this.__awaitableResult.reason);
                            return;
                        }
                    case "resolution":
                        {
                            resolve(this.__awaitableResult.result);
                            return;
                        }
                }
            }
            if (!this.__awaitableCallbacks) {
                this.__awaitableCallbacks = [];
            }
            this.__awaitableCallbacks.push({ resolve: resolve, reject: reject });
        };
        return Awaitable;
    }());
    RS.Awaitable = Awaitable;
})(RS || (RS = {}));
var RS;
(function (RS) {
    /**
     * A generic binary reader.
    **/
    var BinaryReader = /** @class */ (function () {
        /**
         * Initialises a new instance of the BinaryReader class.
         * @param data      Raw data buffer.
        **/
        function BinaryReader(data, initialPointer) {
            if (initialPointer === void 0) { initialPointer = 0; }
            this._dataView = new DataView(data);
            this._pointer = initialPointer;
        }
        var _propObj = {};

        _propObj.pointer = {
            /** Gets or sets the current read position of the reader. */
            get: function () { return this._pointer; },
            set: function (value) { this._pointer = value; },
            enumerable: false,
            configurable: true
        };

        _propObj.length = {
            /** Gets the size of the buffer in bytes. */
            get: function () { return this._dataView.byteLength; },
            enumerable: false,
            configurable: true
        };

        _propObj.eos = {
            /** Gets if we've reached the end of the buffer. */
            get: function () { return this._pointer >= this._dataView.byteLength; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(BinaryReader.prototype, _propObj);
        /**
         * Reads an 8-bit unsigned integer.
        **/
        BinaryReader.prototype.readByte = function () {
            return this._dataView.getUint8(this.advancePointer(1));
        };
        /**
         * Reads an 8-bit signed integer.
        **/
        BinaryReader.prototype.readSByte = function () {
            return this._dataView.getInt8(this.advancePointer(1));
        };
        /**
         * Reads an 16-bit signed integer.
        **/
        BinaryReader.prototype.readShort = function () {
            return this._dataView.getInt16(this.advancePointer(2));
        };
        /**
         * Reads an 16-bit unsigned integer.
        **/
        BinaryReader.prototype.readUShort = function () {
            return this._dataView.getUint16(this.advancePointer(2));
        };
        /**
         * Reads an 32-bit signed integer.
        **/
        BinaryReader.prototype.readInt = function () {
            return this._dataView.getInt32(this.advancePointer(4));
        };
        /**
         * Reads an 32-bit unsigned integer.
        **/
        BinaryReader.prototype.readUInt = function () {
            return this._dataView.getUint32(this.advancePointer(4));
        };
        /**
         * Reads an 32-bit floating point number.
        **/
        BinaryReader.prototype.readFloat = function () {
            return this._dataView.getFloat32(this.advancePointer(4));
        };
        /**
         * Reads an 64-bit floating point number.
        **/
        BinaryReader.prototype.readDouble = function () {
            return this._dataView.getFloat64(this.advancePointer(8));
        };
        /**
         * Reads a fixed-length string.
         * @param length    String length in bytes.
        **/
        BinaryReader.prototype.readFixedString = function (length) {
            var str = "";
            while (length-- > 0) {
                str += String.fromCharCode(this.readByte());
            }
            return str;
        };
        /**
         * Skips the specified amount of bytes.
        **/
        BinaryReader.prototype.skip = function (amount) {
            this._pointer += amount;
        };
        /**
         * Advances the pointer by the specified amount and returns the old pointer.
        **/
        BinaryReader.prototype.advancePointer = function (amount) {
            var oldPointer = this._pointer;
            this._pointer += amount;
            return oldPointer;
        };
        return BinaryReader;
    }());
    RS.BinaryReader = BinaryReader;
})(RS || (RS = {}));
var RS;
(function (RS) {
    var BufferObservable = /** @class */ (function (_super) {
        __extends(BufferObservable, _super);
        function BufferObservable(bufferSize, initialState, resolveFunc) {
            var _this = this;
            var buffer = new Array(bufferSize);
            for (var i = 0; i < bufferSize; ++i) {
                buffer[i] = initialState;
            }
            _this = _super.call(this, resolveFunc(buffer)) || this;
            _this._resolveFunc = resolveFunc;
            _this._buffer = buffer;
            return _this;
        }
        BufferObservable.prototype.push = function (value) {
            for (var i = 0, l = this._buffer.length - 1; i < l; ++i) {
                this._buffer[i] = this._buffer[i + 1];
            }
            this._buffer[this._buffer.length - 1] = value;
            this.value = this._resolveFunc(this._buffer);
        };
        BufferObservable.prototype.dispose = function () {
            if (this._isDisposed) {
                return;
            }
            this._resolveFunc = null;
            this._buffer.length = 0;
            this._buffer = null;
            _super.prototype.dispose.call(this);
        };
        return BufferObservable;
    }(RS.Observable));
    var IBufferObservable;
    (function (IBufferObservable) {
        /**
         * Creates a new buffer observable.
         * @param bufferSize
         * @param initialState
         * @param resolverFunc
         */
        function create(bufferSize, initialState, resolverFunc) {
            return new BufferObservable(bufferSize, initialState, resolverFunc);
        }
        IBufferObservable.create = create;
    })(IBufferObservable = RS.IBufferObservable || (RS.IBufferObservable = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    /**
     * A generic collection of items with an undefined order.
     * Optimised for speed of addition, removal and iteration of items.
     * Items can safely be added and removed while iterating.
     */
    var Collection = /** @class */ (function () {
        /**
         * Initialises a new instance of the Collection class.
         * @param items		Existing backing array.
         */
        function Collection(items) {
            this._items = items || [];
            this._toAdd = [];
            this._toRemove = [];
            this._clearFlag = false;
        }
        var _propObj = {};

        _propObj.count = {
            /** Gets the number of items in this collection. */
            get: function () { return this._items.length; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(Collection.prototype, _propObj);
        /**
         * Adds an item to this collection.
         * @param item		The item to add
         */
        Collection.prototype.addItem = function (item) {
            if (this._iterating) {
                this._toAdd.push(item);
            }
            else {
                this._items.push(item);
            }
        };
        /**
         * Removes an item from this collection.
         * @param item		The item to remove
         */
        Collection.prototype.removeItem = function (item) {
            if (this._iterating) {
                this._toRemove.push(item);
            }
            else {
                var items = this._items;
                var index = items.indexOf(item);
                if (index != -1) {
                    // Is it NOT the last item?
                    if (index < items.length - 1) {
                        // Overwrite it with the last item
                        items[index] = items[items.length - 1];
                    }
                    // Remove last item
                    items.length--;
                }
            }
        };
        /**
         * Gets if this collection contains the specified item.
         * @param item		The item to search for
         */
        Collection.prototype.contains = function (item) {
            return this._items.indexOf(item) !== -1;
        };
        /**
         * Clears all items in this collection.
         * Safe to use within iterate, but will not take effect until after ALL iteration has completed.
         * In addition to above, any attempts to add items AFTER clearing within an iterate will fail silently.
         */
        Collection.prototype.clear = function () {
            if (this._iterating) {
                this._clearFlag = true;
            }
            else {
                this._items.length = 0;
            }
        };
        /**
         * Iterates all items in this collection and calls the specified iterator for each.
         * @returns		The total number of items iterated.
         */
        Collection.prototype.iterate = function (iterator) {
            if (this._iterating) {
                throw new Error("Nested iteration is not supported!");
            }
            this._iterating = true;
            var items = this._items;
            var len = items.length;
            var item;
            for (var i = 0; i < len; i++) {
                item = items[i];
                if (item != null) {
                    iterator(item);
                }
            }
            this._iterating = false;
            if (this._toAdd.length > 0) {
                for (var i = this._toAdd.length - 1; i >= 0; i--) {
                    this.addItem(this._toAdd[i]);
                    this._toAdd.length--;
                }
            }
            if (this._toRemove.length > 0) {
                for (var i = this._toRemove.length - 1; i >= 0; i--) {
                    this.removeItem(this._toRemove[i]);
                    this._toRemove.length--;
                }
            }
            if (this._clearFlag) {
                this._items.length = 0;
                this._clearFlag = false;
            }
            return len;
        };
        return Collection;
    }());
    RS.Collection = Collection;
})(RS || (RS = {}));
var RS;
(function (RS) {
    /**
     * Encapsulates a map of keys to values.
     * The keys and values can be of any type, unlike standard JS maps where keys can only be numbers or strings.
     */
    var ObjectMap = /** @class */ (function () {
        function ObjectMap(hashFunc, equalFunc) {
            this._hashFunc = hashFunc;
            this._equalFunc = equalFunc;
            this._data = {};
        }
        var _propObj = {};

        _propObj.keys = {
            /**
             * Gets all keys in this map.
             */
            get: function () {
                var result = [];
                for (var hash in this._data) {
                    var arr = this._data[hash];
                    for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
                        var pair = arr_1[_i];
                        result.push(pair[0]);
                    }
                }
                return result;
            },
            enumerable: false,
            configurable: true
        };

        _propObj.values = {
            /**
             * Gets all values in this map.
             */
            get: function () {
                var result = [];
                for (var hash in this._data) {
                    var arr = this._data[hash];
                    for (var _i = 0, arr_2 = arr; _i < arr_2.length; _i++) {
                        var pair = arr_2[_i];
                        result.push(pair[1]);
                    }
                }
                return result;
            },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(ObjectMap.prototype, _propObj);
        /**
         * Gets if this map contains the specified key or not.
         * @param key
         */
        ObjectMap.prototype.containsKey = function (key) {
            var hash = this._hashFunc(key);
            var pairs = this._data[hash];
            if (!pairs) {
                return false;
            }
            for (var _i = 0, pairs_1 = pairs; _i < pairs_1.length; _i++) {
                var pair = pairs_1[_i];
                if (this._equalFunc(pair[0], key)) {
                    return true;
                }
            }
            return false;
        };
        /**
         * Gets if this map contains the specified value or not.
         * @param value
         */
        ObjectMap.prototype.containsValue = function (value) {
            for (var hash in this._data) {
                var arr = this._data[hash];
                for (var _i = 0, arr_3 = arr; _i < arr_3.length; _i++) {
                    var pair = arr_3[_i];
                    if (pair[1] === value) {
                        return true;
                    }
                }
            }
            return false;
        };
        /**
         * Gets if this map contains the specified key-value pair or not.
         * @param value
         */
        ObjectMap.prototype.contains = function (key, value) {
            var hash = this._hashFunc(key);
            var pairs = this._data[hash];
            if (!pairs) {
                return false;
            }
            for (var _i = 0, pairs_2 = pairs; _i < pairs_2.length; _i++) {
                var pair = pairs_2[_i];
                if (this._equalFunc(pair[0], key) && pair[1] === value) {
                    return true;
                }
            }
            return false;
        };
        /**
         * Looks up an item from this map, returning the item or null if not found.
         * @param key
         */
        ObjectMap.prototype.get = function (key) {
            var hash = this._hashFunc(key);
            var pairs = this._data[hash];
            if (!pairs) {
                return null;
            }
            for (var _i = 0, pairs_3 = pairs; _i < pairs_3.length; _i++) {
                var pair = pairs_3[_i];
                if (this._equalFunc(pair[0], key)) {
                    return pair[1];
                }
            }
            return null;
        };
        /**
         * Sets an item in this map.
         * @param key
         */
        ObjectMap.prototype.set = function (key, value) {
            var hash = this._hashFunc(key);
            var pairs = this._data[hash];
            if (!pairs) {
                this._data[hash] = [[key, value]];
                return;
            }
            var found = false;
            for (var _i = 0, pairs_4 = pairs; _i < pairs_4.length; _i++) {
                var pair = pairs_4[_i];
                if (this._equalFunc(pair[0], key)) {
                    pair[1] = value;
                    found = true;
                    break;
                }
            }
            if (!found) {
                pairs.push([key, value]);
            }
        };
        /**
         * Removes an item from this map.
         * @param key
         */
        ObjectMap.prototype.remove = function (key) {
            var hash = this._hashFunc(key);
            var pairs = this._data[hash];
            if (!pairs) {
                return null;
            }
            for (var i = 0, l = pairs.length; i < l; ++i) {
                var pair = pairs[i];
                if (this._equalFunc(pair[0], key)) {
                    if (pairs.length === 1) {
                        delete this._data[hash];
                    }
                    else if (i === l - 1) {
                        --pairs.length;
                    }
                    else {
                        pairs[i] = pairs[l - 1];
                        --pairs.length;
                    }
                    return true;
                }
            }
            return false;
        };
        return ObjectMap;
    }());
    RS.ObjectMap = ObjectMap;
})(RS || (RS = {}));
/// <reference path="../Event.ts" />
var RS;
(function (RS) {
    var Util;
    (function (Util) {
        /**
         * @inheritdoc
         * This instance should only be exposed to the object class itself, the interface should be exposed publicly.
         */
        var ObjectTracker = /** @class */ (function () {
            function ObjectTracker() {
                /** @inheritdoc */
                this.onCreated = RS.createEvent();
                /** @inheritdoc */
                this.onDisposed = RS.createEvent();
            }
            ObjectTracker.prototype.notifyCreate = function (obj) {
                this.onCreated.publish(obj);
            };
            ObjectTracker.prototype.notifyDispose = function (obj) {
                this.onDisposed.publish(obj);
            };
            return ObjectTracker;
        }());
        Util.ObjectTracker = ObjectTracker;
        /**
         * Specifies that creation and disposal of any instances of the class should be tracked via the specified object tracker.
         * @param tracker
         */
        Util.Tracked = RS.Decorators.Tag.create(RS.Decorators.TagKind.Class, function (oldCtor) {
            var tracker = Util.Tracked.get(oldCtor);
            // Create hooked ctor clone
            var newCtor = Util.hookClass(oldCtor, function () {
                RS.bindCallbacks(this, RS.Decorators.MemberType.Instance);
                oldCtor.apply(this, arguments);
                tracker.notifyCreate(this);
            });
            // Track disposal
            var oldDispose = newCtor.prototype.dispose;
            if (oldDispose) {
                newCtor.prototype.dispose = function dispose() {
                    if (this.isDisposed) {
                        return;
                    }
                    tracker.notifyDispose(this);
                    oldDispose.call(this);
                };
            }
            return newCtor;
        });
    })(Util = RS.Util || (RS.Util = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    /**
     * Encapsulates a mutable map of string keys to values.
     */
    var ObservableMap = /** @class */ (function () {
        function ObservableMap(initialValue) {
            if (initialValue === void 0) { initialValue = {}; }
            this._isDisposed = false;
            this._resolves = [];
            this._onChanged = RS.createEvent();
            /** Published when the state has changed. */
            this.onChanged = this._onChanged.public;
            this._map = initialValue;
        }
        var _propObj = {};

        _propObj.isDisposed = {
            /** Gets if this observable has been disposed. */
            get: function () { return this._isDisposed; },
            enumerable: false,
            configurable: true
        };

        _propObj.value = {
            /** Gets or sets the content of the map. */
            get: function () {
                var clone = {};
                for (var key in this._map) {
                    if (this._map[key] != null) {
                        clone[key] = this._map[key];
                    }
                }
                return clone;
            },
            set: function (value) {
                for (var key in this._map) {
                    if (!(key in value)) {
                        this.remove(key);
                    }
                }
                for (var key in value) {
                    if (value[key] != null) {
                        this.set(key, value[key]);
                    }
                }
            },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(ObservableMap.prototype, _propObj);
        /**
         * Gets if this map contains the specified key.
         * @param key
         */
        ObservableMap.prototype.containsKey = function (key) {
            return key in this._map;
        };
        /**
         * Gets the key for the specified value.
         * Returns null if the value is not found in the map.
         * Returns the first key found if the value is found multiple times in the map.
         * @param value
         */
        ObservableMap.prototype.keyOf = function (value) {
            for (var key in this._map) {
                if (this._map[key] === value) {
                    return key;
                }
            }
            return null;
        };
        /**
         * Gets if the specified value is found in this map.
         * @param value
         */
        ObservableMap.prototype.containsValue = function (value) {
            return this.keyOf(value) != null;
        };
        /**
         * Gets an item from the map.
         * Returns null if the key is not found.
         * @param key
         */
        ObservableMap.prototype.get = function (key) {
            var v = this._map[key];
            return v == null ? null : v;
        };
        /**
         * Sets an item in the map.
         * @param key
         * @param value
         */
        ObservableMap.prototype.set = function (key, newValue) {
            var oldValue = this._map[key];
            if (oldValue === newValue) {
                return;
            }
            this._map[key] = newValue;
            this._onChanged.publish({ key: key, value: newValue });
            for (var i = this._resolves.length - 1; i >= 0; --i) {
                var resolveData = this._resolves[i];
                if (resolveData.key === key && RS.Is.array(resolveData.value) ? resolveData.value.indexOf(newValue) !== -1 : resolveData.value === newValue) {
                    if (resolveData.resolve) {
                        resolveData.resolve();
                    }
                    this._resolves.splice(i, 1);
                }
            }
        };
        /**
         * Removes an item from the map.
         * @param key
         */
        ObservableMap.prototype.remove = function (key) {
            if (!this.containsKey(key)) {
                return;
            }
            this.set(key, null);
            delete this._map[key];
        };
        /**
         * Returns a promise that resolves when this observable's value has changed to the specified value.
         * @param value
         */
        ObservableMap.prototype.for = function (key, value) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                var curVal = _this.get(key);
                if (RS.Is.array(value) && value.indexOf(curVal) !== -1) {
                    resolve();
                }
                else if (!RS.Is.array(value) && curVal === value) {
                    resolve();
                }
                else {
                    _this._resolves.push({ key: key, value: value, resolve: resolve, reject: reject });
                }
            });
        };
        /**
         * Disposes this observable.
         */
        ObservableMap.prototype.dispose = function () {
            if (this._isDisposed) {
                return;
            }
            for (var _i = 0, _a = this._resolves; _i < _a.length; _i++) {
                var resolve = _a[_i];
                if (resolve.reject) {
                    resolve.reject("disposed");
                }
            }
            this._resolves.length = 0;
            this._resolves = null;
            this._map = null;
            this._isDisposed = true;
        };
        return ObservableMap;
    }());
    RS.ObservableMap = ObservableMap;
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Type;
    (function (Type) {
        Type[Type.Enter = 0] = "Enter";
        Type[Type.Exit = 1] = "Exit";
        Type[Type.Transition = 2] = "Transition";
    })(Type || (Type = {}));
    /** Allows handling of a finite set of observable state transitions. */
    var ObservableStateMachine = /** @class */ (function () {
        function ObservableStateMachine(observable) {
            this.observable = observable;
            this.__handlers = [];
            this.__lastValue = observable.value;
            observable.onChanged(this.onObservableChanged);
        }
        ObservableStateMachine.prototype.setStateEnterHandler = function (value, handler) {
            for (var i = 0; i < this.__handlers.length; i++) {
                var transition = this.__handlers[i];
                if (transition.type === Type.Enter && transition.value === value) {
                    this.__handlers[i] = { type: Type.Enter, value: value, handler: handler };
                    return;
                }
            }
            this.__handlers.push({ type: Type.Enter, value: value, handler: handler });
        };
        ObservableStateMachine.prototype.setStateExitHandler = function (value, handler) {
            for (var i = 0; i < this.__handlers.length; i++) {
                var transition = this.__handlers[i];
                if (transition.type === Type.Exit && transition.value === value) {
                    this.__handlers[i] = { type: Type.Exit, value: value, handler: handler };
                    return;
                }
            }
            this.__handlers.push({ type: Type.Exit, value: value, handler: handler });
        };
        ObservableStateMachine.prototype.setTransitionHandler = function (from, to, handler) {
            if (from === to) {
                throw new Error("Invalid transition: '".concat(from, "' \u2192 '").concat(to, "'"));
            }
            for (var i = 0; i < this.__handlers.length; i++) {
                var transition = this.__handlers[i];
                if (transition.type === Type.Transition && transition.from === from && transition.to === to) {
                    this.__handlers[i] = { type: Type.Transition, from: from, to: to, handler: handler };
                    return;
                }
            }
            this.__handlers.push({ type: Type.Transition, from: from, to: to, handler: handler });
        };
        ObservableStateMachine.prototype.onObservableChanged = function (to) {
            var from = this.__lastValue;
            this.__lastValue = to;
            for (var _i = 0, _a = this.__handlers; _i < _a.length; _i++) {
                var transition = _a[_i];
                switch (transition.type) {
                    case Type.Transition:
                        if (transition.from === from && transition.to === to && transition.handler) {
                            transition.handler(from, to);
                        }
                        break;
                    case Type.Enter:
                        if (transition.value === to && transition.handler) {
                            transition.handler(from, to);
                        }
                        break;
                    case Type.Exit:
                        if (transition.value === from && transition.handler) {
                            transition.handler(from, to);
                        }
                        break;
                }
            }
        };
        var _decObj = {};

        _decObj.onObservableChanged = {
            decorators: [RS.Callback],
            target: ObservableStateMachine.prototype,
            desc: null
        };

        __multiDecorate(_decObj);
        ObservableStateMachine = __decorate([
            RS.HasCallbacks
        ], ObservableStateMachine);
        return ObservableStateMachine;
    }());
    RS.ObservableStateMachine = ObservableStateMachine;
})(RS || (RS = {}));
var RS;
(function (RS) {
    /**
     * Runs several async processing chains in parallel.
    **/
    var ParallelProcessor = /** @class */ (function () {
        function ParallelProcessor(items, threadCount, processor) {
            this._items = items;
            this._threadCount = threadCount;
            this._processor = processor;
        }
        /** Launches all threads and waits until completion, returning the results. */
        ParallelProcessor.prototype.process = function () {
            return __awaiter(this, void 0, void 0, function () {
                var result, threads, i, i;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            result = this._result = {
                                succeedItems: [],
                                failedItems: []
                            };
                            this._curItemIndex = 0;
                            threads = [];
                            for (i = 0; i < this._threadCount; i++) {
                                threads.push(this.thread(i));
                            }
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < this._threadCount)) return [3 /*break*/, 4];
                            return [4 /*yield*/, threads[i]];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4:
                            // Done
                            this._result = null;
                            return [2 /*return*/, result];
                    }
                });
            });
        };
        /** Runs a single thread that will process all items until exhaustion. */
        ParallelProcessor.prototype.thread = function (id) {
            return __awaiter(this, void 0, void 0, function () {
                var success, item, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this._curItemIndex < this._items.length)) return [3 /*break*/, 5];
                            success = true;
                            item = this._items[this._curItemIndex++];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this._processor(item, id)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            success = false;
                            return [3 /*break*/, 4];
                        case 4:
                            if (success) {
                                this._result.succeedItems.push(item);
                            }
                            else {
                                this._result.failedItems.push(item);
                            }
                            return [3 /*break*/, 0];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        return ParallelProcessor;
    }());
    RS.ParallelProcessor = ParallelProcessor;
})(RS || (RS = {}));
var RS;
(function (RS) {
    /**
     * A generic profiler that can be used to track time elapsed.
     * Does not subscribe to any events and so is cheap to allocate and "throw away".
     */
    var Profiler = /** @class */ (function () {
        function Profiler() {
            this.__count = {};
            this.__running = {};
            this.__times = {};
        }
        var _propObj = {};

        _propObj.times = {
            get: function () { return this.__times; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(Profiler.prototype, _propObj);
        Profiler.prototype.start = function (name) {
            var count = this.__count[name];
            if (!count) {
                this.__running[name] = RS.Timer.now;
            }
            this.__count[name] = (count || 0) + 1;
        };
        Profiler.prototype.stop = function (name) {
            if (!this.__count[name]) {
                RS.Log.warn("Profiler: stop() called before start()");
                return;
            }
            if (--this.__count[name]) {
                // Still running
                return;
            }
            var thisTime = RS.Timer.now - this.__running[name];
            var time = this.__times[name];
            if (time) {
                this.__times[name] += thisTime;
            }
            else {
                this.__times[name] = thisTime;
            }
        };
        Profiler.prototype.get = function (name) {
            return this.__times[name] || 0;
        };
        Profiler.prototype.getSeconds = function (name) {
            return this.get(name) / 1000;
        };
        Profiler.prototype.format = function (name) {
            return RS.Timer.format(this.get(name));
        };
        Profiler.prototype.formatAll = function () {
            var out = "";
            for (var name_3 in this.__times) {
                out += "".concat(name_3, ": ").concat(this.format(name_3), "\n");
            }
            return out;
        };
        Profiler.prototype.clear = function () {
            for (var key in this.__times) {
                delete this.__times[key];
            }
        };
        return Profiler;
    }());
    RS.Profiler = Profiler;
})(RS || (RS = {}));
/// <reference path="../Disposable.ts" />
var RS;
(function (RS) {
    /**
     * A resource pool used for caching frequently created short-lived object instances, to reduce pressure on memory and GC.
     */
    var ResourcePool = /** @class */ (function () {
        function ResourcePool(settings, initialCount) {
            if (initialCount === void 0) { initialCount = 0; }
            this.settings = settings;
            this._disposed = false;
            this._pool = new Array(initialCount);
            for (var i = 0; i < initialCount; ++i) {
                this._pool[i] = settings.allocator();
            }
        }
        var _propObj = {};

        _propObj.pooledCount = {
            /** The number of objects currently pooled. */
            get: function () { return this._pool.length; },
            enumerable: false,
            configurable: true
        };

        _propObj.isDisposed = {
            /** Gets if this pool has been disposed. */
            get: function () { return this._disposed; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(ResourcePool.prototype, _propObj);
        /** Gets an instance from this resource pool, or allocates one if needed. */
        ResourcePool.prototype.get = function () {
            if (this._pool.length === 0) {
                return this.settings.allocator();
            }
            else {
                return this._pool.pop();
            }
        };
        /** Releases an instance to this resource pool. */
        ResourcePool.prototype.release = function (instance) {
            if (this.settings.releaser) {
                this.settings.releaser(instance);
            }
            this._pool.push(instance);
        };
        /** Disposes this resource pool and any resources within it. */
        ResourcePool.prototype.dispose = function () {
            if (this._disposed) {
                return;
            }
            for (var _i = 0, _a = this._pool; _i < _a.length; _i++) {
                var instance = _a[_i];
                this.disposeInstance(instance);
            }
            this._pool.length = 0;
            this._pool = null;
            this._disposed = true;
        };
        /** Disposes of the specified instance. */
        ResourcePool.prototype.disposeInstance = function (instance) {
            if (this.settings.disposer) {
                this.settings.disposer(instance);
            }
            else if (RS.Is.disposable(instance)) {
                instance.dispose();
            }
        };
        var _decObj = {};

        _decObj.pooledCount = {
            decorators: [RS.CheckDisposed],
            target: ResourcePool.prototype,
            desc: null
        };

        _decObj.get = {
            decorators: [RS.CheckDisposed],
            target: ResourcePool.prototype,
            desc: null
        };

        _decObj.release = {
            decorators: [RS.CheckDisposed],
            target: ResourcePool.prototype,
            desc: null
        };

        __multiDecorate(_decObj);
        return ResourcePool;
    }());
    RS.ResourcePool = ResourcePool;
})(RS || (RS = {}));
var RS;
(function (RS) {
    /**
     * Encapsulates an asynchronous task.
    **/
    var Task = /** @class */ (function () {
        function Task(callback, startNow) {
            if (startNow === void 0) { startNow = true; }
            this._baseCallback = null;
            this._pendingPromises = [];
            this._completed = false;
            this._failed = false;
            this._failReason = null;
            this._cancelled = false;
            this._started = false;
            this._allowEarlyTermination = false;
            this._cancelledCallbacks = [];
            this._name = "Untitled Task";
            this._baseCallback = callback;
            if (startNow) {
                this.start();
            }
        }
        var _propObj = {};

        _propObj.started = {
            /** Gets if this task has started. */
            get: function () { return this._started; },
            enumerable: false,
            configurable: true
        };

        _propObj.completed = {
            /** Gets if this task has completed. */
            get: function () { return this._completed; },
            enumerable: false,
            configurable: true
        };

        _propObj.failed = {
            /** Gets if this task has failed. */
            get: function () { return this._failed; },
            enumerable: false,
            configurable: true
        };

        _propObj.failReason = {
            /** Gets the reason why this task has failed. */
            get: function () { return this._failReason; },
            enumerable: false,
            configurable: true
        };

        _propObj.result = {
            /** Gets the result of this task. */
            get: function () { return this._value; },
            enumerable: false,
            configurable: true
        };

        _propObj.cancelled = {
            /** Gets if this task has been cancelled. */
            get: function () { return this._cancelled; },
            enumerable: false,
            configurable: true
        };

        _propObj.name = {
            /** Gets or sets the name of this task for debugging purposes. */
            get: function () { return this._name; },
            set: function (value) { this._name = value; },
            enumerable: false,
            configurable: true
        };

        _propObj.allowEarlyTermination = {
            /** Gets or sets if this task is allowed to terminate early if the owner doesn't want it to hold up. */
            get: function () { return this._allowEarlyTermination; },
            set: function (value) { this._allowEarlyTermination = value; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(Task.prototype, _propObj);
        /**
         * Creates a new task from the specified promise.
        **/
        Task.fromPromise = function (promise, startNow) {
            var task = new Task(function (taskArg, resolve, reject) {
                promise.then(resolve, reject);
            }, startNow);
            if (promise instanceof Task) {
                task.name = "-> ".concat(promise.name);
                task.onCancelled(function () { return promise.cancel(); });
            }
            else {
                task.name = "-> Promise";
            }
            return task;
        };
        /**
         * Creates a new task from the specified provider.
         * The provider function will only be evaluated when the task needs to be started.
        **/
        Task.fromPromiseProvider = function (promiseProvider) {
            var task = new Task(function (takeArg, resolve, reject) {
                var promise = promiseProvider();
                if (promise == null) {
                    resolve();
                }
                else {
                    promise.then(resolve, reject);
                }
            }, false);
            task.name = "-> PromiseProvider";
            return task;
        };
        /** Starts this task if it hasn't already been started. */
        Task.prototype.start = function () {
            var _this = this;
            if (this._started) {
                return;
            }
            this._started = true;
            this.log("has started");
            if (this._baseCallback == null) {
                this._baseCallback = function (task, resolve, reject) { return task.doTask(resolve, reject); };
            }
            this._baseCallback(this, function (v) { return _this.onSucceed(v); }, function (r) { return _this.onFail(r); });
        };
        /**
         * Cancels this task.
         * @param reject    If true, rejects all pending promises.
        **/
        Task.prototype.cancel = function (reject) {
            if (reject === void 0) { reject = false; }
            if (this._completed || !this._started) {
                return;
            }
            this.log("was cancelled");
            this._cancelled = true;
            for (var _i = 0, _a = this._cancelledCallbacks; _i < _a.length; _i++) {
                var cancelledCallback = _a[_i];
                cancelledCallback();
            }
            this._cancelledCallbacks = null;
            if (this._completed) {
                return;
            }
            if (reject) {
                this.onFail("Task cancelled");
            }
            else {
                this.onSucceed(undefined);
            }
        };
        /**
         * Attaches callbacks for the resolution and/or rejection of the Promise.
         * @param onfulfilled The callback to execute when the Promise is resolved.
         * @param onrejected The callback to execute when the Promise is rejected.
         * @returns A Promise for the completion of which ever callback is executed.
         */
        Task.prototype.then = function (onfulfilled, onrejected) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                if (_this._completed) {
                    if (_this._failed) {
                        if (onrejected) {
                            onrejected(_this._failReason);
                        }
                        reject(_this._failReason);
                    }
                    else {
                        if (onfulfilled) {
                            onfulfilled(_this._value);
                        }
                        resolve(_this._value);
                    }
                }
                else {
                    _this._pendingPromises.push({
                        onfulfilled: function (value) {
                            if (onfulfilled) {
                                onfulfilled(value);
                            }
                            resolve(value);
                        },
                        onrejected: function (reason) {
                            if (onrejected) {
                                onrejected(reason);
                            }
                            reject(reason);
                        }
                    });
                }
            });
        };
        /**
         * Specify a function to call when this task is cancelled.
         * If the task is ALREADY cancelled, calls immediately.
        **/
        Task.prototype.onCancelled = function (callback) {
            if (this._completed && this._cancelled) {
                callback();
            }
            else {
                this._cancelledCallbacks.push(callback);
            }
        };
        /**
         * Gets a string representation of this task.
        **/
        Task.prototype.toString = function () {
            return this._name;
        };
        /** Logs a debug message. */
        Task.prototype.log = function (message) {
            RS.Logging.ILogger.get().getContext("Task").log("'".concat(this, "' ").concat(message), RS.Logging.LogLevel.Debug);
        };
        /** Performs the async task. */
        Task.prototype.doTask = function (resolve, reject) { return; };
        /** Called when the base promise has succeeded. */
        Task.prototype.onSucceed = function (value) {
            if (this._completed) {
                if (this._cancelled) {
                    return;
                }
                RS.Log.warn("A task tried to complete itself more than once!");
                debugger;
            }
            this.log("has succeeded");
            this._completed = true;
            this._failed = false;
            this._value = value;
            for (var _i = 0, _a = this._pendingPromises; _i < _a.length; _i++) {
                var pendingPromise = _a[_i];
                if (pendingPromise.onfulfilled) {
                    pendingPromise.onfulfilled(value);
                }
            }
            this._pendingPromises.length = 0;
        };
        /** Called when the base promise has failed. */
        Task.prototype.onFail = function (reason) {
            if (this._completed) {
                if (this._cancelled) {
                    return;
                }
                RS.Log.warn("A task tried to complete itself more than once!");
                debugger;
            }
            this.log("has failed (".concat(reason, ")"));
            this._completed = true;
            this._failed = true;
            this._failReason = reason;
            for (var _i = 0, _a = this._pendingPromises; _i < _a.length; _i++) {
                var pendingPromise = _a[_i];
                if (pendingPromise.onrejected) {
                    pendingPromise.onrejected(reason);
                }
            }
            this._pendingPromises.length = 0;
        };
        return Task;
    }());
    RS.Task = Task;
    /**
     * Encapsulates an asynchronous task comprised of a number of sub-tasks.
     * Sub-tasks can be executed in parallel or sequentially.
     * All sub-tasks must be complete before this task is considered complete.
    **/
    var MultiTask = /** @class */ (function (_super) {
        __extends(MultiTask, _super);
        function MultiTask(subTasks, parallel, failIfOneFails, reducer) {
            if (parallel === void 0) { parallel = true; }
            if (failIfOneFails === void 0) { failIfOneFails = true; }
            var _this = _super.call(this, null, false) || this;
            if (subTasks.length === 0) {
                throw new Error("Multi-task created with no sub-tasks");
            }
            if (subTasks.some(function (task) { return task == null; })) {
                throw new Error("Multi-task created with null sub-tasks");
            }
            _this._parallel = parallel;
            _this._subTasks = subTasks;
            _this._failIfOneFails = failIfOneFails;
            _this._reducer = reducer;
            return _this;
        }
        var _propObj = {};

        _propObj.subTasks = {
            /** Gets all sub-tasks that this task is responsible for. */
            get: function () { return this._subTasks; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(MultiTask.prototype, _propObj);
        /**
         * Cancels this task.
         * @param reject    If true, rejects all pending promises.
        **/
        MultiTask.prototype.cancel = function (reject) {
            if (reject === void 0) { reject = false; }
            if (this._completed || !this._started) {
                return;
            }
            this.log("was cancelled");
            this._cancelled = true;
            for (var _i = 0, _a = this._subTasks; _i < _a.length; _i++) {
                var subTask = _a[_i];
                if (!subTask.completed && subTask.started) {
                    subTask.cancel(false);
                }
            }
            for (var _b = 0, _c = this._cancelledCallbacks; _b < _c.length; _b++) {
                var cancelledCallback = _c[_b];
                cancelledCallback();
            }
            this._cancelledCallbacks = null;
            if (this._completed) {
                return;
            }
            if (reject) {
                this.onFail("Task cancelled");
            }
            else {
                this.onSucceed(undefined);
            }
        };
        /** Performs the async task. */
        MultiTask.prototype.doTask = function (resolve, reject) {
            var _this = this;
            if (this._subTasks.length === 0) {
                resolve(undefined);
                return;
            }
            this._numSucceed = 0;
            this._numFail = 0;
            this._pendingSubTasks = this._subTasks.slice();
            this._resolve = resolve;
            this._reject = reject;
            if (this._parallel) {
                this._shouldAttemptEarlyTermination = true;
                var _loop_2 = function (subTask) {
                    subTask.then(function (v) {
                        _this.log("sub task succeeded");
                        _this.onSubTaskSucceed(subTask);
                        return undefined;
                    }, function (r) {
                        _this.log("sub task failed");
                        _this.onSubTaskFail(subTask);
                        return undefined;
                    });
                    subTask.start();
                };
                for (var _i = 0, _a = this._subTasks; _i < _a.length; _i++) {
                    var subTask = _a[_i];
                    _loop_2(subTask);
                }
            }
            else {
                this._shouldAttemptEarlyTermination = false;
                var taskPtr_1 = -1;
                var doNextTask_1 = function () {
                    taskPtr_1++;
                    if (taskPtr_1 >= _this._subTasks.length) {
                        return;
                    }
                    if (_this._cancelled) {
                        _this._resolve(_this._curVal);
                        return;
                    }
                    var subTask = _this._subTasks[taskPtr_1];
                    subTask.then(function (v) {
                        _this.onSubTaskSucceed(subTask);
                        doNextTask_1();
                        return v;
                    }, function (r) {
                        _this.onSubTaskFail(subTask);
                        if (!_this._failIfOneFails) {
                            doNextTask_1();
                        }
                        return r;
                    });
                    subTask.start();
                };
                doNextTask_1();
            }
        };
        MultiTask.prototype.onSubTaskSucceed = function (subTask) {
            if (this._completed) {
                return;
            }
            this._pendingSubTasks.splice(this._pendingSubTasks.indexOf(subTask), 1);
            this._numSucceed++;
            if (this._curVal === undefined) {
                this._curVal = subTask.result;
            }
            else {
                this._curVal = this._reducer != null ? this._reducer(this._curVal, subTask.result) : subTask.result;
            }
            if (this._numSucceed + this._numFail === this._subTasks.length) {
                this._resolve(this._curVal);
            }
            if (this._shouldAttemptEarlyTermination) {
                this.attemptEarlyTermination();
            }
        };
        MultiTask.prototype.onSubTaskFail = function (subTask) {
            if (this._completed) {
                return;
            }
            this._pendingSubTasks.splice(this._pendingSubTasks.indexOf(subTask), 1);
            this._numFail++;
            if (this._failIfOneFails) {
                this._reject();
            }
            else {
                if (this._numSucceed + this._numFail === this._subTasks.length) {
                    this._resolve(this._curVal);
                }
            }
            if (this._shouldAttemptEarlyTermination) {
                this.attemptEarlyTermination();
            }
        };
        MultiTask.prototype.attemptEarlyTermination = function () {
            // Check if all pending sub tasks allow early termination
            if (this._pendingSubTasks.some(function (p) { return !p.allowEarlyTermination; })) {
                return;
            }
            // Infinite loop protection
            this._shouldAttemptEarlyTermination = false;
            // Cancel remaining sub tasks
            var toCancel = __spreadArray([], this._pendingSubTasks, true);
            for (var _i = 0, toCancel_1 = toCancel; _i < toCancel_1.length; _i++) {
                var task = toCancel_1[_i];
                task.cancel(false);
            }
        };
        return MultiTask;
    }(Task));
    RS.MultiTask = MultiTask;
})(RS || (RS = {}));
var RS;
(function (RS) {
    /**
     * A generic timer that can be used to track time elapsed.
     * Does not subscribe to any events and so is cheap to allocate and "throw away".
     */
    var Timer = /** @class */ (function () {
        function Timer() {
            this._startTime = Timer.now;
            this._paused = false;
            this._pauseTime = 0;
        }
        var _propObj = {};

        _propObj.now = {
            /** Gets the current timestamp in ms. */
            get: function () { return (performance || Date).now(); },
            enumerable: false,
            configurable: true
        };

        _propObj.nowSeconds = {
            /** Gets the current timestamp in s. */
            get: function () { return this.now / 1000.0; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(Timer, _propObj);
        /** Formats a time in milliseconds. */
        Timer.format = function (millis) { return "".concat(millis.toFixed(2), "s"); };
        var _propObj = {};

        _propObj.elapsed = {
            /** Gets the amount of elapsed time in ms. */
            get: function () { return (this._paused ? this._pauseTime : Timer.now) - this._startTime; },
            enumerable: false,
            configurable: true
        };

        _propObj.elapsedSeconds = {
            /** Gets the amount of elapsed time in s. */
            get: function () { return this.elapsed / 1000.0; },
            enumerable: false,
            configurable: true
        };

        _propObj.formatted = {
            /** Gets this timer's formatted time. */
            get: function () { return Timer.format(this.elapsed); },
            enumerable: false,
            configurable: true
        };

        _propObj.paused = {
            /** Gets or sets if this timer is paused. */
            get: function () { return this._paused; },
            set: function (value) {
                if (this._paused === value) {
                    return;
                }
                if (value) {
                    this._paused = true;
                    this._pauseTime = Timer.now;
                }
                else {
                    this._startTime = Timer.now - this.elapsed;
                    this._paused = false;
                }
            },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(Timer.prototype, _propObj);
        /** Resets this timer. */
        Timer.prototype.reset = function () {
            this._startTime = Timer.now;
        };
        return Timer;
    }());
    RS.Timer = Timer;
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Util;
    (function (Util) {
        var tmpKeyMap = { __typeID: null };
        /**
         * Encapsulates a map of types (TypeScript classes) to values.
         */
        var TypeMap = /** @class */ (function () {
            function TypeMap() {
                this._map = {};
            }
            var _propObj = {};

            _propObj.keys = {
                /** Gets an array of all keys belonging to this map. */
                get: function () { return Object.keys(this._map).map(function (k) { return TypeMap._allTypes[k]; }); },
                enumerable: false,
                configurable: true
            };

            _propObj.values = {
                /** Gets an array of all values belonging to this map. */
                get: function () {
                    var _this = this;
                    return Object.keys(this._map).map(function (k) { return _this._map[k]; });
                },
                enumerable: false,
                configurable: true
            };

            Object.defineProperties(TypeMap.prototype, _propObj);
            /** Gets the value associated with the given key. */
            TypeMap.prototype.get = function (type) {
                return this._map[this.indexFromClass(type)] || null;
            };
            /** Sets the value associated with the given key. */
            TypeMap.prototype.set = function (type, value) {
                this._map[this.indexFromClass(type)] = value;
            };
            /** Removes the given key from this map. Returns true if successful. */
            TypeMap.prototype.remove = function (type) {
                var idx = this.indexFromClass(type);
                if (idx in this._map) {
                    delete this._map[idx];
                    return true;
                }
                else {
                    return false;
                }
            };
            /** Gets if the specified key can be found in this map. */
            TypeMap.prototype.containsKey = function (type) {
                return this.indexFromClass(type) in this._map;
            };
            /** Gets if the specified value can be found in this map. */
            TypeMap.prototype.containsValue = function (value) {
                for (var key in this._map) {
                    if (this._map[key] === value) {
                        return true;
                    }
                }
                return false;
            };
            /** Gets the first key that maps to the given value within this map. */
            TypeMap.prototype.keyOf = function (value) {
                for (var key in this._map) {
                    if (this._map[key] === value) {
                        return TypeMap._allTypes[key];
                    }
                }
                return null;
            };
            TypeMap.prototype.indexFromClass = function (obj) {
                var proto = obj.prototype;
                Util.hasOwnKeys(proto, tmpKeyMap);
                if (!tmpKeyMap.__typeID) {
                    TypeMap._allTypes.push(obj);
                    proto.__typeID = TypeMap._allTypes.length - 1;
                }
                return proto.__typeID;
            };
            TypeMap._allTypes = [];
            return TypeMap;
        }());
        Util.TypeMap = TypeMap;
    })(Util = RS.Util || (RS.Util = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Is;
    (function (Is) {
        /** Gets if the specified value is a Version. */
        function version(value) {
            return Is.object(value) && Is.number(value.major) && Is.number(value.minor) && Is.number(value.revision);
        }
        Is.version = version;
    })(Is = RS.Is || (RS.Is = {}));
})(RS || (RS = {}));
(function (RS) {
    function Version(major, minor, revision) {
        if (major === void 0) { major = 0; }
        if (minor === void 0) { minor = 0; }
        if (revision === void 0) { revision = 0; }
        return { major: major, minor: minor, revision: revision };
    }
    RS.Version = Version;
    (function (Version) {
        /** Copies a to b. */
        function copy(a, b) {
            b.major = a.major;
            b.minor = a.minor;
            b.revision = a.revision;
        }
        Version.copy = copy;
        /** Clones a. */
        function clone(a, out) {
            out = out || Version();
            copy(a, out);
            return out;
        }
        Version.clone = clone;
        /** Gets if a == b. */
        function equals(a, b) {
            return a.major === b.major && a.minor === b.minor && a.revision === b.revision;
        }
        Version.equals = equals;
        /** Gets if a > b. */
        function greaterThan(a, b) {
            if (a.major === b.major) {
                if (a.minor === b.minor) {
                    return a.revision > b.revision;
                }
                else {
                    return a.minor > b.minor;
                }
            }
            else {
                return a.major > b.major;
            }
        }
        Version.greaterThan = greaterThan;
        /** Gets if a < b. */
        function lessThan(a, b) {
            if (a.major === b.major) {
                if (a.minor === b.minor) {
                    return a.revision < b.revision;
                }
                else {
                    return a.minor < b.minor;
                }
            }
            else {
                return a.major < b.major;
            }
        }
        Version.lessThan = lessThan;
        /**
         * Gets if a is compatible with the specified version values.
         * Non-present version values are assumed to be wildcards.
         * e.g. match(Version(1, 2, 3), 1) = match 1.2.3 with 1.*.* = true
         * e.g. match(Version(1, 2, 3), 1, 3, 3) = match 1.2.3 with 1.3.3 = false
         * e.g. match(Version(1, 2, 3), 1, 2) = match 1.2.3 with 1.2.* = true
         */
        function match(a, major, minor, revision) {
            if (major != null && a.major !== major) {
                return false;
            }
            if (minor != null && a.minor !== minor) {
                return false;
            }
            if (revision != null && a.revision !== revision) {
                return false;
            }
            return true;
        }
        Version.match = match;
        /**
         * Gets the next revision of a.
         * @param a
         * @param out
         */
        function nextRevision(a, out) {
            out = out || Version();
            copy(a, out);
            out.revision++;
            return out;
        }
        Version.nextRevision = nextRevision;
        /**
         * Gets the next minor version of a.
         * @param a
         * @param out
         */
        function nextMinor(a, out) {
            out = out || Version();
            copy(a, out);
            out.minor++;
            out.revision = 0;
            return out;
        }
        Version.nextMinor = nextMinor;
        /**
         * Gets the next major version of a.
         * @param a
         * @param out
         */
        function nextMajor(a, out) {
            out = out || Version();
            copy(a, out);
            out.major++;
            out.minor = 0;
            out.revision = 0;
            return out;
        }
        Version.nextMajor = nextMajor;
        /**
         * Converts a to a string.
         * @param a
         */
        function toString(a) {
            return "".concat(a.major, ".").concat(a.minor, ".").concat(a.revision);
        }
        Version.toString = toString;
        /**
         * Parses a string into a version.
         * @param a
         */
        function fromString(str, out) {
            out = out || Version();
            var arr = str.split(".");
            out.major = parseInt(arr[0]) || 0;
            out.minor = parseInt(arr[1]) || 0;
            out.revision = parseInt(arr[2]) || 0;
            return out;
        }
        Version.fromString = fromString;
    })(Version = RS.Version || (RS.Version = {}));
})(RS || (RS = {}));
/// <reference path="../../decorators/Callbacks.ts" />
/// <reference path="../Observable.ts" />
var RS;
(function (RS) {
    var verboseLogging = false;
    /**
     * A scheduler that works with arbitrary async tasks.
     * Tasks won't be completed in parallel to each other.
     * Tasks may be suspended if more important tasks are added, or the priorities of existing tasks change.
     * Operations track a set of tasks and their progress, and hold their own priority.
     */
    var Scheduler = /** @class */ (function () {
        function Scheduler() {
            this._allTasks = [];
            this._allOps = [];
            this._currentTask = null;
            this._suspended = false;
            this._asyncPending = false;
            this._minPri = null;
            this._autoRefresh = true;
        }
        var _propObj = {};

        _propObj.suspended = {
            /** Gets or sets if this scheduler should be working on tasks or not. */
            get: function () { return this._suspended; },
            set: function (value) {
                if (value === this._suspended) {
                    return;
                }
                this.log(value ? "suspended" : "unsuspended");
                this._suspended = value;
                if (this._autoRefresh) {
                    this.refresh();
                }
            },
            enumerable: false,
            configurable: true
        };

        _propObj.minPriority = {
            /** Gets or sets the minimum priority a task should be to work on it, or null for unbound. */
            get: function () { return this._minPri; },
            set: function (value) {
                if (value === this._minPri) {
                    return;
                }
                this.log("minPri = ".concat(value));
                this._minPri = value;
                if (this._autoRefresh) {
                    this.refresh();
                }
            },
            enumerable: false,
            configurable: true
        };

        _propObj.autoRefresh = {
            /** Gets or sets if this scheduler should refresh whenever something happens. */
            get: function () { return this._autoRefresh; },
            set: function (value) { this._autoRefresh = value; },
            enumerable: false,
            configurable: true
        };

        Object.defineProperties(Scheduler.prototype, _propObj);
        /**
         * Adds a new task to the scheduler.
         * @param task
         */
        Scheduler.prototype.addTask = function (task) {
            task.onCompleted(this.refresh);
            task.onProgressChanged(this.refresh);
            this._allTasks.push(task);
            this._allTasks.sort(function (a, b) { return b.priority - a.priority; });
            this.log(task, "added");
            if (this._autoRefresh) {
                this.refresh();
            }
        };
        /**
         * Adds a new operation to the scheduler.
         * @param task
         */
        Scheduler.prototype.addOperation = function (tasks, priority, debugName) {
            if (priority === void 0) { priority = 0; }
            var errEvent = RS.createEvent();
            for (var _i = 0, tasks_1 = tasks; _i < tasks_1.length; _i++) {
                var task = tasks_1[_i];
                if (this._allTasks.indexOf(task) === -1 && !task.isComplete) {
                    task.onCompleted(this.refresh);
                    task.onProgressChanged(this.refresh);
                    this._allTasks.push(task);
                }
                task.onErrored(function (err) { return errEvent.publish(err); });
            }
            this._allTasks.sort(function (a, b) { return b.priority - a.priority; });
            var exOp = {
                progress: new RS.Observable(0),
                complete: new RS.Observable(false),
                onErrored: errEvent.public
            };
            var op = {
                tasks: tasks.slice(),
                priority: priority,
                public: exOp,
                debugName: "op:".concat(debugName),
                totalWeight: tasks.map(function (t) { return t.progressWeight; }).reduce(function (a, b) { return a + b; }, 0),
                completeWeight: 0
            };
            op.tasks.sort(function (a, b) { return b.priority - a.priority; });
            this._allOps.push(op);
            this._allOps.sort(function (a, b) { return b.priority - a.priority; });
            this.log(op, "added");
            if (this._autoRefresh) {
                this.refresh();
            }
            return exOp;
        };
        /**
         * Checks all state and reorganises current workload if required.
         */
        Scheduler.prototype.refresh = function () {
            var _this = this;
            for (var _i = 0, _a = this._allOps; _i < _a.length; _i++) {
                var op = _a[_i];
                op.public.progress.value = this.computeOperationProgress(op);
            }
            if (this._asyncPending) {
                return;
            }
            var workingTask = this.identifyWorkingTask();
            if (workingTask !== this._currentTask) {
                if (this._currentTask != null) {
                    this._asyncPending = true;
                    this.log(this._currentTask, "suspending");
                    this._currentTask.suspend()
                        .then(function () {
                        _this._asyncPending = false;
                        _this._currentTask = null;
                        _this.refresh();
                    });
                    return;
                }
                if (workingTask != null) {
                    this._asyncPending = true;
                    this._currentTask = workingTask;
                    this.log(this._currentTask, "resuming");
                    this._currentTask.resume()
                        .then(function () {
                        _this._asyncPending = false;
                        _this._currentTask = workingTask;
                        _this.refresh();
                    });
                }
                else {
                    this.log("idle");
                }
            }
        };
        Scheduler.prototype.computeOperationProgress = function (op) {
            var progress = op.completeWeight + op.tasks.map(function (t) { return t.progress * t.progressWeight; }).reduce(function (a, b) { return a + b; }, 0);
            return progress / op.totalWeight;
        };
        Scheduler.prototype.identifyWorkingTask = function () {
            // Are there operations to work on?
            while (this._allOps.length > 0) {
                var op = this._allOps[0];
                if (this._minPri != null && op.priority > this._minPri) {
                    break;
                }
                // Find the first task in the list that is incomplete
                while (op.tasks.length > 0) {
                    var task = op.tasks[0];
                    if (task.isComplete) {
                        if (this._currentTask === task) {
                            this._currentTask = null;
                        }
                        op.completeWeight += task.progress * task.progressWeight;
                        op.tasks.shift();
                        var idx = this._allTasks.indexOf(task);
                        if (idx !== -1) {
                            this._allTasks.splice(idx, 1);
                        }
                        task.onCompleted.off(this.refresh);
                        task.onProgressChanged.off(this.refresh);
                        this.log(task, "complete");
                    }
                    else {
                        return task;
                    }
                }
                // They're all complete
                op.public.progress.value = 1.0;
                op.public.complete.value = true;
                this.log(op, "complete");
                this._allOps.shift();
            }
            // Clean out all complete tasks
            for (var i = this._allTasks.length - 1; i >= 0; --i) {
                var task = this._allTasks[i];
                if (task.isComplete) {
                    this.log(task, "complete");
                    if (this._currentTask === task) {
                        this._currentTask = null;
                    }
                    task.onCompleted.off(this.refresh);
                    task.onProgressChanged.off(this.refresh);
                    this._allTasks.splice(i, 1);
                }
            }
            // Find the first task in the list that is incomplete and falls above minPri
            for (var _i = 0, _a = this._allTasks; _i < _a.length; _i++) {
                var task = _a[_i];
                if (this._minPri == null || task.priority <= this._minPri) {
                    return task;
                }
            }
            // No task found
            return null;
        };
        Scheduler.prototype.log = function (p1, p2) {
            if (!verboseLogging) {
                return;
            }
            if (RS.Is.string(p1)) {
                RS.Log.debug("[Scheduler] ".concat(p1));
            }
            else {
                RS.Log.debug("[Scheduler] [".concat(p1.debugName || "noname", "] ").concat(p2));
            }
        };
        var _decObj = {};

        _decObj.refresh = {
            decorators: [RS.Callback],
            target: Scheduler.prototype,
            desc: null
        };

        __multiDecorate(_decObj);
        Scheduler = __decorate([
            RS.HasCallbacks
        ], Scheduler);
        return Scheduler;
    }());
    RS.Scheduler = Scheduler;
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Logging;
    (function (Logging) {
        var _a;
        /**
         * Whether each log level should show a stack trace.
         */
        var shouldAppendStackTrace = (_a = {},
            _a[Logging.LogLevel.Debug] = false,
            _a[Logging.LogLevel.Info] = false,
            _a[Logging.LogLevel.Warn] = true,
            _a[Logging.LogLevel.Error] = true,
            _a[Logging.LogLevel.Fatal] = true,
            _a[Logging.LogLevel.None] = false,
            _a);
        var DefaultLogger = /** @class */ (function () {
            function DefaultLogger() {
                /** WARNING: queueing unimplemented in DefaultLogger. Use Core.Logging or another ILogging implementation. */
                this.queuedMessages = [];
                /** WARNING: queueing unimplemented in DefaultLogger. Use Core.Logging or another ILogging implementation. */
                this.verbose = true;
                this.logLevel = Logging.LogLevel.DefaultMinimum;
                this.forceStackTrace = false;
            }
            /** WARNING: contexts not supported in DefaultLogger. Use Core.Logging or another ILogging implementation. */
            DefaultLogger.prototype.getContext = function (context) {
                return Logging.ILogger.get();
            };
            /** WARNING: queueing unimplemented in DefaultLogger. Use Core.Logging or another ILogging implementation. */
            DefaultLogger.prototype.queue = function () {
                var messages = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    messages[_i] = arguments[_i];
                }
                var message = messages.join(" ");
                if (this.verbose) {
                    this.log(message, Logging.LogLevel.Debug, true);
                }
            };
            /** WARNING: queueing unimplemented in DefaultLogger. Use Core.Logging or another ILogging implementation. */
            DefaultLogger.prototype.drop = function () {
                return;
            };
            /** WARNING: queueing unimplemented in DefaultLogger. Use Core.Logging or another ILogging implementation. */
            DefaultLogger.prototype.dump = function (logLevel) {
                return;
            };
            /**
             * Logs the specified message.
             */
            DefaultLogger.prototype.log = function (obj, logLevel, excludeStackTrace) {
                var message;
                // Is it an error?
                if (obj instanceof Error) {
                    if (logLevel == null) {
                        logLevel = Logging.LogLevel.Error;
                    }
                    if (this.forceStackTrace || (shouldAppendStackTrace[logLevel] && !excludeStackTrace)) {
                        message = "".concat(obj.message, "\n").concat(obj.stack || "No stack trace available");
                    }
                    else {
                        message = obj.message;
                    }
                }
                else {
                    if (logLevel == null) {
                        logLevel = Logging.LogLevel.Info;
                    }
                    if (this.forceStackTrace || (shouldAppendStackTrace[logLevel] && !excludeStackTrace)) {
                        message = "".concat(obj, "\n").concat(RS.Util.getStackTrace());
                    }
                    else {
                        message = obj;
                    }
                }
                if (logLevel < this.logLevel) {
                    return;
                }
                // Write to console
                switch (logLevel) {
                    case Logging.LogLevel.Debug:
                        console.debug(message);
                        break;
                    case Logging.LogLevel.Info:
                        console.log(message);
                        break;
                    case Logging.LogLevel.Warn:
                        console.warn(message);
                        break;
                    case Logging.LogLevel.Error:
                    case Logging.LogLevel.Fatal:
                        console.error(message);
                        break;
                }
            };
            return DefaultLogger;
        }());
        Logging.ILogger.register(DefaultLogger, true);
    })(Logging = RS.Logging || (RS.Logging = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Request;
    (function (Request) {
        /**
         * Encapsulates a type of response.
         */
        var AJAXResponseType;
        (function (AJAXResponseType) {
            AJAXResponseType[AJAXResponseType.Text = 0] = "Text";
            AJAXResponseType[AJAXResponseType.XML = 1] = "XML";
            AJAXResponseType[AJAXResponseType.JSON = 2] = "JSON";
            AJAXResponseType[AJAXResponseType.Binary = 3] = "Binary";
            AJAXResponseType[AJAXResponseType.Blob = 4] = "Blob";
            AJAXResponseType[AJAXResponseType.ObjectURL = 5] = "ObjectURL";
        })(AJAXResponseType = Request.AJAXResponseType || (Request.AJAXResponseType = {}));
        var ResponseError = /** @class */ (function (_super) {
            __extends(ResponseError, _super);
            function ResponseError(code, statusText) {
                var _this = _super.call(this, "".concat(code, " ").concat(statusText)) || this;
                _this.code = code;
                return _this;
            }
            return ResponseError;
        }(RS.BaseError));
        Request.ResponseError = ResponseError;
        function ajax(settings, responseType) {
            return new Promise(function (resolve, reject) {
                var req = new XMLHttpRequest();
                if (settings.withCredentials != null) {
                    req.withCredentials = settings.withCredentials;
                }
                req.addEventListener("load", function (ev) {
                    if (req.status !== 200) {
                        reject(new ResponseError(req.status, req.statusText));
                        return;
                    }
                    switch (responseType) {
                        case AJAXResponseType.Text:
                            resolve(req.responseText);
                            break;
                        case AJAXResponseType.XML:
                            resolve(req.responseXML);
                            break;
                        case AJAXResponseType.JSON:
                            if (RS.Is.string(req.response)) {
                                var newResponse = void 0;
                                try {
                                    newResponse = JSON.parse(req.response);
                                }
                                catch (err) {
                                    reject(err);
                                    break;
                                }
                                resolve(newResponse);
                            }
                            else {
                                resolve(req.response);
                            }
                            break;
                        case AJAXResponseType.Binary:
                        case AJAXResponseType.Blob:
                            resolve(req.response);
                            break;
                        case AJAXResponseType.ObjectURL:
                            resolve(window.URL.createObjectURL(req.response));
                            break;
                    }
                });
                req.addEventListener("error", function (ev) {
                    reject(ev);
                });
                req.addEventListener("abort", function (ev) {
                    reject("aborted");
                });
                req.open(settings.method || "GET", settings.url, true);
                if (settings.auth) {
                    var auth = btoa("".concat(settings.auth.username, ":").concat(settings.auth.password));
                    req.setRequestHeader("Authorization", "Basic ".concat(auth));
                }
                switch (responseType) {
                    case AJAXResponseType.Text:
                        req.responseType = "text";
                        break;
                    case AJAXResponseType.XML:
                        req.responseType = "document";
                        break;
                    case AJAXResponseType.JSON:
                        req.responseType = "json";
                        break;
                    case AJAXResponseType.Binary:
                        req.responseType = "arraybuffer";
                        break;
                    case AJAXResponseType.Blob:
                    case AJAXResponseType.ObjectURL:
                        req.responseType = "blob";
                        break;
                }
                if (settings.headers) {
                    for (var header in settings.headers) {
                        req.setRequestHeader(header, settings.headers[header]);
                    }
                }
                req.send(settings.postData);
            });
        }
        Request.ajax = ajax;
    })(Request = RS.Request || (RS.Request = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Request;
    (function (Request) {
        /**
         * Sends an asynchronous tag-based request.
         * @param settings
         * @param responseType
         */
        function tag(settings) {
            return new Promise(function (resolve, reject) {
                var el = document.createElement(settings.tagName);
                el.crossOrigin = "anonymous";
                el.addEventListener("load", function (ev) {
                    document.body.removeChild(el);
                    resolve(el);
                });
                el.addEventListener("error", function (ev) {
                    document.body.removeChild(el);
                    reject("Tag based load failed");
                });
                el.style.position = "fixed";
                el.style.width = "0px";
                el.style.height = "0px";
                el.src = settings.url;
                document.body.appendChild(el);
            });
        }
        Request.tag = tag;
    })(Request = RS.Request || (RS.Request = {}));
})(RS || (RS = {}));
//# sourceMappingURL=src.js.map
var RS;
(function (RS) {
    var Localisation;
    (function (Localisation) {
        /**
         * Generates a simple getter function for the specified key.
         * Used by generated code.
         * @param key
         */
        function generateSimpleGetter(key) {
            return function (locale) {
                if (locale == null) {
                    return "NO LOCALE";
                }
                return locale.getString(key, key);
            };
        }
        Localisation.generateSimpleGetter = generateSimpleGetter;
        /**
         * Generates a complex getter function for the specified key.
         * Used by generated code.
         * @param key
         */
        function generateComplexGetter(key, keyMap) {
            return function (locale, substitutions) {
                if (locale == null) {
                    return "NO LOCALE";
                }
                var str = locale.getString(key);
                if (str == null) {
                    return key;
                }
                for (var subKey in substitutions) {
                    var value = substitutions[subKey];
                    var strValue = RS.Is.localisableString(value)
                        ? Localisation.resolveLocalisableString(locale, value)
                        : "".concat(value);
                    str = str.replace(keyMap[subKey], strValue);
                }
                return str;
            };
        }
        Localisation.generateComplexGetter = generateComplexGetter;
        function clone() {
            return RS.Util.clone(this, false);
        }
        Localisation.clone = clone;
        /**
         * Binds the specified static substitutions to the specified complex translation key.
         * @param base
         * @param substitutions
         */
        function bind(base, substitutions) {
            var bound = { get: base.get, getParts: base.getParts, substitutions: {}, clone: clone };
            for (var key in substitutions) {
                bound.substitutions[key] = substitutions[key];
            }
            return bound;
        }
        Localisation.bind = bind;
        /**
         * Resolves the specified LocalisableString into a string.
         * @param locale
         * @param str
         */
        function resolveLocalisableString(locale, str) {
            if (RS.Is.string(str)) {
                return str;
            }
            else if (RS.Is.boundComplexGetter(str)) {
                return str.get(locale, str.substitutions);
            }
            else if (str instanceof Error) {
                return str.stack || str.message;
            }
            else if (str && RS.Is.func(str.get)) {
                return str.get(locale);
            }
            else {
                return "".concat(str);
            }
        }
        Localisation.resolveLocalisableString = resolveLocalisableString;
        var TranslationPart;
        (function (TranslationPart) {
            var Kind;
            (function (Kind) {
                Kind[Kind.Text = 0] = "Text";
                Kind[Kind.Variable = 1] = "Variable";
                Kind[Kind.Protected = 2] = "Protected";
            })(Kind = TranslationPart.Kind || (TranslationPart.Kind = {}));
        })(TranslationPart = Localisation.TranslationPart || (Localisation.TranslationPart = {}));
        var tokenRules = [
            { regex: /\{([a-zA-Z0-9_]+)\}/, group: 1, kind: TranslationPart.Kind.Variable },
            { regex: /(\|\|?\|?)([^\|]+)\1/, group: 2, kind: TranslationPart.Kind.Protected }
        ];
        /**
         * Breaks down a translated string into parts.
         * @param str
         */
        function getParts(str) {
            var result = [];
            var remainingStr = str;
            while (remainingStr.length > 0) {
                var lowestMatch = remainingStr.length;
                var matchRule = null;
                var matchContent = null;
                var matchLength = null;
                for (var _i = 0, tokenRules_1 = tokenRules; _i < tokenRules_1.length; _i++) {
                    var rule = tokenRules_1[_i];
                    var match = rule.regex.exec(remainingStr);
                    if (match) {
                        if (match.index < lowestMatch) {
                            lowestMatch = match.index;
                            matchRule = rule;
                            matchContent = match[rule.group];
                            matchLength = match[0].length;
                        }
                    }
                }
                if (lowestMatch > 0) {
                    result.push({
                        kind: TranslationPart.Kind.Text,
                        value: remainingStr.substr(0, lowestMatch)
                    });
                    remainingStr = remainingStr.substr(lowestMatch);
                }
                if (matchRule) {
                    result.push({
                        kind: matchRule.kind,
                        value: matchContent
                    });
                    remainingStr = remainingStr.substr(matchLength);
                }
            }
            return result;
        }
        Localisation.getParts = getParts;
        var SpecialChars;
        (function (SpecialChars) {
            SpecialChars.NonBreakingSpace = "\u00A0";
        })(SpecialChars = Localisation.SpecialChars || (Localisation.SpecialChars = {}));
        var defaultReduceFunc = function (a, b) { return "".concat(a, "\n").concat(b); };
        function reduce(localisations, reduceFunc) {
            if (reduceFunc === void 0) { reduceFunc = defaultReduceFunc; }
            if (localisations.length === 0) {
                return "";
            }
            function resolve(locale, localisation, substitutions) {
                if (localisation.get) {
                    var complexLocalisation = localisation;
                    return complexLocalisation.get(locale, substitutions);
                }
                return resolveLocalisableString(locale, localisation);
            }
            var composite = {
                get: function (locale, substitutions) { return localisations
                    .map(function (localisation) { return resolve(locale, localisation, substitutions); })
                    .reduce(function (a, b) { return reduceFunc(a, b); }); },
                getParts: function (locale) { return getParts(composite.get(locale, {})); },
                clone: clone
            };
            return composite;
        }
        Localisation.reduce = reduce;
    })(Localisation = RS.Localisation || (RS.Localisation = {}));
})(RS || (RS = {}));
/// <reference path="Utils.ts" />
var RS;
(function (RS) {
    var Localisation;
    (function (Localisation) {
        var standardCurrencySettings = {
            exchangeRate: 1,
            grouping: 3,
            groupingSeparator: ",",
            fractionalDigits: 2,
            fractionalSeparator: ".",
            currencyCodeSpacing: 1,
            currencyCodeBeforeAmount: true,
            currencySymbolSpacing: 0,
            currencySymbolBeforeAmount: true,
            currencyMultiplier: 1,
            displaySymbol: true,
            displayCode: false
        };
        var spaceCharacter = RS.Localisation.SpecialChars.NonBreakingSpace;
        Localisation.currencyMap = {
            "GBP": __assign(__assign({}, standardCurrencySettings), { name: "GBP", symbol: "£", groupingSeparator: ",", fractionalSeparator: "." }),
            "HKD": __assign(__assign({}, standardCurrencySettings), { name: "HKD", symbol: "$", groupingSeparator: ",", fractionalSeparator: "." }),
            "EUR": __assign(__assign({}, standardCurrencySettings), { name: "EUR", symbol: "€", groupingSeparator: ".", fractionalSeparator: "," }),
            "USD": __assign(__assign({}, standardCurrencySettings), { name: "USD", symbol: "$", groupingSeparator: ",", fractionalSeparator: "." }),
            "JPY": __assign(__assign({}, standardCurrencySettings), { name: "JPY", symbol: "¥", groupingSeparator: ",", fractionalSeparator: ".", fractionalDigits: 0, currencySymbolBeforeAmount: false }),
            "SGD": __assign(__assign({}, standardCurrencySettings), { name: "SGD", symbol: "$", groupingSeparator: ",", fractionalSeparator: "." }),
            "AUD": __assign(__assign({}, standardCurrencySettings), { name: "AUD", symbol: "$", groupingSeparator: " ", fractionalSeparator: "." }),
            "CAD": __assign(__assign({}, standardCurrencySettings), { name: "CAD", symbol: "$", groupingSeparator: ",", fractionalSeparator: "." }),
            "CHF": __assign(__assign({}, standardCurrencySettings), { name: "CHF", symbol: "SFr.", groupingSeparator: "'", fractionalSeparator: ".", currencySymbolSpacing: 0 }),
            "DKK": __assign(__assign({}, standardCurrencySettings), { name: "DKK", symbol: "kr", groupingSeparator: ".", fractionalSeparator: ",", currencySymbolSpacing: 1 }),
            "SEK": __assign(__assign({}, standardCurrencySettings), { name: "SEK", symbol: "kr", groupingSeparator: ".", fractionalSeparator: ",", currencySymbolSpacing: 1 }),
            "ARS": __assign(__assign({}, standardCurrencySettings), { name: "ARS", symbol: "$", groupingSeparator: ".", fractionalSeparator: ",", currencyMultiplier: 5 }),
            "BGN": __assign(__assign({}, standardCurrencySettings), { name: "BGN", symbol: "лв.", groupingSeparator: spaceCharacter, fractionalSeparator: ",", currencySymbolBeforeAmount: false, currencyMultiplier: 2 }),
            "BRL": __assign(__assign({}, standardCurrencySettings), { name: "BRL", symbol: "R$", groupingSeparator: ".", fractionalSeparator: ",", currencySymbolSpacing: 1, currencyMultiplier: 2 }),
            "CNY": __assign(__assign({}, standardCurrencySettings), { name: "CNY", symbol: "¥", groupingSeparator: ",", fractionalSeparator: ".", currencyMultiplier: 10 }),
            "CZK": __assign(__assign({}, standardCurrencySettings), { name: "CZK", symbol: "Kč", groupingSeparator: spaceCharacter, fractionalSeparator: ",", currencySymbolSpacing: 1, currencySymbolBeforeAmount: false, currencyMultiplier: 20 }),
            "EEK": __assign(__assign({}, standardCurrencySettings), { name: "EEK", symbol: "€", groupingSeparator: ",", fractionalSeparator: ".", currencySymbolSpacing: 1, currencyMultiplier: 15 }),
            "HRK": __assign(__assign({}, standardCurrencySettings), { name: "HRK", symbol: "Kn", groupingSeparator: ".", fractionalSeparator: ",", currencySymbolSpacing: 1, currencyMultiplier: 10 }),
            "HUF": __assign(__assign({}, standardCurrencySettings), { name: "HUF", symbol: "Ft", groupingSeparator: spaceCharacter, fractionalSeparator: ",", currencySymbolSpacing: 1, currencySymbolBeforeAmount: false, currencyMultiplier: 300 }),
            "INR": __assign(__assign({}, standardCurrencySettings), { name: "INR", symbol: "Rs.", groupingSeparator: ",", fractionalSeparator: ".", currencyMultiplier: 50 }),
            "ISK": __assign(__assign({}, standardCurrencySettings), { name: "ISK", symbol: "kr.", groupingSeparator: ".", fractionalDigits: 0, fractionalSeparator: ",", currencySymbolSpacing: 1, currencySymbolBeforeAmount: false, currencyMultiplier: 200 }),
            "LIL": __assign(__assign({}, standardCurrencySettings), { name: "LTL", symbol: "€", groupingSeparator: ",", fractionalSeparator: ".", currencySymbolSpacing: 1, currencyMultiplier: 5 }),
            "LVL": __assign(__assign({}, standardCurrencySettings), { name: "LVL", symbol: "€", groupingSeparator: ",", fractionalSeparator: ".", currencySymbolSpacing: 1 }),
            "MXN": __assign(__assign({}, standardCurrencySettings), { name: "MXN", symbol: "$", groupingSeparator: ",", fractionalSeparator: ".", currencyMultiplier: 20 }),
            "MYR": __assign(__assign({}, standardCurrencySettings), { name: "MYR", symbol: "RM", groupingSeparator: ",", fractionalSeparator: ".", currencyMultiplier: 5 }),
            "NOK": __assign(__assign({}, standardCurrencySettings), { name: "NOK", symbol: "kr", groupingSeparator: spaceCharacter, fractionalSeparator: ",", currencySymbolSpacing: 1, currencyMultiplier: 10 }),
            "NZD": __assign(__assign({}, standardCurrencySettings), { name: "NZD", symbol: "$", groupingSeparator: ",", fractionalSeparator: ".", currencyMultiplier: 1 }),
            "PEN": __assign(__assign({}, standardCurrencySettings), { name: "PEN", symbol: "S/.", groupingSeparator: ".", fractionalSeparator: ",", currencyMultiplier: 4 }),
            "PLN": __assign(__assign({}, standardCurrencySettings), { name: "PLN", symbol: "zł", groupingSeparator: spaceCharacter, fractionalSeparator: ",", currencySymbolBeforeAmount: false, currencyMultiplier: 5 }),
            "RON": __assign(__assign({}, standardCurrencySettings), { name: "RON", symbol: "LEI", groupingSeparator: ".", fractionalSeparator: ",", currencySymbolSpacing: 1, currencySymbolBeforeAmount: false, currencyMultiplier: 5 }),
            "RUB": __assign(__assign({}, standardCurrencySettings), { name: "RUB", symbol: "руб.", groupingSeparator: spaceCharacter, fractionalSeparator: ",", currencySymbolSpacing: 1, currencySymbolBeforeAmount: false, currencyMultiplier: 40 }),
            "THB": __assign(__assign({}, standardCurrencySettings), { name: "THB", symbol: "THB", groupingSeparator: ",", fractionalSeparator: ".", currencyMultiplier: 40 }),
            "TRY": __assign(__assign({}, standardCurrencySettings), { name: "TRY", symbol: "TL", groupingSeparator: ".", fractionalSeparator: ",", currencySymbolSpacing: 1, currencySymbolBeforeAmount: false, currencyMultiplier: 2 }),
            "TWD": __assign(__assign({}, standardCurrencySettings), { name: "TWD", symbol: "NT$", groupingSeparator: ",", fractionalSeparator: ".", currencyMultiplier: 40 }),
            "ZAR": __assign(__assign({}, standardCurrencySettings), { name: "ZAR", symbol: "R", groupingSeparator: ",", fractionalDigits: 2, fractionalSeparator: ".", currencySymbolSpacing: 1, currencyMultiplier: 10 })
        };
        Localisation.defaultCurrencySettings = Localisation.currencyMap["GBP"];
    })(Localisation = RS.Localisation || (RS.Localisation = {}));
})(RS || (RS = {}));
/// <reference path="CurrencySettings.ts" />
var RS;
(function (RS) {
    var Localisation;
    (function (Localisation) {
        /**
         * Responsible for formatting numbers into a particular currency.
         */
        var CurrencyFormatter = /** @class */ (function () {
            function CurrencyFormatter(settings) {
                if (settings === void 0) { settings = Localisation.defaultCurrencySettings; }
                this._settings = settings;
            }
            var _propObj = {};

            _propObj.settings = {
                /** Gets or sets the currency settings for this formatter. */
                get: function () { return this._settings; },
                set: function (value) { this._settings = value; },
                enumerable: false,
                configurable: true
            };

            Object.defineProperties(CurrencyFormatter.prototype, _propObj);
            /**
             * Formats a number value.
             * @param value The value to format.
             * @param displaySymbol Whether to display the symbol/code or not.
             */
            CurrencyFormatter.prototype.format = function (value, displaySymbol, removeUnusedFractionalDigits) {
                if (displaySymbol === void 0) { displaySymbol = true; }
                return this.performFormat(value, displaySymbol, this._settings.fractionalDigits, removeUnusedFractionalDigits);
            };
            /**
             * Formats a number to a specified amount of fractional digits, irregardless of whether or not the current currency has fractional digits in it.
             * If an amount of fractional digits is not provided, it will format it to 2dp.
             * @param value The value to format.
             * @param displaySymbol Whether to display the symbol/code or not.
             */
            CurrencyFormatter.prototype.formatDecimal = function (value, displaySymbol, fractionalDigits) {
                if (displaySymbol === void 0) { displaySymbol = true; }
                if (fractionalDigits === void 0) { fractionalDigits = 2; }
                return this.performFormat(value, displaySymbol, fractionalDigits);
            };
            CurrencyFormatter.prototype.performFormat = function (value, displaySymbol, fractionalDigits, removeUnusedFractionalDigits) {
                if (displaySymbol === void 0) { displaySymbol = true; }
                if (fractionalDigits === void 0) { fractionalDigits = 2; }
                // Convert to string without decimals
                value = Math.round(value) / 100;
                if (removeUnusedFractionalDigits && (value - Math.floor(value)) === 0) {
                    fractionalDigits = 0;
                }
                var digits = value.toFixed(fractionalDigits);
                var parts = digits.split("");
                var positionOfDecimal = parts.indexOf(".");
                // Insert fractional separator
                if (positionOfDecimal !== -1) {
                    parts[positionOfDecimal] = this._settings.fractionalSeparator;
                }
                var groupFrom;
                if (positionOfDecimal !== -1) {
                    groupFrom = positionOfDecimal - 1;
                }
                else {
                    groupFrom = parts.length - 1;
                }
                // Insert grouping seperators
                var curGroup = 0;
                for (var i = groupFrom; i >= 0; --i) {
                    ++curGroup;
                    if (curGroup >= this._settings.grouping && i > 0) {
                        parts.splice(i, 0, this._settings.groupingSeparator);
                        curGroup = 0;
                    }
                }
                // Insert currency symbol
                if (this._settings.displaySymbol && displaySymbol) {
                    this.attach(this._settings.symbol, parts, this._settings.currencySymbolSpacing, this._settings.currencySymbolBeforeAmount);
                }
                // Insert currency code
                if (this._settings.displayCode && displaySymbol) {
                    this.attach(this._settings.name, parts, this._settings.currencyCodeSpacing, this._settings.currencyCodeBeforeAmount);
                }
                // Join everything together
                return parts.join("");
            };
            CurrencyFormatter.prototype.attach = function (part, parts, spacingCount, before) {
                // Use non-breaking space.
                var spaceCharacter = Localisation.SpecialChars.NonBreakingSpace;
                if (before) {
                    parts.splice(0, 0, part);
                    for (var i = 0; i < spacingCount; ++i) {
                        parts.splice(1, 0, spaceCharacter);
                    }
                }
                else {
                    for (var i = 0; i < spacingCount; ++i) {
                        parts.push(spaceCharacter);
                    }
                    parts.push(part);
                }
            };
            return CurrencyFormatter;
        }());
        Localisation.CurrencyFormatter = CurrencyFormatter;
    })(Localisation = RS.Localisation || (RS.Localisation = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Localisation;
    (function (Localisation) {
        /** Allows localisations to include an arbitrarily-formatted date. */
        var Date;
        (function (Date) {
            /** Binds a compatible localisation to a given Date. */
            function bind(string, date) {
                // Date
                var D = "".concat(date.getDate());
                var DD = RS.Util.padLeft(D, "0", 2);
                var M = "".concat(date.getMonth() + 1);
                var MM = RS.Util.padLeft(M, "0", 2);
                var YYYY = "".concat(date.getFullYear());
                // Standard time
                var hours = date.getHours();
                var H = "".concat(hours);
                var HH = RS.Util.padLeft(H, "0", 2);
                var m = "".concat(date.getMinutes());
                var mm = RS.Util.padLeft(m, "0", 2);
                // 12-hour time
                var pm;
                var h;
                var hh;
                if (hours > 12) {
                    pm = "pm";
                    h = "".concat(date.getHours() - 12);
                    hh = RS.Util.padLeft(h, "0", 2);
                }
                else {
                    pm = "am";
                    h = H;
                    hh = HH;
                }
                return RS.Localisation.bind(string, { D: D, DD: DD, M: M, MM: MM, YYYY: YYYY, H: H, HH: HH, m: m, mm: mm, h: h, hh: hh, pm: pm });
            }
            Date.bind = bind;
        })(Date = Localisation.Date || (Localisation.Date = {}));
    })(Localisation = RS.Localisation || (RS.Localisation = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Is;
    (function (Is) {
        /**
         * Gets if the specified value is a Localisation.LocalisableString
         * @param value
         */
        function localisableString(value) {
            return Is.string(value) ||
                (Is.object(value) && Is.func(value.get) && Is.func(value.getParts)) || // SimpleTranslationReference
                (Is.boundComplexGetter(value)) ||
                (value instanceof Error);
        }
        Is.localisableString = localisableString;
        function boundComplexGetter(value) {
            return Is.object(value) && Is.func(value.get) && Is.object(value.substitutions);
        }
        Is.boundComplexGetter = boundComplexGetter;
    })(Is = RS.Is || (RS.Is = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Localisation;
    (function (Localisation) {
        /**
         * Encapsulates a single locale.
         */
        var Locale = /** @class */ (function () {
            function Locale(langCode, countryCode) {
                this._strings = {};
                this._langCode = langCode;
                this._countryCode = countryCode;
            }
            var _propObj = {};

            _propObj.languageCode = {
                /**
                 * Gets the ISO 639 language code for this locale.
                 * e.g. "en"
                 */
                get: function () { return this._langCode; },
                enumerable: false,
                configurable: true
            };

            _propObj.countryCode = {
                /**
                 * Gets the ISO 3166-1 country code for this locale.
                 * e.g. "US"
                 */
                get: function () { return this._countryCode; },
                enumerable: false,
                configurable: true
            };

            Object.defineProperties(Locale.prototype, _propObj);
            /**
             * Adds a localised string to this locale.
             * @param key
             * @param value
             */
            Locale.prototype.addString = function (key, value) {
                this._strings[key] = value;
            };
            /**
             * Gets a localised string from this locale.
             * @param key
             */
            Locale.prototype.getString = function (key, def) {
                if (def === void 0) { def = key; }
                return this._strings[key] || def;
            };
            return Locale;
        }());
        Localisation.Locale = Locale;
    })(Localisation = RS.Localisation || (RS.Localisation = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var Translations;
    (function (Translations) {
        /** Contains the list of all supported locales. */
        Translations.supportedLocaleCodes = [
            "bg_BG", "ca_ES", "cs_CZ", "da_DK", "de_DE", "el_GR", "en_GB", "en_US", "es_ES", "et_EE", "fi_FI", "fr_CA", "fr_FR", "hr_HR", "hu_HU", "it_IT", "ja_JP", "lt_LT", "lv_LV", "nb_NO", "nl_NL", "no_NO", "pl_PL", "pt_BR", "pt_PT", "ro_RO", "ru_RU", "sk_SK", "sl_SI", "sr_RS", "sr_SR", "sv_SE", "tr_TR"
        ];
        /** The default locale that should be used in the event that the game fails to select an appropriate locale from supportedLocaleCodes */
        Translations.defaultLocaleCode = "en_GB";
    })(Translations = RS.Translations || (RS.Translations = {}));
})(RS || (RS = {}));
//# sourceMappingURL=src.js.map
var RS;
(function (RS) {
    var ExternalHelp;
    (function (ExternalHelp) {
        var Page = /** @class */ (function () {
            function Page(localeCode, version) {
                this.localeCode = localeCode;
                this.version = version;
                this.onLoaded = RS.createSimpleEvent();
                this.onElementLoaded = RS.createEvent(true);
                window.addEventListener("load", this.onLoad);
            }
            var _propObj = {};

            _propObj.languageCode = {
                get: function () { return this.localeCode.split("_")[0]; },
                enumerable: false,
                configurable: true
            };

            _propObj.countryCode = {
                get: function () { return this.localeCode.split("_")[1]; },
                enumerable: false,
                configurable: true
            };

            Object.defineProperties(Page.prototype, _propObj);
            Page.prototype.onLoad = function () {
                window.removeEventListener("load", this.onLoad);
                if (this.onElementLoaded.listenerCount.value > 0) {
                    this.publishLoadedEvent(document.body);
                }
                this.onLoaded.publish();
            };
            Page.prototype.publishLoadedEvent = function (element) {
                var children = element.children;
                for (var i = 0; i < children.length; i++) {
                    var child = children[i];
                    if (!(child instanceof HTMLElement)) {
                        continue;
                    }
                    this.publishLoadedEvent(child);
                }
                this.onElementLoaded.publish(element);
            };
            var _decObj = {};

            _decObj.onLoad = {
                decorators: [RS.Callback],
                target: Page.prototype,
                desc: null
            };

            __multiDecorate(_decObj);
            Page = __decorate([
                RS.HasCallbacks
            ], Page);
            return Page;
        }());
        ExternalHelp.Page = Page;
    })(ExternalHelp = RS.ExternalHelp || (RS.ExternalHelp = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var ExternalHelp;
    (function (ExternalHelp) {
        var PluginRegistry = /** @class */ (function () {
            function PluginRegistry() {
                this._plugins = [];
            }
            var _propObj = {};

            _propObj.plugins = {
                get: function () { return this._plugins; },
                enumerable: false,
                configurable: true
            };

            Object.defineProperties(PluginRegistry.prototype, _propObj);
            PluginRegistry.prototype.register = function (pluginClass) {
                if (this._plugins.indexOf(pluginClass) > -1) {
                    return;
                }
                this._plugins.push(pluginClass);
            };
            return PluginRegistry;
        }());
        ExternalHelp.PluginRegistry = PluginRegistry;
        var PluginManager = /** @class */ (function () {
            function PluginManager(registry, page) {
                this._plugins = registry.plugins.map(function (pluginClass) { return new pluginClass(page); });
            }
            PluginManager.prototype.get = function (pluginClass) {
                return RS.Find.matching(this._plugins, function (plugin) { return plugin instanceof pluginClass; });
            };
            return PluginManager;
        }());
        ExternalHelp.PluginManager = PluginManager;
        var Plugin = /** @class */ (function () {
            function Plugin(page) {
                var _this = this;
                page.onLoaded(function () { return _this.onPageLoaded(page); });
            }
            return Plugin;
        }());
        ExternalHelp.Plugin = Plugin;
        var VisitorPlugin = /** @class */ (function (_super) {
            __extends(VisitorPlugin, _super);
            function VisitorPlugin(page) {
                var _this = _super.call(this, page) || this;
                _this.page = page;
                page.onElementLoaded(function (element) { return _this.onElementLoaded(element); });
                return _this;
            }
            VisitorPlugin.prototype.onPageLoaded = function (page) { };
            return VisitorPlugin;
        }(Plugin));
        ExternalHelp.VisitorPlugin = VisitorPlugin;
    })(ExternalHelp = RS.ExternalHelp || (RS.ExternalHelp = {}));
})(RS || (RS = {}));
/// <reference path="Page.ts" />
/// <reference path="Plugin.ts" />
var RS;
(function (RS) {
    var ExternalHelp;
    (function (ExternalHelp) {
        var versionFromBuild = "1.0.2";
        /** Tracks the plugins to be instantiated. */
        ExternalHelp.pluginRegistry = new ExternalHelp.PluginRegistry();
        var funcName = "initHelp";
        function init(localeCode) {
            var version = RS.Version.fromString(versionFromBuild);
            var page = new ExternalHelp.Page(localeCode, version);
            ExternalHelp.pluginManager = new ExternalHelp.PluginManager(ExternalHelp.pluginRegistry, page);
            RS.Log.info("External help libraries loaded (v".concat(RS.Version.toString(version), ")."));
            delete window[funcName];
        }
        ExternalHelp.init = init;
        window[funcName] = init;
    })(ExternalHelp = RS.ExternalHelp || (RS.ExternalHelp = {}));
})(RS || (RS = {}));
var RS;
(function (RS) {
    var ExternalHelp;
    (function (ExternalHelp) {
        function forEachAncestor(element, callbackfn) {
            for (var el = element.parentElement; el != null; el = el.parentElement) {
                var result = callbackfn(el);
                if (RS.Is.boolean(result) && !result) {
                    break;
                }
            }
        }
        ExternalHelp.forEachAncestor = forEachAncestor;
        /** Searches for an ancestor of the given element matching the given predicate. */
        function findAncestor(element, predicate) {
            for (var el = element.parentElement; el != null; el = el.parentElement) {
                if (predicate(el)) {
                    return el;
                }
            }
            return null;
        }
        ExternalHelp.findAncestor = findAncestor;
        function hideElement(element) {
            element.style.display = "none";
        }
        ExternalHelp.hideElement = hideElement;
        function hideLocalisation(element) {
            var text = element;
            if (!text.classList.contains("rs-locale-text")) {
                text = findAncestor(element, function (ancestor) { return ancestor.classList.contains("rs-locale-text"); });
            }
            if (text) {
                hideElement(text);
                // Hide all parent elements that only contain this element.
                forEachAncestor(text, function (ancestor) {
                    if (ancestor.children.length > 1) {
                        return false;
                    }
                    hideElement(ancestor);
                    return true;
                });
            }
        }
        ExternalHelp.hideLocalisation = hideLocalisation;
    })(ExternalHelp = RS.ExternalHelp || (RS.ExternalHelp = {}));
})(RS || (RS = {}));
/// <reference path="../Init.ts"/>
var RS;
(function (RS) {
    var ExternalHelp;
    (function (ExternalHelp) {
        var ClientVersionPlugin = /** @class */ (function (_super) {
            __extends(ClientVersionPlugin, _super);
            function ClientVersionPlugin(page) {
                var _this = _super.call(this, page) || this;
                _this._versionString = RS.Version.toString(page.version);
                return _this;
            }
            ClientVersionPlugin.prototype.onElementLoaded = function (element) {
                var isMaxWin = element.classList.contains("rs-variable-clientversion");
                if (!isMaxWin) {
                    return;
                }
                element.innerHTML = this._versionString;
            };
            return ClientVersionPlugin;
        }(ExternalHelp.VisitorPlugin));
        ExternalHelp.pluginRegistry.register(ClientVersionPlugin);
    })(ExternalHelp = RS.ExternalHelp || (RS.ExternalHelp = {}));
})(RS || (RS = {}));
/// <reference path="../Init.ts"/>
var RS;
(function (RS) {
    var ExternalHelp;
    (function (ExternalHelp) {
        var defaultYear = "2019";
        var CopyrightPlugin = /** @class */ (function (_super) {
            __extends(CopyrightPlugin, _super);
            function CopyrightPlugin(page) {
                var _this = _super.call(this, page) || this;
                _this._showSecondary = page.languageCode !== "en";
                _this._year = RS.URL.getParameter("cryear", defaultYear);
                return _this;
            }
            CopyrightPlugin.prototype.onPageLoaded = function (page) {
                if (!this._showSecondary) {
                    var secondary = document.getElementById("rs-copyright-en");
                    if (secondary) {
                        secondary.style.display = "none";
                        ExternalHelp.hideLocalisation(secondary);
                    }
                }
            };
            CopyrightPlugin.prototype.onElementLoaded = function (element) {
                var isYear = element.classList.contains("rs-variable-cryear");
                if (!isYear) {
                    return;
                }
                element.innerHTML = "".concat(this._year);
            };
            return CopyrightPlugin;
        }(ExternalHelp.VisitorPlugin));
        ExternalHelp.pluginRegistry.register(CopyrightPlugin);
    })(ExternalHelp = RS.ExternalHelp || (RS.ExternalHelp = {}));
})(RS || (RS = {}));
/// <reference path="../Init.ts"/>
var RS;
(function (RS) {
    var ExternalHelp;
    (function (ExternalHelp) {
        var DocDownload = /** @class */ (function (_super) {
            __extends(DocDownload, _super);
            function DocDownload() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this._locale_codes = ["bg_BG", "ca_ES", "cs_CZ", "da_DK", "de_DE", "el_GR", "en_GB", "en_US", "es_ES",
                    "et_EE", "fi_FI", "fr_CA", "fr_FR", "hr_HR", "hu_HU", "it_IT", "ja_JP", "lt_LT", "lv_LV", "nl_NL", "no_NO", "pl_PL",
                    "pt_PT", "pt_BR", "ro_RO", "ru_RU", "sk_SK", "sl_SI", "sr_RS", "sv_SE", "tr_TR"];
                return _this;
            }
            DocDownload_1 = DocDownload;
            DocDownload.prototype.onPageLoaded = function (page) {
                var _this = this;
                this._locale = page.localeCode;
                var showButton = RS.URL.getParameterAsBool("generateDoc", false);
                if (document.getElementById(DocDownload_1.divID)) {
                    this.showButton(showButton);
                    document.getElementById(DocDownload_1.singleDocButtonID).onclick = this.generateThisDoc.bind(this);
                    document.getElementById(DocDownload_1.multipleDocButtonID).onclick = function () { _this.generateAllDocs(); };
                }
                if (RS.URL.getParameter("dlDoc")) {
                    this.generateThisDoc();
                }
            };
            DocDownload.prototype.getGameName = function () {
                var url = window.location.href;
                var parts = url.split('/');
                var gameName = "";
                //checks if there are at least 3 slashes in the url and takes the 4th part, which is the game name
                if (parts.length >= 4) {
                    gameName = parts[4];
                }
                return gameName;
            };
            DocDownload.prototype.generateAllDocs = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var url, dlParam, prompt, _loop_1, this_1, _i, _a, locale;
                    var _this = this;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                url = window.location.href;
                                dlParam = "&dlDoc=true";
                                prompt = window.prompt("Edit this list to add or remove locales (seperate by comma); Please wait for document generator to finish.", this._locale_codes.join());
                                if (!(prompt == "" || prompt == null)) return [3 /*break*/, 1];
                                RS.Log.debug("No locales given!");
                                return [3 /*break*/, 5];
                            case 1:
                                _loop_1 = function (locale) {
                                    var newUrl, req;
                                    return __generator(this, function (_c) {
                                        switch (_c.label) {
                                            case 0: return [4 /*yield*/, new Promise(function (f) { return setTimeout(f, 500); })];
                                            case 1:
                                                _c.sent();
                                                newUrl = url.replace(this_1._locale, locale).concat(dlParam);
                                                req = new XMLHttpRequest();
                                                req.open('GET', newUrl);
                                                req.onload = function () { return __awaiter(_this, void 0, void 0, function () {
                                                    var win;
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0:
                                                                if (!(req.status != 200)) return [3 /*break*/, 1];
                                                                RS.Log.debug(req.statusText + "Locale given: " + locale + "doesn't correspond to a viable url");
                                                                return [2 /*return*/];
                                                            case 1:
                                                                win = window.open(newUrl);
                                                                return [4 /*yield*/, new Promise(function (f) { return setTimeout(f, 500); })];
                                                            case 2:
                                                                _a.sent();
                                                                win.close();
                                                                _a.label = 3;
                                                            case 3: return [2 /*return*/];
                                                        }
                                                    });
                                                }); };
                                                req.send();
                                                return [2 /*return*/];
                                        }
                                    });
                                };
                                this_1 = this;
                                _i = 0, _a = this._locale_codes;
                                _b.label = 2;
                            case 2:
                                if (!(_i < _a.length)) return [3 /*break*/, 5];
                                locale = _a[_i];
                                return [5 /*yield**/, _loop_1(locale)];
                            case 3:
                                _b.sent();
                                _b.label = 4;
                            case 4:
                                _i++;
                                return [3 /*break*/, 2];
                            case 5: return [2 /*return*/];
                        }
                    });
                });
            };
            DocDownload.prototype.generateThisDoc = function () {
                this.showButton(false);
                // create document
                var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
                    "xmlns:w='urn:schemas-microsoft-com:office:word' " +
                    "xmlns='http://www.w3.org/TR/REC-html40'>" +
                    document.head.innerHTML + "<body>";
                var footer = "</body></html>";
                var sourceHTML = header + document.getElementById("wrapper").innerHTML + footer;
                var source = 'data:application/vnd.ms-word;charset=utf-8,' + sourceHTML;
                // download document
                var blob = new Blob([source], { type: 'text/html' });
                this.saveBlob(blob, this.getGameName() + "-" + this._locale);
                this.showButton(true);
            };
            DocDownload.prototype.saveBlob = function (b, loc) {
                var fileDownload = document.createElement("a");
                var fileRef = window.URL.createObjectURL(b);
                fileDownload.href = fileRef;
                fileDownload.download = loc + ".doc";
                fileDownload.click();
                window.URL.revokeObjectURL(fileRef);
            };
            DocDownload.prototype.showButton = function (visible) {
                document.getElementById(DocDownload_1.divID).style.display = visible ? "" : "none";
            };
            var DocDownload_1;
            DocDownload.singleDocButtonID = "singleDocGen";
            DocDownload.multipleDocButtonID = "multiDocGen";
            DocDownload.divID = "docGenerator";
            var _decObj = {};

            _decObj.generateAllDocs = {
                decorators: [RS.Callback],
                target: DocDownload.prototype,
                desc: null
            };

            __multiDecorate(_decObj);
            DocDownload = DocDownload_1 = __decorate([
                RS.HasCallbacks
            ], DocDownload);
            return DocDownload;
        }(ExternalHelp.Plugin));
        ExternalHelp.pluginRegistry.register(DocDownload);
    })(ExternalHelp = RS.ExternalHelp || (RS.ExternalHelp = {}));
})(RS || (RS = {}));
/// <reference path="../Init.ts"/>
var RS;
(function (RS) {
    var ExternalHelp;
    (function (ExternalHelp) {
        var JackpotPlugin = /** @class */ (function (_super) {
            __extends(JackpotPlugin, _super);
            function JackpotPlugin(page) {
                var _this = _super.call(this, page) || this;
                _this._hasJackpots = RS.URL.getParameterAsBool("hasJackpots", false);
                return _this;
            }
            JackpotPlugin.prototype.onElementLoaded = function (element) {
                var notJackpots = element.classList.contains("rs-nojackpot");
                // hide if not jackpots.
                if (notJackpots && this._hasJackpots) {
                    ExternalHelp.hideElement(element);
                }
                var jackpotsOnly = element.classList.contains("rs-jackpotonly");
                // hide if jackpots.
                if (jackpotsOnly && !this._hasJackpots) {
                    ExternalHelp.hideElement(element);
                }
            };
            return JackpotPlugin;
        }(ExternalHelp.VisitorPlugin));
        ExternalHelp.pluginRegistry.register(JackpotPlugin);
    })(ExternalHelp = RS.ExternalHelp || (RS.ExternalHelp = {}));
})(RS || (RS = {}));
/// <reference path="../Init.ts"/>
var RS;
(function (RS) {
    var ExternalHelp;
    (function (ExternalHelp) {
        var MaxBetPlugin = /** @class */ (function (_super) {
            __extends(MaxBetPlugin, _super);
            function MaxBetPlugin(page) {
                var _this = _super.call(this, page) || this;
                _this._maxBetString = RS.URL.getParameter("maxBet");
                return _this;
            }
            MaxBetPlugin.prototype.onElementLoaded = function (element) {
                var isMaxBet = element.classList.contains("rs-variable-maxbet");
                if (!isMaxBet) {
                    return;
                }
                if (this._maxBetString && isMaxBet) {
                    element.innerHTML = this._maxBetString;
                }
                else {
                    // Hide element, and if we're in a localisation, hide that too.
                    element.style.display = "none";
                    if (isMaxBet) {
                        ExternalHelp.hideLocalisation(element);
                    }
                }
            };
            return MaxBetPlugin;
        }(ExternalHelp.VisitorPlugin));
        ExternalHelp.pluginRegistry.register(MaxBetPlugin);
    })(ExternalHelp = RS.ExternalHelp || (RS.ExternalHelp = {}));
})(RS || (RS = {}));
/// <reference path="../Init.ts"/>
var RS;
(function (RS) {
    var ExternalHelp;
    (function (ExternalHelp) {
        var MaxWinPlugin = /** @class */ (function (_super) {
            __extends(MaxWinPlugin, _super);
            function MaxWinPlugin(page) {
                var _this = _super.call(this, page) || this;
                _this._maxWinString = RS.URL.getParameter("maxWin");
                return _this;
            }
            MaxWinPlugin.prototype.onElementLoaded = function (element) {
                var isMaxWin = element.classList.contains("rs-variable-maxwin");
                var needsMaxWin = isMaxWin || element.classList.contains("rs-needs-maxwin");
                var needsNoMaxWin = element.classList.contains("rs-needs-nomaxwin");
                if (this._maxWinString && needsNoMaxWin) {
                    element.style.display = "none";
                    ExternalHelp.hideLocalisation(element);
                }
                if (!isMaxWin && !needsMaxWin) {
                    return;
                }
                if (this._maxWinString) {
                    if (isMaxWin) {
                        element.innerHTML = this._maxWinString;
                    }
                }
                else {
                    // Hide element, and if we're in a localisation, hide that too.
                    element.style.display = "none";
                    if (isMaxWin) {
                        ExternalHelp.hideLocalisation(element);
                    }
                }
            };
            return MaxWinPlugin;
        }(ExternalHelp.VisitorPlugin));
        ExternalHelp.pluginRegistry.register(MaxWinPlugin);
    })(ExternalHelp = RS.ExternalHelp || (RS.ExternalHelp = {}));
})(RS || (RS = {}));
/// <reference path="../Init.ts"/>
var RS;
(function (RS) {
    var ExternalHelp;
    (function (ExternalHelp) {
        var NTPlugin = /** @class */ (function (_super) {
            __extends(NTPlugin, _super);
            function NTPlugin(page) {
                var _this = _super.call(this, page) || this;
                _this._isNT = RS.URL.getParameterAsBool("isNT", false);
                return _this;
            }
            NTPlugin.prototype.onElementLoaded = function (element) {
                var ntOnly = element.classList.contains("rs-ntonly");
                // hide if NT.
                if (ntOnly && !this._isNT) {
                    ExternalHelp.hideElement(element);
                }
                var notNT = element.classList.contains("rs-notnt");
                // hide if not NT.
                if (notNT && this._isNT) {
                    ExternalHelp.hideElement(element);
                }
            };
            return NTPlugin;
        }(ExternalHelp.VisitorPlugin));
        ExternalHelp.pluginRegistry.register(NTPlugin);
    })(ExternalHelp = RS.ExternalHelp || (RS.ExternalHelp = {}));
})(RS || (RS = {}));
/// <reference path="../Init.ts"/>
var RS;
(function (RS) {
    var ExternalHelp;
    (function (ExternalHelp) {
        var RTPPlugin = /** @class */ (function (_super) {
            __extends(RTPPlugin, _super);
            function RTPPlugin(page) {
                var _this = _super.call(this, page) || this;
                var rawTable = RS.URL.getParameterAsObject("RTPs");
                if (rawTable) {
                    _this._rtpTable = {};
                    for (var rtpName in rawTable) {
                        var rtpValue = rawTable[rtpName];
                        if (rtpValue != null && !RS.Is.number(rtpValue) && !RS.Is.string(rtpValue)) {
                            _this._rtpTable[rtpName] = 101;
                        }
                        else {
                            _this._rtpTable[rtpName] = rtpValue;
                        }
                    }
                }
                _this._defaultRTP = RS.URL.getParameterAsNumber("RTP", -1);
                return _this;
            }
            RTPPlugin.prototype.onElementLoaded = function (element) {
                var isRTP = element.classList.contains("rs-variable-rtp");
                if (!isRTP) {
                    return;
                }
                var rtpName = element.getAttribute("data-rtp-name");
                var rtp = rtpName == null ? this._defaultRTP : this.getNamedRTP(rtpName);
                if (rtp == null) {
                    var nameString = rtpName == null ? "" : " ".concat(rtpName);
                    RS.Log.warn("RTP".concat(nameString, " not found"));
                    ExternalHelp.hideLocalisation(element);
                }
                element.innerHTML = this.rtpToString(rtp);
            };
            RTPPlugin.prototype.rtpToString = function (value) {
                if (RS.Is.string(value)) {
                    return value;
                }
                if (value === -1 || value == null) {
                    return "N/A";
                }
                if (value < 0 || value > 100) {
                    return "&lt;RTP INVALID&gt;";
                }
                return value.toFixed(2);
            };
            RTPPlugin.prototype.getNamedRTP = function (name) {
                // Show default RTP if RTP table not found
                if (!this._rtpTable) {
                    if (name === "single") {
                        return this._defaultRTP;
                    }
                    return null;
                }
                if (name in this._rtpTable) {
                    // RTP with name present but undefined
                    if (this._rtpTable[name] == null) {
                        return -1;
                    }
                    // RTP with name present
                    return this._rtpTable[name];
                }
                // RTP with name actually not present
                return null;
            };
            return RTPPlugin;
        }(ExternalHelp.VisitorPlugin));
        ExternalHelp.pluginRegistry.register(RTPPlugin);
    })(ExternalHelp = RS.ExternalHelp || (RS.ExternalHelp = {}));
})(RS || (RS = {}));
/// <reference path="../Init.ts"/>
var RS;
(function (RS) {
    var ExternalHelp;
    (function (ExternalHelp) {
        var URLPlugin = /** @class */ (function (_super) {
            __extends(URLPlugin, _super);
            function URLPlugin() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            URLPlugin.prototype.onElementLoaded = function (element) {
                var paramName = element.getAttribute("data-url-param");
                if (paramName == null) {
                    return;
                }
                var paramData = RS.URL.getParameter(paramName, "N/A");
                element.innerHTML = paramData;
            };
            return URLPlugin;
        }(ExternalHelp.VisitorPlugin));
        ExternalHelp.pluginRegistry.register(URLPlugin);
    })(ExternalHelp = RS.ExternalHelp || (RS.ExternalHelp = {}));
})(RS || (RS = {}));
//# sourceMappingURL=helpsrc.js.map
/**
 * https://opentype.js.org v1.1.0 | (c) Frederik De Bleser and other contributors | MIT License | Uses tiny-inflate by Devon Govett and string.prototype.codepointat polyfill by Mathias Bynens
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.opentype = {})));
}(this, (function (exports) { 'use strict';

	/*! https://mths.be/codepointat v0.2.0 by @mathias */
	if (!String.prototype.codePointAt) {
		(function() {
			var defineProperty = (function() {
				// IE 8 only supports `Object.defineProperty` on DOM elements
				try {
					var object = {};
					var $defineProperty = Object.defineProperty;
					var result = $defineProperty(object, object, object) && $defineProperty;
				} catch(error) {}
				return result;
			}());
			var codePointAt = function(position) {
				if (this == null) {
					throw TypeError();
				}
				var string = String(this);
				var size = string.length;
				// `ToInteger`
				var index = position ? Number(position) : 0;
				if (index != index) { // better `isNaN`
					index = 0;
				}
				// Account for out-of-bounds indices:
				if (index < 0 || index >= size) {
					return undefined;
				}
				// Get the first code unit
				var first = string.charCodeAt(index);
				var second;
				if ( // check if it’s the start of a surrogate pair
					first >= 0xD800 && first <= 0xDBFF && // high surrogate
					size > index + 1 // there is a next code unit
				) {
					second = string.charCodeAt(index + 1);
					if (second >= 0xDC00 && second <= 0xDFFF) { // low surrogate
						// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
						return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
					}
				}
				return first;
			};
			if (defineProperty) {
				defineProperty(String.prototype, 'codePointAt', {
					'value': codePointAt,
					'configurable': true,
					'writable': true
				});
			} else {
				String.prototype.codePointAt = codePointAt;
			}
		}());
	}

	var TINF_OK = 0;
	var TINF_DATA_ERROR = -3;

	function Tree() {
	  this.table = new Uint16Array(16);   /* table of code length counts */
	  this.trans = new Uint16Array(288);  /* code -> symbol translation table */
	}

	function Data(source, dest) {
	  this.source = source;
	  this.sourceIndex = 0;
	  this.tag = 0;
	  this.bitcount = 0;
	  
	  this.dest = dest;
	  this.destLen = 0;
	  
	  this.ltree = new Tree();  /* dynamic length/symbol tree */
	  this.dtree = new Tree();  /* dynamic distance tree */
	}

	/* --------------------------------------------------- *
	 * -- uninitialized global data (static structures) -- *
	 * --------------------------------------------------- */

	var sltree = new Tree();
	var sdtree = new Tree();

	/* extra bits and base tables for length codes */
	var length_bits = new Uint8Array(30);
	var length_base = new Uint16Array(30);

	/* extra bits and base tables for distance codes */
	var dist_bits = new Uint8Array(30);
	var dist_base = new Uint16Array(30);

	/* special ordering of code length codes */
	var clcidx = new Uint8Array([
	  16, 17, 18, 0, 8, 7, 9, 6,
	  10, 5, 11, 4, 12, 3, 13, 2,
	  14, 1, 15
	]);

	/* used by tinf_decode_trees, avoids allocations every call */
	var code_tree = new Tree();
	var lengths = new Uint8Array(288 + 32);

	/* ----------------------- *
	 * -- utility functions -- *
	 * ----------------------- */

	/* build extra bits and base tables */
	function tinf_build_bits_base(bits, base, delta, first) {
	  var i, sum;

	  /* build bits table */
	  for (i = 0; i < delta; ++i) { bits[i] = 0; }
	  for (i = 0; i < 30 - delta; ++i) { bits[i + delta] = i / delta | 0; }

	  /* build base table */
	  for (sum = first, i = 0; i < 30; ++i) {
	    base[i] = sum;
	    sum += 1 << bits[i];
	  }
	}

	/* build the fixed huffman trees */
	function tinf_build_fixed_trees(lt, dt) {
	  var i;

	  /* build fixed length tree */
	  for (i = 0; i < 7; ++i) { lt.table[i] = 0; }

	  lt.table[7] = 24;
	  lt.table[8] = 152;
	  lt.table[9] = 112;

	  for (i = 0; i < 24; ++i) { lt.trans[i] = 256 + i; }
	  for (i = 0; i < 144; ++i) { lt.trans[24 + i] = i; }
	  for (i = 0; i < 8; ++i) { lt.trans[24 + 144 + i] = 280 + i; }
	  for (i = 0; i < 112; ++i) { lt.trans[24 + 144 + 8 + i] = 144 + i; }

	  /* build fixed distance tree */
	  for (i = 0; i < 5; ++i) { dt.table[i] = 0; }

	  dt.table[5] = 32;

	  for (i = 0; i < 32; ++i) { dt.trans[i] = i; }
	}

	/* given an array of code lengths, build a tree */
	var offs = new Uint16Array(16);

	function tinf_build_tree(t, lengths, off, num) {
	  var i, sum;

	  /* clear code length count table */
	  for (i = 0; i < 16; ++i) { t.table[i] = 0; }

	  /* scan symbol lengths, and sum code length counts */
	  for (i = 0; i < num; ++i) { t.table[lengths[off + i]]++; }

	  t.table[0] = 0;

	  /* compute offset table for distribution sort */
	  for (sum = 0, i = 0; i < 16; ++i) {
	    offs[i] = sum;
	    sum += t.table[i];
	  }

	  /* create code->symbol translation table (symbols sorted by code) */
	  for (i = 0; i < num; ++i) {
	    if (lengths[off + i]) { t.trans[offs[lengths[off + i]]++] = i; }
	  }
	}

	/* ---------------------- *
	 * -- decode functions -- *
	 * ---------------------- */

	/* get one bit from source stream */
	function tinf_getbit(d) {
	  /* check if tag is empty */
	  if (!d.bitcount--) {
	    /* load next tag */
	    d.tag = d.source[d.sourceIndex++];
	    d.bitcount = 7;
	  }

	  /* shift bit out of tag */
	  var bit = d.tag & 1;
	  d.tag >>>= 1;

	  return bit;
	}

	/* read a num bit value from a stream and add base */
	function tinf_read_bits(d, num, base) {
	  if (!num)
	    { return base; }

	  while (d.bitcount < 24) {
	    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
	    d.bitcount += 8;
	  }

	  var val = d.tag & (0xffff >>> (16 - num));
	  d.tag >>>= num;
	  d.bitcount -= num;
	  return val + base;
	}

	/* given a data stream and a tree, decode a symbol */
	function tinf_decode_symbol(d, t) {
	  while (d.bitcount < 24) {
	    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
	    d.bitcount += 8;
	  }
	  
	  var sum = 0, cur = 0, len = 0;
	  var tag = d.tag;

	  /* get more bits while code value is above sum */
	  do {
	    cur = 2 * cur + (tag & 1);
	    tag >>>= 1;
	    ++len;

	    sum += t.table[len];
	    cur -= t.table[len];
	  } while (cur >= 0);
	  
	  d.tag = tag;
	  d.bitcount -= len;

	  return t.trans[sum + cur];
	}

	/* given a data stream, decode dynamic trees from it */
	function tinf_decode_trees(d, lt, dt) {
	  var hlit, hdist, hclen;
	  var i, num, length;

	  /* get 5 bits HLIT (257-286) */
	  hlit = tinf_read_bits(d, 5, 257);

	  /* get 5 bits HDIST (1-32) */
	  hdist = tinf_read_bits(d, 5, 1);

	  /* get 4 bits HCLEN (4-19) */
	  hclen = tinf_read_bits(d, 4, 4);

	  for (i = 0; i < 19; ++i) { lengths[i] = 0; }

	  /* read code lengths for code length alphabet */
	  for (i = 0; i < hclen; ++i) {
	    /* get 3 bits code length (0-7) */
	    var clen = tinf_read_bits(d, 3, 0);
	    lengths[clcidx[i]] = clen;
	  }

	  /* build code length tree */
	  tinf_build_tree(code_tree, lengths, 0, 19);

	  /* decode code lengths for the dynamic trees */
	  for (num = 0; num < hlit + hdist;) {
	    var sym = tinf_decode_symbol(d, code_tree);

	    switch (sym) {
	      case 16:
	        /* copy previous code length 3-6 times (read 2 bits) */
	        var prev = lengths[num - 1];
	        for (length = tinf_read_bits(d, 2, 3); length; --length) {
	          lengths[num++] = prev;
	        }
	        break;
	      case 17:
	        /* repeat code length 0 for 3-10 times (read 3 bits) */
	        for (length = tinf_read_bits(d, 3, 3); length; --length) {
	          lengths[num++] = 0;
	        }
	        break;
	      case 18:
	        /* repeat code length 0 for 11-138 times (read 7 bits) */
	        for (length = tinf_read_bits(d, 7, 11); length; --length) {
	          lengths[num++] = 0;
	        }
	        break;
	      default:
	        /* values 0-15 represent the actual code lengths */
	        lengths[num++] = sym;
	        break;
	    }
	  }

	  /* build dynamic trees */
	  tinf_build_tree(lt, lengths, 0, hlit);
	  tinf_build_tree(dt, lengths, hlit, hdist);
	}

	/* ----------------------------- *
	 * -- block inflate functions -- *
	 * ----------------------------- */

	/* given a stream and two trees, inflate a block of data */
	function tinf_inflate_block_data(d, lt, dt) {
	  while (1) {
	    var sym = tinf_decode_symbol(d, lt);

	    /* check for end of block */
	    if (sym === 256) {
	      return TINF_OK;
	    }

	    if (sym < 256) {
	      d.dest[d.destLen++] = sym;
	    } else {
	      var length, dist, offs;
	      var i;

	      sym -= 257;

	      /* possibly get more bits from length code */
	      length = tinf_read_bits(d, length_bits[sym], length_base[sym]);

	      dist = tinf_decode_symbol(d, dt);

	      /* possibly get more bits from distance code */
	      offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);

	      /* copy match */
	      for (i = offs; i < offs + length; ++i) {
	        d.dest[d.destLen++] = d.dest[i];
	      }
	    }
	  }
	}

	/* inflate an uncompressed block of data */
	function tinf_inflate_uncompressed_block(d) {
	  var length, invlength;
	  var i;
	  
	  /* unread from bitbuffer */
	  while (d.bitcount > 8) {
	    d.sourceIndex--;
	    d.bitcount -= 8;
	  }

	  /* get length */
	  length = d.source[d.sourceIndex + 1];
	  length = 256 * length + d.source[d.sourceIndex];

	  /* get one's complement of length */
	  invlength = d.source[d.sourceIndex + 3];
	  invlength = 256 * invlength + d.source[d.sourceIndex + 2];

	  /* check length */
	  if (length !== (~invlength & 0x0000ffff))
	    { return TINF_DATA_ERROR; }

	  d.sourceIndex += 4;

	  /* copy block */
	  for (i = length; i; --i)
	    { d.dest[d.destLen++] = d.source[d.sourceIndex++]; }

	  /* make sure we start next block on a byte boundary */
	  d.bitcount = 0;

	  return TINF_OK;
	}

	/* inflate stream from source to dest */
	function tinf_uncompress(source, dest) {
	  var d = new Data(source, dest);
	  var bfinal, btype, res;

	  do {
	    /* read final block flag */
	    bfinal = tinf_getbit(d);

	    /* read block type (2 bits) */
	    btype = tinf_read_bits(d, 2, 0);

	    /* decompress block */
	    switch (btype) {
	      case 0:
	        /* decompress uncompressed block */
	        res = tinf_inflate_uncompressed_block(d);
	        break;
	      case 1:
	        /* decompress block with fixed huffman trees */
	        res = tinf_inflate_block_data(d, sltree, sdtree);
	        break;
	      case 2:
	        /* decompress block with dynamic huffman trees */
	        tinf_decode_trees(d, d.ltree, d.dtree);
	        res = tinf_inflate_block_data(d, d.ltree, d.dtree);
	        break;
	      default:
	        res = TINF_DATA_ERROR;
	    }

	    if (res !== TINF_OK)
	      { throw new Error('Data error'); }

	  } while (!bfinal);

	  if (d.destLen < d.dest.length) {
	    if (typeof d.dest.slice === 'function')
	      { return d.dest.slice(0, d.destLen); }
	    else
	      { return d.dest.subarray(0, d.destLen); }
	  }
	  
	  return d.dest;
	}

	/* -------------------- *
	 * -- initialization -- *
	 * -------------------- */

	/* build fixed huffman trees */
	tinf_build_fixed_trees(sltree, sdtree);

	/* build extra bits and base tables */
	tinf_build_bits_base(length_bits, length_base, 4, 3);
	tinf_build_bits_base(dist_bits, dist_base, 2, 1);

	/* fix a special case */
	length_bits[28] = 0;
	length_base[28] = 258;

	var tinyInflate = tinf_uncompress;

	// The Bounding Box object

	function derive(v0, v1, v2, v3, t) {
	    return Math.pow(1 - t, 3) * v0 +
	        3 * Math.pow(1 - t, 2) * t * v1 +
	        3 * (1 - t) * Math.pow(t, 2) * v2 +
	        Math.pow(t, 3) * v3;
	}
	/**
	 * A bounding box is an enclosing box that describes the smallest measure within which all the points lie.
	 * It is used to calculate the bounding box of a glyph or text path.
	 *
	 * On initialization, x1/y1/x2/y2 will be NaN. Check if the bounding box is empty using `isEmpty()`.
	 *
	 * @exports opentype.BoundingBox
	 * @class
	 * @constructor
	 */
	function BoundingBox() {
	    this.x1 = Number.NaN;
	    this.y1 = Number.NaN;
	    this.x2 = Number.NaN;
	    this.y2 = Number.NaN;
	}

	/**
	 * Returns true if the bounding box is empty, that is, no points have been added to the box yet.
	 */
	BoundingBox.prototype.isEmpty = function() {
	    return isNaN(this.x1) || isNaN(this.y1) || isNaN(this.x2) || isNaN(this.y2);
	};

	/**
	 * Add the point to the bounding box.
	 * The x1/y1/x2/y2 coordinates of the bounding box will now encompass the given point.
	 * @param {number} x - The X coordinate of the point.
	 * @param {number} y - The Y coordinate of the point.
	 */
	BoundingBox.prototype.addPoint = function(x, y) {
	    if (typeof x === 'number') {
	        if (isNaN(this.x1) || isNaN(this.x2)) {
	            this.x1 = x;
	            this.x2 = x;
	        }
	        if (x < this.x1) {
	            this.x1 = x;
	        }
	        if (x > this.x2) {
	            this.x2 = x;
	        }
	    }
	    if (typeof y === 'number') {
	        if (isNaN(this.y1) || isNaN(this.y2)) {
	            this.y1 = y;
	            this.y2 = y;
	        }
	        if (y < this.y1) {
	            this.y1 = y;
	        }
	        if (y > this.y2) {
	            this.y2 = y;
	        }
	    }
	};

	/**
	 * Add a X coordinate to the bounding box.
	 * This extends the bounding box to include the X coordinate.
	 * This function is used internally inside of addBezier.
	 * @param {number} x - The X coordinate of the point.
	 */
	BoundingBox.prototype.addX = function(x) {
	    this.addPoint(x, null);
	};

	/**
	 * Add a Y coordinate to the bounding box.
	 * This extends the bounding box to include the Y coordinate.
	 * This function is used internally inside of addBezier.
	 * @param {number} y - The Y coordinate of the point.
	 */
	BoundingBox.prototype.addY = function(y) {
	    this.addPoint(null, y);
	};

	/**
	 * Add a Bézier curve to the bounding box.
	 * This extends the bounding box to include the entire Bézier.
	 * @param {number} x0 - The starting X coordinate.
	 * @param {number} y0 - The starting Y coordinate.
	 * @param {number} x1 - The X coordinate of the first control point.
	 * @param {number} y1 - The Y coordinate of the first control point.
	 * @param {number} x2 - The X coordinate of the second control point.
	 * @param {number} y2 - The Y coordinate of the second control point.
	 * @param {number} x - The ending X coordinate.
	 * @param {number} y - The ending Y coordinate.
	 */
	BoundingBox.prototype.addBezier = function(x0, y0, x1, y1, x2, y2, x, y) {
	    var this$1 = this;

	    // This code is based on http://nishiohirokazu.blogspot.com/2009/06/how-to-calculate-bezier-curves-bounding.html
	    // and https://github.com/icons8/svg-path-bounding-box

	    var p0 = [x0, y0];
	    var p1 = [x1, y1];
	    var p2 = [x2, y2];
	    var p3 = [x, y];

	    this.addPoint(x0, y0);
	    this.addPoint(x, y);

	    for (var i = 0; i <= 1; i++) {
	        var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
	        var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
	        var c = 3 * p1[i] - 3 * p0[i];

	        if (a === 0) {
	            if (b === 0) { continue; }
	            var t = -c / b;
	            if (0 < t && t < 1) {
	                if (i === 0) { this$1.addX(derive(p0[i], p1[i], p2[i], p3[i], t)); }
	                if (i === 1) { this$1.addY(derive(p0[i], p1[i], p2[i], p3[i], t)); }
	            }
	            continue;
	        }

	        var b2ac = Math.pow(b, 2) - 4 * c * a;
	        if (b2ac < 0) { continue; }
	        var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
	        if (0 < t1 && t1 < 1) {
	            if (i === 0) { this$1.addX(derive(p0[i], p1[i], p2[i], p3[i], t1)); }
	            if (i === 1) { this$1.addY(derive(p0[i], p1[i], p2[i], p3[i], t1)); }
	        }
	        var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
	        if (0 < t2 && t2 < 1) {
	            if (i === 0) { this$1.addX(derive(p0[i], p1[i], p2[i], p3[i], t2)); }
	            if (i === 1) { this$1.addY(derive(p0[i], p1[i], p2[i], p3[i], t2)); }
	        }
	    }
	};

	/**
	 * Add a quadratic curve to the bounding box.
	 * This extends the bounding box to include the entire quadratic curve.
	 * @param {number} x0 - The starting X coordinate.
	 * @param {number} y0 - The starting Y coordinate.
	 * @param {number} x1 - The X coordinate of the control point.
	 * @param {number} y1 - The Y coordinate of the control point.
	 * @param {number} x - The ending X coordinate.
	 * @param {number} y - The ending Y coordinate.
	 */
	BoundingBox.prototype.addQuad = function(x0, y0, x1, y1, x, y) {
	    var cp1x = x0 + 2 / 3 * (x1 - x0);
	    var cp1y = y0 + 2 / 3 * (y1 - y0);
	    var cp2x = cp1x + 1 / 3 * (x - x0);
	    var cp2y = cp1y + 1 / 3 * (y - y0);
	    this.addBezier(x0, y0, cp1x, cp1y, cp2x, cp2y, x, y);
	};

	// Geometric objects

	/**
	 * A bézier path containing a set of path commands similar to a SVG path.
	 * Paths can be drawn on a context using `draw`.
	 * @exports opentype.Path
	 * @class
	 * @constructor
	 */
	function Path() {
	    this.commands = [];
	    this.fill = 'black';
	    this.stroke = null;
	    this.strokeWidth = 1;
	}

	/**
	 * @param  {number} x
	 * @param  {number} y
	 */
	Path.prototype.moveTo = function(x, y) {
	    this.commands.push({
	        type: 'M',
	        x: x,
	        y: y
	    });
	};

	/**
	 * @param  {number} x
	 * @param  {number} y
	 */
	Path.prototype.lineTo = function(x, y) {
	    this.commands.push({
	        type: 'L',
	        x: x,
	        y: y
	    });
	};

	/**
	 * Draws cubic curve
	 * @function
	 * curveTo
	 * @memberof opentype.Path.prototype
	 * @param  {number} x1 - x of control 1
	 * @param  {number} y1 - y of control 1
	 * @param  {number} x2 - x of control 2
	 * @param  {number} y2 - y of control 2
	 * @param  {number} x - x of path point
	 * @param  {number} y - y of path point
	 */

	/**
	 * Draws cubic curve
	 * @function
	 * bezierCurveTo
	 * @memberof opentype.Path.prototype
	 * @param  {number} x1 - x of control 1
	 * @param  {number} y1 - y of control 1
	 * @param  {number} x2 - x of control 2
	 * @param  {number} y2 - y of control 2
	 * @param  {number} x - x of path point
	 * @param  {number} y - y of path point
	 * @see curveTo
	 */
	Path.prototype.curveTo = Path.prototype.bezierCurveTo = function(x1, y1, x2, y2, x, y) {
	    this.commands.push({
	        type: 'C',
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2,
	        x: x,
	        y: y
	    });
	};

	/**
	 * Draws quadratic curve
	 * @function
	 * quadraticCurveTo
	 * @memberof opentype.Path.prototype
	 * @param  {number} x1 - x of control
	 * @param  {number} y1 - y of control
	 * @param  {number} x - x of path point
	 * @param  {number} y - y of path point
	 */

	/**
	 * Draws quadratic curve
	 * @function
	 * quadTo
	 * @memberof opentype.Path.prototype
	 * @param  {number} x1 - x of control
	 * @param  {number} y1 - y of control
	 * @param  {number} x - x of path point
	 * @param  {number} y - y of path point
	 */
	Path.prototype.quadTo = Path.prototype.quadraticCurveTo = function(x1, y1, x, y) {
	    this.commands.push({
	        type: 'Q',
	        x1: x1,
	        y1: y1,
	        x: x,
	        y: y
	    });
	};

	/**
	 * Closes the path
	 * @function closePath
	 * @memberof opentype.Path.prototype
	 */

	/**
	 * Close the path
	 * @function close
	 * @memberof opentype.Path.prototype
	 */
	Path.prototype.close = Path.prototype.closePath = function() {
	    this.commands.push({
	        type: 'Z'
	    });
	};

	/**
	 * Add the given path or list of commands to the commands of this path.
	 * @param  {Array} pathOrCommands - another opentype.Path, an opentype.BoundingBox, or an array of commands.
	 */
	Path.prototype.extend = function(pathOrCommands) {
	    if (pathOrCommands.commands) {
	        pathOrCommands = pathOrCommands.commands;
	    } else if (pathOrCommands instanceof BoundingBox) {
	        var box = pathOrCommands;
	        this.moveTo(box.x1, box.y1);
	        this.lineTo(box.x2, box.y1);
	        this.lineTo(box.x2, box.y2);
	        this.lineTo(box.x1, box.y2);
	        this.close();
	        return;
	    }

	    Array.prototype.push.apply(this.commands, pathOrCommands);
	};

	/**
	 * Calculate the bounding box of the path.
	 * @returns {opentype.BoundingBox}
	 */
	Path.prototype.getBoundingBox = function() {
	    var this$1 = this;

	    var box = new BoundingBox();

	    var startX = 0;
	    var startY = 0;
	    var prevX = 0;
	    var prevY = 0;
	    for (var i = 0; i < this.commands.length; i++) {
	        var cmd = this$1.commands[i];
	        switch (cmd.type) {
	            case 'M':
	                box.addPoint(cmd.x, cmd.y);
	                startX = prevX = cmd.x;
	                startY = prevY = cmd.y;
	                break;
	            case 'L':
	                box.addPoint(cmd.x, cmd.y);
	                prevX = cmd.x;
	                prevY = cmd.y;
	                break;
	            case 'Q':
	                box.addQuad(prevX, prevY, cmd.x1, cmd.y1, cmd.x, cmd.y);
	                prevX = cmd.x;
	                prevY = cmd.y;
	                break;
	            case 'C':
	                box.addBezier(prevX, prevY, cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
	                prevX = cmd.x;
	                prevY = cmd.y;
	                break;
	            case 'Z':
	                prevX = startX;
	                prevY = startY;
	                break;
	            default:
	                throw new Error('Unexpected path command ' + cmd.type);
	        }
	    }
	    if (box.isEmpty()) {
	        box.addPoint(0, 0);
	    }
	    return box;
	};

	/**
	 * Draw the path to a 2D context.
	 * @param {CanvasRenderingContext2D} ctx - A 2D drawing context.
	 */
	Path.prototype.draw = function(ctx) {
	    var this$1 = this;

	    ctx.beginPath();
	    for (var i = 0; i < this.commands.length; i += 1) {
	        var cmd = this$1.commands[i];
	        if (cmd.type === 'M') {
	            ctx.moveTo(cmd.x, cmd.y);
	        } else if (cmd.type === 'L') {
	            ctx.lineTo(cmd.x, cmd.y);
	        } else if (cmd.type === 'C') {
	            ctx.bezierCurveTo(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
	        } else if (cmd.type === 'Q') {
	            ctx.quadraticCurveTo(cmd.x1, cmd.y1, cmd.x, cmd.y);
	        } else if (cmd.type === 'Z') {
	            ctx.closePath();
	        }
	    }

	    if (this.fill) {
	        ctx.fillStyle = this.fill;
	        ctx.fill();
	    }

	    if (this.stroke) {
	        ctx.strokeStyle = this.stroke;
	        ctx.lineWidth = this.strokeWidth;
	        ctx.stroke();
	    }
	};

	/**
	 * Convert the Path to a string of path data instructions
	 * See http://www.w3.org/TR/SVG/paths.html#PathData
	 * @param  {number} [decimalPlaces=2] - The amount of decimal places for floating-point values
	 * @return {string}
	 */
	Path.prototype.toPathData = function(decimalPlaces) {
	    var this$1 = this;

	    decimalPlaces = decimalPlaces !== undefined ? decimalPlaces : 2;

	    function floatToString(v) {
	        if (Math.round(v) === v) {
	            return '' + Math.round(v);
	        } else {
	            return v.toFixed(decimalPlaces);
	        }
	    }

	    function packValues() {
	        var arguments$1 = arguments;

	        var s = '';
	        for (var i = 0; i < arguments.length; i += 1) {
	            var v = arguments$1[i];
	            if (v >= 0 && i > 0) {
	                s += ' ';
	            }

	            s += floatToString(v);
	        }

	        return s;
	    }

	    var d = '';
	    for (var i = 0; i < this.commands.length; i += 1) {
	        var cmd = this$1.commands[i];
	        if (cmd.type === 'M') {
	            d += 'M' + packValues(cmd.x, cmd.y);
	        } else if (cmd.type === 'L') {
	            d += 'L' + packValues(cmd.x, cmd.y);
	        } else if (cmd.type === 'C') {
	            d += 'C' + packValues(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
	        } else if (cmd.type === 'Q') {
	            d += 'Q' + packValues(cmd.x1, cmd.y1, cmd.x, cmd.y);
	        } else if (cmd.type === 'Z') {
	            d += 'Z';
	        }
	    }

	    return d;
	};

	/**
	 * Convert the path to an SVG <path> element, as a string.
	 * @param  {number} [decimalPlaces=2] - The amount of decimal places for floating-point values
	 * @return {string}
	 */
	Path.prototype.toSVG = function(decimalPlaces) {
	    var svg = '<path d="';
	    svg += this.toPathData(decimalPlaces);
	    svg += '"';
	    if (this.fill && this.fill !== 'black') {
	        if (this.fill === null) {
	            svg += ' fill="none"';
	        } else {
	            svg += ' fill="' + this.fill + '"';
	        }
	    }

	    if (this.stroke) {
	        svg += ' stroke="' + this.stroke + '" stroke-width="' + this.strokeWidth + '"';
	    }

	    svg += '/>';
	    return svg;
	};

	/**
	 * Convert the path to a DOM element.
	 * @param  {number} [decimalPlaces=2] - The amount of decimal places for floating-point values
	 * @return {SVGPathElement}
	 */
	Path.prototype.toDOMElement = function(decimalPlaces) {
	    var temporaryPath = this.toPathData(decimalPlaces);
	    var newPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');

	    newPath.setAttribute('d', temporaryPath);

	    return newPath;
	};

	// Run-time checking of preconditions.

	function fail(message) {
	    throw new Error(message);
	}

	// Precondition function that checks if the given predicate is true.
	// If not, it will throw an error.
	function argument(predicate, message) {
	    if (!predicate) {
	        fail(message);
	    }
	}
	var check = { fail: fail, argument: argument, assert: argument };

	// Data types used in the OpenType font file.

	var LIMIT16 = 32768; // The limit at which a 16-bit number switches signs == 2^15
	var LIMIT32 = 2147483648; // The limit at which a 32-bit number switches signs == 2 ^ 31

	/**
	 * @exports opentype.decode
	 * @class
	 */
	var decode = {};
	/**
	 * @exports opentype.encode
	 * @class
	 */
	var encode = {};
	/**
	 * @exports opentype.sizeOf
	 * @class
	 */
	var sizeOf = {};

	// Return a function that always returns the same value.
	function constant(v) {
	    return function() {
	        return v;
	    };
	}

	// OpenType data types //////////////////////////////////////////////////////

	/**
	 * Convert an 8-bit unsigned integer to a list of 1 byte.
	 * @param {number}
	 * @returns {Array}
	 */
	encode.BYTE = function(v) {
	    check.argument(v >= 0 && v <= 255, 'Byte value should be between 0 and 255.');
	    return [v];
	};
	/**
	 * @constant
	 * @type {number}
	 */
	sizeOf.BYTE = constant(1);

	/**
	 * Convert a 8-bit signed integer to a list of 1 byte.
	 * @param {string}
	 * @returns {Array}
	 */
	encode.CHAR = function(v) {
	    return [v.charCodeAt(0)];
	};

	/**
	 * @constant
	 * @type {number}
	 */
	sizeOf.CHAR = constant(1);

	/**
	 * Convert an ASCII string to a list of bytes.
	 * @param {string}
	 * @returns {Array}
	 */
	encode.CHARARRAY = function(v) {
	    var b = [];
	    for (var i = 0; i < v.length; i += 1) {
	        b[i] = v.charCodeAt(i);
	    }

	    return b;
	};

	/**
	 * @param {Array}
	 * @returns {number}
	 */
	sizeOf.CHARARRAY = function(v) {
	    return v.length;
	};

	/**
	 * Convert a 16-bit unsigned integer to a list of 2 bytes.
	 * @param {number}
	 * @returns {Array}
	 */
	encode.USHORT = function(v) {
	    return [(v >> 8) & 0xFF, v & 0xFF];
	};

	/**
	 * @constant
	 * @type {number}
	 */
	sizeOf.USHORT = constant(2);

	/**
	 * Convert a 16-bit signed integer to a list of 2 bytes.
	 * @param {number}
	 * @returns {Array}
	 */
	encode.SHORT = function(v) {
	    // Two's complement
	    if (v >= LIMIT16) {
	        v = -(2 * LIMIT16 - v);
	    }

	    return [(v >> 8) & 0xFF, v & 0xFF];
	};

	/**
	 * @constant
	 * @type {number}
	 */
	sizeOf.SHORT = constant(2);

	/**
	 * Convert a 24-bit unsigned integer to a list of 3 bytes.
	 * @param {number}
	 * @returns {Array}
	 */
	encode.UINT24 = function(v) {
	    return [(v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
	};

	/**
	 * @constant
	 * @type {number}
	 */
	sizeOf.UINT24 = constant(3);

	/**
	 * Convert a 32-bit unsigned integer to a list of 4 bytes.
	 * @param {number}
	 * @returns {Array}
	 */
	encode.ULONG = function(v) {
	    return [(v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
	};

	/**
	 * @constant
	 * @type {number}
	 */
	sizeOf.ULONG = constant(4);

	/**
	 * Convert a 32-bit unsigned integer to a list of 4 bytes.
	 * @param {number}
	 * @returns {Array}
	 */
	encode.LONG = function(v) {
	    // Two's complement
	    if (v >= LIMIT32) {
	        v = -(2 * LIMIT32 - v);
	    }

	    return [(v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
	};

	/**
	 * @constant
	 * @type {number}
	 */
	sizeOf.LONG = constant(4);

	encode.FIXED = encode.ULONG;
	sizeOf.FIXED = sizeOf.ULONG;

	encode.FWORD = encode.SHORT;
	sizeOf.FWORD = sizeOf.SHORT;

	encode.UFWORD = encode.USHORT;
	sizeOf.UFWORD = sizeOf.USHORT;

	/**
	 * Convert a 32-bit Apple Mac timestamp integer to a list of 8 bytes, 64-bit timestamp.
	 * @param {number}
	 * @returns {Array}
	 */
	encode.LONGDATETIME = function(v) {
	    return [0, 0, 0, 0, (v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
	};

	/**
	 * @constant
	 * @type {number}
	 */
	sizeOf.LONGDATETIME = constant(8);

	/**
	 * Convert a 4-char tag to a list of 4 bytes.
	 * @param {string}
	 * @returns {Array}
	 */
	encode.TAG = function(v) {
	    check.argument(v.length === 4, 'Tag should be exactly 4 ASCII characters.');
	    return [v.charCodeAt(0),
	            v.charCodeAt(1),
	            v.charCodeAt(2),
	            v.charCodeAt(3)];
	};

	/**
	 * @constant
	 * @type {number}
	 */
	sizeOf.TAG = constant(4);

	// CFF data types ///////////////////////////////////////////////////////////

	encode.Card8 = encode.BYTE;
	sizeOf.Card8 = sizeOf.BYTE;

	encode.Card16 = encode.USHORT;
	sizeOf.Card16 = sizeOf.USHORT;

	encode.OffSize = encode.BYTE;
	sizeOf.OffSize = sizeOf.BYTE;

	encode.SID = encode.USHORT;
	sizeOf.SID = sizeOf.USHORT;

	// Convert a numeric operand or charstring number to a variable-size list of bytes.
	/**
	 * Convert a numeric operand or charstring number to a variable-size list of bytes.
	 * @param {number}
	 * @returns {Array}
	 */
	encode.NUMBER = function(v) {
	    if (v >= -107 && v <= 107) {
	        return [v + 139];
	    } else if (v >= 108 && v <= 1131) {
	        v = v - 108;
	        return [(v >> 8) + 247, v & 0xFF];
	    } else if (v >= -1131 && v <= -108) {
	        v = -v - 108;
	        return [(v >> 8) + 251, v & 0xFF];
	    } else if (v >= -32768 && v <= 32767) {
	        return encode.NUMBER16(v);
	    } else {
	        return encode.NUMBER32(v);
	    }
	};

	/**
	 * @param {number}
	 * @returns {number}
	 */
	sizeOf.NUMBER = function(v) {
	    return encode.NUMBER(v).length;
	};

	/**
	 * Convert a signed number between -32768 and +32767 to a three-byte value.
	 * This ensures we always use three bytes, but is not the most compact format.
	 * @param {number}
	 * @returns {Array}
	 */
	encode.NUMBER16 = function(v) {
	    return [28, (v >> 8) & 0xFF, v & 0xFF];
	};

	/**
	 * @constant
	 * @type {number}
	 */
	sizeOf.NUMBER16 = constant(3);

	/**
	 * Convert a signed number between -(2^31) and +(2^31-1) to a five-byte value.
	 * This is useful if you want to be sure you always use four bytes,
	 * at the expense of wasting a few bytes for smaller numbers.
	 * @param {number}
	 * @returns {Array}
	 */
	encode.NUMBER32 = function(v) {
	    return [29, (v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
	};

	/**
	 * @constant
	 * @type {number}
	 */
	sizeOf.NUMBER32 = constant(5);

	/**
	 * @param {number}
	 * @returns {Array}
	 */
	encode.REAL = function(v) {
	    var value = v.toString();

	    // Some numbers use an epsilon to encode the value. (e.g. JavaScript will store 0.0000001 as 1e-7)
	    // This code converts it back to a number without the epsilon.
	    var m = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(value);
	    if (m) {
	        var epsilon = parseFloat('1e' + ((m[2] ? +m[2] : 0) + m[1].length));
	        value = (Math.round(v * epsilon) / epsilon).toString();
	    }

	    var nibbles = '';
	    for (var i = 0, ii = value.length; i < ii; i += 1) {
	        var c = value[i];
	        if (c === 'e') {
	            nibbles += value[++i] === '-' ? 'c' : 'b';
	        } else if (c === '.') {
	            nibbles += 'a';
	        } else if (c === '-') {
	            nibbles += 'e';
	        } else {
	            nibbles += c;
	        }
	    }

	    nibbles += (nibbles.length & 1) ? 'f' : 'ff';
	    var out = [30];
	    for (var i$1 = 0, ii$1 = nibbles.length; i$1 < ii$1; i$1 += 2) {
	        out.push(parseInt(nibbles.substr(i$1, 2), 16));
	    }

	    return out;
	};

	/**
	 * @param {number}
	 * @returns {number}
	 */
	sizeOf.REAL = function(v) {
	    return encode.REAL(v).length;
	};

	encode.NAME = encode.CHARARRAY;
	sizeOf.NAME = sizeOf.CHARARRAY;

	encode.STRING = encode.CHARARRAY;
	sizeOf.STRING = sizeOf.CHARARRAY;

	/**
	 * @param {DataView} data
	 * @param {number} offset
	 * @param {number} numBytes
	 * @returns {string}
	 */
	decode.UTF8 = function(data, offset, numBytes) {
	    var codePoints = [];
	    var numChars = numBytes;
	    for (var j = 0; j < numChars; j++, offset += 1) {
	        codePoints[j] = data.getUint8(offset);
	    }

	    return String.fromCharCode.apply(null, codePoints);
	};

	/**
	 * @param {DataView} data
	 * @param {number} offset
	 * @param {number} numBytes
	 * @returns {string}
	 */
	decode.UTF16 = function(data, offset, numBytes) {
	    var codePoints = [];
	    var numChars = numBytes / 2;
	    for (var j = 0; j < numChars; j++, offset += 2) {
	        codePoints[j] = data.getUint16(offset);
	    }

	    return String.fromCharCode.apply(null, codePoints);
	};

	/**
	 * Convert a JavaScript string to UTF16-BE.
	 * @param {string}
	 * @returns {Array}
	 */
	encode.UTF16 = function(v) {
	    var b = [];
	    for (var i = 0; i < v.length; i += 1) {
	        var codepoint = v.charCodeAt(i);
	        b[b.length] = (codepoint >> 8) & 0xFF;
	        b[b.length] = codepoint & 0xFF;
	    }

	    return b;
	};

	/**
	 * @param {string}
	 * @returns {number}
	 */
	sizeOf.UTF16 = function(v) {
	    return v.length * 2;
	};

	// Data for converting old eight-bit Macintosh encodings to Unicode.
	// This representation is optimized for decoding; encoding is slower
	// and needs more memory. The assumption is that all opentype.js users
	// want to open fonts, but saving a font will be comparatively rare
	// so it can be more expensive. Keyed by IANA character set name.
	//
	// Python script for generating these strings:
	//
	//     s = u''.join([chr(c).decode('mac_greek') for c in range(128, 256)])
	//     print(s.encode('utf-8'))
	/**
	 * @private
	 */
	var eightBitMacEncodings = {
	    'x-mac-croatian':  // Python: 'mac_croatian'
	    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø' +
	    '¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ',
	    'x-mac-cyrillic':  // Python: 'mac_cyrillic'
	    'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњ' +
	    'јЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю',
	    'x-mac-gaelic': // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/GAELIC.TXT
	    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæø' +
	    'ṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ',
	    'x-mac-greek':  // Python: 'mac_greek'
	    'Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩ' +
	    'άΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ\u00AD',
	    'x-mac-icelandic':  // Python: 'mac_iceland'
	    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
	    '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
	    'x-mac-inuit': // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/INUIT.TXT
	    'ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗ' +
	    'ᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł',
	    'x-mac-ce':  // Python: 'mac_latin2'
	    'ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅ' +
	    'ņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ',
	    macintosh:  // Python: 'mac_roman'
	    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
	    '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
	    'x-mac-romanian':  // Python: 'mac_romanian'
	    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș' +
	    '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
	    'x-mac-turkish':  // Python: 'mac_turkish'
	    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
	    '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ'
	};

	/**
	 * Decodes an old-style Macintosh string. Returns either a Unicode JavaScript
	 * string, or 'undefined' if the encoding is unsupported. For example, we do
	 * not support Chinese, Japanese or Korean because these would need large
	 * mapping tables.
	 * @param {DataView} dataView
	 * @param {number} offset
	 * @param {number} dataLength
	 * @param {string} encoding
	 * @returns {string}
	 */
	decode.MACSTRING = function(dataView, offset, dataLength, encoding) {
	    var table = eightBitMacEncodings[encoding];
	    if (table === undefined) {
	        return undefined;
	    }

	    var result = '';
	    for (var i = 0; i < dataLength; i++) {
	        var c = dataView.getUint8(offset + i);
	        // In all eight-bit Mac encodings, the characters 0x00..0x7F are
	        // mapped to U+0000..U+007F; we only need to look up the others.
	        if (c <= 0x7F) {
	            result += String.fromCharCode(c);
	        } else {
	            result += table[c & 0x7F];
	        }
	    }

	    return result;
	};

	// Helper function for encode.MACSTRING. Returns a dictionary for mapping
	// Unicode character codes to their 8-bit MacOS equivalent. This table
	// is not exactly a super cheap data structure, but we do not care because
	// encoding Macintosh strings is only rarely needed in typical applications.
	var macEncodingTableCache = typeof WeakMap === 'function' && new WeakMap();
	var macEncodingCacheKeys;
	var getMacEncodingTable = function (encoding) {
	    // Since we use encoding as a cache key for WeakMap, it has to be
	    // a String object and not a literal. And at least on NodeJS 2.10.1,
	    // WeakMap requires that the same String instance is passed for cache hits.
	    if (!macEncodingCacheKeys) {
	        macEncodingCacheKeys = {};
	        for (var e in eightBitMacEncodings) {
	            /*jshint -W053 */  // Suppress "Do not use String as a constructor."
	            macEncodingCacheKeys[e] = new String(e);
	        }
	    }

	    var cacheKey = macEncodingCacheKeys[encoding];
	    if (cacheKey === undefined) {
	        return undefined;
	    }

	    // We can't do "if (cache.has(key)) {return cache.get(key)}" here:
	    // since garbage collection may run at any time, it could also kick in
	    // between the calls to cache.has() and cache.get(). In that case,
	    // we would return 'undefined' even though we do support the encoding.
	    if (macEncodingTableCache) {
	        var cachedTable = macEncodingTableCache.get(cacheKey);
	        if (cachedTable !== undefined) {
	            return cachedTable;
	        }
	    }

	    var decodingTable = eightBitMacEncodings[encoding];
	    if (decodingTable === undefined) {
	        return undefined;
	    }

	    var encodingTable = {};
	    for (var i = 0; i < decodingTable.length; i++) {
	        encodingTable[decodingTable.charCodeAt(i)] = i + 0x80;
	    }

	    if (macEncodingTableCache) {
	        macEncodingTableCache.set(cacheKey, encodingTable);
	    }

	    return encodingTable;
	};

	/**
	 * Encodes an old-style Macintosh string. Returns a byte array upon success.
	 * If the requested encoding is unsupported, or if the input string contains
	 * a character that cannot be expressed in the encoding, the function returns
	 * 'undefined'.
	 * @param {string} str
	 * @param {string} encoding
	 * @returns {Array}
	 */
	encode.MACSTRING = function(str, encoding) {
	    var table = getMacEncodingTable(encoding);
	    if (table === undefined) {
	        return undefined;
	    }

	    var result = [];
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);

	        // In all eight-bit Mac encodings, the characters 0x00..0x7F are
	        // mapped to U+0000..U+007F; we only need to look up the others.
	        if (c >= 0x80) {
	            c = table[c];
	            if (c === undefined) {
	                // str contains a Unicode character that cannot be encoded
	                // in the requested encoding.
	                return undefined;
	            }
	        }
	        result[i] = c;
	        // result.push(c);
	    }

	    return result;
	};

	/**
	 * @param {string} str
	 * @param {string} encoding
	 * @returns {number}
	 */
	sizeOf.MACSTRING = function(str, encoding) {
	    var b = encode.MACSTRING(str, encoding);
	    if (b !== undefined) {
	        return b.length;
	    } else {
	        return 0;
	    }
	};

	// Helper for encode.VARDELTAS
	function isByteEncodable(value) {
	    return value >= -128 && value <= 127;
	}

	// Helper for encode.VARDELTAS
	function encodeVarDeltaRunAsZeroes(deltas, pos, result) {
	    var runLength = 0;
	    var numDeltas = deltas.length;
	    while (pos < numDeltas && runLength < 64 && deltas[pos] === 0) {
	        ++pos;
	        ++runLength;
	    }
	    result.push(0x80 | (runLength - 1));
	    return pos;
	}

	// Helper for encode.VARDELTAS
	function encodeVarDeltaRunAsBytes(deltas, offset, result) {
	    var runLength = 0;
	    var numDeltas = deltas.length;
	    var pos = offset;
	    while (pos < numDeltas && runLength < 64) {
	        var value = deltas[pos];
	        if (!isByteEncodable(value)) {
	            break;
	        }

	        // Within a byte-encoded run of deltas, a single zero is best
	        // stored literally as 0x00 value. However, if we have two or
	        // more zeroes in a sequence, it is better to start a new run.
	        // Fore example, the sequence of deltas [15, 15, 0, 15, 15]
	        // becomes 6 bytes (04 0F 0F 00 0F 0F) when storing the zero
	        // within the current run, but 7 bytes (01 0F 0F 80 01 0F 0F)
	        // when starting a new run.
	        if (value === 0 && pos + 1 < numDeltas && deltas[pos + 1] === 0) {
	            break;
	        }

	        ++pos;
	        ++runLength;
	    }
	    result.push(runLength - 1);
	    for (var i = offset; i < pos; ++i) {
	        result.push((deltas[i] + 256) & 0xff);
	    }
	    return pos;
	}

	// Helper for encode.VARDELTAS
	function encodeVarDeltaRunAsWords(deltas, offset, result) {
	    var runLength = 0;
	    var numDeltas = deltas.length;
	    var pos = offset;
	    while (pos < numDeltas && runLength < 64) {
	        var value = deltas[pos];

	        // Within a word-encoded run of deltas, it is easiest to start
	        // a new run (with a different encoding) whenever we encounter
	        // a zero value. For example, the sequence [0x6666, 0, 0x7777]
	        // needs 7 bytes when storing the zero inside the current run
	        // (42 66 66 00 00 77 77), and equally 7 bytes when starting a
	        // new run (40 66 66 80 40 77 77).
	        if (value === 0) {
	            break;
	        }

	        // Within a word-encoded run of deltas, a single value in the
	        // range (-128..127) should be encoded within the current run
	        // because it is more compact. For example, the sequence
	        // [0x6666, 2, 0x7777] becomes 7 bytes when storing the value
	        // literally (42 66 66 00 02 77 77), but 8 bytes when starting
	        // a new run (40 66 66 00 02 40 77 77).
	        if (isByteEncodable(value) && pos + 1 < numDeltas && isByteEncodable(deltas[pos + 1])) {
	            break;
	        }

	        ++pos;
	        ++runLength;
	    }
	    result.push(0x40 | (runLength - 1));
	    for (var i = offset; i < pos; ++i) {
	        var val = deltas[i];
	        result.push(((val + 0x10000) >> 8) & 0xff, (val + 0x100) & 0xff);
	    }
	    return pos;
	}

	/**
	 * Encode a list of variation adjustment deltas.
	 *
	 * Variation adjustment deltas are used in ‘gvar’ and ‘cvar’ tables.
	 * They indicate how points (in ‘gvar’) or values (in ‘cvar’) get adjusted
	 * when generating instances of variation fonts.
	 *
	 * @see https://www.microsoft.com/typography/otspec/gvar.htm
	 * @see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM06/Chap6gvar.html
	 * @param {Array}
	 * @return {Array}
	 */
	encode.VARDELTAS = function(deltas) {
	    var pos = 0;
	    var result = [];
	    while (pos < deltas.length) {
	        var value = deltas[pos];
	        if (value === 0) {
	            pos = encodeVarDeltaRunAsZeroes(deltas, pos, result);
	        } else if (value >= -128 && value <= 127) {
	            pos = encodeVarDeltaRunAsBytes(deltas, pos, result);
	        } else {
	            pos = encodeVarDeltaRunAsWords(deltas, pos, result);
	        }
	    }
	    return result;
	};

	// Convert a list of values to a CFF INDEX structure.
	// The values should be objects containing name / type / value.
	/**
	 * @param {Array} l
	 * @returns {Array}
	 */
	encode.INDEX = function(l) {
	    //var offset, offsets, offsetEncoder, encodedOffsets, encodedOffset, data,
	    //    i, v;
	    // Because we have to know which data type to use to encode the offsets,
	    // we have to go through the values twice: once to encode the data and
	    // calculate the offsets, then again to encode the offsets using the fitting data type.
	    var offset = 1; // First offset is always 1.
	    var offsets = [offset];
	    var data = [];
	    for (var i = 0; i < l.length; i += 1) {
	        var v = encode.OBJECT(l[i]);
	        Array.prototype.push.apply(data, v);
	        offset += v.length;
	        offsets.push(offset);
	    }

	    if (data.length === 0) {
	        return [0, 0];
	    }

	    var encodedOffsets = [];
	    var offSize = (1 + Math.floor(Math.log(offset) / Math.log(2)) / 8) | 0;
	    var offsetEncoder = [undefined, encode.BYTE, encode.USHORT, encode.UINT24, encode.ULONG][offSize];
	    for (var i$1 = 0; i$1 < offsets.length; i$1 += 1) {
	        var encodedOffset = offsetEncoder(offsets[i$1]);
	        Array.prototype.push.apply(encodedOffsets, encodedOffset);
	    }

	    return Array.prototype.concat(encode.Card16(l.length),
	                           encode.OffSize(offSize),
	                           encodedOffsets,
	                           data);
	};

	/**
	 * @param {Array}
	 * @returns {number}
	 */
	sizeOf.INDEX = function(v) {
	    return encode.INDEX(v).length;
	};

	/**
	 * Convert an object to a CFF DICT structure.
	 * The keys should be numeric.
	 * The values should be objects containing name / type / value.
	 * @param {Object} m
	 * @returns {Array}
	 */
	encode.DICT = function(m) {
	    var d = [];
	    var keys = Object.keys(m);
	    var length = keys.length;

	    for (var i = 0; i < length; i += 1) {
	        // Object.keys() return string keys, but our keys are always numeric.
	        var k = parseInt(keys[i], 0);
	        var v = m[k];
	        // Value comes before the key.
	        d = d.concat(encode.OPERAND(v.value, v.type));
	        d = d.concat(encode.OPERATOR(k));
	    }

	    return d;
	};

	/**
	 * @param {Object}
	 * @returns {number}
	 */
	sizeOf.DICT = function(m) {
	    return encode.DICT(m).length;
	};

	/**
	 * @param {number}
	 * @returns {Array}
	 */
	encode.OPERATOR = function(v) {
	    if (v < 1200) {
	        return [v];
	    } else {
	        return [12, v - 1200];
	    }
	};

	/**
	 * @param {Array} v
	 * @param {string}
	 * @returns {Array}
	 */
	encode.OPERAND = function(v, type) {
	    var d = [];
	    if (Array.isArray(type)) {
	        for (var i = 0; i < type.length; i += 1) {
	            check.argument(v.length === type.length, 'Not enough arguments given for type' + type);
	            d = d.concat(encode.OPERAND(v[i], type[i]));
	        }
	    } else {
	        if (type === 'SID') {
	            d = d.concat(encode.NUMBER(v));
	        } else if (type === 'offset') {
	            // We make it easy for ourselves and always encode offsets as
	            // 4 bytes. This makes offset calculation for the top dict easier.
	            d = d.concat(encode.NUMBER32(v));
	        } else if (type === 'number') {
	            d = d.concat(encode.NUMBER(v));
	        } else if (type === 'real') {
	            d = d.concat(encode.REAL(v));
	        } else {
	            throw new Error('Unknown operand type ' + type);
	            // FIXME Add support for booleans
	        }
	    }

	    return d;
	};

	encode.OP = encode.BYTE;
	sizeOf.OP = sizeOf.BYTE;

	// memoize charstring encoding using WeakMap if available
	var wmm = typeof WeakMap === 'function' && new WeakMap();

	/**
	 * Convert a list of CharString operations to bytes.
	 * @param {Array}
	 * @returns {Array}
	 */
	encode.CHARSTRING = function(ops) {
	    // See encode.MACSTRING for why we don't do "if (wmm && wmm.has(ops))".
	    if (wmm) {
	        var cachedValue = wmm.get(ops);
	        if (cachedValue !== undefined) {
	            return cachedValue;
	        }
	    }

	    var d = [];
	    var length = ops.length;

	    for (var i = 0; i < length; i += 1) {
	        var op = ops[i];
	        d = d.concat(encode[op.type](op.value));
	    }

	    if (wmm) {
	        wmm.set(ops, d);
	    }

	    return d;
	};

	/**
	 * @param {Array}
	 * @returns {number}
	 */
	sizeOf.CHARSTRING = function(ops) {
	    return encode.CHARSTRING(ops).length;
	};

	// Utility functions ////////////////////////////////////////////////////////

	/**
	 * Convert an object containing name / type / value to bytes.
	 * @param {Object}
	 * @returns {Array}
	 */
	encode.OBJECT = function(v) {
	    var encodingFunction = encode[v.type];
	    check.argument(encodingFunction !== undefined, 'No encoding function for type ' + v.type);
	    return encodingFunction(v.value);
	};

	/**
	 * @param {Object}
	 * @returns {number}
	 */
	sizeOf.OBJECT = function(v) {
	    var sizeOfFunction = sizeOf[v.type];
	    check.argument(sizeOfFunction !== undefined, 'No sizeOf function for type ' + v.type);
	    return sizeOfFunction(v.value);
	};

	/**
	 * Convert a table object to bytes.
	 * A table contains a list of fields containing the metadata (name, type and default value).
	 * The table itself has the field values set as attributes.
	 * @param {opentype.Table}
	 * @returns {Array}
	 */
	encode.TABLE = function(table) {
	    var d = [];
	    var length = table.fields.length;
	    var subtables = [];
	    var subtableOffsets = [];

	    for (var i = 0; i < length; i += 1) {
	        var field = table.fields[i];
	        var encodingFunction = encode[field.type];
	        check.argument(encodingFunction !== undefined, 'No encoding function for field type ' + field.type + ' (' + field.name + ')');
	        var value = table[field.name];
	        if (value === undefined) {
	            value = field.value;
	        }

	        var bytes = encodingFunction(value);

	        if (field.type === 'TABLE') {
	            subtableOffsets.push(d.length);
	            d = d.concat([0, 0]);
	            subtables.push(bytes);
	        } else {
	            d = d.concat(bytes);
	        }
	    }

	    for (var i$1 = 0; i$1 < subtables.length; i$1 += 1) {
	        var o = subtableOffsets[i$1];
	        var offset = d.length;
	        check.argument(offset < 65536, 'Table ' + table.tableName + ' too big.');
	        d[o] = offset >> 8;
	        d[o + 1] = offset & 0xff;
	        d = d.concat(subtables[i$1]);
	    }

	    return d;
	};

	/**
	 * @param {opentype.Table}
	 * @returns {number}
	 */
	sizeOf.TABLE = function(table) {
	    var numBytes = 0;
	    var length = table.fields.length;

	    for (var i = 0; i < length; i += 1) {
	        var field = table.fields[i];
	        var sizeOfFunction = sizeOf[field.type];
	        check.argument(sizeOfFunction !== undefined, 'No sizeOf function for field type ' + field.type + ' (' + field.name + ')');
	        var value = table[field.name];
	        if (value === undefined) {
	            value = field.value;
	        }

	        numBytes += sizeOfFunction(value);

	        // Subtables take 2 more bytes for offsets.
	        if (field.type === 'TABLE') {
	            numBytes += 2;
	        }
	    }

	    return numBytes;
	};

	encode.RECORD = encode.TABLE;
	sizeOf.RECORD = sizeOf.TABLE;

	// Merge in a list of bytes.
	encode.LITERAL = function(v) {
	    return v;
	};

	sizeOf.LITERAL = function(v) {
	    return v.length;
	};

	// Table metadata

	/**
	 * @exports opentype.Table
	 * @class
	 * @param {string} tableName
	 * @param {Array} fields
	 * @param {Object} options
	 * @constructor
	 */
	function Table(tableName, fields, options) {
	    var this$1 = this;

	    for (var i = 0; i < fields.length; i += 1) {
	        var field = fields[i];
	        this$1[field.name] = field.value;
	    }

	    this.tableName = tableName;
	    this.fields = fields;
	    if (options) {
	        var optionKeys = Object.keys(options);
	        for (var i$1 = 0; i$1 < optionKeys.length; i$1 += 1) {
	            var k = optionKeys[i$1];
	            var v = options[k];
	            if (this$1[k] !== undefined) {
	                this$1[k] = v;
	            }
	        }
	    }
	}

	/**
	 * Encodes the table and returns an array of bytes
	 * @return {Array}
	 */
	Table.prototype.encode = function() {
	    return encode.TABLE(this);
	};

	/**
	 * Get the size of the table.
	 * @return {number}
	 */
	Table.prototype.sizeOf = function() {
	    return sizeOf.TABLE(this);
	};

	/**
	 * @private
	 */
	function ushortList(itemName, list, count) {
	    if (count === undefined) {
	        count = list.length;
	    }
	    var fields = new Array(list.length + 1);
	    fields[0] = {name: itemName + 'Count', type: 'USHORT', value: count};
	    for (var i = 0; i < list.length; i++) {
	        fields[i + 1] = {name: itemName + i, type: 'USHORT', value: list[i]};
	    }
	    return fields;
	}

	/**
	 * @private
	 */
	function tableList(itemName, records, itemCallback) {
	    var count = records.length;
	    var fields = new Array(count + 1);
	    fields[0] = {name: itemName + 'Count', type: 'USHORT', value: count};
	    for (var i = 0; i < count; i++) {
	        fields[i + 1] = {name: itemName + i, type: 'TABLE', value: itemCallback(records[i], i)};
	    }
	    return fields;
	}

	/**
	 * @private
	 */
	function recordList(itemName, records, itemCallback) {
	    var count = records.length;
	    var fields = [];
	    fields[0] = {name: itemName + 'Count', type: 'USHORT', value: count};
	    for (var i = 0; i < count; i++) {
	        fields = fields.concat(itemCallback(records[i], i));
	    }
	    return fields;
	}

	// Common Layout Tables

	/**
	 * @exports opentype.Coverage
	 * @class
	 * @param {opentype.Table}
	 * @constructor
	 * @extends opentype.Table
	 */
	function Coverage(coverageTable) {
	    if (coverageTable.format === 1) {
	        Table.call(this, 'coverageTable',
	            [{name: 'coverageFormat', type: 'USHORT', value: 1}]
	            .concat(ushortList('glyph', coverageTable.glyphs))
	        );
	    } else {
	        check.assert(false, 'Can\'t create coverage table format 2 yet.');
	    }
	}
	Coverage.prototype = Object.create(Table.prototype);
	Coverage.prototype.constructor = Coverage;

	function ScriptList(scriptListTable) {
	    Table.call(this, 'scriptListTable',
	        recordList('scriptRecord', scriptListTable, function(scriptRecord, i) {
	            var script = scriptRecord.script;
	            var defaultLangSys = script.defaultLangSys;
	            check.assert(!!defaultLangSys, 'Unable to write GSUB: script ' + scriptRecord.tag + ' has no default language system.');
	            return [
	                {name: 'scriptTag' + i, type: 'TAG', value: scriptRecord.tag},
	                {name: 'script' + i, type: 'TABLE', value: new Table('scriptTable', [
	                    {name: 'defaultLangSys', type: 'TABLE', value: new Table('defaultLangSys', [
	                        {name: 'lookupOrder', type: 'USHORT', value: 0},
	                        {name: 'reqFeatureIndex', type: 'USHORT', value: defaultLangSys.reqFeatureIndex}]
	                        .concat(ushortList('featureIndex', defaultLangSys.featureIndexes)))}
	                    ].concat(recordList('langSys', script.langSysRecords, function(langSysRecord, i) {
	                        var langSys = langSysRecord.langSys;
	                        return [
	                            {name: 'langSysTag' + i, type: 'TAG', value: langSysRecord.tag},
	                            {name: 'langSys' + i, type: 'TABLE', value: new Table('langSys', [
	                                {name: 'lookupOrder', type: 'USHORT', value: 0},
	                                {name: 'reqFeatureIndex', type: 'USHORT', value: langSys.reqFeatureIndex}
	                                ].concat(ushortList('featureIndex', langSys.featureIndexes)))}
	                        ];
	                    })))}
	            ];
	        })
	    );
	}
	ScriptList.prototype = Object.create(Table.prototype);
	ScriptList.prototype.constructor = ScriptList;

	/**
	 * @exports opentype.FeatureList
	 * @class
	 * @param {opentype.Table}
	 * @constructor
	 * @extends opentype.Table
	 */
	function FeatureList(featureListTable) {
	    Table.call(this, 'featureListTable',
	        recordList('featureRecord', featureListTable, function(featureRecord, i) {
	            var feature = featureRecord.feature;
	            return [
	                {name: 'featureTag' + i, type: 'TAG', value: featureRecord.tag},
	                {name: 'feature' + i, type: 'TABLE', value: new Table('featureTable', [
	                    {name: 'featureParams', type: 'USHORT', value: feature.featureParams} ].concat(ushortList('lookupListIndex', feature.lookupListIndexes)))}
	            ];
	        })
	    );
	}
	FeatureList.prototype = Object.create(Table.prototype);
	FeatureList.prototype.constructor = FeatureList;

	/**
	 * @exports opentype.LookupList
	 * @class
	 * @param {opentype.Table}
	 * @param {Object}
	 * @constructor
	 * @extends opentype.Table
	 */
	function LookupList(lookupListTable, subtableMakers) {
	    Table.call(this, 'lookupListTable', tableList('lookup', lookupListTable, function(lookupTable) {
	        var subtableCallback = subtableMakers[lookupTable.lookupType];
	        check.assert(!!subtableCallback, 'Unable to write GSUB lookup type ' + lookupTable.lookupType + ' tables.');
	        return new Table('lookupTable', [
	            {name: 'lookupType', type: 'USHORT', value: lookupTable.lookupType},
	            {name: 'lookupFlag', type: 'USHORT', value: lookupTable.lookupFlag}
	        ].concat(tableList('subtable', lookupTable.subtables, subtableCallback)));
	    }));
	}
	LookupList.prototype = Object.create(Table.prototype);
	LookupList.prototype.constructor = LookupList;

	// Record = same as Table, but inlined (a Table has an offset and its data is further in the stream)
	// Don't use offsets inside Records (probable bug), only in Tables.
	var table = {
	    Table: Table,
	    Record: Table,
	    Coverage: Coverage,
	    ScriptList: ScriptList,
	    FeatureList: FeatureList,
	    LookupList: LookupList,
	    ushortList: ushortList,
	    tableList: tableList,
	    recordList: recordList,
	};

	// Parsing utility functions

	// Retrieve an unsigned byte from the DataView.
	function getByte(dataView, offset) {
	    return dataView.getUint8(offset);
	}

	// Retrieve an unsigned 16-bit short from the DataView.
	// The value is stored in big endian.
	function getUShort(dataView, offset) {
	    return dataView.getUint16(offset, false);
	}

	// Retrieve a signed 16-bit short from the DataView.
	// The value is stored in big endian.
	function getShort(dataView, offset) {
	    return dataView.getInt16(offset, false);
	}

	// Retrieve an unsigned 32-bit long from the DataView.
	// The value is stored in big endian.
	function getULong(dataView, offset) {
	    return dataView.getUint32(offset, false);
	}

	// Retrieve a 32-bit signed fixed-point number (16.16) from the DataView.
	// The value is stored in big endian.
	function getFixed(dataView, offset) {
	    var decimal = dataView.getInt16(offset, false);
	    var fraction = dataView.getUint16(offset + 2, false);
	    return decimal + fraction / 65535;
	}

	// Retrieve a 4-character tag from the DataView.
	// Tags are used to identify tables.
	function getTag(dataView, offset) {
	    var tag = '';
	    for (var i = offset; i < offset + 4; i += 1) {
	        tag += String.fromCharCode(dataView.getInt8(i));
	    }

	    return tag;
	}

	// Retrieve an offset from the DataView.
	// Offsets are 1 to 4 bytes in length, depending on the offSize argument.
	function getOffset(dataView, offset, offSize) {
	    var v = 0;
	    for (var i = 0; i < offSize; i += 1) {
	        v <<= 8;
	        v += dataView.getUint8(offset + i);
	    }

	    return v;
	}

	// Retrieve a number of bytes from start offset to the end offset from the DataView.
	function getBytes(dataView, startOffset, endOffset) {
	    var bytes = [];
	    for (var i = startOffset; i < endOffset; i += 1) {
	        bytes.push(dataView.getUint8(i));
	    }

	    return bytes;
	}

	// Convert the list of bytes to a string.
	function bytesToString(bytes) {
	    var s = '';
	    for (var i = 0; i < bytes.length; i += 1) {
	        s += String.fromCharCode(bytes[i]);
	    }

	    return s;
	}

	var typeOffsets = {
	    byte: 1,
	    uShort: 2,
	    short: 2,
	    uLong: 4,
	    fixed: 4,
	    longDateTime: 8,
	    tag: 4
	};

	// A stateful parser that changes the offset whenever a value is retrieved.
	// The data is a DataView.
	function Parser(data, offset) {
	    this.data = data;
	    this.offset = offset;
	    this.relativeOffset = 0;
	}

	Parser.prototype.parseByte = function() {
	    var v = this.data.getUint8(this.offset + this.relativeOffset);
	    this.relativeOffset += 1;
	    return v;
	};

	Parser.prototype.parseChar = function() {
	    var v = this.data.getInt8(this.offset + this.relativeOffset);
	    this.relativeOffset += 1;
	    return v;
	};

	Parser.prototype.parseCard8 = Parser.prototype.parseByte;

	Parser.prototype.parseUShort = function() {
	    var v = this.data.getUint16(this.offset + this.relativeOffset);
	    this.relativeOffset += 2;
	    return v;
	};

	Parser.prototype.parseCard16 = Parser.prototype.parseUShort;
	Parser.prototype.parseSID = Parser.prototype.parseUShort;
	Parser.prototype.parseOffset16 = Parser.prototype.parseUShort;

	Parser.prototype.parseShort = function() {
	    var v = this.data.getInt16(this.offset + this.relativeOffset);
	    this.relativeOffset += 2;
	    return v;
	};

	Parser.prototype.parseF2Dot14 = function() {
	    var v = this.data.getInt16(this.offset + this.relativeOffset) / 16384;
	    this.relativeOffset += 2;
	    return v;
	};

	Parser.prototype.parseULong = function() {
	    var v = getULong(this.data, this.offset + this.relativeOffset);
	    this.relativeOffset += 4;
	    return v;
	};

	Parser.prototype.parseOffset32 = Parser.prototype.parseULong;

	Parser.prototype.parseFixed = function() {
	    var v = getFixed(this.data, this.offset + this.relativeOffset);
	    this.relativeOffset += 4;
	    return v;
	};

	Parser.prototype.parseString = function(length) {
	    var dataView = this.data;
	    var offset = this.offset + this.relativeOffset;
	    var string = '';
	    this.relativeOffset += length;
	    for (var i = 0; i < length; i++) {
	        string += String.fromCharCode(dataView.getUint8(offset + i));
	    }

	    return string;
	};

	Parser.prototype.parseTag = function() {
	    return this.parseString(4);
	};

	// LONGDATETIME is a 64-bit integer.
	// JavaScript and unix timestamps traditionally use 32 bits, so we
	// only take the last 32 bits.
	// + Since until 2038 those bits will be filled by zeros we can ignore them.
	Parser.prototype.parseLongDateTime = function() {
	    var v = getULong(this.data, this.offset + this.relativeOffset + 4);
	    // Subtract seconds between 01/01/1904 and 01/01/1970
	    // to convert Apple Mac timestamp to Standard Unix timestamp
	    v -= 2082844800;
	    this.relativeOffset += 8;
	    return v;
	};

	Parser.prototype.parseVersion = function(minorBase) {
	    var major = getUShort(this.data, this.offset + this.relativeOffset);

	    // How to interpret the minor version is very vague in the spec. 0x5000 is 5, 0x1000 is 1
	    // Default returns the correct number if minor = 0xN000 where N is 0-9
	    // Set minorBase to 1 for tables that use minor = N where N is 0-9
	    var minor = getUShort(this.data, this.offset + this.relativeOffset + 2);
	    this.relativeOffset += 4;
	    if (minorBase === undefined) { minorBase = 0x1000; }
	    return major + minor / minorBase / 10;
	};

	Parser.prototype.skip = function(type, amount) {
	    if (amount === undefined) {
	        amount = 1;
	    }

	    this.relativeOffset += typeOffsets[type] * amount;
	};

	///// Parsing lists and records ///////////////////////////////

	// Parse a list of 32 bit unsigned integers.
	Parser.prototype.parseULongList = function(count) {
	    if (count === undefined) { count = this.parseULong(); }
	    var offsets = new Array(count);
	    var dataView = this.data;
	    var offset = this.offset + this.relativeOffset;
	    for (var i = 0; i < count; i++) {
	        offsets[i] = dataView.getUint32(offset);
	        offset += 4;
	    }

	    this.relativeOffset += count * 4;
	    return offsets;
	};

	// Parse a list of 16 bit unsigned integers. The length of the list can be read on the stream
	// or provided as an argument.
	Parser.prototype.parseOffset16List =
	Parser.prototype.parseUShortList = function(count) {
	    if (count === undefined) { count = this.parseUShort(); }
	    var offsets = new Array(count);
	    var dataView = this.data;
	    var offset = this.offset + this.relativeOffset;
	    for (var i = 0; i < count; i++) {
	        offsets[i] = dataView.getUint16(offset);
	        offset += 2;
	    }

	    this.relativeOffset += count * 2;
	    return offsets;
	};

	// Parses a list of 16 bit signed integers.
	Parser.prototype.parseShortList = function(count) {
	    var list = new Array(count);
	    var dataView = this.data;
	    var offset = this.offset + this.relativeOffset;
	    for (var i = 0; i < count; i++) {
	        list[i] = dataView.getInt16(offset);
	        offset += 2;
	    }

	    this.relativeOffset += count * 2;
	    return list;
	};

	// Parses a list of bytes.
	Parser.prototype.parseByteList = function(count) {
	    var list = new Array(count);
	    var dataView = this.data;
	    var offset = this.offset + this.relativeOffset;
	    for (var i = 0; i < count; i++) {
	        list[i] = dataView.getUint8(offset++);
	    }

	    this.relativeOffset += count;
	    return list;
	};

	/**
	 * Parse a list of items.
	 * Record count is optional, if omitted it is read from the stream.
	 * itemCallback is one of the Parser methods.
	 */
	Parser.prototype.parseList = function(count, itemCallback) {
	    var this$1 = this;

	    if (!itemCallback) {
	        itemCallback = count;
	        count = this.parseUShort();
	    }
	    var list = new Array(count);
	    for (var i = 0; i < count; i++) {
	        list[i] = itemCallback.call(this$1);
	    }
	    return list;
	};

	Parser.prototype.parseList32 = function(count, itemCallback) {
	    var this$1 = this;

	    if (!itemCallback) {
	        itemCallback = count;
	        count = this.parseULong();
	    }
	    var list = new Array(count);
	    for (var i = 0; i < count; i++) {
	        list[i] = itemCallback.call(this$1);
	    }
	    return list;
	};

	/**
	 * Parse a list of records.
	 * Record count is optional, if omitted it is read from the stream.
	 * Example of recordDescription: { sequenceIndex: Parser.uShort, lookupListIndex: Parser.uShort }
	 */
	Parser.prototype.parseRecordList = function(count, recordDescription) {
	    var this$1 = this;

	    // If the count argument is absent, read it in the stream.
	    if (!recordDescription) {
	        recordDescription = count;
	        count = this.parseUShort();
	    }
	    var records = new Array(count);
	    var fields = Object.keys(recordDescription);
	    for (var i = 0; i < count; i++) {
	        var rec = {};
	        for (var j = 0; j < fields.length; j++) {
	            var fieldName = fields[j];
	            var fieldType = recordDescription[fieldName];
	            rec[fieldName] = fieldType.call(this$1);
	        }
	        records[i] = rec;
	    }
	    return records;
	};

	Parser.prototype.parseRecordList32 = function(count, recordDescription) {
	    var this$1 = this;

	    // If the count argument is absent, read it in the stream.
	    if (!recordDescription) {
	        recordDescription = count;
	        count = this.parseULong();
	    }
	    var records = new Array(count);
	    var fields = Object.keys(recordDescription);
	    for (var i = 0; i < count; i++) {
	        var rec = {};
	        for (var j = 0; j < fields.length; j++) {
	            var fieldName = fields[j];
	            var fieldType = recordDescription[fieldName];
	            rec[fieldName] = fieldType.call(this$1);
	        }
	        records[i] = rec;
	    }
	    return records;
	};

	// Parse a data structure into an object
	// Example of description: { sequenceIndex: Parser.uShort, lookupListIndex: Parser.uShort }
	Parser.prototype.parseStruct = function(description) {
	    var this$1 = this;

	    if (typeof description === 'function') {
	        return description.call(this);
	    } else {
	        var fields = Object.keys(description);
	        var struct = {};
	        for (var j = 0; j < fields.length; j++) {
	            var fieldName = fields[j];
	            var fieldType = description[fieldName];
	            struct[fieldName] = fieldType.call(this$1);
	        }
	        return struct;
	    }
	};

	/**
	 * Parse a GPOS valueRecord
	 * https://docs.microsoft.com/en-us/typography/opentype/spec/gpos#value-record
	 * valueFormat is optional, if omitted it is read from the stream.
	 */
	Parser.prototype.parseValueRecord = function(valueFormat) {
	    if (valueFormat === undefined) {
	        valueFormat = this.parseUShort();
	    }
	    if (valueFormat === 0) {
	        // valueFormat2 in kerning pairs is most often 0
	        // in this case return undefined instead of an empty object, to save space
	        return;
	    }
	    var valueRecord = {};

	    if (valueFormat & 0x0001) { valueRecord.xPlacement = this.parseShort(); }
	    if (valueFormat & 0x0002) { valueRecord.yPlacement = this.parseShort(); }
	    if (valueFormat & 0x0004) { valueRecord.xAdvance = this.parseShort(); }
	    if (valueFormat & 0x0008) { valueRecord.yAdvance = this.parseShort(); }

	    // Device table (non-variable font) / VariationIndex table (variable font) not supported
	    // https://docs.microsoft.com/fr-fr/typography/opentype/spec/chapter2#devVarIdxTbls
	    if (valueFormat & 0x0010) { valueRecord.xPlaDevice = undefined; this.parseShort(); }
	    if (valueFormat & 0x0020) { valueRecord.yPlaDevice = undefined; this.parseShort(); }
	    if (valueFormat & 0x0040) { valueRecord.xAdvDevice = undefined; this.parseShort(); }
	    if (valueFormat & 0x0080) { valueRecord.yAdvDevice = undefined; this.parseShort(); }

	    return valueRecord;
	};

	/**
	 * Parse a list of GPOS valueRecords
	 * https://docs.microsoft.com/en-us/typography/opentype/spec/gpos#value-record
	 * valueFormat and valueCount are read from the stream.
	 */
	Parser.prototype.parseValueRecordList = function() {
	    var this$1 = this;

	    var valueFormat = this.parseUShort();
	    var valueCount = this.parseUShort();
	    var values = new Array(valueCount);
	    for (var i = 0; i < valueCount; i++) {
	        values[i] = this$1.parseValueRecord(valueFormat);
	    }
	    return values;
	};

	Parser.prototype.parsePointer = function(description) {
	    var structOffset = this.parseOffset16();
	    if (structOffset > 0) {
	        // NULL offset => return undefined
	        return new Parser(this.data, this.offset + structOffset).parseStruct(description);
	    }
	    return undefined;
	};

	Parser.prototype.parsePointer32 = function(description) {
	    var structOffset = this.parseOffset32();
	    if (structOffset > 0) {
	        // NULL offset => return undefined
	        return new Parser(this.data, this.offset + structOffset).parseStruct(description);
	    }
	    return undefined;
	};

	/**
	 * Parse a list of offsets to lists of 16-bit integers,
	 * or a list of offsets to lists of offsets to any kind of items.
	 * If itemCallback is not provided, a list of list of UShort is assumed.
	 * If provided, itemCallback is called on each item and must parse the item.
	 * See examples in tables/gsub.js
	 */
	Parser.prototype.parseListOfLists = function(itemCallback) {
	    var this$1 = this;

	    var offsets = this.parseOffset16List();
	    var count = offsets.length;
	    var relativeOffset = this.relativeOffset;
	    var list = new Array(count);
	    for (var i = 0; i < count; i++) {
	        var start = offsets[i];
	        if (start === 0) {
	            // NULL offset
	            // Add i as owned property to list. Convenient with assert.
	            list[i] = undefined;
	            continue;
	        }
	        this$1.relativeOffset = start;
	        if (itemCallback) {
	            var subOffsets = this$1.parseOffset16List();
	            var subList = new Array(subOffsets.length);
	            for (var j = 0; j < subOffsets.length; j++) {
	                this$1.relativeOffset = start + subOffsets[j];
	                subList[j] = itemCallback.call(this$1);
	            }
	            list[i] = subList;
	        } else {
	            list[i] = this$1.parseUShortList();
	        }
	    }
	    this.relativeOffset = relativeOffset;
	    return list;
	};

	///// Complex tables parsing //////////////////////////////////

	// Parse a coverage table in a GSUB, GPOS or GDEF table.
	// https://www.microsoft.com/typography/OTSPEC/chapter2.htm
	// parser.offset must point to the start of the table containing the coverage.
	Parser.prototype.parseCoverage = function() {
	    var this$1 = this;

	    var startOffset = this.offset + this.relativeOffset;
	    var format = this.parseUShort();
	    var count = this.parseUShort();
	    if (format === 1) {
	        return {
	            format: 1,
	            glyphs: this.parseUShortList(count)
	        };
	    } else if (format === 2) {
	        var ranges = new Array(count);
	        for (var i = 0; i < count; i++) {
	            ranges[i] = {
	                start: this$1.parseUShort(),
	                end: this$1.parseUShort(),
	                index: this$1.parseUShort()
	            };
	        }
	        return {
	            format: 2,
	            ranges: ranges
	        };
	    }
	    throw new Error('0x' + startOffset.toString(16) + ': Coverage format must be 1 or 2.');
	};

	// Parse a Class Definition Table in a GSUB, GPOS or GDEF table.
	// https://www.microsoft.com/typography/OTSPEC/chapter2.htm
	Parser.prototype.parseClassDef = function() {
	    var startOffset = this.offset + this.relativeOffset;
	    var format = this.parseUShort();
	    if (format === 1) {
	        return {
	            format: 1,
	            startGlyph: this.parseUShort(),
	            classes: this.parseUShortList()
	        };
	    } else if (format === 2) {
	        return {
	            format: 2,
	            ranges: this.parseRecordList({
	                start: Parser.uShort,
	                end: Parser.uShort,
	                classId: Parser.uShort
	            })
	        };
	    }
	    throw new Error('0x' + startOffset.toString(16) + ': ClassDef format must be 1 or 2.');
	};

	///// Static methods ///////////////////////////////////
	// These convenience methods can be used as callbacks and should be called with "this" context set to a Parser instance.

	Parser.list = function(count, itemCallback) {
	    return function() {
	        return this.parseList(count, itemCallback);
	    };
	};

	Parser.list32 = function(count, itemCallback) {
	    return function() {
	        return this.parseList32(count, itemCallback);
	    };
	};

	Parser.recordList = function(count, recordDescription) {
	    return function() {
	        return this.parseRecordList(count, recordDescription);
	    };
	};

	Parser.recordList32 = function(count, recordDescription) {
	    return function() {
	        return this.parseRecordList32(count, recordDescription);
	    };
	};

	Parser.pointer = function(description) {
	    return function() {
	        return this.parsePointer(description);
	    };
	};

	Parser.pointer32 = function(description) {
	    return function() {
	        return this.parsePointer32(description);
	    };
	};

	Parser.tag = Parser.prototype.parseTag;
	Parser.byte = Parser.prototype.parseByte;
	Parser.uShort = Parser.offset16 = Parser.prototype.parseUShort;
	Parser.uShortList = Parser.prototype.parseUShortList;
	Parser.uLong = Parser.offset32 = Parser.prototype.parseULong;
	Parser.uLongList = Parser.prototype.parseULongList;
	Parser.struct = Parser.prototype.parseStruct;
	Parser.coverage = Parser.prototype.parseCoverage;
	Parser.classDef = Parser.prototype.parseClassDef;

	///// Script, Feature, Lookup lists ///////////////////////////////////////////////
	// https://www.microsoft.com/typography/OTSPEC/chapter2.htm

	var langSysTable = {
	    reserved: Parser.uShort,
	    reqFeatureIndex: Parser.uShort,
	    featureIndexes: Parser.uShortList
	};

	Parser.prototype.parseScriptList = function() {
	    return this.parsePointer(Parser.recordList({
	        tag: Parser.tag,
	        script: Parser.pointer({
	            defaultLangSys: Parser.pointer(langSysTable),
	            langSysRecords: Parser.recordList({
	                tag: Parser.tag,
	                langSys: Parser.pointer(langSysTable)
	            })
	        })
	    })) || [];
	};

	Parser.prototype.parseFeatureList = function() {
	    return this.parsePointer(Parser.recordList({
	        tag: Parser.tag,
	        feature: Parser.pointer({
	            featureParams: Parser.offset16,
	            lookupListIndexes: Parser.uShortList
	        })
	    })) || [];
	};

	Parser.prototype.parseLookupList = function(lookupTableParsers) {
	    return this.parsePointer(Parser.list(Parser.pointer(function() {
	        var lookupType = this.parseUShort();
	        check.argument(1 <= lookupType && lookupType <= 9, 'GPOS/GSUB lookup type ' + lookupType + ' unknown.');
	        var lookupFlag = this.parseUShort();
	        var useMarkFilteringSet = lookupFlag & 0x10;
	        return {
	            lookupType: lookupType,
	            lookupFlag: lookupFlag,
	            subtables: this.parseList(Parser.pointer(lookupTableParsers[lookupType])),
	            markFilteringSet: useMarkFilteringSet ? this.parseUShort() : undefined
	        };
	    }))) || [];
	};

	Parser.prototype.parseFeatureVariationsList = function() {
	    return this.parsePointer32(function() {
	        var majorVersion = this.parseUShort();
	        var minorVersion = this.parseUShort();
	        check.argument(majorVersion === 1 && minorVersion < 1, 'GPOS/GSUB feature variations table unknown.');
	        var featureVariations = this.parseRecordList32({
	            conditionSetOffset: Parser.offset32,
	            featureTableSubstitutionOffset: Parser.offset32
	        });
	        return featureVariations;
	    }) || [];
	};

	var parse = {
	    getByte: getByte,
	    getCard8: getByte,
	    getUShort: getUShort,
	    getCard16: getUShort,
	    getShort: getShort,
	    getULong: getULong,
	    getFixed: getFixed,
	    getTag: getTag,
	    getOffset: getOffset,
	    getBytes: getBytes,
	    bytesToString: bytesToString,
	    Parser: Parser,
	};

	// The `cmap` table stores the mappings from characters to glyphs.

	function parseCmapTableFormat12(cmap, p) {
	    //Skip reserved.
	    p.parseUShort();

	    // Length in bytes of the sub-tables.
	    cmap.length = p.parseULong();
	    cmap.language = p.parseULong();

	    var groupCount;
	    cmap.groupCount = groupCount = p.parseULong();
	    cmap.glyphIndexMap = {};

	    for (var i = 0; i < groupCount; i += 1) {
	        var startCharCode = p.parseULong();
	        var endCharCode = p.parseULong();
	        var startGlyphId = p.parseULong();

	        for (var c = startCharCode; c <= endCharCode; c += 1) {
	            cmap.glyphIndexMap[c] = startGlyphId;
	            startGlyphId++;
	        }
	    }
	}

	function parseCmapTableFormat4(cmap, p, data, start, offset) {
	    // Length in bytes of the sub-tables.
	    cmap.length = p.parseUShort();
	    cmap.language = p.parseUShort();

	    // segCount is stored x 2.
	    var segCount;
	    cmap.segCount = segCount = p.parseUShort() >> 1;

	    // Skip searchRange, entrySelector, rangeShift.
	    p.skip('uShort', 3);

	    // The "unrolled" mapping from character codes to glyph indices.
	    cmap.glyphIndexMap = {};
	    var endCountParser = new parse.Parser(data, start + offset + 14);
	    var startCountParser = new parse.Parser(data, start + offset + 16 + segCount * 2);
	    var idDeltaParser = new parse.Parser(data, start + offset + 16 + segCount * 4);
	    var idRangeOffsetParser = new parse.Parser(data, start + offset + 16 + segCount * 6);
	    var glyphIndexOffset = start + offset + 16 + segCount * 8;
	    for (var i = 0; i < segCount - 1; i += 1) {
	        var glyphIndex = (void 0);
	        var endCount = endCountParser.parseUShort();
	        var startCount = startCountParser.parseUShort();
	        var idDelta = idDeltaParser.parseShort();
	        var idRangeOffset = idRangeOffsetParser.parseUShort();
	        for (var c = startCount; c <= endCount; c += 1) {
	            if (idRangeOffset !== 0) {
	                // The idRangeOffset is relative to the current position in the idRangeOffset array.
	                // Take the current offset in the idRangeOffset array.
	                glyphIndexOffset = (idRangeOffsetParser.offset + idRangeOffsetParser.relativeOffset - 2);

	                // Add the value of the idRangeOffset, which will move us into the glyphIndex array.
	                glyphIndexOffset += idRangeOffset;

	                // Then add the character index of the current segment, multiplied by 2 for USHORTs.
	                glyphIndexOffset += (c - startCount) * 2;
	                glyphIndex = parse.getUShort(data, glyphIndexOffset);
	                if (glyphIndex !== 0) {
	                    glyphIndex = (glyphIndex + idDelta) & 0xFFFF;
	                }
	            } else {
	                glyphIndex = (c + idDelta) & 0xFFFF;
	            }

	            cmap.glyphIndexMap[c] = glyphIndex;
	        }
	    }
	}

	// Parse the `cmap` table. This table stores the mappings from characters to glyphs.
	// There are many available formats, but we only support the Windows format 4 and 12.
	// This function returns a `CmapEncoding` object or null if no supported format could be found.
	function parseCmapTable(data, start) {
	    var cmap = {};
	    cmap.version = parse.getUShort(data, start);
	    check.argument(cmap.version === 0, 'cmap table version should be 0.');

	    // The cmap table can contain many sub-tables, each with their own format.
	    // We're only interested in a "platform 0" (Unicode format) and "platform 3" (Windows format) table.
	    cmap.numTables = parse.getUShort(data, start + 2);
	    var offset = -1;
	    for (var i = cmap.numTables - 1; i >= 0; i -= 1) {
	        var platformId = parse.getUShort(data, start + 4 + (i * 8));
	        var encodingId = parse.getUShort(data, start + 4 + (i * 8) + 2);
	        if ((platformId === 3 && (encodingId === 0 || encodingId === 1 || encodingId === 10)) ||
	            (platformId === 0 && (encodingId === 0 || encodingId === 1 || encodingId === 2 || encodingId === 3 || encodingId === 4))) {
	            offset = parse.getULong(data, start + 4 + (i * 8) + 4);
	            break;
	        }
	    }

	    if (offset === -1) {
	        // There is no cmap table in the font that we support.
	        throw new Error('No valid cmap sub-tables found.');
	    }

	    var p = new parse.Parser(data, start + offset);
	    cmap.format = p.parseUShort();

	    if (cmap.format === 12) {
	        parseCmapTableFormat12(cmap, p);
	    } else if (cmap.format === 4) {
	        parseCmapTableFormat4(cmap, p, data, start, offset);
	    } else {
	        throw new Error('Only format 4 and 12 cmap tables are supported (found format ' + cmap.format + ').');
	    }

	    return cmap;
	}

	function addSegment(t, code, glyphIndex) {
	    t.segments.push({
	        end: code,
	        start: code,
	        delta: -(code - glyphIndex),
	        offset: 0,
	        glyphIndex: glyphIndex
	    });
	}

	function addTerminatorSegment(t) {
	    t.segments.push({
	        end: 0xFFFF,
	        start: 0xFFFF,
	        delta: 1,
	        offset: 0
	    });
	}

	// Make cmap table, format 4 by default, 12 if needed only
	function makeCmapTable(glyphs) {
	    // Plan 0 is the base Unicode Plan but emojis, for example are on another plan, and needs cmap 12 format (with 32bit)
	    var isPlan0Only = true;
	    var i;

	    // Check if we need to add cmap format 12 or if format 4 only is fine
	    for (i = glyphs.length - 1; i > 0; i -= 1) {
	        var g = glyphs.get(i);
	        if (g.unicode > 65535) {
	            console.log('Adding CMAP format 12 (needed!)');
	            isPlan0Only = false;
	            break;
	        }
	    }

	    var cmapTable = [
	        {name: 'version', type: 'USHORT', value: 0},
	        {name: 'numTables', type: 'USHORT', value: isPlan0Only ? 1 : 2},

	        // CMAP 4 header
	        {name: 'platformID', type: 'USHORT', value: 3},
	        {name: 'encodingID', type: 'USHORT', value: 1},
	        {name: 'offset', type: 'ULONG', value: isPlan0Only ? 12 : (12 + 8)}
	    ];

	    if (!isPlan0Only)
	        { cmapTable = cmapTable.concat([
	            // CMAP 12 header
	            {name: 'cmap12PlatformID', type: 'USHORT', value: 3}, // We encode only for PlatformID = 3 (Windows) because it is supported everywhere
	            {name: 'cmap12EncodingID', type: 'USHORT', value: 10},
	            {name: 'cmap12Offset', type: 'ULONG', value: 0}
	        ]); }

	    cmapTable = cmapTable.concat([
	        // CMAP 4 Subtable
	        {name: 'format', type: 'USHORT', value: 4},
	        {name: 'cmap4Length', type: 'USHORT', value: 0},
	        {name: 'language', type: 'USHORT', value: 0},
	        {name: 'segCountX2', type: 'USHORT', value: 0},
	        {name: 'searchRange', type: 'USHORT', value: 0},
	        {name: 'entrySelector', type: 'USHORT', value: 0},
	        {name: 'rangeShift', type: 'USHORT', value: 0}
	    ]);

	    var t = new table.Table('cmap', cmapTable);

	    t.segments = [];
	    for (i = 0; i < glyphs.length; i += 1) {
	        var glyph = glyphs.get(i);
	        for (var j = 0; j < glyph.unicodes.length; j += 1) {
	            addSegment(t, glyph.unicodes[j], i);
	        }

	        t.segments = t.segments.sort(function (a, b) {
	            return a.start - b.start;
	        });
	    }

	    addTerminatorSegment(t);

	    var segCount = t.segments.length;
	    var segCountToRemove = 0;

	    // CMAP 4
	    // Set up parallel segment arrays.
	    var endCounts = [];
	    var startCounts = [];
	    var idDeltas = [];
	    var idRangeOffsets = [];
	    var glyphIds = [];

	    // CMAP 12
	    var cmap12Groups = [];

	    // Reminder this loop is not following the specification at 100%
	    // The specification -> find suites of characters and make a group
	    // Here we're doing one group for each letter
	    // Doing as the spec can save 8 times (or more) space
	    for (i = 0; i < segCount; i += 1) {
	        var segment = t.segments[i];

	        // CMAP 4
	        if (segment.end <= 65535 && segment.start <= 65535) {
	            endCounts = endCounts.concat({name: 'end_' + i, type: 'USHORT', value: segment.end});
	            startCounts = startCounts.concat({name: 'start_' + i, type: 'USHORT', value: segment.start});
	            idDeltas = idDeltas.concat({name: 'idDelta_' + i, type: 'SHORT', value: segment.delta});
	            idRangeOffsets = idRangeOffsets.concat({name: 'idRangeOffset_' + i, type: 'USHORT', value: segment.offset});
	            if (segment.glyphId !== undefined) {
	                glyphIds = glyphIds.concat({name: 'glyph_' + i, type: 'USHORT', value: segment.glyphId});
	            }
	        } else {
	            // Skip Unicode > 65535 (16bit unsigned max) for CMAP 4, will be added in CMAP 12
	            segCountToRemove += 1;
	        }

	        // CMAP 12
	        // Skip Terminator Segment
	        if (!isPlan0Only && segment.glyphIndex !== undefined) {
	            cmap12Groups = cmap12Groups.concat({name: 'cmap12Start_' + i, type: 'ULONG', value: segment.start});
	            cmap12Groups = cmap12Groups.concat({name: 'cmap12End_' + i, type: 'ULONG', value: segment.end});
	            cmap12Groups = cmap12Groups.concat({name: 'cmap12Glyph_' + i, type: 'ULONG', value: segment.glyphIndex});
	        }
	    }

	    // CMAP 4 Subtable
	    t.segCountX2 = (segCount - segCountToRemove) * 2;
	    t.searchRange = Math.pow(2, Math.floor(Math.log((segCount - segCountToRemove)) / Math.log(2))) * 2;
	    t.entrySelector = Math.log(t.searchRange / 2) / Math.log(2);
	    t.rangeShift = t.segCountX2 - t.searchRange;

	    t.fields = t.fields.concat(endCounts);
	    t.fields.push({name: 'reservedPad', type: 'USHORT', value: 0});
	    t.fields = t.fields.concat(startCounts);
	    t.fields = t.fields.concat(idDeltas);
	    t.fields = t.fields.concat(idRangeOffsets);
	    t.fields = t.fields.concat(glyphIds);

	    t.cmap4Length = 14 + // Subtable header
	        endCounts.length * 2 +
	        2 + // reservedPad
	        startCounts.length * 2 +
	        idDeltas.length * 2 +
	        idRangeOffsets.length * 2 +
	        glyphIds.length * 2;

	    if (!isPlan0Only) {
	        // CMAP 12 Subtable
	        var cmap12Length = 16 + // Subtable header
	            cmap12Groups.length * 4;

	        t.cmap12Offset = 12 + (2 * 2) + 4 + t.cmap4Length;
	        t.fields = t.fields.concat([
	            {name: 'cmap12Format', type: 'USHORT', value: 12},
	            {name: 'cmap12Reserved', type: 'USHORT', value: 0},
	            {name: 'cmap12Length', type: 'ULONG', value: cmap12Length},
	            {name: 'cmap12Language', type: 'ULONG', value: 0},
	            {name: 'cmap12nGroups', type: 'ULONG', value: cmap12Groups.length / 3}
	        ]);

	        t.fields = t.fields.concat(cmap12Groups);
	    }

	    return t;
	}

	var cmap = { parse: parseCmapTable, make: makeCmapTable };

	// Glyph encoding

	var cffStandardStrings = [
	    '.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright',
	    'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two',
	    'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater',
	    'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S',
	    'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore',
	    'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
	    'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling',
	    'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft',
	    'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph',
	    'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand',
	    'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring',
	    'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE',
	    'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu',
	    'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn',
	    'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright',
	    'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex',
	    'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex',
	    'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute',
	    'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute',
	    'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute',
	    'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave',
	    'yacute', 'ydieresis', 'zcaron', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior',
	    'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', '266 ff', 'onedotenleader',
	    'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle',
	    'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'commasuperior', 'threequartersemdash', 'periodsuperior',
	    'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior',
	    'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'ffi', 'ffl',
	    'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall',
	    'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall',
	    'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall',
	    'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall',
	    'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall',
	    'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall',
	    'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds',
	    'zerosuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior',
	    'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior',
	    'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior',
	    'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall',
	    'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall',
	    'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall',
	    'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall',
	    'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall', '001.000',
	    '001.001', '001.002', '001.003', 'Black', 'Bold', 'Book', 'Light', 'Medium', 'Regular', 'Roman', 'Semibold'];

	var cffStandardEncoding = [
	    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
	    '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright',
	    'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two',
	    'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater',
	    'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S',
	    'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore',
	    'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
	    'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', '', '', '', '', '', '', '',
	    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
	    'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle',
	    'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', '', 'endash', 'dagger',
	    'daggerdbl', 'periodcentered', '', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright',
	    'guillemotright', 'ellipsis', 'perthousand', '', 'questiondown', '', 'grave', 'acute', 'circumflex', 'tilde',
	    'macron', 'breve', 'dotaccent', 'dieresis', '', 'ring', 'cedilla', '', 'hungarumlaut', 'ogonek', 'caron',
	    'emdash', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'AE', '', 'ordfeminine', '', '', '',
	    '', 'Lslash', 'Oslash', 'OE', 'ordmasculine', '', '', '', '', '', 'ae', '', '', '', 'dotlessi', '', '',
	    'lslash', 'oslash', 'oe', 'germandbls'];

	var cffExpertEncoding = [
	    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
	    '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', '', 'dollaroldstyle', 'dollarsuperior',
	    'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader',
	    'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle',
	    'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon',
	    'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', '', 'asuperior',
	    'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', '', '', 'isuperior', '', '', 'lsuperior', 'msuperior',
	    'nsuperior', 'osuperior', '', '', 'rsuperior', 'ssuperior', 'tsuperior', '', 'ff', 'fi', 'fl', 'ffi', 'ffl',
	    'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall',
	    'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall',
	    'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall',
	    'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', '', '', '', '', '',
	    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
	    'exclamdownsmall', 'centoldstyle', 'Lslashsmall', '', '', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall',
	    'Brevesmall', 'Caronsmall', '', 'Dotaccentsmall', '', '', 'Macronsmall', '', '', 'figuredash', 'hypheninferior',
	    '', '', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', '', '', '', 'onequarter', 'onehalf', 'threequarters',
	    'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '',
	    '', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior',
	    'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior',
	    'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior',
	    'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall',
	    'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall',
	    'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall',
	    'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall',
	    'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall',
	    'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];

	var standardNames = [
	    '.notdef', '.null', 'nonmarkingreturn', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent',
	    'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash',
	    'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less',
	    'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
	    'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright',
	    'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o',
	    'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde',
	    'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave',
	    'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis',
	    'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis',
	    'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section',
	    'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal',
	    'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation',
	    'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown',
	    'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright',
	    'ellipsis', 'nonbreakingspace', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft',
	    'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction',
	    'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase',
	    'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute',
	    'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex',
	    'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut',
	    'ogonek', 'caron', 'Lslash', 'lslash', 'Scaron', 'scaron', 'Zcaron', 'zcaron', 'brokenbar', 'Eth', 'eth',
	    'Yacute', 'yacute', 'Thorn', 'thorn', 'minus', 'multiply', 'onesuperior', 'twosuperior', 'threesuperior',
	    'onehalf', 'onequarter', 'threequarters', 'franc', 'Gbreve', 'gbreve', 'Idotaccent', 'Scedilla', 'scedilla',
	    'Cacute', 'cacute', 'Ccaron', 'ccaron', 'dcroat'];

	/**
	 * This is the encoding used for fonts created from scratch.
	 * It loops through all glyphs and finds the appropriate unicode value.
	 * Since it's linear time, other encodings will be faster.
	 * @exports opentype.DefaultEncoding
	 * @class
	 * @constructor
	 * @param {opentype.Font}
	 */
	function DefaultEncoding(font) {
	    this.font = font;
	}

	DefaultEncoding.prototype.charToGlyphIndex = function(c) {
	    var code = c.codePointAt(0);
	    var glyphs = this.font.glyphs;
	    if (glyphs) {
	        for (var i = 0; i < glyphs.length; i += 1) {
	            var glyph = glyphs.get(i);
	            for (var j = 0; j < glyph.unicodes.length; j += 1) {
	                if (glyph.unicodes[j] === code) {
	                    return i;
	                }
	            }
	        }
	    }
	    return null;
	};

	/**
	 * @exports opentype.CmapEncoding
	 * @class
	 * @constructor
	 * @param {Object} cmap - a object with the cmap encoded data
	 */
	function CmapEncoding(cmap) {
	    this.cmap = cmap;
	}

	/**
	 * @param  {string} c - the character
	 * @return {number} The glyph index.
	 */
	CmapEncoding.prototype.charToGlyphIndex = function(c) {
	    return this.cmap.glyphIndexMap[c.codePointAt(0)] || 0;
	};

	/**
	 * @exports opentype.CffEncoding
	 * @class
	 * @constructor
	 * @param {string} encoding - The encoding
	 * @param {Array} charset - The character set.
	 */
	function CffEncoding(encoding, charset) {
	    this.encoding = encoding;
	    this.charset = charset;
	}

	/**
	 * @param  {string} s - The character
	 * @return {number} The index.
	 */
	CffEncoding.prototype.charToGlyphIndex = function(s) {
	    var code = s.codePointAt(0);
	    var charName = this.encoding[code];
	    return this.charset.indexOf(charName);
	};

	/**
	 * @exports opentype.GlyphNames
	 * @class
	 * @constructor
	 * @param {Object} post
	 */
	function GlyphNames(post) {
	    var this$1 = this;

	    switch (post.version) {
	        case 1:
	            this.names = standardNames.slice();
	            break;
	        case 2:
	            this.names = new Array(post.numberOfGlyphs);
	            for (var i = 0; i < post.numberOfGlyphs; i++) {
	                if (post.glyphNameIndex[i] < standardNames.length) {
	                    this$1.names[i] = standardNames[post.glyphNameIndex[i]];
	                } else {
	                    this$1.names[i] = post.names[post.glyphNameIndex[i] - standardNames.length];
	                }
	            }

	            break;
	        case 2.5:
	            this.names = new Array(post.numberOfGlyphs);
	            for (var i$1 = 0; i$1 < post.numberOfGlyphs; i$1++) {
	                this$1.names[i$1] = standardNames[i$1 + post.glyphNameIndex[i$1]];
	            }

	            break;
	        case 3:
	            this.names = [];
	            break;
	        default:
	            this.names = [];
	            break;
	    }
	}

	/**
	 * Gets the index of a glyph by name.
	 * @param  {string} name - The glyph name
	 * @return {number} The index
	 */
	GlyphNames.prototype.nameToGlyphIndex = function(name) {
	    return this.names.indexOf(name);
	};

	/**
	 * @param  {number} gid
	 * @return {string}
	 */
	GlyphNames.prototype.glyphIndexToName = function(gid) {
	    return this.names[gid];
	};

	function addGlyphNamesAll(font) {
	    var glyph;
	    var glyphIndexMap = font.tables.cmap.glyphIndexMap;
	    var charCodes = Object.keys(glyphIndexMap);

	    for (var i = 0; i < charCodes.length; i += 1) {
	        var c = charCodes[i];
	        var glyphIndex = glyphIndexMap[c];
	        glyph = font.glyphs.get(glyphIndex);
	        glyph.addUnicode(parseInt(c));
	    }

	    for (var i$1 = 0; i$1 < font.glyphs.length; i$1 += 1) {
	        glyph = font.glyphs.get(i$1);
	        if (font.cffEncoding) {
	            if (font.isCIDFont) {
	                glyph.name = 'gid' + i$1;
	            } else {
	                glyph.name = font.cffEncoding.charset[i$1];
	            }
	        } else if (font.glyphNames.names) {
	            glyph.name = font.glyphNames.glyphIndexToName(i$1);
	        }
	    }
	}

	function addGlyphNamesToUnicodeMap(font) {
	    font._IndexToUnicodeMap = {};

	    var glyphIndexMap = font.tables.cmap.glyphIndexMap;
	    var charCodes = Object.keys(glyphIndexMap);

	    for (var i = 0; i < charCodes.length; i += 1) {
	        var c = charCodes[i];
	        var glyphIndex = glyphIndexMap[c];
	        if (font._IndexToUnicodeMap[glyphIndex] === undefined) {
	            font._IndexToUnicodeMap[glyphIndex] = {
	                unicodes: [parseInt(c)]
	            };
	        } else {
	            font._IndexToUnicodeMap[glyphIndex].unicodes.push(parseInt(c));
	        }
	    }
	}

	/**
	 * @alias opentype.addGlyphNames
	 * @param {opentype.Font}
	 * @param {Object}
	 */
	function addGlyphNames(font, opt) {
	    if (opt.lowMemory) {
	        addGlyphNamesToUnicodeMap(font);
	    } else {
	        addGlyphNamesAll(font);
	    }
	}

	// Drawing utility functions.

	// Draw a line on the given context from point `x1,y1` to point `x2,y2`.
	function line(ctx, x1, y1, x2, y2) {
	    ctx.beginPath();
	    ctx.moveTo(x1, y1);
	    ctx.lineTo(x2, y2);
	    ctx.stroke();
	}

	var draw = { line: line };

	// The Glyph object
	// import glyf from './tables/glyf' Can't be imported here, because it's a circular dependency

	function getPathDefinition(glyph, path) {
	    var _path = path || new Path();
	    return {
	        configurable: true,

	        get: function() {
	            if (typeof _path === 'function') {
	                _path = _path();
	            }

	            return _path;
	        },

	        set: function(p) {
	            _path = p;
	        }
	    };
	}
	/**
	 * @typedef GlyphOptions
	 * @type Object
	 * @property {string} [name] - The glyph name
	 * @property {number} [unicode]
	 * @property {Array} [unicodes]
	 * @property {number} [xMin]
	 * @property {number} [yMin]
	 * @property {number} [xMax]
	 * @property {number} [yMax]
	 * @property {number} [advanceWidth]
	 */

	// A Glyph is an individual mark that often corresponds to a character.
	// Some glyphs, such as ligatures, are a combination of many characters.
	// Glyphs are the basic building blocks of a font.
	//
	// The `Glyph` class contains utility methods for drawing the path and its points.
	/**
	 * @exports opentype.Glyph
	 * @class
	 * @param {GlyphOptions}
	 * @constructor
	 */
	function Glyph(options) {
	    // By putting all the code on a prototype function (which is only declared once)
	    // we reduce the memory requirements for larger fonts by some 2%
	    this.bindConstructorValues(options);
	}

	/**
	 * @param  {GlyphOptions}
	 */
	Glyph.prototype.bindConstructorValues = function(options) {
	    this.index = options.index || 0;

	    // These three values cannot be deferred for memory optimization:
	    this.name = options.name || null;
	    this.unicode = options.unicode || undefined;
	    this.unicodes = options.unicodes || options.unicode !== undefined ? [options.unicode] : [];

	    // But by binding these values only when necessary, we reduce can
	    // the memory requirements by almost 3% for larger fonts.
	    if (options.xMin) {
	        this.xMin = options.xMin;
	    }

	    if (options.yMin) {
	        this.yMin = options.yMin;
	    }

	    if (options.xMax) {
	        this.xMax = options.xMax;
	    }

	    if (options.yMax) {
	        this.yMax = options.yMax;
	    }

	    if (options.advanceWidth) {
	        this.advanceWidth = options.advanceWidth;
	    }

	    // The path for a glyph is the most memory intensive, and is bound as a value
	    // with a getter/setter to ensure we actually do path parsing only once the
	    // path is actually needed by anything.
	    Object.defineProperty(this, 'path', getPathDefinition(this, options.path));
	};

	/**
	 * @param {number}
	 */
	Glyph.prototype.addUnicode = function(unicode) {
	    if (this.unicodes.length === 0) {
	        this.unicode = unicode;
	    }

	    this.unicodes.push(unicode);
	};

	/**
	 * Calculate the minimum bounding box for this glyph.
	 * @return {opentype.BoundingBox}
	 */
	Glyph.prototype.getBoundingBox = function() {
	    return this.path.getBoundingBox();
	};

	/**
	 * Convert the glyph to a Path we can draw on a drawing context.
	 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
	 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
	 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
	 * @param  {Object=} options - xScale, yScale to stretch the glyph.
	 * @param  {opentype.Font} if hinting is to be used, the font
	 * @return {opentype.Path}
	 */
	Glyph.prototype.getPath = function(x, y, fontSize, options, font) {
	    x = x !== undefined ? x : 0;
	    y = y !== undefined ? y : 0;
	    fontSize = fontSize !== undefined ? fontSize : 72;
	    var commands;
	    var hPoints;
	    if (!options) { options = { }; }
	    var xScale = options.xScale;
	    var yScale = options.yScale;

	    if (options.hinting && font && font.hinting) {
	        // in case of hinting, the hinting engine takes care
	        // of scaling the points (not the path) before hinting.
	        hPoints = this.path && font.hinting.exec(this, fontSize);
	        // in case the hinting engine failed hPoints is undefined
	        // and thus reverts to plain rending
	    }

	    if (hPoints) {
	        // Call font.hinting.getCommands instead of `glyf.getPath(hPoints).commands` to avoid a circular dependency
	        commands = font.hinting.getCommands(hPoints);
	        x = Math.round(x);
	        y = Math.round(y);
	        // TODO in case of hinting xyScaling is not yet supported
	        xScale = yScale = 1;
	    } else {
	        commands = this.path.commands;
	        var scale = 1 / (this.path.unitsPerEm || 1000) * fontSize;
	        if (xScale === undefined) { xScale = scale; }
	        if (yScale === undefined) { yScale = scale; }
	    }

	    var p = new Path();
	    for (var i = 0; i < commands.length; i += 1) {
	        var cmd = commands[i];
	        if (cmd.type === 'M') {
	            p.moveTo(x + (cmd.x * xScale), y + (-cmd.y * yScale));
	        } else if (cmd.type === 'L') {
	            p.lineTo(x + (cmd.x * xScale), y + (-cmd.y * yScale));
	        } else if (cmd.type === 'Q') {
	            p.quadraticCurveTo(x + (cmd.x1 * xScale), y + (-cmd.y1 * yScale),
	                               x + (cmd.x * xScale), y + (-cmd.y * yScale));
	        } else if (cmd.type === 'C') {
	            p.curveTo(x + (cmd.x1 * xScale), y + (-cmd.y1 * yScale),
	                      x + (cmd.x2 * xScale), y + (-cmd.y2 * yScale),
	                      x + (cmd.x * xScale), y + (-cmd.y * yScale));
	        } else if (cmd.type === 'Z') {
	            p.closePath();
	        }
	    }

	    return p;
	};

	/**
	 * Split the glyph into contours.
	 * This function is here for backwards compatibility, and to
	 * provide raw access to the TrueType glyph outlines.
	 * @return {Array}
	 */
	Glyph.prototype.getContours = function() {
	    var this$1 = this;

	    if (this.points === undefined) {
	        return [];
	    }

	    var contours = [];
	    var currentContour = [];
	    for (var i = 0; i < this.points.length; i += 1) {
	        var pt = this$1.points[i];
	        currentContour.push(pt);
	        if (pt.lastPointOfContour) {
	            contours.push(currentContour);
	            currentContour = [];
	        }
	    }

	    check.argument(currentContour.length === 0, 'There are still points left in the current contour.');
	    return contours;
	};

	/**
	 * Calculate the xMin/yMin/xMax/yMax/lsb/rsb for a Glyph.
	 * @return {Object}
	 */
	Glyph.prototype.getMetrics = function() {
	    var commands = this.path.commands;
	    var xCoords = [];
	    var yCoords = [];
	    for (var i = 0; i < commands.length; i += 1) {
	        var cmd = commands[i];
	        if (cmd.type !== 'Z') {
	            xCoords.push(cmd.x);
	            yCoords.push(cmd.y);
	        }

	        if (cmd.type === 'Q' || cmd.type === 'C') {
	            xCoords.push(cmd.x1);
	            yCoords.push(cmd.y1);
	        }

	        if (cmd.type === 'C') {
	            xCoords.push(cmd.x2);
	            yCoords.push(cmd.y2);
	        }
	    }

	    var metrics = {
	        xMin: Math.min.apply(null, xCoords),
	        yMin: Math.min.apply(null, yCoords),
	        xMax: Math.max.apply(null, xCoords),
	        yMax: Math.max.apply(null, yCoords),
	        leftSideBearing: this.leftSideBearing
	    };

	    if (!isFinite(metrics.xMin)) {
	        metrics.xMin = 0;
	    }

	    if (!isFinite(metrics.xMax)) {
	        metrics.xMax = this.advanceWidth;
	    }

	    if (!isFinite(metrics.yMin)) {
	        metrics.yMin = 0;
	    }

	    if (!isFinite(metrics.yMax)) {
	        metrics.yMax = 0;
	    }

	    metrics.rightSideBearing = this.advanceWidth - metrics.leftSideBearing - (metrics.xMax - metrics.xMin);
	    return metrics;
	};

	/**
	 * Draw the glyph on the given context.
	 * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
	 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
	 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
	 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
	 * @param  {Object=} options - xScale, yScale to stretch the glyph.
	 */
	Glyph.prototype.draw = function(ctx, x, y, fontSize, options) {
	    this.getPath(x, y, fontSize, options).draw(ctx);
	};

	/**
	 * Draw the points of the glyph.
	 * On-curve points will be drawn in blue, off-curve points will be drawn in red.
	 * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
	 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
	 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
	 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
	 */
	Glyph.prototype.drawPoints = function(ctx, x, y, fontSize) {
	    function drawCircles(l, x, y, scale) {
	        var PI_SQ = Math.PI * 2;
	        ctx.beginPath();
	        for (var j = 0; j < l.length; j += 1) {
	            ctx.moveTo(x + (l[j].x * scale), y + (l[j].y * scale));
	            ctx.arc(x + (l[j].x * scale), y + (l[j].y * scale), 2, 0, PI_SQ, false);
	        }

	        ctx.closePath();
	        ctx.fill();
	    }

	    x = x !== undefined ? x : 0;
	    y = y !== undefined ? y : 0;
	    fontSize = fontSize !== undefined ? fontSize : 24;
	    var scale = 1 / this.path.unitsPerEm * fontSize;

	    var blueCircles = [];
	    var redCircles = [];
	    var path = this.path;
	    for (var i = 0; i < path.commands.length; i += 1) {
	        var cmd = path.commands[i];
	        if (cmd.x !== undefined) {
	            blueCircles.push({x: cmd.x, y: -cmd.y});
	        }

	        if (cmd.x1 !== undefined) {
	            redCircles.push({x: cmd.x1, y: -cmd.y1});
	        }

	        if (cmd.x2 !== undefined) {
	            redCircles.push({x: cmd.x2, y: -cmd.y2});
	        }
	    }

	    ctx.fillStyle = 'blue';
	    drawCircles(blueCircles, x, y, scale);
	    ctx.fillStyle = 'red';
	    drawCircles(redCircles, x, y, scale);
	};

	/**
	 * Draw lines indicating important font measurements.
	 * Black lines indicate the origin of the coordinate system (point 0,0).
	 * Blue lines indicate the glyph bounding box.
	 * Green line indicates the advance width of the glyph.
	 * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
	 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
	 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
	 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
	 */
	Glyph.prototype.drawMetrics = function(ctx, x, y, fontSize) {
	    var scale;
	    x = x !== undefined ? x : 0;
	    y = y !== undefined ? y : 0;
	    fontSize = fontSize !== undefined ? fontSize : 24;
	    scale = 1 / this.path.unitsPerEm * fontSize;
	    ctx.lineWidth = 1;

	    // Draw the origin
	    ctx.strokeStyle = 'black';
	    draw.line(ctx, x, -10000, x, 10000);
	    draw.line(ctx, -10000, y, 10000, y);

	    // This code is here due to memory optimization: by not using
	    // defaults in the constructor, we save a notable amount of memory.
	    var xMin = this.xMin || 0;
	    var yMin = this.yMin || 0;
	    var xMax = this.xMax || 0;
	    var yMax = this.yMax || 0;
	    var advanceWidth = this.advanceWidth || 0;

	    // Draw the glyph box
	    ctx.strokeStyle = 'blue';
	    draw.line(ctx, x + (xMin * scale), -10000, x + (xMin * scale), 10000);
	    draw.line(ctx, x + (xMax * scale), -10000, x + (xMax * scale), 10000);
	    draw.line(ctx, -10000, y + (-yMin * scale), 10000, y + (-yMin * scale));
	    draw.line(ctx, -10000, y + (-yMax * scale), 10000, y + (-yMax * scale));

	    // Draw the advance width
	    ctx.strokeStyle = 'green';
	    draw.line(ctx, x + (advanceWidth * scale), -10000, x + (advanceWidth * scale), 10000);
	};

	// The GlyphSet object

	// Define a property on the glyph that depends on the path being loaded.
	function defineDependentProperty(glyph, externalName, internalName) {
	    Object.defineProperty(glyph, externalName, {
	        get: function() {
	            // Request the path property to make sure the path is loaded.
	            glyph.path; // jshint ignore:line
	            return glyph[internalName];
	        },
	        set: function(newValue) {
	            glyph[internalName] = newValue;
	        },
	        enumerable: true,
	        configurable: true
	    });
	}

	/**
	 * A GlyphSet represents all glyphs available in the font, but modelled using
	 * a deferred glyph loader, for retrieving glyphs only once they are absolutely
	 * necessary, to keep the memory footprint down.
	 * @exports opentype.GlyphSet
	 * @class
	 * @param {opentype.Font}
	 * @param {Array}
	 */
	function GlyphSet(font, glyphs) {
	    var this$1 = this;

	    this.font = font;
	    this.glyphs = {};
	    if (Array.isArray(glyphs)) {
	        for (var i = 0; i < glyphs.length; i++) {
	            var glyph = glyphs[i];
	            glyph.path.unitsPerEm = font.unitsPerEm;
	            this$1.glyphs[i] = glyph;
	        }
	    }

	    this.length = (glyphs && glyphs.length) || 0;
	}

	/**
	 * @param  {number} index
	 * @return {opentype.Glyph}
	 */
	GlyphSet.prototype.get = function(index) {
	    // this.glyphs[index] is 'undefined' when low memory mode is on. glyph is pushed on request only.
	    if (this.glyphs[index] === undefined) {
	        this.font._push(index);
	        if (typeof this.glyphs[index] === 'function') {
	            this.glyphs[index] = this.glyphs[index]();
	        }

	        var glyph = this.glyphs[index];
	        var unicodeObj = this.font._IndexToUnicodeMap[index];

	        if (unicodeObj) {
	            for (var j = 0; j < unicodeObj.unicodes.length; j++)
	                { glyph.addUnicode(unicodeObj.unicodes[j]); }
	        }

	        if (this.font.cffEncoding) {
	            if (this.font.isCIDFont) {
	                glyph.name = 'gid' + index;
	            } else {
	                glyph.name = this.font.cffEncoding.charset[index];
	            }
	        } else if (this.font.glyphNames.names) {
	            glyph.name = this.font.glyphNames.glyphIndexToName(index);
	        }

	        this.glyphs[index].advanceWidth = this.font._hmtxTableData[index].advanceWidth;
	        this.glyphs[index].leftSideBearing = this.font._hmtxTableData[index].leftSideBearing;
	    } else {
	        if (typeof this.glyphs[index] === 'function') {
	            this.glyphs[index] = this.glyphs[index]();
	        }
	    }

	    return this.glyphs[index];
	};

	/**
	 * @param  {number} index
	 * @param  {Object}
	 */
	GlyphSet.prototype.push = function(index, loader) {
	    this.glyphs[index] = loader;
	    this.length++;
	};

	/**
	 * @alias opentype.glyphLoader
	 * @param  {opentype.Font} font
	 * @param  {number} index
	 * @return {opentype.Glyph}
	 */
	function glyphLoader(font, index) {
	    return new Glyph({index: index, font: font});
	}

	/**
	 * Generate a stub glyph that can be filled with all metadata *except*
	 * the "points" and "path" properties, which must be loaded only once
	 * the glyph's path is actually requested for text shaping.
	 * @alias opentype.ttfGlyphLoader
	 * @param  {opentype.Font} font
	 * @param  {number} index
	 * @param  {Function} parseGlyph
	 * @param  {Object} data
	 * @param  {number} position
	 * @param  {Function} buildPath
	 * @return {opentype.Glyph}
	 */
	function ttfGlyphLoader(font, index, parseGlyph, data, position, buildPath) {
	    return function() {
	        var glyph = new Glyph({index: index, font: font});

	        glyph.path = function() {
	            parseGlyph(glyph, data, position);
	            var path = buildPath(font.glyphs, glyph);
	            path.unitsPerEm = font.unitsPerEm;
	            return path;
	        };

	        defineDependentProperty(glyph, 'xMin', '_xMin');
	        defineDependentProperty(glyph, 'xMax', '_xMax');
	        defineDependentProperty(glyph, 'yMin', '_yMin');
	        defineDependentProperty(glyph, 'yMax', '_yMax');

	        return glyph;
	    };
	}
	/**
	 * @alias opentype.cffGlyphLoader
	 * @param  {opentype.Font} font
	 * @param  {number} index
	 * @param  {Function} parseCFFCharstring
	 * @param  {string} charstring
	 * @return {opentype.Glyph}
	 */
	function cffGlyphLoader(font, index, parseCFFCharstring, charstring) {
	    return function() {
	        var glyph = new Glyph({index: index, font: font});

	        glyph.path = function() {
	            var path = parseCFFCharstring(font, glyph, charstring);
	            path.unitsPerEm = font.unitsPerEm;
	            return path;
	        };

	        return glyph;
	    };
	}

	var glyphset = { GlyphSet: GlyphSet, glyphLoader: glyphLoader, ttfGlyphLoader: ttfGlyphLoader, cffGlyphLoader: cffGlyphLoader };

	// The `CFF` table contains the glyph outlines in PostScript format.

	// Custom equals function that can also check lists.
	function equals(a, b) {
	    if (a === b) {
	        return true;
	    } else if (Array.isArray(a) && Array.isArray(b)) {
	        if (a.length !== b.length) {
	            return false;
	        }

	        for (var i = 0; i < a.length; i += 1) {
	            if (!equals(a[i], b[i])) {
	                return false;
	            }
	        }

	        return true;
	    } else {
	        return false;
	    }
	}

	// Subroutines are encoded using the negative half of the number space.
	// See type 2 chapter 4.7 "Subroutine operators".
	function calcCFFSubroutineBias(subrs) {
	    var bias;
	    if (subrs.length < 1240) {
	        bias = 107;
	    } else if (subrs.length < 33900) {
	        bias = 1131;
	    } else {
	        bias = 32768;
	    }

	    return bias;
	}

	// Parse a `CFF` INDEX array.
	// An index array consists of a list of offsets, then a list of objects at those offsets.
	function parseCFFIndex(data, start, conversionFn) {
	    var offsets = [];
	    var objects = [];
	    var count = parse.getCard16(data, start);
	    var objectOffset;
	    var endOffset;
	    if (count !== 0) {
	        var offsetSize = parse.getByte(data, start + 2);
	        objectOffset = start + ((count + 1) * offsetSize) + 2;
	        var pos = start + 3;
	        for (var i = 0; i < count + 1; i += 1) {
	            offsets.push(parse.getOffset(data, pos, offsetSize));
	            pos += offsetSize;
	        }

	        // The total size of the index array is 4 header bytes + the value of the last offset.
	        endOffset = objectOffset + offsets[count];
	    } else {
	        endOffset = start + 2;
	    }

	    for (var i$1 = 0; i$1 < offsets.length - 1; i$1 += 1) {
	        var value = parse.getBytes(data, objectOffset + offsets[i$1], objectOffset + offsets[i$1 + 1]);
	        if (conversionFn) {
	            value = conversionFn(value);
	        }

	        objects.push(value);
	    }

	    return {objects: objects, startOffset: start, endOffset: endOffset};
	}

	function parseCFFIndexLowMemory(data, start) {
	    var offsets = [];
	    var count = parse.getCard16(data, start);
	    var objectOffset;
	    var endOffset;
	    if (count !== 0) {
	        var offsetSize = parse.getByte(data, start + 2);
	        objectOffset = start + ((count + 1) * offsetSize) + 2;
	        var pos = start + 3;
	        for (var i = 0; i < count + 1; i += 1) {
	            offsets.push(parse.getOffset(data, pos, offsetSize));
	            pos += offsetSize;
	        }

	        // The total size of the index array is 4 header bytes + the value of the last offset.
	        endOffset = objectOffset + offsets[count];
	    } else {
	        endOffset = start + 2;
	    }

	    return {offsets: offsets, startOffset: start, endOffset: endOffset};
	}
	function getCffIndexObject(i, offsets, data, start, conversionFn) {
	    var count = parse.getCard16(data, start);
	    var objectOffset = 0;
	    if (count !== 0) {
	        var offsetSize = parse.getByte(data, start + 2);
	        objectOffset = start + ((count + 1) * offsetSize) + 2;
	    }

	    var value = parse.getBytes(data, objectOffset + offsets[i], objectOffset + offsets[i + 1]);
	    if (conversionFn) {
	        value = conversionFn(value);
	    }
	    return value;
	}

	// Parse a `CFF` DICT real value.
	function parseFloatOperand(parser) {
	    var s = '';
	    var eof = 15;
	    var lookup = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'E', 'E-', null, '-'];
	    while (true) {
	        var b = parser.parseByte();
	        var n1 = b >> 4;
	        var n2 = b & 15;

	        if (n1 === eof) {
	            break;
	        }

	        s += lookup[n1];

	        if (n2 === eof) {
	            break;
	        }

	        s += lookup[n2];
	    }

	    return parseFloat(s);
	}

	// Parse a `CFF` DICT operand.
	function parseOperand(parser, b0) {
	    var b1;
	    var b2;
	    var b3;
	    var b4;
	    if (b0 === 28) {
	        b1 = parser.parseByte();
	        b2 = parser.parseByte();
	        return b1 << 8 | b2;
	    }

	    if (b0 === 29) {
	        b1 = parser.parseByte();
	        b2 = parser.parseByte();
	        b3 = parser.parseByte();
	        b4 = parser.parseByte();
	        return b1 << 24 | b2 << 16 | b3 << 8 | b4;
	    }

	    if (b0 === 30) {
	        return parseFloatOperand(parser);
	    }

	    if (b0 >= 32 && b0 <= 246) {
	        return b0 - 139;
	    }

	    if (b0 >= 247 && b0 <= 250) {
	        b1 = parser.parseByte();
	        return (b0 - 247) * 256 + b1 + 108;
	    }

	    if (b0 >= 251 && b0 <= 254) {
	        b1 = parser.parseByte();
	        return -(b0 - 251) * 256 - b1 - 108;
	    }

	    throw new Error('Invalid b0 ' + b0);
	}

	// Convert the entries returned by `parseDict` to a proper dictionary.
	// If a value is a list of one, it is unpacked.
	function entriesToObject(entries) {
	    var o = {};
	    for (var i = 0; i < entries.length; i += 1) {
	        var key = entries[i][0];
	        var values = entries[i][1];
	        var value = (void 0);
	        if (values.length === 1) {
	            value = values[0];
	        } else {
	            value = values;
	        }

	        if (o.hasOwnProperty(key) && !isNaN(o[key])) {
	            throw new Error('Object ' + o + ' already has key ' + key);
	        }

	        o[key] = value;
	    }

	    return o;
	}

	// Parse a `CFF` DICT object.
	// A dictionary contains key-value pairs in a compact tokenized format.
	function parseCFFDict(data, start, size) {
	    start = start !== undefined ? start : 0;
	    var parser = new parse.Parser(data, start);
	    var entries = [];
	    var operands = [];
	    size = size !== undefined ? size : data.length;

	    while (parser.relativeOffset < size) {
	        var op = parser.parseByte();

	        // The first byte for each dict item distinguishes between operator (key) and operand (value).
	        // Values <= 21 are operators.
	        if (op <= 21) {
	            // Two-byte operators have an initial escape byte of 12.
	            if (op === 12) {
	                op = 1200 + parser.parseByte();
	            }

	            entries.push([op, operands]);
	            operands = [];
	        } else {
	            // Since the operands (values) come before the operators (keys), we store all operands in a list
	            // until we encounter an operator.
	            operands.push(parseOperand(parser, op));
	        }
	    }

	    return entriesToObject(entries);
	}

	// Given a String Index (SID), return the value of the string.
	// Strings below index 392 are standard CFF strings and are not encoded in the font.
	function getCFFString(strings, index) {
	    if (index <= 390) {
	        index = cffStandardStrings[index];
	    } else {
	        index = strings[index - 391];
	    }

	    return index;
	}

	// Interpret a dictionary and return a new dictionary with readable keys and values for missing entries.
	// This function takes `meta` which is a list of objects containing `operand`, `name` and `default`.
	function interpretDict(dict, meta, strings) {
	    var newDict = {};
	    var value;

	    // Because we also want to include missing values, we start out from the meta list
	    // and lookup values in the dict.
	    for (var i = 0; i < meta.length; i += 1) {
	        var m = meta[i];

	        if (Array.isArray(m.type)) {
	            var values = [];
	            values.length = m.type.length;
	            for (var j = 0; j < m.type.length; j++) {
	                value = dict[m.op] !== undefined ? dict[m.op][j] : undefined;
	                if (value === undefined) {
	                    value = m.value !== undefined && m.value[j] !== undefined ? m.value[j] : null;
	                }
	                if (m.type[j] === 'SID') {
	                    value = getCFFString(strings, value);
	                }
	                values[j] = value;
	            }
	            newDict[m.name] = values;
	        } else {
	            value = dict[m.op];
	            if (value === undefined) {
	                value = m.value !== undefined ? m.value : null;
	            }

	            if (m.type === 'SID') {
	                value = getCFFString(strings, value);
	            }
	            newDict[m.name] = value;
	        }
	    }

	    return newDict;
	}

	// Parse the CFF header.
	function parseCFFHeader(data, start) {
	    var header = {};
	    header.formatMajor = parse.getCard8(data, start);
	    header.formatMinor = parse.getCard8(data, start + 1);
	    header.size = parse.getCard8(data, start + 2);
	    header.offsetSize = parse.getCard8(data, start + 3);
	    header.startOffset = start;
	    header.endOffset = start + 4;
	    return header;
	}

	var TOP_DICT_META = [
	    {name: 'version', op: 0, type: 'SID'},
	    {name: 'notice', op: 1, type: 'SID'},
	    {name: 'copyright', op: 1200, type: 'SID'},
	    {name: 'fullName', op: 2, type: 'SID'},
	    {name: 'familyName', op: 3, type: 'SID'},
	    {name: 'weight', op: 4, type: 'SID'},
	    {name: 'isFixedPitch', op: 1201, type: 'number', value: 0},
	    {name: 'italicAngle', op: 1202, type: 'number', value: 0},
	    {name: 'underlinePosition', op: 1203, type: 'number', value: -100},
	    {name: 'underlineThickness', op: 1204, type: 'number', value: 50},
	    {name: 'paintType', op: 1205, type: 'number', value: 0},
	    {name: 'charstringType', op: 1206, type: 'number', value: 2},
	    {
	        name: 'fontMatrix',
	        op: 1207,
	        type: ['real', 'real', 'real', 'real', 'real', 'real'],
	        value: [0.001, 0, 0, 0.001, 0, 0]
	    },
	    {name: 'uniqueId', op: 13, type: 'number'},
	    {name: 'fontBBox', op: 5, type: ['number', 'number', 'number', 'number'], value: [0, 0, 0, 0]},
	    {name: 'strokeWidth', op: 1208, type: 'number', value: 0},
	    {name: 'xuid', op: 14, type: [], value: null},
	    {name: 'charset', op: 15, type: 'offset', value: 0},
	    {name: 'encoding', op: 16, type: 'offset', value: 0},
	    {name: 'charStrings', op: 17, type: 'offset', value: 0},
	    {name: 'private', op: 18, type: ['number', 'offset'], value: [0, 0]},
	    {name: 'ros', op: 1230, type: ['SID', 'SID', 'number']},
	    {name: 'cidFontVersion', op: 1231, type: 'number', value: 0},
	    {name: 'cidFontRevision', op: 1232, type: 'number', value: 0},
	    {name: 'cidFontType', op: 1233, type: 'number', value: 0},
	    {name: 'cidCount', op: 1234, type: 'number', value: 8720},
	    {name: 'uidBase', op: 1235, type: 'number'},
	    {name: 'fdArray', op: 1236, type: 'offset'},
	    {name: 'fdSelect', op: 1237, type: 'offset'},
	    {name: 'fontName', op: 1238, type: 'SID'}
	];

	var PRIVATE_DICT_META = [
	    {name: 'subrs', op: 19, type: 'offset', value: 0},
	    {name: 'defaultWidthX', op: 20, type: 'number', value: 0},
	    {name: 'nominalWidthX', op: 21, type: 'number', value: 0}
	];

	// Parse the CFF top dictionary. A CFF table can contain multiple fonts, each with their own top dictionary.
	// The top dictionary contains the essential metadata for the font, together with the private dictionary.
	function parseCFFTopDict(data, strings) {
	    var dict = parseCFFDict(data, 0, data.byteLength);
	    return interpretDict(dict, TOP_DICT_META, strings);
	}

	// Parse the CFF private dictionary. We don't fully parse out all the values, only the ones we need.
	function parseCFFPrivateDict(data, start, size, strings) {
	    var dict = parseCFFDict(data, start, size);
	    return interpretDict(dict, PRIVATE_DICT_META, strings);
	}

	// Returns a list of "Top DICT"s found using an INDEX list.
	// Used to read both the usual high-level Top DICTs and also the FDArray
	// discovered inside CID-keyed fonts.  When a Top DICT has a reference to
	// a Private DICT that is read and saved into the Top DICT.
	//
	// In addition to the expected/optional values as outlined in TOP_DICT_META
	// the following values might be saved into the Top DICT.
	//
	//    _subrs []        array of local CFF subroutines from Private DICT
	//    _subrsBias       bias value computed from number of subroutines
	//                      (see calcCFFSubroutineBias() and parseCFFCharstring())
	//    _defaultWidthX   default widths for CFF characters
	//    _nominalWidthX   bias added to width embedded within glyph description
	//
	//    _privateDict     saved copy of parsed Private DICT from Top DICT
	function gatherCFFTopDicts(data, start, cffIndex, strings) {
	    var topDictArray = [];
	    for (var iTopDict = 0; iTopDict < cffIndex.length; iTopDict += 1) {
	        var topDictData = new DataView(new Uint8Array(cffIndex[iTopDict]).buffer);
	        var topDict = parseCFFTopDict(topDictData, strings);
	        topDict._subrs = [];
	        topDict._subrsBias = 0;
	        var privateSize = topDict.private[0];
	        var privateOffset = topDict.private[1];
	        if (privateSize !== 0 && privateOffset !== 0) {
	            var privateDict = parseCFFPrivateDict(data, privateOffset + start, privateSize, strings);
	            topDict._defaultWidthX = privateDict.defaultWidthX;
	            topDict._nominalWidthX = privateDict.nominalWidthX;
	            if (privateDict.subrs !== 0) {
	                var subrOffset = privateOffset + privateDict.subrs;
	                var subrIndex = parseCFFIndex(data, subrOffset + start);
	                topDict._subrs = subrIndex.objects;
	                topDict._subrsBias = calcCFFSubroutineBias(topDict._subrs);
	            }
	            topDict._privateDict = privateDict;
	        }
	        topDictArray.push(topDict);
	    }
	    return topDictArray;
	}

	// Parse the CFF charset table, which contains internal names for all the glyphs.
	// This function will return a list of glyph names.
	// See Adobe TN #5176 chapter 13, "Charsets".
	function parseCFFCharset(data, start, nGlyphs, strings) {
	    var sid;
	    var count;
	    var parser = new parse.Parser(data, start);

	    // The .notdef glyph is not included, so subtract 1.
	    nGlyphs -= 1;
	    var charset = ['.notdef'];

	    var format = parser.parseCard8();
	    if (format === 0) {
	        for (var i = 0; i < nGlyphs; i += 1) {
	            sid = parser.parseSID();
	            charset.push(getCFFString(strings, sid));
	        }
	    } else if (format === 1) {
	        while (charset.length <= nGlyphs) {
	            sid = parser.parseSID();
	            count = parser.parseCard8();
	            for (var i$1 = 0; i$1 <= count; i$1 += 1) {
	                charset.push(getCFFString(strings, sid));
	                sid += 1;
	            }
	        }
	    } else if (format === 2) {
	        while (charset.length <= nGlyphs) {
	            sid = parser.parseSID();
	            count = parser.parseCard16();
	            for (var i$2 = 0; i$2 <= count; i$2 += 1) {
	                charset.push(getCFFString(strings, sid));
	                sid += 1;
	            }
	        }
	    } else {
	        throw new Error('Unknown charset format ' + format);
	    }

	    return charset;
	}

	// Parse the CFF encoding data. Only one encoding can be specified per font.
	// See Adobe TN #5176 chapter 12, "Encodings".
	function parseCFFEncoding(data, start, charset) {
	    var code;
	    var enc = {};
	    var parser = new parse.Parser(data, start);
	    var format = parser.parseCard8();
	    if (format === 0) {
	        var nCodes = parser.parseCard8();
	        for (var i = 0; i < nCodes; i += 1) {
	            code = parser.parseCard8();
	            enc[code] = i;
	        }
	    } else if (format === 1) {
	        var nRanges = parser.parseCard8();
	        code = 1;
	        for (var i$1 = 0; i$1 < nRanges; i$1 += 1) {
	            var first = parser.parseCard8();
	            var nLeft = parser.parseCard8();
	            for (var j = first; j <= first + nLeft; j += 1) {
	                enc[j] = code;
	                code += 1;
	            }
	        }
	    } else {
	        throw new Error('Unknown encoding format ' + format);
	    }

	    return new CffEncoding(enc, charset);
	}

	// Take in charstring code and return a Glyph object.
	// The encoding is described in the Type 2 Charstring Format
	// https://www.microsoft.com/typography/OTSPEC/charstr2.htm
	function parseCFFCharstring(font, glyph, code) {
	    var c1x;
	    var c1y;
	    var c2x;
	    var c2y;
	    var p = new Path();
	    var stack = [];
	    var nStems = 0;
	    var haveWidth = false;
	    var open = false;
	    var x = 0;
	    var y = 0;
	    var subrs;
	    var subrsBias;
	    var defaultWidthX;
	    var nominalWidthX;
	    if (font.isCIDFont) {
	        var fdIndex = font.tables.cff.topDict._fdSelect[glyph.index];
	        var fdDict = font.tables.cff.topDict._fdArray[fdIndex];
	        subrs = fdDict._subrs;
	        subrsBias = fdDict._subrsBias;
	        defaultWidthX = fdDict._defaultWidthX;
	        nominalWidthX = fdDict._nominalWidthX;
	    } else {
	        subrs = font.tables.cff.topDict._subrs;
	        subrsBias = font.tables.cff.topDict._subrsBias;
	        defaultWidthX = font.tables.cff.topDict._defaultWidthX;
	        nominalWidthX = font.tables.cff.topDict._nominalWidthX;
	    }
	    var width = defaultWidthX;

	    function newContour(x, y) {
	        if (open) {
	            p.closePath();
	        }

	        p.moveTo(x, y);
	        open = true;
	    }

	    function parseStems() {
	        var hasWidthArg;

	        // The number of stem operators on the stack is always even.
	        // If the value is uneven, that means a width is specified.
	        hasWidthArg = stack.length % 2 !== 0;
	        if (hasWidthArg && !haveWidth) {
	            width = stack.shift() + nominalWidthX;
	        }

	        nStems += stack.length >> 1;
	        stack.length = 0;
	        haveWidth = true;
	    }

	    function parse$$1(code) {
	        var b1;
	        var b2;
	        var b3;
	        var b4;
	        var codeIndex;
	        var subrCode;
	        var jpx;
	        var jpy;
	        var c3x;
	        var c3y;
	        var c4x;
	        var c4y;

	        var i = 0;
	        while (i < code.length) {
	            var v = code[i];
	            i += 1;
	            switch (v) {
	                case 1: // hstem
	                    parseStems();
	                    break;
	                case 3: // vstem
	                    parseStems();
	                    break;
	                case 4: // vmoveto
	                    if (stack.length > 1 && !haveWidth) {
	                        width = stack.shift() + nominalWidthX;
	                        haveWidth = true;
	                    }

	                    y += stack.pop();
	                    newContour(x, y);
	                    break;
	                case 5: // rlineto
	                    while (stack.length > 0) {
	                        x += stack.shift();
	                        y += stack.shift();
	                        p.lineTo(x, y);
	                    }

	                    break;
	                case 6: // hlineto
	                    while (stack.length > 0) {
	                        x += stack.shift();
	                        p.lineTo(x, y);
	                        if (stack.length === 0) {
	                            break;
	                        }

	                        y += stack.shift();
	                        p.lineTo(x, y);
	                    }

	                    break;
	                case 7: // vlineto
	                    while (stack.length > 0) {
	                        y += stack.shift();
	                        p.lineTo(x, y);
	                        if (stack.length === 0) {
	                            break;
	                        }

	                        x += stack.shift();
	                        p.lineTo(x, y);
	                    }

	                    break;
	                case 8: // rrcurveto
	                    while (stack.length > 0) {
	                        c1x = x + stack.shift();
	                        c1y = y + stack.shift();
	                        c2x = c1x + stack.shift();
	                        c2y = c1y + stack.shift();
	                        x = c2x + stack.shift();
	                        y = c2y + stack.shift();
	                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                    }

	                    break;
	                case 10: // callsubr
	                    codeIndex = stack.pop() + subrsBias;
	                    subrCode = subrs[codeIndex];
	                    if (subrCode) {
	                        parse$$1(subrCode);
	                    }

	                    break;
	                case 11: // return
	                    return;
	                case 12: // flex operators
	                    v = code[i];
	                    i += 1;
	                    switch (v) {
	                        case 35: // flex
	                            // |- dx1 dy1 dx2 dy2 dx3 dy3 dx4 dy4 dx5 dy5 dx6 dy6 fd flex (12 35) |-
	                            c1x = x   + stack.shift();    // dx1
	                            c1y = y   + stack.shift();    // dy1
	                            c2x = c1x + stack.shift();    // dx2
	                            c2y = c1y + stack.shift();    // dy2
	                            jpx = c2x + stack.shift();    // dx3
	                            jpy = c2y + stack.shift();    // dy3
	                            c3x = jpx + stack.shift();    // dx4
	                            c3y = jpy + stack.shift();    // dy4
	                            c4x = c3x + stack.shift();    // dx5
	                            c4y = c3y + stack.shift();    // dy5
	                            x = c4x   + stack.shift();    // dx6
	                            y = c4y   + stack.shift();    // dy6
	                            stack.shift();                // flex depth
	                            p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
	                            p.curveTo(c3x, c3y, c4x, c4y, x, y);
	                            break;
	                        case 34: // hflex
	                            // |- dx1 dx2 dy2 dx3 dx4 dx5 dx6 hflex (12 34) |-
	                            c1x = x   + stack.shift();    // dx1
	                            c1y = y;                      // dy1
	                            c2x = c1x + stack.shift();    // dx2
	                            c2y = c1y + stack.shift();    // dy2
	                            jpx = c2x + stack.shift();    // dx3
	                            jpy = c2y;                    // dy3
	                            c3x = jpx + stack.shift();    // dx4
	                            c3y = c2y;                    // dy4
	                            c4x = c3x + stack.shift();    // dx5
	                            c4y = y;                      // dy5
	                            x = c4x + stack.shift();      // dx6
	                            p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
	                            p.curveTo(c3x, c3y, c4x, c4y, x, y);
	                            break;
	                        case 36: // hflex1
	                            // |- dx1 dy1 dx2 dy2 dx3 dx4 dx5 dy5 dx6 hflex1 (12 36) |-
	                            c1x = x   + stack.shift();    // dx1
	                            c1y = y   + stack.shift();    // dy1
	                            c2x = c1x + stack.shift();    // dx2
	                            c2y = c1y + stack.shift();    // dy2
	                            jpx = c2x + stack.shift();    // dx3
	                            jpy = c2y;                    // dy3
	                            c3x = jpx + stack.shift();    // dx4
	                            c3y = c2y;                    // dy4
	                            c4x = c3x + stack.shift();    // dx5
	                            c4y = c3y + stack.shift();    // dy5
	                            x = c4x + stack.shift();      // dx6
	                            p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
	                            p.curveTo(c3x, c3y, c4x, c4y, x, y);
	                            break;
	                        case 37: // flex1
	                            // |- dx1 dy1 dx2 dy2 dx3 dy3 dx4 dy4 dx5 dy5 d6 flex1 (12 37) |-
	                            c1x = x   + stack.shift();    // dx1
	                            c1y = y   + stack.shift();    // dy1
	                            c2x = c1x + stack.shift();    // dx2
	                            c2y = c1y + stack.shift();    // dy2
	                            jpx = c2x + stack.shift();    // dx3
	                            jpy = c2y + stack.shift();    // dy3
	                            c3x = jpx + stack.shift();    // dx4
	                            c3y = jpy + stack.shift();    // dy4
	                            c4x = c3x + stack.shift();    // dx5
	                            c4y = c3y + stack.shift();    // dy5
	                            if (Math.abs(c4x - x) > Math.abs(c4y - y)) {
	                                x = c4x + stack.shift();
	                            } else {
	                                y = c4y + stack.shift();
	                            }

	                            p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
	                            p.curveTo(c3x, c3y, c4x, c4y, x, y);
	                            break;
	                        default:
	                            console.log('Glyph ' + glyph.index + ': unknown operator ' + 1200 + v);
	                            stack.length = 0;
	                    }
	                    break;
	                case 14: // endchar
	                    if (stack.length > 0 && !haveWidth) {
	                        width = stack.shift() + nominalWidthX;
	                        haveWidth = true;
	                    }

	                    if (open) {
	                        p.closePath();
	                        open = false;
	                    }

	                    break;
	                case 18: // hstemhm
	                    parseStems();
	                    break;
	                case 19: // hintmask
	                case 20: // cntrmask
	                    parseStems();
	                    i += (nStems + 7) >> 3;
	                    break;
	                case 21: // rmoveto
	                    if (stack.length > 2 && !haveWidth) {
	                        width = stack.shift() + nominalWidthX;
	                        haveWidth = true;
	                    }

	                    y += stack.pop();
	                    x += stack.pop();
	                    newContour(x, y);
	                    break;
	                case 22: // hmoveto
	                    if (stack.length > 1 && !haveWidth) {
	                        width = stack.shift() + nominalWidthX;
	                        haveWidth = true;
	                    }

	                    x += stack.pop();
	                    newContour(x, y);
	                    break;
	                case 23: // vstemhm
	                    parseStems();
	                    break;
	                case 24: // rcurveline
	                    while (stack.length > 2) {
	                        c1x = x + stack.shift();
	                        c1y = y + stack.shift();
	                        c2x = c1x + stack.shift();
	                        c2y = c1y + stack.shift();
	                        x = c2x + stack.shift();
	                        y = c2y + stack.shift();
	                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                    }

	                    x += stack.shift();
	                    y += stack.shift();
	                    p.lineTo(x, y);
	                    break;
	                case 25: // rlinecurve
	                    while (stack.length > 6) {
	                        x += stack.shift();
	                        y += stack.shift();
	                        p.lineTo(x, y);
	                    }

	                    c1x = x + stack.shift();
	                    c1y = y + stack.shift();
	                    c2x = c1x + stack.shift();
	                    c2y = c1y + stack.shift();
	                    x = c2x + stack.shift();
	                    y = c2y + stack.shift();
	                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                    break;
	                case 26: // vvcurveto
	                    if (stack.length % 2) {
	                        x += stack.shift();
	                    }

	                    while (stack.length > 0) {
	                        c1x = x;
	                        c1y = y + stack.shift();
	                        c2x = c1x + stack.shift();
	                        c2y = c1y + stack.shift();
	                        x = c2x;
	                        y = c2y + stack.shift();
	                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                    }

	                    break;
	                case 27: // hhcurveto
	                    if (stack.length % 2) {
	                        y += stack.shift();
	                    }

	                    while (stack.length > 0) {
	                        c1x = x + stack.shift();
	                        c1y = y;
	                        c2x = c1x + stack.shift();
	                        c2y = c1y + stack.shift();
	                        x = c2x + stack.shift();
	                        y = c2y;
	                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                    }

	                    break;
	                case 28: // shortint
	                    b1 = code[i];
	                    b2 = code[i + 1];
	                    stack.push(((b1 << 24) | (b2 << 16)) >> 16);
	                    i += 2;
	                    break;
	                case 29: // callgsubr
	                    codeIndex = stack.pop() + font.gsubrsBias;
	                    subrCode = font.gsubrs[codeIndex];
	                    if (subrCode) {
	                        parse$$1(subrCode);
	                    }

	                    break;
	                case 30: // vhcurveto
	                    while (stack.length > 0) {
	                        c1x = x;
	                        c1y = y + stack.shift();
	                        c2x = c1x + stack.shift();
	                        c2y = c1y + stack.shift();
	                        x = c2x + stack.shift();
	                        y = c2y + (stack.length === 1 ? stack.shift() : 0);
	                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                        if (stack.length === 0) {
	                            break;
	                        }

	                        c1x = x + stack.shift();
	                        c1y = y;
	                        c2x = c1x + stack.shift();
	                        c2y = c1y + stack.shift();
	                        y = c2y + stack.shift();
	                        x = c2x + (stack.length === 1 ? stack.shift() : 0);
	                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                    }

	                    break;
	                case 31: // hvcurveto
	                    while (stack.length > 0) {
	                        c1x = x + stack.shift();
	                        c1y = y;
	                        c2x = c1x + stack.shift();
	                        c2y = c1y + stack.shift();
	                        y = c2y + stack.shift();
	                        x = c2x + (stack.length === 1 ? stack.shift() : 0);
	                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                        if (stack.length === 0) {
	                            break;
	                        }

	                        c1x = x;
	                        c1y = y + stack.shift();
	                        c2x = c1x + stack.shift();
	                        c2y = c1y + stack.shift();
	                        x = c2x + stack.shift();
	                        y = c2y + (stack.length === 1 ? stack.shift() : 0);
	                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                    }

	                    break;
	                default:
	                    if (v < 32) {
	                        console.log('Glyph ' + glyph.index + ': unknown operator ' + v);
	                    } else if (v < 247) {
	                        stack.push(v - 139);
	                    } else if (v < 251) {
	                        b1 = code[i];
	                        i += 1;
	                        stack.push((v - 247) * 256 + b1 + 108);
	                    } else if (v < 255) {
	                        b1 = code[i];
	                        i += 1;
	                        stack.push(-(v - 251) * 256 - b1 - 108);
	                    } else {
	                        b1 = code[i];
	                        b2 = code[i + 1];
	                        b3 = code[i + 2];
	                        b4 = code[i + 3];
	                        i += 4;
	                        stack.push(((b1 << 24) | (b2 << 16) | (b3 << 8) | b4) / 65536);
	                    }
	            }
	        }
	    }

	    parse$$1(code);

	    glyph.advanceWidth = width;
	    return p;
	}

	function parseCFFFDSelect(data, start, nGlyphs, fdArrayCount) {
	    var fdSelect = [];
	    var fdIndex;
	    var parser = new parse.Parser(data, start);
	    var format = parser.parseCard8();
	    if (format === 0) {
	        // Simple list of nGlyphs elements
	        for (var iGid = 0; iGid < nGlyphs; iGid++) {
	            fdIndex = parser.parseCard8();
	            if (fdIndex >= fdArrayCount) {
	                throw new Error('CFF table CID Font FDSelect has bad FD index value ' + fdIndex + ' (FD count ' + fdArrayCount + ')');
	            }
	            fdSelect.push(fdIndex);
	        }
	    } else if (format === 3) {
	        // Ranges
	        var nRanges = parser.parseCard16();
	        var first = parser.parseCard16();
	        if (first !== 0) {
	            throw new Error('CFF Table CID Font FDSelect format 3 range has bad initial GID ' + first);
	        }
	        var next;
	        for (var iRange = 0; iRange < nRanges; iRange++) {
	            fdIndex = parser.parseCard8();
	            next = parser.parseCard16();
	            if (fdIndex >= fdArrayCount) {
	                throw new Error('CFF table CID Font FDSelect has bad FD index value ' + fdIndex + ' (FD count ' + fdArrayCount + ')');
	            }
	            if (next > nGlyphs) {
	                throw new Error('CFF Table CID Font FDSelect format 3 range has bad GID ' + next);
	            }
	            for (; first < next; first++) {
	                fdSelect.push(fdIndex);
	            }
	            first = next;
	        }
	        if (next !== nGlyphs) {
	            throw new Error('CFF Table CID Font FDSelect format 3 range has bad final GID ' + next);
	        }
	    } else {
	        throw new Error('CFF Table CID Font FDSelect table has unsupported format ' + format);
	    }
	    return fdSelect;
	}

	// Parse the `CFF` table, which contains the glyph outlines in PostScript format.
	function parseCFFTable(data, start, font, opt) {
	    font.tables.cff = {};
	    var header = parseCFFHeader(data, start);
	    var nameIndex = parseCFFIndex(data, header.endOffset, parse.bytesToString);
	    var topDictIndex = parseCFFIndex(data, nameIndex.endOffset);
	    var stringIndex = parseCFFIndex(data, topDictIndex.endOffset, parse.bytesToString);
	    var globalSubrIndex = parseCFFIndex(data, stringIndex.endOffset);
	    font.gsubrs = globalSubrIndex.objects;
	    font.gsubrsBias = calcCFFSubroutineBias(font.gsubrs);

	    var topDictArray = gatherCFFTopDicts(data, start, topDictIndex.objects, stringIndex.objects);
	    if (topDictArray.length !== 1) {
	        throw new Error('CFF table has too many fonts in \'FontSet\' - count of fonts NameIndex.length = ' + topDictArray.length);
	    }

	    var topDict = topDictArray[0];
	    font.tables.cff.topDict = topDict;

	    if (topDict._privateDict) {
	        font.defaultWidthX = topDict._privateDict.defaultWidthX;
	        font.nominalWidthX = topDict._privateDict.nominalWidthX;
	    }

	    if (topDict.ros[0] !== undefined && topDict.ros[1] !== undefined) {
	        font.isCIDFont = true;
	    }

	    if (font.isCIDFont) {
	        var fdArrayOffset = topDict.fdArray;
	        var fdSelectOffset = topDict.fdSelect;
	        if (fdArrayOffset === 0 || fdSelectOffset === 0) {
	            throw new Error('Font is marked as a CID font, but FDArray and/or FDSelect information is missing');
	        }
	        fdArrayOffset += start;
	        var fdArrayIndex = parseCFFIndex(data, fdArrayOffset);
	        var fdArray = gatherCFFTopDicts(data, start, fdArrayIndex.objects, stringIndex.objects);
	        topDict._fdArray = fdArray;
	        fdSelectOffset += start;
	        topDict._fdSelect = parseCFFFDSelect(data, fdSelectOffset, font.numGlyphs, fdArray.length);
	    }

	    var privateDictOffset = start + topDict.private[1];
	    var privateDict = parseCFFPrivateDict(data, privateDictOffset, topDict.private[0], stringIndex.objects);
	    font.defaultWidthX = privateDict.defaultWidthX;
	    font.nominalWidthX = privateDict.nominalWidthX;

	    if (privateDict.subrs !== 0) {
	        var subrOffset = privateDictOffset + privateDict.subrs;
	        var subrIndex = parseCFFIndex(data, subrOffset);
	        font.subrs = subrIndex.objects;
	        font.subrsBias = calcCFFSubroutineBias(font.subrs);
	    } else {
	        font.subrs = [];
	        font.subrsBias = 0;
	    }

	    // Offsets in the top dict are relative to the beginning of the CFF data, so add the CFF start offset.
	    var charStringsIndex;
	    if (opt.lowMemory) {
	        charStringsIndex = parseCFFIndexLowMemory(data, start + topDict.charStrings);
	        font.nGlyphs = charStringsIndex.offsets.length;
	    } else {
	        charStringsIndex = parseCFFIndex(data, start + topDict.charStrings);
	        font.nGlyphs = charStringsIndex.objects.length;
	    }

	    var charset = parseCFFCharset(data, start + topDict.charset, font.nGlyphs, stringIndex.objects);
	    if (topDict.encoding === 0) {
	        // Standard encoding
	        font.cffEncoding = new CffEncoding(cffStandardEncoding, charset);
	    } else if (topDict.encoding === 1) {
	        // Expert encoding
	        font.cffEncoding = new CffEncoding(cffExpertEncoding, charset);
	    } else {
	        font.cffEncoding = parseCFFEncoding(data, start + topDict.encoding, charset);
	    }

	    // Prefer the CMAP encoding to the CFF encoding.
	    font.encoding = font.encoding || font.cffEncoding;

	    font.glyphs = new glyphset.GlyphSet(font);
	    if (opt.lowMemory) {
	        font._push = function(i) {
	            var charString = getCffIndexObject(i, charStringsIndex.offsets, data, start + topDict.charStrings);
	            font.glyphs.push(i, glyphset.cffGlyphLoader(font, i, parseCFFCharstring, charString));
	        };
	    } else {
	        for (var i = 0; i < font.nGlyphs; i += 1) {
	            var charString = charStringsIndex.objects[i];
	            font.glyphs.push(i, glyphset.cffGlyphLoader(font, i, parseCFFCharstring, charString));
	        }
	    }
	}

	// Convert a string to a String ID (SID).
	// The list of strings is modified in place.
	function encodeString(s, strings) {
	    var sid;

	    // Is the string in the CFF standard strings?
	    var i = cffStandardStrings.indexOf(s);
	    if (i >= 0) {
	        sid = i;
	    }

	    // Is the string already in the string index?
	    i = strings.indexOf(s);
	    if (i >= 0) {
	        sid = i + cffStandardStrings.length;
	    } else {
	        sid = cffStandardStrings.length + strings.length;
	        strings.push(s);
	    }

	    return sid;
	}

	function makeHeader() {
	    return new table.Record('Header', [
	        {name: 'major', type: 'Card8', value: 1},
	        {name: 'minor', type: 'Card8', value: 0},
	        {name: 'hdrSize', type: 'Card8', value: 4},
	        {name: 'major', type: 'Card8', value: 1}
	    ]);
	}

	function makeNameIndex(fontNames) {
	    var t = new table.Record('Name INDEX', [
	        {name: 'names', type: 'INDEX', value: []}
	    ]);
	    t.names = [];
	    for (var i = 0; i < fontNames.length; i += 1) {
	        t.names.push({name: 'name_' + i, type: 'NAME', value: fontNames[i]});
	    }

	    return t;
	}

	// Given a dictionary's metadata, create a DICT structure.
	function makeDict(meta, attrs, strings) {
	    var m = {};
	    for (var i = 0; i < meta.length; i += 1) {
	        var entry = meta[i];
	        var value = attrs[entry.name];
	        if (value !== undefined && !equals(value, entry.value)) {
	            if (entry.type === 'SID') {
	                value = encodeString(value, strings);
	            }

	            m[entry.op] = {name: entry.name, type: entry.type, value: value};
	        }
	    }

	    return m;
	}

	// The Top DICT houses the global font attributes.
	function makeTopDict(attrs, strings) {
	    var t = new table.Record('Top DICT', [
	        {name: 'dict', type: 'DICT', value: {}}
	    ]);
	    t.dict = makeDict(TOP_DICT_META, attrs, strings);
	    return t;
	}

	function makeTopDictIndex(topDict) {
	    var t = new table.Record('Top DICT INDEX', [
	        {name: 'topDicts', type: 'INDEX', value: []}
	    ]);
	    t.topDicts = [{name: 'topDict_0', type: 'TABLE', value: topDict}];
	    return t;
	}

	function makeStringIndex(strings) {
	    var t = new table.Record('String INDEX', [
	        {name: 'strings', type: 'INDEX', value: []}
	    ]);
	    t.strings = [];
	    for (var i = 0; i < strings.length; i += 1) {
	        t.strings.push({name: 'string_' + i, type: 'STRING', value: strings[i]});
	    }

	    return t;
	}

	function makeGlobalSubrIndex() {
	    // Currently we don't use subroutines.
	    return new table.Record('Global Subr INDEX', [
	        {name: 'subrs', type: 'INDEX', value: []}
	    ]);
	}

	function makeCharsets(glyphNames, strings) {
	    var t = new table.Record('Charsets', [
	        {name: 'format', type: 'Card8', value: 0}
	    ]);
	    for (var i = 0; i < glyphNames.length; i += 1) {
	        var glyphName = glyphNames[i];
	        var glyphSID = encodeString(glyphName, strings);
	        t.fields.push({name: 'glyph_' + i, type: 'SID', value: glyphSID});
	    }

	    return t;
	}

	function glyphToOps(glyph) {
	    var ops = [];
	    var path = glyph.path;
	    ops.push({name: 'width', type: 'NUMBER', value: glyph.advanceWidth});
	    var x = 0;
	    var y = 0;
	    for (var i = 0; i < path.commands.length; i += 1) {
	        var dx = (void 0);
	        var dy = (void 0);
	        var cmd = path.commands[i];
	        if (cmd.type === 'Q') {
	            // CFF only supports bézier curves, so convert the quad to a bézier.
	            var _13 = 1 / 3;
	            var _23 = 2 / 3;

	            // We're going to create a new command so we don't change the original path.
	            cmd = {
	                type: 'C',
	                x: cmd.x,
	                y: cmd.y,
	                x1: _13 * x + _23 * cmd.x1,
	                y1: _13 * y + _23 * cmd.y1,
	                x2: _13 * cmd.x + _23 * cmd.x1,
	                y2: _13 * cmd.y + _23 * cmd.y1
	            };
	        }

	        if (cmd.type === 'M') {
	            dx = Math.round(cmd.x - x);
	            dy = Math.round(cmd.y - y);
	            ops.push({name: 'dx', type: 'NUMBER', value: dx});
	            ops.push({name: 'dy', type: 'NUMBER', value: dy});
	            ops.push({name: 'rmoveto', type: 'OP', value: 21});
	            x = Math.round(cmd.x);
	            y = Math.round(cmd.y);
	        } else if (cmd.type === 'L') {
	            dx = Math.round(cmd.x - x);
	            dy = Math.round(cmd.y - y);
	            ops.push({name: 'dx', type: 'NUMBER', value: dx});
	            ops.push({name: 'dy', type: 'NUMBER', value: dy});
	            ops.push({name: 'rlineto', type: 'OP', value: 5});
	            x = Math.round(cmd.x);
	            y = Math.round(cmd.y);
	        } else if (cmd.type === 'C') {
	            var dx1 = Math.round(cmd.x1 - x);
	            var dy1 = Math.round(cmd.y1 - y);
	            var dx2 = Math.round(cmd.x2 - cmd.x1);
	            var dy2 = Math.round(cmd.y2 - cmd.y1);
	            dx = Math.round(cmd.x - cmd.x2);
	            dy = Math.round(cmd.y - cmd.y2);
	            ops.push({name: 'dx1', type: 'NUMBER', value: dx1});
	            ops.push({name: 'dy1', type: 'NUMBER', value: dy1});
	            ops.push({name: 'dx2', type: 'NUMBER', value: dx2});
	            ops.push({name: 'dy2', type: 'NUMBER', value: dy2});
	            ops.push({name: 'dx', type: 'NUMBER', value: dx});
	            ops.push({name: 'dy', type: 'NUMBER', value: dy});
	            ops.push({name: 'rrcurveto', type: 'OP', value: 8});
	            x = Math.round(cmd.x);
	            y = Math.round(cmd.y);
	        }

	        // Contours are closed automatically.
	    }

	    ops.push({name: 'endchar', type: 'OP', value: 14});
	    return ops;
	}

	function makeCharStringsIndex(glyphs) {
	    var t = new table.Record('CharStrings INDEX', [
	        {name: 'charStrings', type: 'INDEX', value: []}
	    ]);

	    for (var i = 0; i < glyphs.length; i += 1) {
	        var glyph = glyphs.get(i);
	        var ops = glyphToOps(glyph);
	        t.charStrings.push({name: glyph.name, type: 'CHARSTRING', value: ops});
	    }

	    return t;
	}

	function makePrivateDict(attrs, strings) {
	    var t = new table.Record('Private DICT', [
	        {name: 'dict', type: 'DICT', value: {}}
	    ]);
	    t.dict = makeDict(PRIVATE_DICT_META, attrs, strings);
	    return t;
	}

	function makeCFFTable(glyphs, options) {
	    var t = new table.Table('CFF ', [
	        {name: 'header', type: 'RECORD'},
	        {name: 'nameIndex', type: 'RECORD'},
	        {name: 'topDictIndex', type: 'RECORD'},
	        {name: 'stringIndex', type: 'RECORD'},
	        {name: 'globalSubrIndex', type: 'RECORD'},
	        {name: 'charsets', type: 'RECORD'},
	        {name: 'charStringsIndex', type: 'RECORD'},
	        {name: 'privateDict', type: 'RECORD'}
	    ]);

	    var fontScale = 1 / options.unitsPerEm;
	    // We use non-zero values for the offsets so that the DICT encodes them.
	    // This is important because the size of the Top DICT plays a role in offset calculation,
	    // and the size shouldn't change after we've written correct offsets.
	    var attrs = {
	        version: options.version,
	        fullName: options.fullName,
	        familyName: options.familyName,
	        weight: options.weightName,
	        fontBBox: options.fontBBox || [0, 0, 0, 0],
	        fontMatrix: [fontScale, 0, 0, fontScale, 0, 0],
	        charset: 999,
	        encoding: 0,
	        charStrings: 999,
	        private: [0, 999]
	    };

	    var privateAttrs = {};

	    var glyphNames = [];
	    var glyph;

	    // Skip first glyph (.notdef)
	    for (var i = 1; i < glyphs.length; i += 1) {
	        glyph = glyphs.get(i);
	        glyphNames.push(glyph.name);
	    }

	    var strings = [];

	    t.header = makeHeader();
	    t.nameIndex = makeNameIndex([options.postScriptName]);
	    var topDict = makeTopDict(attrs, strings);
	    t.topDictIndex = makeTopDictIndex(topDict);
	    t.globalSubrIndex = makeGlobalSubrIndex();
	    t.charsets = makeCharsets(glyphNames, strings);
	    t.charStringsIndex = makeCharStringsIndex(glyphs);
	    t.privateDict = makePrivateDict(privateAttrs, strings);

	    // Needs to come at the end, to encode all custom strings used in the font.
	    t.stringIndex = makeStringIndex(strings);

	    var startOffset = t.header.sizeOf() +
	        t.nameIndex.sizeOf() +
	        t.topDictIndex.sizeOf() +
	        t.stringIndex.sizeOf() +
	        t.globalSubrIndex.sizeOf();
	    attrs.charset = startOffset;

	    // We use the CFF standard encoding; proper encoding will be handled in cmap.
	    attrs.encoding = 0;
	    attrs.charStrings = attrs.charset + t.charsets.sizeOf();
	    attrs.private[1] = attrs.charStrings + t.charStringsIndex.sizeOf();

	    // Recreate the Top DICT INDEX with the correct offsets.
	    topDict = makeTopDict(attrs, strings);
	    t.topDictIndex = makeTopDictIndex(topDict);

	    return t;
	}

	var cff = { parse: parseCFFTable, make: makeCFFTable };

	// The `head` table contains global information about the font.

	// Parse the header `head` table
	function parseHeadTable(data, start) {
	    var head = {};
	    var p = new parse.Parser(data, start);
	    head.version = p.parseVersion();
	    head.fontRevision = Math.round(p.parseFixed() * 1000) / 1000;
	    head.checkSumAdjustment = p.parseULong();
	    head.magicNumber = p.parseULong();
	    check.argument(head.magicNumber === 0x5F0F3CF5, 'Font header has wrong magic number.');
	    head.flags = p.parseUShort();
	    head.unitsPerEm = p.parseUShort();
	    head.created = p.parseLongDateTime();
	    head.modified = p.parseLongDateTime();
	    head.xMin = p.parseShort();
	    head.yMin = p.parseShort();
	    head.xMax = p.parseShort();
	    head.yMax = p.parseShort();
	    head.macStyle = p.parseUShort();
	    head.lowestRecPPEM = p.parseUShort();
	    head.fontDirectionHint = p.parseShort();
	    head.indexToLocFormat = p.parseShort();
	    head.glyphDataFormat = p.parseShort();
	    return head;
	}

	function makeHeadTable(options) {
	    // Apple Mac timestamp epoch is 01/01/1904 not 01/01/1970
	    var timestamp = Math.round(new Date().getTime() / 1000) + 2082844800;
	    var createdTimestamp = timestamp;

	    if (options.createdTimestamp) {
	        createdTimestamp = options.createdTimestamp + 2082844800;
	    }

	    return new table.Table('head', [
	        {name: 'version', type: 'FIXED', value: 0x00010000},
	        {name: 'fontRevision', type: 'FIXED', value: 0x00010000},
	        {name: 'checkSumAdjustment', type: 'ULONG', value: 0},
	        {name: 'magicNumber', type: 'ULONG', value: 0x5F0F3CF5},
	        {name: 'flags', type: 'USHORT', value: 0},
	        {name: 'unitsPerEm', type: 'USHORT', value: 1000},
	        {name: 'created', type: 'LONGDATETIME', value: createdTimestamp},
	        {name: 'modified', type: 'LONGDATETIME', value: timestamp},
	        {name: 'xMin', type: 'SHORT', value: 0},
	        {name: 'yMin', type: 'SHORT', value: 0},
	        {name: 'xMax', type: 'SHORT', value: 0},
	        {name: 'yMax', type: 'SHORT', value: 0},
	        {name: 'macStyle', type: 'USHORT', value: 0},
	        {name: 'lowestRecPPEM', type: 'USHORT', value: 0},
	        {name: 'fontDirectionHint', type: 'SHORT', value: 2},
	        {name: 'indexToLocFormat', type: 'SHORT', value: 0},
	        {name: 'glyphDataFormat', type: 'SHORT', value: 0}
	    ], options);
	}

	var head = { parse: parseHeadTable, make: makeHeadTable };

	// The `hhea` table contains information for horizontal layout.

	// Parse the horizontal header `hhea` table
	function parseHheaTable(data, start) {
	    var hhea = {};
	    var p = new parse.Parser(data, start);
	    hhea.version = p.parseVersion();
	    hhea.ascender = p.parseShort();
	    hhea.descender = p.parseShort();
	    hhea.lineGap = p.parseShort();
	    hhea.advanceWidthMax = p.parseUShort();
	    hhea.minLeftSideBearing = p.parseShort();
	    hhea.minRightSideBearing = p.parseShort();
	    hhea.xMaxExtent = p.parseShort();
	    hhea.caretSlopeRise = p.parseShort();
	    hhea.caretSlopeRun = p.parseShort();
	    hhea.caretOffset = p.parseShort();
	    p.relativeOffset += 8;
	    hhea.metricDataFormat = p.parseShort();
	    hhea.numberOfHMetrics = p.parseUShort();
	    return hhea;
	}

	function makeHheaTable(options) {
	    return new table.Table('hhea', [
	        {name: 'version', type: 'FIXED', value: 0x00010000},
	        {name: 'ascender', type: 'FWORD', value: 0},
	        {name: 'descender', type: 'FWORD', value: 0},
	        {name: 'lineGap', type: 'FWORD', value: 0},
	        {name: 'advanceWidthMax', type: 'UFWORD', value: 0},
	        {name: 'minLeftSideBearing', type: 'FWORD', value: 0},
	        {name: 'minRightSideBearing', type: 'FWORD', value: 0},
	        {name: 'xMaxExtent', type: 'FWORD', value: 0},
	        {name: 'caretSlopeRise', type: 'SHORT', value: 1},
	        {name: 'caretSlopeRun', type: 'SHORT', value: 0},
	        {name: 'caretOffset', type: 'SHORT', value: 0},
	        {name: 'reserved1', type: 'SHORT', value: 0},
	        {name: 'reserved2', type: 'SHORT', value: 0},
	        {name: 'reserved3', type: 'SHORT', value: 0},
	        {name: 'reserved4', type: 'SHORT', value: 0},
	        {name: 'metricDataFormat', type: 'SHORT', value: 0},
	        {name: 'numberOfHMetrics', type: 'USHORT', value: 0}
	    ], options);
	}

	var hhea = { parse: parseHheaTable, make: makeHheaTable };

	// The `hmtx` table contains the horizontal metrics for all glyphs.

	function parseHmtxTableAll(data, start, numMetrics, numGlyphs, glyphs) {
	    var advanceWidth;
	    var leftSideBearing;
	    var p = new parse.Parser(data, start);
	    for (var i = 0; i < numGlyphs; i += 1) {
	        // If the font is monospaced, only one entry is needed. This last entry applies to all subsequent glyphs.
	        if (i < numMetrics) {
	            advanceWidth = p.parseUShort();
	            leftSideBearing = p.parseShort();
	        }

	        var glyph = glyphs.get(i);
	        glyph.advanceWidth = advanceWidth;
	        glyph.leftSideBearing = leftSideBearing;
	    }
	}

	function parseHmtxTableOnLowMemory(font, data, start, numMetrics, numGlyphs) {
	    font._hmtxTableData = {};

	    var advanceWidth;
	    var leftSideBearing;
	    var p = new parse.Parser(data, start);
	    for (var i = 0; i < numGlyphs; i += 1) {
	        // If the font is monospaced, only one entry is needed. This last entry applies to all subsequent glyphs.
	        if (i < numMetrics) {
	            advanceWidth = p.parseUShort();
	            leftSideBearing = p.parseShort();
	        }

	        font._hmtxTableData[i] = {
	            advanceWidth: advanceWidth,
	            leftSideBearing: leftSideBearing
	        };
	    }
	}

	// Parse the `hmtx` table, which contains the horizontal metrics for all glyphs.
	// This function augments the glyph array, adding the advanceWidth and leftSideBearing to each glyph.
	function parseHmtxTable(font, data, start, numMetrics, numGlyphs, glyphs, opt) {
	    if (opt.lowMemory)
	        { parseHmtxTableOnLowMemory(font, data, start, numMetrics, numGlyphs); }
	    else
	        { parseHmtxTableAll(data, start, numMetrics, numGlyphs, glyphs); }
	}

	function makeHmtxTable(glyphs) {
	    var t = new table.Table('hmtx', []);
	    for (var i = 0; i < glyphs.length; i += 1) {
	        var glyph = glyphs.get(i);
	        var advanceWidth = glyph.advanceWidth || 0;
	        var leftSideBearing = glyph.leftSideBearing || 0;
	        t.fields.push({name: 'advanceWidth_' + i, type: 'USHORT', value: advanceWidth});
	        t.fields.push({name: 'leftSideBearing_' + i, type: 'SHORT', value: leftSideBearing});
	    }

	    return t;
	}

	var hmtx = { parse: parseHmtxTable, make: makeHmtxTable };

	// The `ltag` table stores IETF BCP-47 language tags. It allows supporting

	function makeLtagTable(tags) {
	    var result = new table.Table('ltag', [
	        {name: 'version', type: 'ULONG', value: 1},
	        {name: 'flags', type: 'ULONG', value: 0},
	        {name: 'numTags', type: 'ULONG', value: tags.length}
	    ]);

	    var stringPool = '';
	    var stringPoolOffset = 12 + tags.length * 4;
	    for (var i = 0; i < tags.length; ++i) {
	        var pos = stringPool.indexOf(tags[i]);
	        if (pos < 0) {
	            pos = stringPool.length;
	            stringPool += tags[i];
	        }

	        result.fields.push({name: 'offset ' + i, type: 'USHORT', value: stringPoolOffset + pos});
	        result.fields.push({name: 'length ' + i, type: 'USHORT', value: tags[i].length});
	    }

	    result.fields.push({name: 'stringPool', type: 'CHARARRAY', value: stringPool});
	    return result;
	}

	function parseLtagTable(data, start) {
	    var p = new parse.Parser(data, start);
	    var tableVersion = p.parseULong();
	    check.argument(tableVersion === 1, 'Unsupported ltag table version.');
	    // The 'ltag' specification does not define any flags; skip the field.
	    p.skip('uLong', 1);
	    var numTags = p.parseULong();

	    var tags = [];
	    for (var i = 0; i < numTags; i++) {
	        var tag = '';
	        var offset = start + p.parseUShort();
	        var length = p.parseUShort();
	        for (var j = offset; j < offset + length; ++j) {
	            tag += String.fromCharCode(data.getInt8(j));
	        }

	        tags.push(tag);
	    }

	    return tags;
	}

	var ltag = { make: makeLtagTable, parse: parseLtagTable };

	// The `maxp` table establishes the memory requirements for the font.

	// Parse the maximum profile `maxp` table.
	function parseMaxpTable(data, start) {
	    var maxp = {};
	    var p = new parse.Parser(data, start);
	    maxp.version = p.parseVersion();
	    maxp.numGlyphs = p.parseUShort();
	    if (maxp.version === 1.0) {
	        maxp.maxPoints = p.parseUShort();
	        maxp.maxContours = p.parseUShort();
	        maxp.maxCompositePoints = p.parseUShort();
	        maxp.maxCompositeContours = p.parseUShort();
	        maxp.maxZones = p.parseUShort();
	        maxp.maxTwilightPoints = p.parseUShort();
	        maxp.maxStorage = p.parseUShort();
	        maxp.maxFunctionDefs = p.parseUShort();
	        maxp.maxInstructionDefs = p.parseUShort();
	        maxp.maxStackElements = p.parseUShort();
	        maxp.maxSizeOfInstructions = p.parseUShort();
	        maxp.maxComponentElements = p.parseUShort();
	        maxp.maxComponentDepth = p.parseUShort();
	    }

	    return maxp;
	}

	function makeMaxpTable(numGlyphs) {
	    return new table.Table('maxp', [
	        {name: 'version', type: 'FIXED', value: 0x00005000},
	        {name: 'numGlyphs', type: 'USHORT', value: numGlyphs}
	    ]);
	}

	var maxp = { parse: parseMaxpTable, make: makeMaxpTable };

	// The `name` naming table.

	// NameIDs for the name table.
	var nameTableNames = [
	    'copyright',              // 0
	    'fontFamily',             // 1
	    'fontSubfamily',          // 2
	    'uniqueID',               // 3
	    'fullName',               // 4
	    'version',                // 5
	    'postScriptName',         // 6
	    'trademark',              // 7
	    'manufacturer',           // 8
	    'designer',               // 9
	    'description',            // 10
	    'manufacturerURL',        // 11
	    'designerURL',            // 12
	    'license',                // 13
	    'licenseURL',             // 14
	    'reserved',               // 15
	    'preferredFamily',        // 16
	    'preferredSubfamily',     // 17
	    'compatibleFullName',     // 18
	    'sampleText',             // 19
	    'postScriptFindFontName', // 20
	    'wwsFamily',              // 21
	    'wwsSubfamily'            // 22
	];

	var macLanguages = {
	    0: 'en',
	    1: 'fr',
	    2: 'de',
	    3: 'it',
	    4: 'nl',
	    5: 'sv',
	    6: 'es',
	    7: 'da',
	    8: 'pt',
	    9: 'no',
	    10: 'he',
	    11: 'ja',
	    12: 'ar',
	    13: 'fi',
	    14: 'el',
	    15: 'is',
	    16: 'mt',
	    17: 'tr',
	    18: 'hr',
	    19: 'zh-Hant',
	    20: 'ur',
	    21: 'hi',
	    22: 'th',
	    23: 'ko',
	    24: 'lt',
	    25: 'pl',
	    26: 'hu',
	    27: 'es',
	    28: 'lv',
	    29: 'se',
	    30: 'fo',
	    31: 'fa',
	    32: 'ru',
	    33: 'zh',
	    34: 'nl-BE',
	    35: 'ga',
	    36: 'sq',
	    37: 'ro',
	    38: 'cz',
	    39: 'sk',
	    40: 'si',
	    41: 'yi',
	    42: 'sr',
	    43: 'mk',
	    44: 'bg',
	    45: 'uk',
	    46: 'be',
	    47: 'uz',
	    48: 'kk',
	    49: 'az-Cyrl',
	    50: 'az-Arab',
	    51: 'hy',
	    52: 'ka',
	    53: 'mo',
	    54: 'ky',
	    55: 'tg',
	    56: 'tk',
	    57: 'mn-CN',
	    58: 'mn',
	    59: 'ps',
	    60: 'ks',
	    61: 'ku',
	    62: 'sd',
	    63: 'bo',
	    64: 'ne',
	    65: 'sa',
	    66: 'mr',
	    67: 'bn',
	    68: 'as',
	    69: 'gu',
	    70: 'pa',
	    71: 'or',
	    72: 'ml',
	    73: 'kn',
	    74: 'ta',
	    75: 'te',
	    76: 'si',
	    77: 'my',
	    78: 'km',
	    79: 'lo',
	    80: 'vi',
	    81: 'id',
	    82: 'tl',
	    83: 'ms',
	    84: 'ms-Arab',
	    85: 'am',
	    86: 'ti',
	    87: 'om',
	    88: 'so',
	    89: 'sw',
	    90: 'rw',
	    91: 'rn',
	    92: 'ny',
	    93: 'mg',
	    94: 'eo',
	    128: 'cy',
	    129: 'eu',
	    130: 'ca',
	    131: 'la',
	    132: 'qu',
	    133: 'gn',
	    134: 'ay',
	    135: 'tt',
	    136: 'ug',
	    137: 'dz',
	    138: 'jv',
	    139: 'su',
	    140: 'gl',
	    141: 'af',
	    142: 'br',
	    143: 'iu',
	    144: 'gd',
	    145: 'gv',
	    146: 'ga',
	    147: 'to',
	    148: 'el-polyton',
	    149: 'kl',
	    150: 'az',
	    151: 'nn'
	};

	// MacOS language ID → MacOS script ID
	//
	// Note that the script ID is not sufficient to determine what encoding
	// to use in TrueType files. For some languages, MacOS used a modification
	// of a mainstream script. For example, an Icelandic name would be stored
	// with smRoman in the TrueType naming table, but the actual encoding
	// is a special Icelandic version of the normal Macintosh Roman encoding.
	// As another example, Inuktitut uses an 8-bit encoding for Canadian Aboriginal
	// Syllables but MacOS had run out of available script codes, so this was
	// done as a (pretty radical) "modification" of Ethiopic.
	//
	// http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
	var macLanguageToScript = {
	    0: 0,  // langEnglish → smRoman
	    1: 0,  // langFrench → smRoman
	    2: 0,  // langGerman → smRoman
	    3: 0,  // langItalian → smRoman
	    4: 0,  // langDutch → smRoman
	    5: 0,  // langSwedish → smRoman
	    6: 0,  // langSpanish → smRoman
	    7: 0,  // langDanish → smRoman
	    8: 0,  // langPortuguese → smRoman
	    9: 0,  // langNorwegian → smRoman
	    10: 5,  // langHebrew → smHebrew
	    11: 1,  // langJapanese → smJapanese
	    12: 4,  // langArabic → smArabic
	    13: 0,  // langFinnish → smRoman
	    14: 6,  // langGreek → smGreek
	    15: 0,  // langIcelandic → smRoman (modified)
	    16: 0,  // langMaltese → smRoman
	    17: 0,  // langTurkish → smRoman (modified)
	    18: 0,  // langCroatian → smRoman (modified)
	    19: 2,  // langTradChinese → smTradChinese
	    20: 4,  // langUrdu → smArabic
	    21: 9,  // langHindi → smDevanagari
	    22: 21,  // langThai → smThai
	    23: 3,  // langKorean → smKorean
	    24: 29,  // langLithuanian → smCentralEuroRoman
	    25: 29,  // langPolish → smCentralEuroRoman
	    26: 29,  // langHungarian → smCentralEuroRoman
	    27: 29,  // langEstonian → smCentralEuroRoman
	    28: 29,  // langLatvian → smCentralEuroRoman
	    29: 0,  // langSami → smRoman
	    30: 0,  // langFaroese → smRoman (modified)
	    31: 4,  // langFarsi → smArabic (modified)
	    32: 7,  // langRussian → smCyrillic
	    33: 25,  // langSimpChinese → smSimpChinese
	    34: 0,  // langFlemish → smRoman
	    35: 0,  // langIrishGaelic → smRoman (modified)
	    36: 0,  // langAlbanian → smRoman
	    37: 0,  // langRomanian → smRoman (modified)
	    38: 29,  // langCzech → smCentralEuroRoman
	    39: 29,  // langSlovak → smCentralEuroRoman
	    40: 0,  // langSlovenian → smRoman (modified)
	    41: 5,  // langYiddish → smHebrew
	    42: 7,  // langSerbian → smCyrillic
	    43: 7,  // langMacedonian → smCyrillic
	    44: 7,  // langBulgarian → smCyrillic
	    45: 7,  // langUkrainian → smCyrillic (modified)
	    46: 7,  // langByelorussian → smCyrillic
	    47: 7,  // langUzbek → smCyrillic
	    48: 7,  // langKazakh → smCyrillic
	    49: 7,  // langAzerbaijani → smCyrillic
	    50: 4,  // langAzerbaijanAr → smArabic
	    51: 24,  // langArmenian → smArmenian
	    52: 23,  // langGeorgian → smGeorgian
	    53: 7,  // langMoldavian → smCyrillic
	    54: 7,  // langKirghiz → smCyrillic
	    55: 7,  // langTajiki → smCyrillic
	    56: 7,  // langTurkmen → smCyrillic
	    57: 27,  // langMongolian → smMongolian
	    58: 7,  // langMongolianCyr → smCyrillic
	    59: 4,  // langPashto → smArabic
	    60: 4,  // langKurdish → smArabic
	    61: 4,  // langKashmiri → smArabic
	    62: 4,  // langSindhi → smArabic
	    63: 26,  // langTibetan → smTibetan
	    64: 9,  // langNepali → smDevanagari
	    65: 9,  // langSanskrit → smDevanagari
	    66: 9,  // langMarathi → smDevanagari
	    67: 13,  // langBengali → smBengali
	    68: 13,  // langAssamese → smBengali
	    69: 11,  // langGujarati → smGujarati
	    70: 10,  // langPunjabi → smGurmukhi
	    71: 12,  // langOriya → smOriya
	    72: 17,  // langMalayalam → smMalayalam
	    73: 16,  // langKannada → smKannada
	    74: 14,  // langTamil → smTamil
	    75: 15,  // langTelugu → smTelugu
	    76: 18,  // langSinhalese → smSinhalese
	    77: 19,  // langBurmese → smBurmese
	    78: 20,  // langKhmer → smKhmer
	    79: 22,  // langLao → smLao
	    80: 30,  // langVietnamese → smVietnamese
	    81: 0,  // langIndonesian → smRoman
	    82: 0,  // langTagalog → smRoman
	    83: 0,  // langMalayRoman → smRoman
	    84: 4,  // langMalayArabic → smArabic
	    85: 28,  // langAmharic → smEthiopic
	    86: 28,  // langTigrinya → smEthiopic
	    87: 28,  // langOromo → smEthiopic
	    88: 0,  // langSomali → smRoman
	    89: 0,  // langSwahili → smRoman
	    90: 0,  // langKinyarwanda → smRoman
	    91: 0,  // langRundi → smRoman
	    92: 0,  // langNyanja → smRoman
	    93: 0,  // langMalagasy → smRoman
	    94: 0,  // langEsperanto → smRoman
	    128: 0,  // langWelsh → smRoman (modified)
	    129: 0,  // langBasque → smRoman
	    130: 0,  // langCatalan → smRoman
	    131: 0,  // langLatin → smRoman
	    132: 0,  // langQuechua → smRoman
	    133: 0,  // langGuarani → smRoman
	    134: 0,  // langAymara → smRoman
	    135: 7,  // langTatar → smCyrillic
	    136: 4,  // langUighur → smArabic
	    137: 26,  // langDzongkha → smTibetan
	    138: 0,  // langJavaneseRom → smRoman
	    139: 0,  // langSundaneseRom → smRoman
	    140: 0,  // langGalician → smRoman
	    141: 0,  // langAfrikaans → smRoman
	    142: 0,  // langBreton → smRoman (modified)
	    143: 28,  // langInuktitut → smEthiopic (modified)
	    144: 0,  // langScottishGaelic → smRoman (modified)
	    145: 0,  // langManxGaelic → smRoman (modified)
	    146: 0,  // langIrishGaelicScript → smRoman (modified)
	    147: 0,  // langTongan → smRoman
	    148: 6,  // langGreekAncient → smRoman
	    149: 0,  // langGreenlandic → smRoman
	    150: 0,  // langAzerbaijanRoman → smRoman
	    151: 0   // langNynorsk → smRoman
	};

	// While Microsoft indicates a region/country for all its language
	// IDs, we omit the region code if it's equal to the "most likely
	// region subtag" according to Unicode CLDR. For scripts, we omit
	// the subtag if it is equal to the Suppress-Script entry in the
	// IANA language subtag registry for IETF BCP 47.
	//
	// For example, Microsoft states that its language code 0x041A is
	// Croatian in Croatia. We transform this to the BCP 47 language code 'hr'
	// and not 'hr-HR' because Croatia is the default country for Croatian,
	// according to Unicode CLDR. As another example, Microsoft states
	// that 0x101A is Croatian (Latin) in Bosnia-Herzegovina. We transform
	// this to 'hr-BA' and not 'hr-Latn-BA' because Latin is the default script
	// for the Croatian language, according to IANA.
	//
	// http://www.unicode.org/cldr/charts/latest/supplemental/likely_subtags.html
	// http://www.iana.org/assignments/language-subtag-registry/language-subtag-registry
	var windowsLanguages = {
	    0x0436: 'af',
	    0x041C: 'sq',
	    0x0484: 'gsw',
	    0x045E: 'am',
	    0x1401: 'ar-DZ',
	    0x3C01: 'ar-BH',
	    0x0C01: 'ar',
	    0x0801: 'ar-IQ',
	    0x2C01: 'ar-JO',
	    0x3401: 'ar-KW',
	    0x3001: 'ar-LB',
	    0x1001: 'ar-LY',
	    0x1801: 'ary',
	    0x2001: 'ar-OM',
	    0x4001: 'ar-QA',
	    0x0401: 'ar-SA',
	    0x2801: 'ar-SY',
	    0x1C01: 'aeb',
	    0x3801: 'ar-AE',
	    0x2401: 'ar-YE',
	    0x042B: 'hy',
	    0x044D: 'as',
	    0x082C: 'az-Cyrl',
	    0x042C: 'az',
	    0x046D: 'ba',
	    0x042D: 'eu',
	    0x0423: 'be',
	    0x0845: 'bn',
	    0x0445: 'bn-IN',
	    0x201A: 'bs-Cyrl',
	    0x141A: 'bs',
	    0x047E: 'br',
	    0x0402: 'bg',
	    0x0403: 'ca',
	    0x0C04: 'zh-HK',
	    0x1404: 'zh-MO',
	    0x0804: 'zh',
	    0x1004: 'zh-SG',
	    0x0404: 'zh-TW',
	    0x0483: 'co',
	    0x041A: 'hr',
	    0x101A: 'hr-BA',
	    0x0405: 'cs',
	    0x0406: 'da',
	    0x048C: 'prs',
	    0x0465: 'dv',
	    0x0813: 'nl-BE',
	    0x0413: 'nl',
	    0x0C09: 'en-AU',
	    0x2809: 'en-BZ',
	    0x1009: 'en-CA',
	    0x2409: 'en-029',
	    0x4009: 'en-IN',
	    0x1809: 'en-IE',
	    0x2009: 'en-JM',
	    0x4409: 'en-MY',
	    0x1409: 'en-NZ',
	    0x3409: 'en-PH',
	    0x4809: 'en-SG',
	    0x1C09: 'en-ZA',
	    0x2C09: 'en-TT',
	    0x0809: 'en-GB',
	    0x0409: 'en',
	    0x3009: 'en-ZW',
	    0x0425: 'et',
	    0x0438: 'fo',
	    0x0464: 'fil',
	    0x040B: 'fi',
	    0x080C: 'fr-BE',
	    0x0C0C: 'fr-CA',
	    0x040C: 'fr',
	    0x140C: 'fr-LU',
	    0x180C: 'fr-MC',
	    0x100C: 'fr-CH',
	    0x0462: 'fy',
	    0x0456: 'gl',
	    0x0437: 'ka',
	    0x0C07: 'de-AT',
	    0x0407: 'de',
	    0x1407: 'de-LI',
	    0x1007: 'de-LU',
	    0x0807: 'de-CH',
	    0x0408: 'el',
	    0x046F: 'kl',
	    0x0447: 'gu',
	    0x0468: 'ha',
	    0x040D: 'he',
	    0x0439: 'hi',
	    0x040E: 'hu',
	    0x040F: 'is',
	    0x0470: 'ig',
	    0x0421: 'id',
	    0x045D: 'iu',
	    0x085D: 'iu-Latn',
	    0x083C: 'ga',
	    0x0434: 'xh',
	    0x0435: 'zu',
	    0x0410: 'it',
	    0x0810: 'it-CH',
	    0x0411: 'ja',
	    0x044B: 'kn',
	    0x043F: 'kk',
	    0x0453: 'km',
	    0x0486: 'quc',
	    0x0487: 'rw',
	    0x0441: 'sw',
	    0x0457: 'kok',
	    0x0412: 'ko',
	    0x0440: 'ky',
	    0x0454: 'lo',
	    0x0426: 'lv',
	    0x0427: 'lt',
	    0x082E: 'dsb',
	    0x046E: 'lb',
	    0x042F: 'mk',
	    0x083E: 'ms-BN',
	    0x043E: 'ms',
	    0x044C: 'ml',
	    0x043A: 'mt',
	    0x0481: 'mi',
	    0x047A: 'arn',
	    0x044E: 'mr',
	    0x047C: 'moh',
	    0x0450: 'mn',
	    0x0850: 'mn-CN',
	    0x0461: 'ne',
	    0x0414: 'nb',
	    0x0814: 'nn',
	    0x0482: 'oc',
	    0x0448: 'or',
	    0x0463: 'ps',
	    0x0415: 'pl',
	    0x0416: 'pt',
	    0x0816: 'pt-PT',
	    0x0446: 'pa',
	    0x046B: 'qu-BO',
	    0x086B: 'qu-EC',
	    0x0C6B: 'qu',
	    0x0418: 'ro',
	    0x0417: 'rm',
	    0x0419: 'ru',
	    0x243B: 'smn',
	    0x103B: 'smj-NO',
	    0x143B: 'smj',
	    0x0C3B: 'se-FI',
	    0x043B: 'se',
	    0x083B: 'se-SE',
	    0x203B: 'sms',
	    0x183B: 'sma-NO',
	    0x1C3B: 'sms',
	    0x044F: 'sa',
	    0x1C1A: 'sr-Cyrl-BA',
	    0x0C1A: 'sr',
	    0x181A: 'sr-Latn-BA',
	    0x081A: 'sr-Latn',
	    0x046C: 'nso',
	    0x0432: 'tn',
	    0x045B: 'si',
	    0x041B: 'sk',
	    0x0424: 'sl',
	    0x2C0A: 'es-AR',
	    0x400A: 'es-BO',
	    0x340A: 'es-CL',
	    0x240A: 'es-CO',
	    0x140A: 'es-CR',
	    0x1C0A: 'es-DO',
	    0x300A: 'es-EC',
	    0x440A: 'es-SV',
	    0x100A: 'es-GT',
	    0x480A: 'es-HN',
	    0x080A: 'es-MX',
	    0x4C0A: 'es-NI',
	    0x180A: 'es-PA',
	    0x3C0A: 'es-PY',
	    0x280A: 'es-PE',
	    0x500A: 'es-PR',

	    // Microsoft has defined two different language codes for
	    // “Spanish with modern sorting” and “Spanish with traditional
	    // sorting”. This makes sense for collation APIs, and it would be
	    // possible to express this in BCP 47 language tags via Unicode
	    // extensions (eg., es-u-co-trad is Spanish with traditional
	    // sorting). However, for storing names in fonts, the distinction
	    // does not make sense, so we give “es” in both cases.
	    0x0C0A: 'es',
	    0x040A: 'es',

	    0x540A: 'es-US',
	    0x380A: 'es-UY',
	    0x200A: 'es-VE',
	    0x081D: 'sv-FI',
	    0x041D: 'sv',
	    0x045A: 'syr',
	    0x0428: 'tg',
	    0x085F: 'tzm',
	    0x0449: 'ta',
	    0x0444: 'tt',
	    0x044A: 'te',
	    0x041E: 'th',
	    0x0451: 'bo',
	    0x041F: 'tr',
	    0x0442: 'tk',
	    0x0480: 'ug',
	    0x0422: 'uk',
	    0x042E: 'hsb',
	    0x0420: 'ur',
	    0x0843: 'uz-Cyrl',
	    0x0443: 'uz',
	    0x042A: 'vi',
	    0x0452: 'cy',
	    0x0488: 'wo',
	    0x0485: 'sah',
	    0x0478: 'ii',
	    0x046A: 'yo'
	};

	// Returns a IETF BCP 47 language code, for example 'zh-Hant'
	// for 'Chinese in the traditional script'.
	function getLanguageCode(platformID, languageID, ltag) {
	    switch (platformID) {
	        case 0:  // Unicode
	            if (languageID === 0xFFFF) {
	                return 'und';
	            } else if (ltag) {
	                return ltag[languageID];
	            }

	            break;

	        case 1:  // Macintosh
	            return macLanguages[languageID];

	        case 3:  // Windows
	            return windowsLanguages[languageID];
	    }

	    return undefined;
	}

	var utf16 = 'utf-16';

	// MacOS script ID → encoding. This table stores the default case,
	// which can be overridden by macLanguageEncodings.
	var macScriptEncodings = {
	    0: 'macintosh',           // smRoman
	    1: 'x-mac-japanese',      // smJapanese
	    2: 'x-mac-chinesetrad',   // smTradChinese
	    3: 'x-mac-korean',        // smKorean
	    6: 'x-mac-greek',         // smGreek
	    7: 'x-mac-cyrillic',      // smCyrillic
	    9: 'x-mac-devanagai',     // smDevanagari
	    10: 'x-mac-gurmukhi',     // smGurmukhi
	    11: 'x-mac-gujarati',     // smGujarati
	    12: 'x-mac-oriya',        // smOriya
	    13: 'x-mac-bengali',      // smBengali
	    14: 'x-mac-tamil',        // smTamil
	    15: 'x-mac-telugu',       // smTelugu
	    16: 'x-mac-kannada',      // smKannada
	    17: 'x-mac-malayalam',    // smMalayalam
	    18: 'x-mac-sinhalese',    // smSinhalese
	    19: 'x-mac-burmese',      // smBurmese
	    20: 'x-mac-khmer',        // smKhmer
	    21: 'x-mac-thai',         // smThai
	    22: 'x-mac-lao',          // smLao
	    23: 'x-mac-georgian',     // smGeorgian
	    24: 'x-mac-armenian',     // smArmenian
	    25: 'x-mac-chinesesimp',  // smSimpChinese
	    26: 'x-mac-tibetan',      // smTibetan
	    27: 'x-mac-mongolian',    // smMongolian
	    28: 'x-mac-ethiopic',     // smEthiopic
	    29: 'x-mac-ce',           // smCentralEuroRoman
	    30: 'x-mac-vietnamese',   // smVietnamese
	    31: 'x-mac-extarabic'     // smExtArabic
	};

	// MacOS language ID → encoding. This table stores the exceptional
	// cases, which override macScriptEncodings. For writing MacOS naming
	// tables, we need to emit a MacOS script ID. Therefore, we cannot
	// merge macScriptEncodings into macLanguageEncodings.
	//
	// http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
	var macLanguageEncodings = {
	    15: 'x-mac-icelandic',    // langIcelandic
	    17: 'x-mac-turkish',      // langTurkish
	    18: 'x-mac-croatian',     // langCroatian
	    24: 'x-mac-ce',           // langLithuanian
	    25: 'x-mac-ce',           // langPolish
	    26: 'x-mac-ce',           // langHungarian
	    27: 'x-mac-ce',           // langEstonian
	    28: 'x-mac-ce',           // langLatvian
	    30: 'x-mac-icelandic',    // langFaroese
	    37: 'x-mac-romanian',     // langRomanian
	    38: 'x-mac-ce',           // langCzech
	    39: 'x-mac-ce',           // langSlovak
	    40: 'x-mac-ce',           // langSlovenian
	    143: 'x-mac-inuit',       // langInuktitut
	    146: 'x-mac-gaelic'       // langIrishGaelicScript
	};

	function getEncoding(platformID, encodingID, languageID) {
	    switch (platformID) {
	        case 0:  // Unicode
	            return utf16;

	        case 1:  // Apple Macintosh
	            return macLanguageEncodings[languageID] || macScriptEncodings[encodingID];

	        case 3:  // Microsoft Windows
	            if (encodingID === 1 || encodingID === 10) {
	                return utf16;
	            }

	            break;
	    }

	    return undefined;
	}

	// Parse the naming `name` table.
	// FIXME: Format 1 additional fields are not supported yet.
	// ltag is the content of the `ltag' table, such as ['en', 'zh-Hans', 'de-CH-1904'].
	function parseNameTable(data, start, ltag) {
	    var name = {};
	    var p = new parse.Parser(data, start);
	    var format = p.parseUShort();
	    var count = p.parseUShort();
	    var stringOffset = p.offset + p.parseUShort();
	    for (var i = 0; i < count; i++) {
	        var platformID = p.parseUShort();
	        var encodingID = p.parseUShort();
	        var languageID = p.parseUShort();
	        var nameID = p.parseUShort();
	        var property = nameTableNames[nameID] || nameID;
	        var byteLength = p.parseUShort();
	        var offset = p.parseUShort();
	        var language = getLanguageCode(platformID, languageID, ltag);
	        var encoding = getEncoding(platformID, encodingID, languageID);
	        if (encoding !== undefined && language !== undefined) {
	            var text = (void 0);
	            if (encoding === utf16) {
	                text = decode.UTF16(data, stringOffset + offset, byteLength);
	            } else {
	                text = decode.MACSTRING(data, stringOffset + offset, byteLength, encoding);
	            }

	            if (text) {
	                var translations = name[property];
	                if (translations === undefined) {
	                    translations = name[property] = {};
	                }

	                translations[language] = text;
	            }
	        }
	    }

	    var langTagCount = 0;
	    if (format === 1) {
	        // FIXME: Also handle Microsoft's 'name' table 1.
	        langTagCount = p.parseUShort();
	    }

	    return name;
	}

	// {23: 'foo'} → {'foo': 23}
	// ['bar', 'baz'] → {'bar': 0, 'baz': 1}
	function reverseDict(dict) {
	    var result = {};
	    for (var key in dict) {
	        result[dict[key]] = parseInt(key);
	    }

	    return result;
	}

	function makeNameRecord(platformID, encodingID, languageID, nameID, length, offset) {
	    return new table.Record('NameRecord', [
	        {name: 'platformID', type: 'USHORT', value: platformID},
	        {name: 'encodingID', type: 'USHORT', value: encodingID},
	        {name: 'languageID', type: 'USHORT', value: languageID},
	        {name: 'nameID', type: 'USHORT', value: nameID},
	        {name: 'length', type: 'USHORT', value: length},
	        {name: 'offset', type: 'USHORT', value: offset}
	    ]);
	}

	// Finds the position of needle in haystack, or -1 if not there.
	// Like String.indexOf(), but for arrays.
	function findSubArray(needle, haystack) {
	    var needleLength = needle.length;
	    var limit = haystack.length - needleLength + 1;

	    loop:
	    for (var pos = 0; pos < limit; pos++) {
	        for (; pos < limit; pos++) {
	            for (var k = 0; k < needleLength; k++) {
	                if (haystack[pos + k] !== needle[k]) {
	                    continue loop;
	                }
	            }

	            return pos;
	        }
	    }

	    return -1;
	}

	function addStringToPool(s, pool) {
	    var offset = findSubArray(s, pool);
	    if (offset < 0) {
	        offset = pool.length;
	        var i = 0;
	        var len = s.length;
	        for (; i < len; ++i) {
	            pool.push(s[i]);
	        }

	    }

	    return offset;
	}

	function makeNameTable(names, ltag) {
	    var nameID;
	    var nameIDs = [];

	    var namesWithNumericKeys = {};
	    var nameTableIds = reverseDict(nameTableNames);
	    for (var key in names) {
	        var id = nameTableIds[key];
	        if (id === undefined) {
	            id = key;
	        }

	        nameID = parseInt(id);

	        if (isNaN(nameID)) {
	            throw new Error('Name table entry "' + key + '" does not exist, see nameTableNames for complete list.');
	        }

	        namesWithNumericKeys[nameID] = names[key];
	        nameIDs.push(nameID);
	    }

	    var macLanguageIds = reverseDict(macLanguages);
	    var windowsLanguageIds = reverseDict(windowsLanguages);

	    var nameRecords = [];
	    var stringPool = [];

	    for (var i = 0; i < nameIDs.length; i++) {
	        nameID = nameIDs[i];
	        var translations = namesWithNumericKeys[nameID];
	        for (var lang in translations) {
	            var text = translations[lang];

	            // For MacOS, we try to emit the name in the form that was introduced
	            // in the initial version of the TrueType spec (in the late 1980s).
	            // However, this can fail for various reasons: the requested BCP 47
	            // language code might not have an old-style Mac equivalent;
	            // we might not have a codec for the needed character encoding;
	            // or the name might contain characters that cannot be expressed
	            // in the old-style Macintosh encoding. In case of failure, we emit
	            // the name in a more modern fashion (Unicode encoding with BCP 47
	            // language tags) that is recognized by MacOS 10.5, released in 2009.
	            // If fonts were only read by operating systems, we could simply
	            // emit all names in the modern form; this would be much easier.
	            // However, there are many applications and libraries that read
	            // 'name' tables directly, and these will usually only recognize
	            // the ancient form (silently skipping the unrecognized names).
	            var macPlatform = 1;  // Macintosh
	            var macLanguage = macLanguageIds[lang];
	            var macScript = macLanguageToScript[macLanguage];
	            var macEncoding = getEncoding(macPlatform, macScript, macLanguage);
	            var macName = encode.MACSTRING(text, macEncoding);
	            if (macName === undefined) {
	                macPlatform = 0;  // Unicode
	                macLanguage = ltag.indexOf(lang);
	                if (macLanguage < 0) {
	                    macLanguage = ltag.length;
	                    ltag.push(lang);
	                }

	                macScript = 4;  // Unicode 2.0 and later
	                macName = encode.UTF16(text);
	            }

	            var macNameOffset = addStringToPool(macName, stringPool);
	            nameRecords.push(makeNameRecord(macPlatform, macScript, macLanguage,
	                                            nameID, macName.length, macNameOffset));

	            var winLanguage = windowsLanguageIds[lang];
	            if (winLanguage !== undefined) {
	                var winName = encode.UTF16(text);
	                var winNameOffset = addStringToPool(winName, stringPool);
	                nameRecords.push(makeNameRecord(3, 1, winLanguage,
	                                                nameID, winName.length, winNameOffset));
	            }
	        }
	    }

	    nameRecords.sort(function(a, b) {
	        return ((a.platformID - b.platformID) ||
	                (a.encodingID - b.encodingID) ||
	                (a.languageID - b.languageID) ||
	                (a.nameID - b.nameID));
	    });

	    var t = new table.Table('name', [
	        {name: 'format', type: 'USHORT', value: 0},
	        {name: 'count', type: 'USHORT', value: nameRecords.length},
	        {name: 'stringOffset', type: 'USHORT', value: 6 + nameRecords.length * 12}
	    ]);

	    for (var r = 0; r < nameRecords.length; r++) {
	        t.fields.push({name: 'record_' + r, type: 'RECORD', value: nameRecords[r]});
	    }

	    t.fields.push({name: 'strings', type: 'LITERAL', value: stringPool});
	    return t;
	}

	var _name = { parse: parseNameTable, make: makeNameTable };

	// The `OS/2` table contains metrics required in OpenType fonts.

	var unicodeRanges = [
	    {begin: 0x0000, end: 0x007F}, // Basic Latin
	    {begin: 0x0080, end: 0x00FF}, // Latin-1 Supplement
	    {begin: 0x0100, end: 0x017F}, // Latin Extended-A
	    {begin: 0x0180, end: 0x024F}, // Latin Extended-B
	    {begin: 0x0250, end: 0x02AF}, // IPA Extensions
	    {begin: 0x02B0, end: 0x02FF}, // Spacing Modifier Letters
	    {begin: 0x0300, end: 0x036F}, // Combining Diacritical Marks
	    {begin: 0x0370, end: 0x03FF}, // Greek and Coptic
	    {begin: 0x2C80, end: 0x2CFF}, // Coptic
	    {begin: 0x0400, end: 0x04FF}, // Cyrillic
	    {begin: 0x0530, end: 0x058F}, // Armenian
	    {begin: 0x0590, end: 0x05FF}, // Hebrew
	    {begin: 0xA500, end: 0xA63F}, // Vai
	    {begin: 0x0600, end: 0x06FF}, // Arabic
	    {begin: 0x07C0, end: 0x07FF}, // NKo
	    {begin: 0x0900, end: 0x097F}, // Devanagari
	    {begin: 0x0980, end: 0x09FF}, // Bengali
	    {begin: 0x0A00, end: 0x0A7F}, // Gurmukhi
	    {begin: 0x0A80, end: 0x0AFF}, // Gujarati
	    {begin: 0x0B00, end: 0x0B7F}, // Oriya
	    {begin: 0x0B80, end: 0x0BFF}, // Tamil
	    {begin: 0x0C00, end: 0x0C7F}, // Telugu
	    {begin: 0x0C80, end: 0x0CFF}, // Kannada
	    {begin: 0x0D00, end: 0x0D7F}, // Malayalam
	    {begin: 0x0E00, end: 0x0E7F}, // Thai
	    {begin: 0x0E80, end: 0x0EFF}, // Lao
	    {begin: 0x10A0, end: 0x10FF}, // Georgian
	    {begin: 0x1B00, end: 0x1B7F}, // Balinese
	    {begin: 0x1100, end: 0x11FF}, // Hangul Jamo
	    {begin: 0x1E00, end: 0x1EFF}, // Latin Extended Additional
	    {begin: 0x1F00, end: 0x1FFF}, // Greek Extended
	    {begin: 0x2000, end: 0x206F}, // General Punctuation
	    {begin: 0x2070, end: 0x209F}, // Superscripts And Subscripts
	    {begin: 0x20A0, end: 0x20CF}, // Currency Symbol
	    {begin: 0x20D0, end: 0x20FF}, // Combining Diacritical Marks For Symbols
	    {begin: 0x2100, end: 0x214F}, // Letterlike Symbols
	    {begin: 0x2150, end: 0x218F}, // Number Forms
	    {begin: 0x2190, end: 0x21FF}, // Arrows
	    {begin: 0x2200, end: 0x22FF}, // Mathematical Operators
	    {begin: 0x2300, end: 0x23FF}, // Miscellaneous Technical
	    {begin: 0x2400, end: 0x243F}, // Control Pictures
	    {begin: 0x2440, end: 0x245F}, // Optical Character Recognition
	    {begin: 0x2460, end: 0x24FF}, // Enclosed Alphanumerics
	    {begin: 0x2500, end: 0x257F}, // Box Drawing
	    {begin: 0x2580, end: 0x259F}, // Block Elements
	    {begin: 0x25A0, end: 0x25FF}, // Geometric Shapes
	    {begin: 0x2600, end: 0x26FF}, // Miscellaneous Symbols
	    {begin: 0x2700, end: 0x27BF}, // Dingbats
	    {begin: 0x3000, end: 0x303F}, // CJK Symbols And Punctuation
	    {begin: 0x3040, end: 0x309F}, // Hiragana
	    {begin: 0x30A0, end: 0x30FF}, // Katakana
	    {begin: 0x3100, end: 0x312F}, // Bopomofo
	    {begin: 0x3130, end: 0x318F}, // Hangul Compatibility Jamo
	    {begin: 0xA840, end: 0xA87F}, // Phags-pa
	    {begin: 0x3200, end: 0x32FF}, // Enclosed CJK Letters And Months
	    {begin: 0x3300, end: 0x33FF}, // CJK Compatibility
	    {begin: 0xAC00, end: 0xD7AF}, // Hangul Syllables
	    {begin: 0xD800, end: 0xDFFF}, // Non-Plane 0 *
	    {begin: 0x10900, end: 0x1091F}, // Phoenicia
	    {begin: 0x4E00, end: 0x9FFF}, // CJK Unified Ideographs
	    {begin: 0xE000, end: 0xF8FF}, // Private Use Area (plane 0)
	    {begin: 0x31C0, end: 0x31EF}, // CJK Strokes
	    {begin: 0xFB00, end: 0xFB4F}, // Alphabetic Presentation Forms
	    {begin: 0xFB50, end: 0xFDFF}, // Arabic Presentation Forms-A
	    {begin: 0xFE20, end: 0xFE2F}, // Combining Half Marks
	    {begin: 0xFE10, end: 0xFE1F}, // Vertical Forms
	    {begin: 0xFE50, end: 0xFE6F}, // Small Form Variants
	    {begin: 0xFE70, end: 0xFEFF}, // Arabic Presentation Forms-B
	    {begin: 0xFF00, end: 0xFFEF}, // Halfwidth And Fullwidth Forms
	    {begin: 0xFFF0, end: 0xFFFF}, // Specials
	    {begin: 0x0F00, end: 0x0FFF}, // Tibetan
	    {begin: 0x0700, end: 0x074F}, // Syriac
	    {begin: 0x0780, end: 0x07BF}, // Thaana
	    {begin: 0x0D80, end: 0x0DFF}, // Sinhala
	    {begin: 0x1000, end: 0x109F}, // Myanmar
	    {begin: 0x1200, end: 0x137F}, // Ethiopic
	    {begin: 0x13A0, end: 0x13FF}, // Cherokee
	    {begin: 0x1400, end: 0x167F}, // Unified Canadian Aboriginal Syllabics
	    {begin: 0x1680, end: 0x169F}, // Ogham
	    {begin: 0x16A0, end: 0x16FF}, // Runic
	    {begin: 0x1780, end: 0x17FF}, // Khmer
	    {begin: 0x1800, end: 0x18AF}, // Mongolian
	    {begin: 0x2800, end: 0x28FF}, // Braille Patterns
	    {begin: 0xA000, end: 0xA48F}, // Yi Syllables
	    {begin: 0x1700, end: 0x171F}, // Tagalog
	    {begin: 0x10300, end: 0x1032F}, // Old Italic
	    {begin: 0x10330, end: 0x1034F}, // Gothic
	    {begin: 0x10400, end: 0x1044F}, // Deseret
	    {begin: 0x1D000, end: 0x1D0FF}, // Byzantine Musical Symbols
	    {begin: 0x1D400, end: 0x1D7FF}, // Mathematical Alphanumeric Symbols
	    {begin: 0xFF000, end: 0xFFFFD}, // Private Use (plane 15)
	    {begin: 0xFE00, end: 0xFE0F}, // Variation Selectors
	    {begin: 0xE0000, end: 0xE007F}, // Tags
	    {begin: 0x1900, end: 0x194F}, // Limbu
	    {begin: 0x1950, end: 0x197F}, // Tai Le
	    {begin: 0x1980, end: 0x19DF}, // New Tai Lue
	    {begin: 0x1A00, end: 0x1A1F}, // Buginese
	    {begin: 0x2C00, end: 0x2C5F}, // Glagolitic
	    {begin: 0x2D30, end: 0x2D7F}, // Tifinagh
	    {begin: 0x4DC0, end: 0x4DFF}, // Yijing Hexagram Symbols
	    {begin: 0xA800, end: 0xA82F}, // Syloti Nagri
	    {begin: 0x10000, end: 0x1007F}, // Linear B Syllabary
	    {begin: 0x10140, end: 0x1018F}, // Ancient Greek Numbers
	    {begin: 0x10380, end: 0x1039F}, // Ugaritic
	    {begin: 0x103A0, end: 0x103DF}, // Old Persian
	    {begin: 0x10450, end: 0x1047F}, // Shavian
	    {begin: 0x10480, end: 0x104AF}, // Osmanya
	    {begin: 0x10800, end: 0x1083F}, // Cypriot Syllabary
	    {begin: 0x10A00, end: 0x10A5F}, // Kharoshthi
	    {begin: 0x1D300, end: 0x1D35F}, // Tai Xuan Jing Symbols
	    {begin: 0x12000, end: 0x123FF}, // Cuneiform
	    {begin: 0x1D360, end: 0x1D37F}, // Counting Rod Numerals
	    {begin: 0x1B80, end: 0x1BBF}, // Sundanese
	    {begin: 0x1C00, end: 0x1C4F}, // Lepcha
	    {begin: 0x1C50, end: 0x1C7F}, // Ol Chiki
	    {begin: 0xA880, end: 0xA8DF}, // Saurashtra
	    {begin: 0xA900, end: 0xA92F}, // Kayah Li
	    {begin: 0xA930, end: 0xA95F}, // Rejang
	    {begin: 0xAA00, end: 0xAA5F}, // Cham
	    {begin: 0x10190, end: 0x101CF}, // Ancient Symbols
	    {begin: 0x101D0, end: 0x101FF}, // Phaistos Disc
	    {begin: 0x102A0, end: 0x102DF}, // Carian
	    {begin: 0x1F030, end: 0x1F09F}  // Domino Tiles
	];

	function getUnicodeRange(unicode) {
	    for (var i = 0; i < unicodeRanges.length; i += 1) {
	        var range = unicodeRanges[i];
	        if (unicode >= range.begin && unicode < range.end) {
	            return i;
	        }
	    }

	    return -1;
	}

	// Parse the OS/2 and Windows metrics `OS/2` table
	function parseOS2Table(data, start) {
	    var os2 = {};
	    var p = new parse.Parser(data, start);
	    os2.version = p.parseUShort();
	    os2.xAvgCharWidth = p.parseShort();
	    os2.usWeightClass = p.parseUShort();
	    os2.usWidthClass = p.parseUShort();
	    os2.fsType = p.parseUShort();
	    os2.ySubscriptXSize = p.parseShort();
	    os2.ySubscriptYSize = p.parseShort();
	    os2.ySubscriptXOffset = p.parseShort();
	    os2.ySubscriptYOffset = p.parseShort();
	    os2.ySuperscriptXSize = p.parseShort();
	    os2.ySuperscriptYSize = p.parseShort();
	    os2.ySuperscriptXOffset = p.parseShort();
	    os2.ySuperscriptYOffset = p.parseShort();
	    os2.yStrikeoutSize = p.parseShort();
	    os2.yStrikeoutPosition = p.parseShort();
	    os2.sFamilyClass = p.parseShort();
	    os2.panose = [];
	    for (var i = 0; i < 10; i++) {
	        os2.panose[i] = p.parseByte();
	    }

	    os2.ulUnicodeRange1 = p.parseULong();
	    os2.ulUnicodeRange2 = p.parseULong();
	    os2.ulUnicodeRange3 = p.parseULong();
	    os2.ulUnicodeRange4 = p.parseULong();
	    os2.achVendID = String.fromCharCode(p.parseByte(), p.parseByte(), p.parseByte(), p.parseByte());
	    os2.fsSelection = p.parseUShort();
	    os2.usFirstCharIndex = p.parseUShort();
	    os2.usLastCharIndex = p.parseUShort();
	    os2.sTypoAscender = p.parseShort();
	    os2.sTypoDescender = p.parseShort();
	    os2.sTypoLineGap = p.parseShort();
	    os2.usWinAscent = p.parseUShort();
	    os2.usWinDescent = p.parseUShort();
	    if (os2.version >= 1) {
	        os2.ulCodePageRange1 = p.parseULong();
	        os2.ulCodePageRange2 = p.parseULong();
	    }

	    if (os2.version >= 2) {
	        os2.sxHeight = p.parseShort();
	        os2.sCapHeight = p.parseShort();
	        os2.usDefaultChar = p.parseUShort();
	        os2.usBreakChar = p.parseUShort();
	        os2.usMaxContent = p.parseUShort();
	    }

	    return os2;
	}

	function makeOS2Table(options) {
	    return new table.Table('OS/2', [
	        {name: 'version', type: 'USHORT', value: 0x0003},
	        {name: 'xAvgCharWidth', type: 'SHORT', value: 0},
	        {name: 'usWeightClass', type: 'USHORT', value: 0},
	        {name: 'usWidthClass', type: 'USHORT', value: 0},
	        {name: 'fsType', type: 'USHORT', value: 0},
	        {name: 'ySubscriptXSize', type: 'SHORT', value: 650},
	        {name: 'ySubscriptYSize', type: 'SHORT', value: 699},
	        {name: 'ySubscriptXOffset', type: 'SHORT', value: 0},
	        {name: 'ySubscriptYOffset', type: 'SHORT', value: 140},
	        {name: 'ySuperscriptXSize', type: 'SHORT', value: 650},
	        {name: 'ySuperscriptYSize', type: 'SHORT', value: 699},
	        {name: 'ySuperscriptXOffset', type: 'SHORT', value: 0},
	        {name: 'ySuperscriptYOffset', type: 'SHORT', value: 479},
	        {name: 'yStrikeoutSize', type: 'SHORT', value: 49},
	        {name: 'yStrikeoutPosition', type: 'SHORT', value: 258},
	        {name: 'sFamilyClass', type: 'SHORT', value: 0},
	        {name: 'bFamilyType', type: 'BYTE', value: 0},
	        {name: 'bSerifStyle', type: 'BYTE', value: 0},
	        {name: 'bWeight', type: 'BYTE', value: 0},
	        {name: 'bProportion', type: 'BYTE', value: 0},
	        {name: 'bContrast', type: 'BYTE', value: 0},
	        {name: 'bStrokeVariation', type: 'BYTE', value: 0},
	        {name: 'bArmStyle', type: 'BYTE', value: 0},
	        {name: 'bLetterform', type: 'BYTE', value: 0},
	        {name: 'bMidline', type: 'BYTE', value: 0},
	        {name: 'bXHeight', type: 'BYTE', value: 0},
	        {name: 'ulUnicodeRange1', type: 'ULONG', value: 0},
	        {name: 'ulUnicodeRange2', type: 'ULONG', value: 0},
	        {name: 'ulUnicodeRange3', type: 'ULONG', value: 0},
	        {name: 'ulUnicodeRange4', type: 'ULONG', value: 0},
	        {name: 'achVendID', type: 'CHARARRAY', value: 'XXXX'},
	        {name: 'fsSelection', type: 'USHORT', value: 0},
	        {name: 'usFirstCharIndex', type: 'USHORT', value: 0},
	        {name: 'usLastCharIndex', type: 'USHORT', value: 0},
	        {name: 'sTypoAscender', type: 'SHORT', value: 0},
	        {name: 'sTypoDescender', type: 'SHORT', value: 0},
	        {name: 'sTypoLineGap', type: 'SHORT', value: 0},
	        {name: 'usWinAscent', type: 'USHORT', value: 0},
	        {name: 'usWinDescent', type: 'USHORT', value: 0},
	        {name: 'ulCodePageRange1', type: 'ULONG', value: 0},
	        {name: 'ulCodePageRange2', type: 'ULONG', value: 0},
	        {name: 'sxHeight', type: 'SHORT', value: 0},
	        {name: 'sCapHeight', type: 'SHORT', value: 0},
	        {name: 'usDefaultChar', type: 'USHORT', value: 0},
	        {name: 'usBreakChar', type: 'USHORT', value: 0},
	        {name: 'usMaxContext', type: 'USHORT', value: 0}
	    ], options);
	}

	var os2 = { parse: parseOS2Table, make: makeOS2Table, unicodeRanges: unicodeRanges, getUnicodeRange: getUnicodeRange };

	// The `post` table stores additional PostScript information, such as glyph names.

	// Parse the PostScript `post` table
	function parsePostTable(data, start) {
	    var post = {};
	    var p = new parse.Parser(data, start);
	    post.version = p.parseVersion();
	    post.italicAngle = p.parseFixed();
	    post.underlinePosition = p.parseShort();
	    post.underlineThickness = p.parseShort();
	    post.isFixedPitch = p.parseULong();
	    post.minMemType42 = p.parseULong();
	    post.maxMemType42 = p.parseULong();
	    post.minMemType1 = p.parseULong();
	    post.maxMemType1 = p.parseULong();
	    switch (post.version) {
	        case 1:
	            post.names = standardNames.slice();
	            break;
	        case 2:
	            post.numberOfGlyphs = p.parseUShort();
	            post.glyphNameIndex = new Array(post.numberOfGlyphs);
	            for (var i = 0; i < post.numberOfGlyphs; i++) {
	                post.glyphNameIndex[i] = p.parseUShort();
	            }

	            post.names = [];
	            for (var i$1 = 0; i$1 < post.numberOfGlyphs; i$1++) {
	                if (post.glyphNameIndex[i$1] >= standardNames.length) {
	                    var nameLength = p.parseChar();
	                    post.names.push(p.parseString(nameLength));
	                }
	            }

	            break;
	        case 2.5:
	            post.numberOfGlyphs = p.parseUShort();
	            post.offset = new Array(post.numberOfGlyphs);
	            for (var i$2 = 0; i$2 < post.numberOfGlyphs; i$2++) {
	                post.offset[i$2] = p.parseChar();
	            }

	            break;
	    }
	    return post;
	}

	function makePostTable() {
	    return new table.Table('post', [
	        {name: 'version', type: 'FIXED', value: 0x00030000},
	        {name: 'italicAngle', type: 'FIXED', value: 0},
	        {name: 'underlinePosition', type: 'FWORD', value: 0},
	        {name: 'underlineThickness', type: 'FWORD', value: 0},
	        {name: 'isFixedPitch', type: 'ULONG', value: 0},
	        {name: 'minMemType42', type: 'ULONG', value: 0},
	        {name: 'maxMemType42', type: 'ULONG', value: 0},
	        {name: 'minMemType1', type: 'ULONG', value: 0},
	        {name: 'maxMemType1', type: 'ULONG', value: 0}
	    ]);
	}

	var post = { parse: parsePostTable, make: makePostTable };

	// The `GSUB` table contains ligatures, among other things.

	var subtableParsers = new Array(9);         // subtableParsers[0] is unused

	// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#SS
	subtableParsers[1] = function parseLookup1() {
	    var start = this.offset + this.relativeOffset;
	    var substFormat = this.parseUShort();
	    if (substFormat === 1) {
	        return {
	            substFormat: 1,
	            coverage: this.parsePointer(Parser.coverage),
	            deltaGlyphId: this.parseUShort()
	        };
	    } else if (substFormat === 2) {
	        return {
	            substFormat: 2,
	            coverage: this.parsePointer(Parser.coverage),
	            substitute: this.parseOffset16List()
	        };
	    }
	    check.assert(false, '0x' + start.toString(16) + ': lookup type 1 format must be 1 or 2.');
	};

	// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#MS
	subtableParsers[2] = function parseLookup2() {
	    var substFormat = this.parseUShort();
	    check.argument(substFormat === 1, 'GSUB Multiple Substitution Subtable identifier-format must be 1');
	    return {
	        substFormat: substFormat,
	        coverage: this.parsePointer(Parser.coverage),
	        sequences: this.parseListOfLists()
	    };
	};

	// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#AS
	subtableParsers[3] = function parseLookup3() {
	    var substFormat = this.parseUShort();
	    check.argument(substFormat === 1, 'GSUB Alternate Substitution Subtable identifier-format must be 1');
	    return {
	        substFormat: substFormat,
	        coverage: this.parsePointer(Parser.coverage),
	        alternateSets: this.parseListOfLists()
	    };
	};

	// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#LS
	subtableParsers[4] = function parseLookup4() {
	    var substFormat = this.parseUShort();
	    check.argument(substFormat === 1, 'GSUB ligature table identifier-format must be 1');
	    return {
	        substFormat: substFormat,
	        coverage: this.parsePointer(Parser.coverage),
	        ligatureSets: this.parseListOfLists(function() {
	            return {
	                ligGlyph: this.parseUShort(),
	                components: this.parseUShortList(this.parseUShort() - 1)
	            };
	        })
	    };
	};

	var lookupRecordDesc = {
	    sequenceIndex: Parser.uShort,
	    lookupListIndex: Parser.uShort
	};

	// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#CSF
	subtableParsers[5] = function parseLookup5() {
	    var start = this.offset + this.relativeOffset;
	    var substFormat = this.parseUShort();

	    if (substFormat === 1) {
	        return {
	            substFormat: substFormat,
	            coverage: this.parsePointer(Parser.coverage),
	            ruleSets: this.parseListOfLists(function() {
	                var glyphCount = this.parseUShort();
	                var substCount = this.parseUShort();
	                return {
	                    input: this.parseUShortList(glyphCount - 1),
	                    lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
	                };
	            })
	        };
	    } else if (substFormat === 2) {
	        return {
	            substFormat: substFormat,
	            coverage: this.parsePointer(Parser.coverage),
	            classDef: this.parsePointer(Parser.classDef),
	            classSets: this.parseListOfLists(function() {
	                var glyphCount = this.parseUShort();
	                var substCount = this.parseUShort();
	                return {
	                    classes: this.parseUShortList(glyphCount - 1),
	                    lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
	                };
	            })
	        };
	    } else if (substFormat === 3) {
	        var glyphCount = this.parseUShort();
	        var substCount = this.parseUShort();
	        return {
	            substFormat: substFormat,
	            coverages: this.parseList(glyphCount, Parser.pointer(Parser.coverage)),
	            lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
	        };
	    }
	    check.assert(false, '0x' + start.toString(16) + ': lookup type 5 format must be 1, 2 or 3.');
	};

	// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#CC
	subtableParsers[6] = function parseLookup6() {
	    var start = this.offset + this.relativeOffset;
	    var substFormat = this.parseUShort();
	    if (substFormat === 1) {
	        return {
	            substFormat: 1,
	            coverage: this.parsePointer(Parser.coverage),
	            chainRuleSets: this.parseListOfLists(function() {
	                return {
	                    backtrack: this.parseUShortList(),
	                    input: this.parseUShortList(this.parseShort() - 1),
	                    lookahead: this.parseUShortList(),
	                    lookupRecords: this.parseRecordList(lookupRecordDesc)
	                };
	            })
	        };
	    } else if (substFormat === 2) {
	        return {
	            substFormat: 2,
	            coverage: this.parsePointer(Parser.coverage),
	            backtrackClassDef: this.parsePointer(Parser.classDef),
	            inputClassDef: this.parsePointer(Parser.classDef),
	            lookaheadClassDef: this.parsePointer(Parser.classDef),
	            chainClassSet: this.parseListOfLists(function() {
	                return {
	                    backtrack: this.parseUShortList(),
	                    input: this.parseUShortList(this.parseShort() - 1),
	                    lookahead: this.parseUShortList(),
	                    lookupRecords: this.parseRecordList(lookupRecordDesc)
	                };
	            })
	        };
	    } else if (substFormat === 3) {
	        return {
	            substFormat: 3,
	            backtrackCoverage: this.parseList(Parser.pointer(Parser.coverage)),
	            inputCoverage: this.parseList(Parser.pointer(Parser.coverage)),
	            lookaheadCoverage: this.parseList(Parser.pointer(Parser.coverage)),
	            lookupRecords: this.parseRecordList(lookupRecordDesc)
	        };
	    }
	    check.assert(false, '0x' + start.toString(16) + ': lookup type 6 format must be 1, 2 or 3.');
	};

	// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#ES
	subtableParsers[7] = function parseLookup7() {
	    // Extension Substitution subtable
	    var substFormat = this.parseUShort();
	    check.argument(substFormat === 1, 'GSUB Extension Substitution subtable identifier-format must be 1');
	    var extensionLookupType = this.parseUShort();
	    var extensionParser = new Parser(this.data, this.offset + this.parseULong());
	    return {
	        substFormat: 1,
	        lookupType: extensionLookupType,
	        extension: subtableParsers[extensionLookupType].call(extensionParser)
	    };
	};

	// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#RCCS
	subtableParsers[8] = function parseLookup8() {
	    var substFormat = this.parseUShort();
	    check.argument(substFormat === 1, 'GSUB Reverse Chaining Contextual Single Substitution Subtable identifier-format must be 1');
	    return {
	        substFormat: substFormat,
	        coverage: this.parsePointer(Parser.coverage),
	        backtrackCoverage: this.parseList(Parser.pointer(Parser.coverage)),
	        lookaheadCoverage: this.parseList(Parser.pointer(Parser.coverage)),
	        substitutes: this.parseUShortList()
	    };
	};

	// https://www.microsoft.com/typography/OTSPEC/gsub.htm
	function parseGsubTable(data, start) {
	    start = start || 0;
	    var p = new Parser(data, start);
	    var tableVersion = p.parseVersion(1);
	    check.argument(tableVersion === 1 || tableVersion === 1.1, 'Unsupported GSUB table version.');
	    if (tableVersion === 1) {
	        return {
	            version: tableVersion,
	            scripts: p.parseScriptList(),
	            features: p.parseFeatureList(),
	            lookups: p.parseLookupList(subtableParsers)
	        };
	    } else {
	        return {
	            version: tableVersion,
	            scripts: p.parseScriptList(),
	            features: p.parseFeatureList(),
	            lookups: p.parseLookupList(subtableParsers),
	            variations: p.parseFeatureVariationsList()
	        };
	    }

	}

	// GSUB Writing //////////////////////////////////////////////
	var subtableMakers = new Array(9);

	subtableMakers[1] = function makeLookup1(subtable) {
	    if (subtable.substFormat === 1) {
	        return new table.Table('substitutionTable', [
	            {name: 'substFormat', type: 'USHORT', value: 1},
	            {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)},
	            {name: 'deltaGlyphID', type: 'USHORT', value: subtable.deltaGlyphId}
	        ]);
	    } else {
	        return new table.Table('substitutionTable', [
	            {name: 'substFormat', type: 'USHORT', value: 2},
	            {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
	        ].concat(table.ushortList('substitute', subtable.substitute)));
	    }
	    check.fail('Lookup type 1 substFormat must be 1 or 2.');
	};

	subtableMakers[3] = function makeLookup3(subtable) {
	    check.assert(subtable.substFormat === 1, 'Lookup type 3 substFormat must be 1.');
	    return new table.Table('substitutionTable', [
	        {name: 'substFormat', type: 'USHORT', value: 1},
	        {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
	    ].concat(table.tableList('altSet', subtable.alternateSets, function(alternateSet) {
	        return new table.Table('alternateSetTable', table.ushortList('alternate', alternateSet));
	    })));
	};

	subtableMakers[4] = function makeLookup4(subtable) {
	    check.assert(subtable.substFormat === 1, 'Lookup type 4 substFormat must be 1.');
	    return new table.Table('substitutionTable', [
	        {name: 'substFormat', type: 'USHORT', value: 1},
	        {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
	    ].concat(table.tableList('ligSet', subtable.ligatureSets, function(ligatureSet) {
	        return new table.Table('ligatureSetTable', table.tableList('ligature', ligatureSet, function(ligature) {
	            return new table.Table('ligatureTable',
	                [{name: 'ligGlyph', type: 'USHORT', value: ligature.ligGlyph}]
	                .concat(table.ushortList('component', ligature.components, ligature.components.length + 1))
	            );
	        }));
	    })));
	};

	function makeGsubTable(gsub) {
	    return new table.Table('GSUB', [
	        {name: 'version', type: 'ULONG', value: 0x10000},
	        {name: 'scripts', type: 'TABLE', value: new table.ScriptList(gsub.scripts)},
	        {name: 'features', type: 'TABLE', value: new table.FeatureList(gsub.features)},
	        {name: 'lookups', type: 'TABLE', value: new table.LookupList(gsub.lookups, subtableMakers)}
	    ]);
	}

	var gsub = { parse: parseGsubTable, make: makeGsubTable };

	// The `GPOS` table contains kerning pairs, among other things.

	// Parse the metadata `meta` table.
	// https://developer.apple.com/fonts/TrueType-Reference-Manual/RM06/Chap6meta.html
	function parseMetaTable(data, start) {
	    var p = new parse.Parser(data, start);
	    var tableVersion = p.parseULong();
	    check.argument(tableVersion === 1, 'Unsupported META table version.');
	    p.parseULong(); // flags - currently unused and set to 0
	    p.parseULong(); // tableOffset
	    var numDataMaps = p.parseULong();

	    var tags = {};
	    for (var i = 0; i < numDataMaps; i++) {
	        var tag = p.parseTag();
	        var dataOffset = p.parseULong();
	        var dataLength = p.parseULong();
	        var text = decode.UTF8(data, start + dataOffset, dataLength);

	        tags[tag] = text;
	    }
	    return tags;
	}

	function makeMetaTable(tags) {
	    var numTags = Object.keys(tags).length;
	    var stringPool = '';
	    var stringPoolOffset = 16 + numTags * 12;

	    var result = new table.Table('meta', [
	        {name: 'version', type: 'ULONG', value: 1},
	        {name: 'flags', type: 'ULONG', value: 0},
	        {name: 'offset', type: 'ULONG', value: stringPoolOffset},
	        {name: 'numTags', type: 'ULONG', value: numTags}
	    ]);

	    for (var tag in tags) {
	        var pos = stringPool.length;
	        stringPool += tags[tag];

	        result.fields.push({name: 'tag ' + tag, type: 'TAG', value: tag});
	        result.fields.push({name: 'offset ' + tag, type: 'ULONG', value: stringPoolOffset + pos});
	        result.fields.push({name: 'length ' + tag, type: 'ULONG', value: tags[tag].length});
	    }

	    result.fields.push({name: 'stringPool', type: 'CHARARRAY', value: stringPool});

	    return result;
	}

	var meta = { parse: parseMetaTable, make: makeMetaTable };

	// The `sfnt` wrapper provides organization for the tables in the font.

	function log2(v) {
	    return Math.log(v) / Math.log(2) | 0;
	}

	function computeCheckSum(bytes) {
	    while (bytes.length % 4 !== 0) {
	        bytes.push(0);
	    }

	    var sum = 0;
	    for (var i = 0; i < bytes.length; i += 4) {
	        sum += (bytes[i] << 24) +
	            (bytes[i + 1] << 16) +
	            (bytes[i + 2] << 8) +
	            (bytes[i + 3]);
	    }

	    sum %= Math.pow(2, 32);
	    return sum;
	}

	function makeTableRecord(tag, checkSum, offset, length) {
	    return new table.Record('Table Record', [
	        {name: 'tag', type: 'TAG', value: tag !== undefined ? tag : ''},
	        {name: 'checkSum', type: 'ULONG', value: checkSum !== undefined ? checkSum : 0},
	        {name: 'offset', type: 'ULONG', value: offset !== undefined ? offset : 0},
	        {name: 'length', type: 'ULONG', value: length !== undefined ? length : 0}
	    ]);
	}

	function makeSfntTable(tables) {
	    var sfnt = new table.Table('sfnt', [
	        {name: 'version', type: 'TAG', value: 'OTTO'},
	        {name: 'numTables', type: 'USHORT', value: 0},
	        {name: 'searchRange', type: 'USHORT', value: 0},
	        {name: 'entrySelector', type: 'USHORT', value: 0},
	        {name: 'rangeShift', type: 'USHORT', value: 0}
	    ]);
	    sfnt.tables = tables;
	    sfnt.numTables = tables.length;
	    var highestPowerOf2 = Math.pow(2, log2(sfnt.numTables));
	    sfnt.searchRange = 16 * highestPowerOf2;
	    sfnt.entrySelector = log2(highestPowerOf2);
	    sfnt.rangeShift = sfnt.numTables * 16 - sfnt.searchRange;

	    var recordFields = [];
	    var tableFields = [];

	    var offset = sfnt.sizeOf() + (makeTableRecord().sizeOf() * sfnt.numTables);
	    while (offset % 4 !== 0) {
	        offset += 1;
	        tableFields.push({name: 'padding', type: 'BYTE', value: 0});
	    }

	    for (var i = 0; i < tables.length; i += 1) {
	        var t = tables[i];
	        check.argument(t.tableName.length === 4, 'Table name' + t.tableName + ' is invalid.');
	        var tableLength = t.sizeOf();
	        var tableRecord = makeTableRecord(t.tableName, computeCheckSum(t.encode()), offset, tableLength);
	        recordFields.push({name: tableRecord.tag + ' Table Record', type: 'RECORD', value: tableRecord});
	        tableFields.push({name: t.tableName + ' table', type: 'RECORD', value: t});
	        offset += tableLength;
	        check.argument(!isNaN(offset), 'Something went wrong calculating the offset.');
	        while (offset % 4 !== 0) {
	            offset += 1;
	            tableFields.push({name: 'padding', type: 'BYTE', value: 0});
	        }
	    }

	    // Table records need to be sorted alphabetically.
	    recordFields.sort(function(r1, r2) {
	        if (r1.value.tag > r2.value.tag) {
	            return 1;
	        } else {
	            return -1;
	        }
	    });

	    sfnt.fields = sfnt.fields.concat(recordFields);
	    sfnt.fields = sfnt.fields.concat(tableFields);
	    return sfnt;
	}

	// Get the metrics for a character. If the string has more than one character
	// this function returns metrics for the first available character.
	// You can provide optional fallback metrics if no characters are available.
	function metricsForChar(font, chars, notFoundMetrics) {
	    for (var i = 0; i < chars.length; i += 1) {
	        var glyphIndex = font.charToGlyphIndex(chars[i]);
	        if (glyphIndex > 0) {
	            var glyph = font.glyphs.get(glyphIndex);
	            return glyph.getMetrics();
	        }
	    }

	    return notFoundMetrics;
	}

	function average(vs) {
	    var sum = 0;
	    for (var i = 0; i < vs.length; i += 1) {
	        sum += vs[i];
	    }

	    return sum / vs.length;
	}

	// Convert the font object to a SFNT data structure.
	// This structure contains all the necessary tables and metadata to create a binary OTF file.
	function fontToSfntTable(font) {
	    var xMins = [];
	    var yMins = [];
	    var xMaxs = [];
	    var yMaxs = [];
	    var advanceWidths = [];
	    var leftSideBearings = [];
	    var rightSideBearings = [];
	    var firstCharIndex;
	    var lastCharIndex = 0;
	    var ulUnicodeRange1 = 0;
	    var ulUnicodeRange2 = 0;
	    var ulUnicodeRange3 = 0;
	    var ulUnicodeRange4 = 0;

	    for (var i = 0; i < font.glyphs.length; i += 1) {
	        var glyph = font.glyphs.get(i);
	        var unicode = glyph.unicode | 0;

	        if (isNaN(glyph.advanceWidth)) {
	            throw new Error('Glyph ' + glyph.name + ' (' + i + '): advanceWidth is not a number.');
	        }

	        if (firstCharIndex > unicode || firstCharIndex === undefined) {
	            // ignore .notdef char
	            if (unicode > 0) {
	                firstCharIndex = unicode;
	            }
	        }

	        if (lastCharIndex < unicode) {
	            lastCharIndex = unicode;
	        }

	        var position = os2.getUnicodeRange(unicode);
	        if (position < 32) {
	            ulUnicodeRange1 |= 1 << position;
	        } else if (position < 64) {
	            ulUnicodeRange2 |= 1 << position - 32;
	        } else if (position < 96) {
	            ulUnicodeRange3 |= 1 << position - 64;
	        } else if (position < 123) {
	            ulUnicodeRange4 |= 1 << position - 96;
	        } else {
	            throw new Error('Unicode ranges bits > 123 are reserved for internal usage');
	        }
	        // Skip non-important characters.
	        if (glyph.name === '.notdef') { continue; }
	        var metrics = glyph.getMetrics();
	        xMins.push(metrics.xMin);
	        yMins.push(metrics.yMin);
	        xMaxs.push(metrics.xMax);
	        yMaxs.push(metrics.yMax);
	        leftSideBearings.push(metrics.leftSideBearing);
	        rightSideBearings.push(metrics.rightSideBearing);
	        advanceWidths.push(glyph.advanceWidth);
	    }

	    var globals = {
	        xMin: Math.min.apply(null, xMins),
	        yMin: Math.min.apply(null, yMins),
	        xMax: Math.max.apply(null, xMaxs),
	        yMax: Math.max.apply(null, yMaxs),
	        advanceWidthMax: Math.max.apply(null, advanceWidths),
	        advanceWidthAvg: average(advanceWidths),
	        minLeftSideBearing: Math.min.apply(null, leftSideBearings),
	        maxLeftSideBearing: Math.max.apply(null, leftSideBearings),
	        minRightSideBearing: Math.min.apply(null, rightSideBearings)
	    };
	    globals.ascender = font.ascender;
	    globals.descender = font.descender;

	    var headTable = head.make({
	        flags: 3, // 00000011 (baseline for font at y=0; left sidebearing point at x=0)
	        unitsPerEm: font.unitsPerEm,
	        xMin: globals.xMin,
	        yMin: globals.yMin,
	        xMax: globals.xMax,
	        yMax: globals.yMax,
	        lowestRecPPEM: 3,
	        createdTimestamp: font.createdTimestamp
	    });

	    var hheaTable = hhea.make({
	        ascender: globals.ascender,
	        descender: globals.descender,
	        advanceWidthMax: globals.advanceWidthMax,
	        minLeftSideBearing: globals.minLeftSideBearing,
	        minRightSideBearing: globals.minRightSideBearing,
	        xMaxExtent: globals.maxLeftSideBearing + (globals.xMax - globals.xMin),
	        numberOfHMetrics: font.glyphs.length
	    });

	    var maxpTable = maxp.make(font.glyphs.length);

	    var os2Table = os2.make({
	        xAvgCharWidth: Math.round(globals.advanceWidthAvg),
	        usWeightClass: font.tables.os2.usWeightClass,
	        usWidthClass: font.tables.os2.usWidthClass,
	        usFirstCharIndex: firstCharIndex,
	        usLastCharIndex: lastCharIndex,
	        ulUnicodeRange1: ulUnicodeRange1,
	        ulUnicodeRange2: ulUnicodeRange2,
	        ulUnicodeRange3: ulUnicodeRange3,
	        ulUnicodeRange4: ulUnicodeRange4,
	        fsSelection: font.tables.os2.fsSelection, // REGULAR
	        // See http://typophile.com/node/13081 for more info on vertical metrics.
	        // We get metrics for typical characters (such as "x" for xHeight).
	        // We provide some fallback characters if characters are unavailable: their
	        // ordering was chosen experimentally.
	        sTypoAscender: globals.ascender,
	        sTypoDescender: globals.descender,
	        sTypoLineGap: 0,
	        usWinAscent: globals.yMax,
	        usWinDescent: Math.abs(globals.yMin),
	        ulCodePageRange1: 1, // FIXME: hard-code Latin 1 support for now
	        sxHeight: metricsForChar(font, 'xyvw', {yMax: Math.round(globals.ascender / 2)}).yMax,
	        sCapHeight: metricsForChar(font, 'HIKLEFJMNTZBDPRAGOQSUVWXY', globals).yMax,
	        usDefaultChar: font.hasChar(' ') ? 32 : 0, // Use space as the default character, if available.
	        usBreakChar: font.hasChar(' ') ? 32 : 0 // Use space as the break character, if available.
	    });

	    var hmtxTable = hmtx.make(font.glyphs);
	    var cmapTable = cmap.make(font.glyphs);

	    var englishFamilyName = font.getEnglishName('fontFamily');
	    var englishStyleName = font.getEnglishName('fontSubfamily');
	    var englishFullName = englishFamilyName + ' ' + englishStyleName;
	    var postScriptName = font.getEnglishName('postScriptName');
	    if (!postScriptName) {
	        postScriptName = englishFamilyName.replace(/\s/g, '') + '-' + englishStyleName;
	    }

	    var names = {};
	    for (var n in font.names) {
	        names[n] = font.names[n];
	    }

	    if (!names.uniqueID) {
	        names.uniqueID = {en: font.getEnglishName('manufacturer') + ':' + englishFullName};
	    }

	    if (!names.postScriptName) {
	        names.postScriptName = {en: postScriptName};
	    }

	    if (!names.preferredFamily) {
	        names.preferredFamily = font.names.fontFamily;
	    }

	    if (!names.preferredSubfamily) {
	        names.preferredSubfamily = font.names.fontSubfamily;
	    }

	    var languageTags = [];
	    var nameTable = _name.make(names, languageTags);
	    var ltagTable = (languageTags.length > 0 ? ltag.make(languageTags) : undefined);

	    var postTable = post.make();
	    var cffTable = cff.make(font.glyphs, {
	        version: font.getEnglishName('version'),
	        fullName: englishFullName,
	        familyName: englishFamilyName,
	        weightName: englishStyleName,
	        postScriptName: postScriptName,
	        unitsPerEm: font.unitsPerEm,
	        fontBBox: [0, globals.yMin, globals.ascender, globals.advanceWidthMax]
	    });

	    var metaTable = (font.metas && Object.keys(font.metas).length > 0) ? meta.make(font.metas) : undefined;

	    // The order does not matter because makeSfntTable() will sort them.
	    var tables = [headTable, hheaTable, maxpTable, os2Table, nameTable, cmapTable, postTable, cffTable, hmtxTable];
	    if (ltagTable) {
	        tables.push(ltagTable);
	    }
	    // Optional tables
	    if (font.tables.gsub) {
	        tables.push(gsub.make(font.tables.gsub));
	    }
	    if (metaTable) {
	        tables.push(metaTable);
	    }

	    var sfntTable = makeSfntTable(tables);

	    // Compute the font's checkSum and store it in head.checkSumAdjustment.
	    var bytes = sfntTable.encode();
	    var checkSum = computeCheckSum(bytes);
	    var tableFields = sfntTable.fields;
	    var checkSumAdjusted = false;
	    for (var i$1 = 0; i$1 < tableFields.length; i$1 += 1) {
	        if (tableFields[i$1].name === 'head table') {
	            tableFields[i$1].value.checkSumAdjustment = 0xB1B0AFBA - checkSum;
	            checkSumAdjusted = true;
	            break;
	        }
	    }

	    if (!checkSumAdjusted) {
	        throw new Error('Could not find head table with checkSum to adjust.');
	    }

	    return sfntTable;
	}

	var sfnt = { make: makeSfntTable, fontToTable: fontToSfntTable, computeCheckSum: computeCheckSum };

	// The Layout object is the prototype of Substitution objects, and provides

	function searchTag(arr, tag) {
	    /* jshint bitwise: false */
	    var imin = 0;
	    var imax = arr.length - 1;
	    while (imin <= imax) {
	        var imid = (imin + imax) >>> 1;
	        var val = arr[imid].tag;
	        if (val === tag) {
	            return imid;
	        } else if (val < tag) {
	            imin = imid + 1;
	        } else { imax = imid - 1; }
	    }
	    // Not found: return -1-insertion point
	    return -imin - 1;
	}

	function binSearch(arr, value) {
	    /* jshint bitwise: false */
	    var imin = 0;
	    var imax = arr.length - 1;
	    while (imin <= imax) {
	        var imid = (imin + imax) >>> 1;
	        var val = arr[imid];
	        if (val === value) {
	            return imid;
	        } else if (val < value) {
	            imin = imid + 1;
	        } else { imax = imid - 1; }
	    }
	    // Not found: return -1-insertion point
	    return -imin - 1;
	}

	// binary search in a list of ranges (coverage, class definition)
	function searchRange(ranges, value) {
	    // jshint bitwise: false
	    var range;
	    var imin = 0;
	    var imax = ranges.length - 1;
	    while (imin <= imax) {
	        var imid = (imin + imax) >>> 1;
	        range = ranges[imid];
	        var start = range.start;
	        if (start === value) {
	            return range;
	        } else if (start < value) {
	            imin = imid + 1;
	        } else { imax = imid - 1; }
	    }
	    if (imin > 0) {
	        range = ranges[imin - 1];
	        if (value > range.end) { return 0; }
	        return range;
	    }
	}

	/**
	 * @exports opentype.Layout
	 * @class
	 */
	function Layout(font, tableName) {
	    this.font = font;
	    this.tableName = tableName;
	}

	Layout.prototype = {

	    /**
	     * Binary search an object by "tag" property
	     * @instance
	     * @function searchTag
	     * @memberof opentype.Layout
	     * @param  {Array} arr
	     * @param  {string} tag
	     * @return {number}
	     */
	    searchTag: searchTag,

	    /**
	     * Binary search in a list of numbers
	     * @instance
	     * @function binSearch
	     * @memberof opentype.Layout
	     * @param  {Array} arr
	     * @param  {number} value
	     * @return {number}
	     */
	    binSearch: binSearch,

	    /**
	     * Get or create the Layout table (GSUB, GPOS etc).
	     * @param  {boolean} create - Whether to create a new one.
	     * @return {Object} The GSUB or GPOS table.
	     */
	    getTable: function(create) {
	        var layout = this.font.tables[this.tableName];
	        if (!layout && create) {
	            layout = this.font.tables[this.tableName] = this.createDefaultTable();
	        }
	        return layout;
	    },

	    /**
	     * Returns all scripts in the substitution table.
	     * @instance
	     * @return {Array}
	     */
	    getScriptNames: function() {
	        var layout = this.getTable();
	        if (!layout) { return []; }
	        return layout.scripts.map(function(script) {
	            return script.tag;
	        });
	    },

	    /**
	     * Returns the best bet for a script name.
	     * Returns 'DFLT' if it exists.
	     * If not, returns 'latn' if it exists.
	     * If neither exist, returns undefined.
	     */
	    getDefaultScriptName: function() {
	        var layout = this.getTable();
	        if (!layout) { return; }
	        var hasLatn = false;
	        for (var i = 0; i < layout.scripts.length; i++) {
	            var name = layout.scripts[i].tag;
	            if (name === 'DFLT') { return name; }
	            if (name === 'latn') { hasLatn = true; }
	        }
	        if (hasLatn) { return 'latn'; }
	    },

	    /**
	     * Returns all LangSysRecords in the given script.
	     * @instance
	     * @param {string} [script='DFLT']
	     * @param {boolean} create - forces the creation of this script table if it doesn't exist.
	     * @return {Object} An object with tag and script properties.
	     */
	    getScriptTable: function(script, create) {
	        var layout = this.getTable(create);
	        if (layout) {
	            script = script || 'DFLT';
	            var scripts = layout.scripts;
	            var pos = searchTag(layout.scripts, script);
	            if (pos >= 0) {
	                return scripts[pos].script;
	            } else if (create) {
	                var scr = {
	                    tag: script,
	                    script: {
	                        defaultLangSys: {reserved: 0, reqFeatureIndex: 0xffff, featureIndexes: []},
	                        langSysRecords: []
	                    }
	                };
	                scripts.splice(-1 - pos, 0, scr);
	                return scr.script;
	            }
	        }
	    },

	    /**
	     * Returns a language system table
	     * @instance
	     * @param {string} [script='DFLT']
	     * @param {string} [language='dlft']
	     * @param {boolean} create - forces the creation of this langSysTable if it doesn't exist.
	     * @return {Object}
	     */
	    getLangSysTable: function(script, language, create) {
	        var scriptTable = this.getScriptTable(script, create);
	        if (scriptTable) {
	            if (!language || language === 'dflt' || language === 'DFLT') {
	                return scriptTable.defaultLangSys;
	            }
	            var pos = searchTag(scriptTable.langSysRecords, language);
	            if (pos >= 0) {
	                return scriptTable.langSysRecords[pos].langSys;
	            } else if (create) {
	                var langSysRecord = {
	                    tag: language,
	                    langSys: {reserved: 0, reqFeatureIndex: 0xffff, featureIndexes: []}
	                };
	                scriptTable.langSysRecords.splice(-1 - pos, 0, langSysRecord);
	                return langSysRecord.langSys;
	            }
	        }
	    },

	    /**
	     * Get a specific feature table.
	     * @instance
	     * @param {string} [script='DFLT']
	     * @param {string} [language='dlft']
	     * @param {string} feature - One of the codes listed at https://www.microsoft.com/typography/OTSPEC/featurelist.htm
	     * @param {boolean} create - forces the creation of the feature table if it doesn't exist.
	     * @return {Object}
	     */
	    getFeatureTable: function(script, language, feature, create) {
	        var langSysTable = this.getLangSysTable(script, language, create);
	        if (langSysTable) {
	            var featureRecord;
	            var featIndexes = langSysTable.featureIndexes;
	            var allFeatures = this.font.tables[this.tableName].features;
	            // The FeatureIndex array of indices is in arbitrary order,
	            // even if allFeatures is sorted alphabetically by feature tag.
	            for (var i = 0; i < featIndexes.length; i++) {
	                featureRecord = allFeatures[featIndexes[i]];
	                if (featureRecord.tag === feature) {
	                    return featureRecord.feature;
	                }
	            }
	            if (create) {
	                var index = allFeatures.length;
	                // Automatic ordering of features would require to shift feature indexes in the script list.
	                check.assert(index === 0 || feature >= allFeatures[index - 1].tag, 'Features must be added in alphabetical order.');
	                featureRecord = {
	                    tag: feature,
	                    feature: { params: 0, lookupListIndexes: [] }
	                };
	                allFeatures.push(featureRecord);
	                featIndexes.push(index);
	                return featureRecord.feature;
	            }
	        }
	    },

	    /**
	     * Get the lookup tables of a given type for a script/language/feature.
	     * @instance
	     * @param {string} [script='DFLT']
	     * @param {string} [language='dlft']
	     * @param {string} feature - 4-letter feature code
	     * @param {number} lookupType - 1 to 9
	     * @param {boolean} create - forces the creation of the lookup table if it doesn't exist, with no subtables.
	     * @return {Object[]}
	     */
	    getLookupTables: function(script, language, feature, lookupType, create) {
	        var featureTable = this.getFeatureTable(script, language, feature, create);
	        var tables = [];
	        if (featureTable) {
	            var lookupTable;
	            var lookupListIndexes = featureTable.lookupListIndexes;
	            var allLookups = this.font.tables[this.tableName].lookups;
	            // lookupListIndexes are in no particular order, so use naive search.
	            for (var i = 0; i < lookupListIndexes.length; i++) {
	                lookupTable = allLookups[lookupListIndexes[i]];
	                if (lookupTable.lookupType === lookupType) {
	                    tables.push(lookupTable);
	                }
	            }
	            if (tables.length === 0 && create) {
	                lookupTable = {
	                    lookupType: lookupType,
	                    lookupFlag: 0,
	                    subtables: [],
	                    markFilteringSet: undefined
	                };
	                var index = allLookups.length;
	                allLookups.push(lookupTable);
	                lookupListIndexes.push(index);
	                return [lookupTable];
	            }
	        }
	        return tables;
	    },

	    /**
	     * Find a glyph in a class definition table
	     * https://docs.microsoft.com/en-us/typography/opentype/spec/chapter2#class-definition-table
	     * @param {object} classDefTable - an OpenType Layout class definition table
	     * @param {number} glyphIndex - the index of the glyph to find
	     * @returns {number} -1 if not found
	     */
	    getGlyphClass: function(classDefTable, glyphIndex) {
	        switch (classDefTable.format) {
	            case 1:
	                if (classDefTable.startGlyph <= glyphIndex && glyphIndex < classDefTable.startGlyph + classDefTable.classes.length) {
	                    return classDefTable.classes[glyphIndex - classDefTable.startGlyph];
	                }
	                return 0;
	            case 2:
	                var range = searchRange(classDefTable.ranges, glyphIndex);
	                return range ? range.classId : 0;
	        }
	    },

	    /**
	     * Find a glyph in a coverage table
	     * https://docs.microsoft.com/en-us/typography/opentype/spec/chapter2#coverage-table
	     * @param {object} coverageTable - an OpenType Layout coverage table
	     * @param {number} glyphIndex - the index of the glyph to find
	     * @returns {number} -1 if not found
	     */
	    getCoverageIndex: function(coverageTable, glyphIndex) {
	        switch (coverageTable.format) {
	            case 1:
	                var index = binSearch(coverageTable.glyphs, glyphIndex);
	                return index >= 0 ? index : -1;
	            case 2:
	                var range = searchRange(coverageTable.ranges, glyphIndex);
	                return range ? range.index + glyphIndex - range.start : -1;
	        }
	    },

	    /**
	     * Returns the list of glyph indexes of a coverage table.
	     * Format 1: the list is stored raw
	     * Format 2: compact list as range records.
	     * @instance
	     * @param  {Object} coverageTable
	     * @return {Array}
	     */
	    expandCoverage: function(coverageTable) {
	        if (coverageTable.format === 1) {
	            return coverageTable.glyphs;
	        } else {
	            var glyphs = [];
	            var ranges = coverageTable.ranges;
	            for (var i = 0; i < ranges.length; i++) {
	                var range = ranges[i];
	                var start = range.start;
	                var end = range.end;
	                for (var j = start; j <= end; j++) {
	                    glyphs.push(j);
	                }
	            }
	            return glyphs;
	        }
	    }

	};

	// The Position object provides utility methods to manipulate

	/**
	 * @exports opentype.Position
	 * @class
	 * @extends opentype.Layout
	 * @param {opentype.Font}
	 * @constructor
	 */
	function Position(font) {
	    Layout.call(this, font, 'gpos');
	}

	Position.prototype = Layout.prototype;

	/**
	 * Init some data for faster and easier access later.
	 */
	Position.prototype.init = function() {
	    var script = this.getDefaultScriptName();
	    this.defaultKerningTables = this.getKerningTables(script);
	};

	/**
	 * Find a glyph pair in a list of lookup tables of type 2 and retrieve the xAdvance kerning value.
	 *
	 * @param {integer} leftIndex - left glyph index
	 * @param {integer} rightIndex - right glyph index
	 * @returns {integer}
	 */
	Position.prototype.getKerningValue = function(kerningLookups, leftIndex, rightIndex) {
	    var this$1 = this;

	    for (var i = 0; i < kerningLookups.length; i++) {
	        var subtables = kerningLookups[i].subtables;
	        for (var j = 0; j < subtables.length; j++) {
	            var subtable = subtables[j];
	            var covIndex = this$1.getCoverageIndex(subtable.coverage, leftIndex);
	            if (covIndex < 0) { continue; }
	            switch (subtable.posFormat) {
	                case 1:
	                    // Search Pair Adjustment Positioning Format 1
	                    var pairSet = subtable.pairSets[covIndex];
	                    for (var k = 0; k < pairSet.length; k++) {
	                        var pair = pairSet[k];
	                        if (pair.secondGlyph === rightIndex) {
	                            return pair.value1 && pair.value1.xAdvance || 0;
	                        }
	                    }
	                    break;      // left glyph found, not right glyph - try next subtable
	                case 2:
	                    // Search Pair Adjustment Positioning Format 2
	                    var class1 = this$1.getGlyphClass(subtable.classDef1, leftIndex);
	                    var class2 = this$1.getGlyphClass(subtable.classDef2, rightIndex);
	                    var pair$1 = subtable.classRecords[class1][class2];
	                    return pair$1.value1 && pair$1.value1.xAdvance || 0;
	            }
	        }
	    }
	    return 0;
	};

	/**
	 * List all kerning lookup tables.
	 *
	 * @param {string} [script='DFLT'] - use font.position.getDefaultScriptName() for a better default value
	 * @param {string} [language='dflt']
	 * @return {object[]} The list of kerning lookup tables (may be empty), or undefined if there is no GPOS table (and we should use the kern table)
	 */
	Position.prototype.getKerningTables = function(script, language) {
	    if (this.font.tables.gpos) {
	        return this.getLookupTables(script, language, 'kern', 2);
	    }
	};

	// The Substitution object provides utility methods to manipulate

	/**
	 * @exports opentype.Substitution
	 * @class
	 * @extends opentype.Layout
	 * @param {opentype.Font}
	 * @constructor
	 */
	function Substitution(font) {
	    Layout.call(this, font, 'gsub');
	}

	// Check if 2 arrays of primitives are equal.
	function arraysEqual(ar1, ar2) {
	    var n = ar1.length;
	    if (n !== ar2.length) { return false; }
	    for (var i = 0; i < n; i++) {
	        if (ar1[i] !== ar2[i]) { return false; }
	    }
	    return true;
	}

	// Find the first subtable of a lookup table in a particular format.
	function getSubstFormat(lookupTable, format, defaultSubtable) {
	    var subtables = lookupTable.subtables;
	    for (var i = 0; i < subtables.length; i++) {
	        var subtable = subtables[i];
	        if (subtable.substFormat === format) {
	            return subtable;
	        }
	    }
	    if (defaultSubtable) {
	        subtables.push(defaultSubtable);
	        return defaultSubtable;
	    }
	    return undefined;
	}

	Substitution.prototype = Layout.prototype;

	/**
	 * Create a default GSUB table.
	 * @return {Object} gsub - The GSUB table.
	 */
	Substitution.prototype.createDefaultTable = function() {
	    // Generate a default empty GSUB table with just a DFLT script and dflt lang sys.
	    return {
	        version: 1,
	        scripts: [{
	            tag: 'DFLT',
	            script: {
	                defaultLangSys: { reserved: 0, reqFeatureIndex: 0xffff, featureIndexes: [] },
	                langSysRecords: []
	            }
	        }],
	        features: [],
	        lookups: []
	    };
	};

	/**
	 * List all single substitutions (lookup type 1) for a given script, language, and feature.
	 * @param {string} [script='DFLT']
	 * @param {string} [language='dflt']
	 * @param {string} feature - 4-character feature name ('aalt', 'salt', 'ss01'...)
	 * @return {Array} substitutions - The list of substitutions.
	 */
	Substitution.prototype.getSingle = function(feature, script, language) {
	    var this$1 = this;

	    var substitutions = [];
	    var lookupTables = this.getLookupTables(script, language, feature, 1);
	    for (var idx = 0; idx < lookupTables.length; idx++) {
	        var subtables = lookupTables[idx].subtables;
	        for (var i = 0; i < subtables.length; i++) {
	            var subtable = subtables[i];
	            var glyphs = this$1.expandCoverage(subtable.coverage);
	            var j = (void 0);
	            if (subtable.substFormat === 1) {
	                var delta = subtable.deltaGlyphId;
	                for (j = 0; j < glyphs.length; j++) {
	                    var glyph = glyphs[j];
	                    substitutions.push({ sub: glyph, by: glyph + delta });
	                }
	            } else {
	                var substitute = subtable.substitute;
	                for (j = 0; j < glyphs.length; j++) {
	                    substitutions.push({ sub: glyphs[j], by: substitute[j] });
	                }
	            }
	        }
	    }
	    return substitutions;
	};

	/**
	 * List all alternates (lookup type 3) for a given script, language, and feature.
	 * @param {string} [script='DFLT']
	 * @param {string} [language='dflt']
	 * @param {string} feature - 4-character feature name ('aalt', 'salt'...)
	 * @return {Array} alternates - The list of alternates
	 */
	Substitution.prototype.getAlternates = function(feature, script, language) {
	    var this$1 = this;

	    var alternates = [];
	    var lookupTables = this.getLookupTables(script, language, feature, 3);
	    for (var idx = 0; idx < lookupTables.length; idx++) {
	        var subtables = lookupTables[idx].subtables;
	        for (var i = 0; i < subtables.length; i++) {
	            var subtable = subtables[i];
	            var glyphs = this$1.expandCoverage(subtable.coverage);
	            var alternateSets = subtable.alternateSets;
	            for (var j = 0; j < glyphs.length; j++) {
	                alternates.push({ sub: glyphs[j], by: alternateSets[j] });
	            }
	        }
	    }
	    return alternates;
	};

	/**
	 * List all ligatures (lookup type 4) for a given script, language, and feature.
	 * The result is an array of ligature objects like { sub: [ids], by: id }
	 * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
	 * @param {string} [script='DFLT']
	 * @param {string} [language='dflt']
	 * @return {Array} ligatures - The list of ligatures.
	 */
	Substitution.prototype.getLigatures = function(feature, script, language) {
	    var this$1 = this;

	    var ligatures = [];
	    var lookupTables = this.getLookupTables(script, language, feature, 4);
	    for (var idx = 0; idx < lookupTables.length; idx++) {
	        var subtables = lookupTables[idx].subtables;
	        for (var i = 0; i < subtables.length; i++) {
	            var subtable = subtables[i];
	            var glyphs = this$1.expandCoverage(subtable.coverage);
	            var ligatureSets = subtable.ligatureSets;
	            for (var j = 0; j < glyphs.length; j++) {
	                var startGlyph = glyphs[j];
	                var ligSet = ligatureSets[j];
	                for (var k = 0; k < ligSet.length; k++) {
	                    var lig = ligSet[k];
	                    ligatures.push({
	                        sub: [startGlyph].concat(lig.components),
	                        by: lig.ligGlyph
	                    });
	                }
	            }
	        }
	    }
	    return ligatures;
	};

	/**
	 * Add or modify a single substitution (lookup type 1)
	 * Format 2, more flexible, is always used.
	 * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
	 * @param {Object} substitution - { sub: id, delta: number } for format 1 or { sub: id, by: id } for format 2.
	 * @param {string} [script='DFLT']
	 * @param {string} [language='dflt']
	 */
	Substitution.prototype.addSingle = function(feature, substitution, script, language) {
	    var lookupTable = this.getLookupTables(script, language, feature, 1, true)[0];
	    var subtable = getSubstFormat(lookupTable, 2, {                // lookup type 1 subtable, format 2, coverage format 1
	        substFormat: 2,
	        coverage: {format: 1, glyphs: []},
	        substitute: []
	    });
	    check.assert(subtable.coverage.format === 1, 'Ligature: unable to modify coverage table format ' + subtable.coverage.format);
	    var coverageGlyph = substitution.sub;
	    var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
	    if (pos < 0) {
	        pos = -1 - pos;
	        subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
	        subtable.substitute.splice(pos, 0, 0);
	    }
	    subtable.substitute[pos] = substitution.by;
	};

	/**
	 * Add or modify an alternate substitution (lookup type 1)
	 * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
	 * @param {Object} substitution - { sub: id, by: [ids] }
	 * @param {string} [script='DFLT']
	 * @param {string} [language='dflt']
	 */
	Substitution.prototype.addAlternate = function(feature, substitution, script, language) {
	    var lookupTable = this.getLookupTables(script, language, feature, 3, true)[0];
	    var subtable = getSubstFormat(lookupTable, 1, {                // lookup type 3 subtable, format 1, coverage format 1
	        substFormat: 1,
	        coverage: {format: 1, glyphs: []},
	        alternateSets: []
	    });
	    check.assert(subtable.coverage.format === 1, 'Ligature: unable to modify coverage table format ' + subtable.coverage.format);
	    var coverageGlyph = substitution.sub;
	    var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
	    if (pos < 0) {
	        pos = -1 - pos;
	        subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
	        subtable.alternateSets.splice(pos, 0, 0);
	    }
	    subtable.alternateSets[pos] = substitution.by;
	};

	/**
	 * Add a ligature (lookup type 4)
	 * Ligatures with more components must be stored ahead of those with fewer components in order to be found
	 * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
	 * @param {Object} ligature - { sub: [ids], by: id }
	 * @param {string} [script='DFLT']
	 * @param {string} [language='dflt']
	 */
	Substitution.prototype.addLigature = function(feature, ligature, script, language) {
	    var lookupTable = this.getLookupTables(script, language, feature, 4, true)[0];
	    var subtable = lookupTable.subtables[0];
	    if (!subtable) {
	        subtable = {                // lookup type 4 subtable, format 1, coverage format 1
	            substFormat: 1,
	            coverage: { format: 1, glyphs: [] },
	            ligatureSets: []
	        };
	        lookupTable.subtables[0] = subtable;
	    }
	    check.assert(subtable.coverage.format === 1, 'Ligature: unable to modify coverage table format ' + subtable.coverage.format);
	    var coverageGlyph = ligature.sub[0];
	    var ligComponents = ligature.sub.slice(1);
	    var ligatureTable = {
	        ligGlyph: ligature.by,
	        components: ligComponents
	    };
	    var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
	    if (pos >= 0) {
	        // ligatureSet already exists
	        var ligatureSet = subtable.ligatureSets[pos];
	        for (var i = 0; i < ligatureSet.length; i++) {
	            // If ligature already exists, return.
	            if (arraysEqual(ligatureSet[i].components, ligComponents)) {
	                return;
	            }
	        }
	        // ligature does not exist: add it.
	        ligatureSet.push(ligatureTable);
	    } else {
	        // Create a new ligatureSet and add coverage for the first glyph.
	        pos = -1 - pos;
	        subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
	        subtable.ligatureSets.splice(pos, 0, [ligatureTable]);
	    }
	};

	/**
	 * List all feature data for a given script and language.
	 * @param {string} feature - 4-letter feature name
	 * @param {string} [script='DFLT']
	 * @param {string} [language='dflt']
	 * @return {Array} substitutions - The list of substitutions.
	 */
	Substitution.prototype.getFeature = function(feature, script, language) {
	    if (/ss\d\d/.test(feature)) {
	        // ss01 - ss20
	        return this.getSingle(feature, script, language);
	    }
	    switch (feature) {
	        case 'aalt':
	        case 'salt':
	            return this.getSingle(feature, script, language)
	                    .concat(this.getAlternates(feature, script, language));
	        case 'dlig':
	        case 'liga':
	        case 'rlig': return this.getLigatures(feature, script, language);
	    }
	    return undefined;
	};

	/**
	 * Add a substitution to a feature for a given script and language.
	 * @param {string} feature - 4-letter feature name
	 * @param {Object} sub - the substitution to add (an object like { sub: id or [ids], by: id or [ids] })
	 * @param {string} [script='DFLT']
	 * @param {string} [language='dflt']
	 */
	Substitution.prototype.add = function(feature, sub, script, language) {
	    if (/ss\d\d/.test(feature)) {
	        // ss01 - ss20
	        return this.addSingle(feature, sub, script, language);
	    }
	    switch (feature) {
	        case 'aalt':
	        case 'salt':
	            if (typeof sub.by === 'number') {
	                return this.addSingle(feature, sub, script, language);
	            }
	            return this.addAlternate(feature, sub, script, language);
	        case 'dlig':
	        case 'liga':
	        case 'rlig':
	            return this.addLigature(feature, sub, script, language);
	    }
	    return undefined;
	};

	function isBrowser() {
	    return typeof window !== 'undefined';
	}

	function nodeBufferToArrayBuffer(buffer) {
	    var ab = new ArrayBuffer(buffer.length);
	    var view = new Uint8Array(ab);
	    for (var i = 0; i < buffer.length; ++i) {
	        view[i] = buffer[i];
	    }

	    return ab;
	}

	function arrayBufferToNodeBuffer(ab) {
	    var buffer = new Buffer(ab.byteLength);
	    var view = new Uint8Array(ab);
	    for (var i = 0; i < buffer.length; ++i) {
	        buffer[i] = view[i];
	    }

	    return buffer;
	}

	function checkArgument(expression, message) {
	    if (!expression) {
	        throw message;
	    }
	}

	// The `glyf` table describes the glyphs in TrueType outline format.

	// Parse the coordinate data for a glyph.
	function parseGlyphCoordinate(p, flag, previousValue, shortVectorBitMask, sameBitMask) {
	    var v;
	    if ((flag & shortVectorBitMask) > 0) {
	        // The coordinate is 1 byte long.
	        v = p.parseByte();
	        // The `same` bit is re-used for short values to signify the sign of the value.
	        if ((flag & sameBitMask) === 0) {
	            v = -v;
	        }

	        v = previousValue + v;
	    } else {
	        //  The coordinate is 2 bytes long.
	        // If the `same` bit is set, the coordinate is the same as the previous coordinate.
	        if ((flag & sameBitMask) > 0) {
	            v = previousValue;
	        } else {
	            // Parse the coordinate as a signed 16-bit delta value.
	            v = previousValue + p.parseShort();
	        }
	    }

	    return v;
	}

	// Parse a TrueType glyph.
	function parseGlyph(glyph, data, start) {
	    var p = new parse.Parser(data, start);
	    glyph.numberOfContours = p.parseShort();
	    glyph._xMin = p.parseShort();
	    glyph._yMin = p.parseShort();
	    glyph._xMax = p.parseShort();
	    glyph._yMax = p.parseShort();
	    var flags;
	    var flag;

	    if (glyph.numberOfContours > 0) {
	        // This glyph is not a composite.
	        var endPointIndices = glyph.endPointIndices = [];
	        for (var i = 0; i < glyph.numberOfContours; i += 1) {
	            endPointIndices.push(p.parseUShort());
	        }

	        glyph.instructionLength = p.parseUShort();
	        glyph.instructions = [];
	        for (var i$1 = 0; i$1 < glyph.instructionLength; i$1 += 1) {
	            glyph.instructions.push(p.parseByte());
	        }

	        var numberOfCoordinates = endPointIndices[endPointIndices.length - 1] + 1;
	        flags = [];
	        for (var i$2 = 0; i$2 < numberOfCoordinates; i$2 += 1) {
	            flag = p.parseByte();
	            flags.push(flag);
	            // If bit 3 is set, we repeat this flag n times, where n is the next byte.
	            if ((flag & 8) > 0) {
	                var repeatCount = p.parseByte();
	                for (var j = 0; j < repeatCount; j += 1) {
	                    flags.push(flag);
	                    i$2 += 1;
	                }
	            }
	        }

	        check.argument(flags.length === numberOfCoordinates, 'Bad flags.');

	        if (endPointIndices.length > 0) {
	            var points = [];
	            var point;
	            // X/Y coordinates are relative to the previous point, except for the first point which is relative to 0,0.
	            if (numberOfCoordinates > 0) {
	                for (var i$3 = 0; i$3 < numberOfCoordinates; i$3 += 1) {
	                    flag = flags[i$3];
	                    point = {};
	                    point.onCurve = !!(flag & 1);
	                    point.lastPointOfContour = endPointIndices.indexOf(i$3) >= 0;
	                    points.push(point);
	                }

	                var px = 0;
	                for (var i$4 = 0; i$4 < numberOfCoordinates; i$4 += 1) {
	                    flag = flags[i$4];
	                    point = points[i$4];
	                    point.x = parseGlyphCoordinate(p, flag, px, 2, 16);
	                    px = point.x;
	                }

	                var py = 0;
	                for (var i$5 = 0; i$5 < numberOfCoordinates; i$5 += 1) {
	                    flag = flags[i$5];
	                    point = points[i$5];
	                    point.y = parseGlyphCoordinate(p, flag, py, 4, 32);
	                    py = point.y;
	                }
	            }

	            glyph.points = points;
	        } else {
	            glyph.points = [];
	        }
	    } else if (glyph.numberOfContours === 0) {
	        glyph.points = [];
	    } else {
	        glyph.isComposite = true;
	        glyph.points = [];
	        glyph.components = [];
	        var moreComponents = true;
	        while (moreComponents) {
	            flags = p.parseUShort();
	            var component = {
	                glyphIndex: p.parseUShort(),
	                xScale: 1,
	                scale01: 0,
	                scale10: 0,
	                yScale: 1,
	                dx: 0,
	                dy: 0
	            };
	            if ((flags & 1) > 0) {
	                // The arguments are words
	                if ((flags & 2) > 0) {
	                    // values are offset
	                    component.dx = p.parseShort();
	                    component.dy = p.parseShort();
	                } else {
	                    // values are matched points
	                    component.matchedPoints = [p.parseUShort(), p.parseUShort()];
	                }

	            } else {
	                // The arguments are bytes
	                if ((flags & 2) > 0) {
	                    // values are offset
	                    component.dx = p.parseChar();
	                    component.dy = p.parseChar();
	                } else {
	                    // values are matched points
	                    component.matchedPoints = [p.parseByte(), p.parseByte()];
	                }
	            }

	            if ((flags & 8) > 0) {
	                // We have a scale
	                component.xScale = component.yScale = p.parseF2Dot14();
	            } else if ((flags & 64) > 0) {
	                // We have an X / Y scale
	                component.xScale = p.parseF2Dot14();
	                component.yScale = p.parseF2Dot14();
	            } else if ((flags & 128) > 0) {
	                // We have a 2x2 transformation
	                component.xScale = p.parseF2Dot14();
	                component.scale01 = p.parseF2Dot14();
	                component.scale10 = p.parseF2Dot14();
	                component.yScale = p.parseF2Dot14();
	            }

	            glyph.components.push(component);
	            moreComponents = !!(flags & 32);
	        }
	        if (flags & 0x100) {
	            // We have instructions
	            glyph.instructionLength = p.parseUShort();
	            glyph.instructions = [];
	            for (var i$6 = 0; i$6 < glyph.instructionLength; i$6 += 1) {
	                glyph.instructions.push(p.parseByte());
	            }
	        }
	    }
	}

	// Transform an array of points and return a new array.
	function transformPoints(points, transform) {
	    var newPoints = [];
	    for (var i = 0; i < points.length; i += 1) {
	        var pt = points[i];
	        var newPt = {
	            x: transform.xScale * pt.x + transform.scale01 * pt.y + transform.dx,
	            y: transform.scale10 * pt.x + transform.yScale * pt.y + transform.dy,
	            onCurve: pt.onCurve,
	            lastPointOfContour: pt.lastPointOfContour
	        };
	        newPoints.push(newPt);
	    }

	    return newPoints;
	}

	function getContours(points) {
	    var contours = [];
	    var currentContour = [];
	    for (var i = 0; i < points.length; i += 1) {
	        var pt = points[i];
	        currentContour.push(pt);
	        if (pt.lastPointOfContour) {
	            contours.push(currentContour);
	            currentContour = [];
	        }
	    }

	    check.argument(currentContour.length === 0, 'There are still points left in the current contour.');
	    return contours;
	}

	// Convert the TrueType glyph outline to a Path.
	function getPath(points) {
	    var p = new Path();
	    if (!points) {
	        return p;
	    }

	    var contours = getContours(points);

	    for (var contourIndex = 0; contourIndex < contours.length; ++contourIndex) {
	        var contour = contours[contourIndex];

	        var prev = null;
	        var curr = contour[contour.length - 1];
	        var next = contour[0];

	        if (curr.onCurve) {
	            p.moveTo(curr.x, curr.y);
	        } else {
	            if (next.onCurve) {
	                p.moveTo(next.x, next.y);
	            } else {
	                // If both first and last points are off-curve, start at their middle.
	                var start = {x: (curr.x + next.x) * 0.5, y: (curr.y + next.y) * 0.5};
	                p.moveTo(start.x, start.y);
	            }
	        }

	        for (var i = 0; i < contour.length; ++i) {
	            prev = curr;
	            curr = next;
	            next = contour[(i + 1) % contour.length];

	            if (curr.onCurve) {
	                // This is a straight line.
	                p.lineTo(curr.x, curr.y);
	            } else {
	                var prev2 = prev;
	                var next2 = next;

	                if (!prev.onCurve) {
	                    prev2 = { x: (curr.x + prev.x) * 0.5, y: (curr.y + prev.y) * 0.5 };
	                }

	                if (!next.onCurve) {
	                    next2 = { x: (curr.x + next.x) * 0.5, y: (curr.y + next.y) * 0.5 };
	                }

	                p.quadraticCurveTo(curr.x, curr.y, next2.x, next2.y);
	            }
	        }

	        p.closePath();
	    }
	    return p;
	}

	function buildPath(glyphs, glyph) {
	    if (glyph.isComposite) {
	        for (var j = 0; j < glyph.components.length; j += 1) {
	            var component = glyph.components[j];
	            var componentGlyph = glyphs.get(component.glyphIndex);
	            // Force the ttfGlyphLoader to parse the glyph.
	            componentGlyph.getPath();
	            if (componentGlyph.points) {
	                var transformedPoints = (void 0);
	                if (component.matchedPoints === undefined) {
	                    // component positioned by offset
	                    transformedPoints = transformPoints(componentGlyph.points, component);
	                } else {
	                    // component positioned by matched points
	                    if ((component.matchedPoints[0] > glyph.points.length - 1) ||
	                        (component.matchedPoints[1] > componentGlyph.points.length - 1)) {
	                        throw Error('Matched points out of range in ' + glyph.name);
	                    }
	                    var firstPt = glyph.points[component.matchedPoints[0]];
	                    var secondPt = componentGlyph.points[component.matchedPoints[1]];
	                    var transform = {
	                        xScale: component.xScale, scale01: component.scale01,
	                        scale10: component.scale10, yScale: component.yScale,
	                        dx: 0, dy: 0
	                    };
	                    secondPt = transformPoints([secondPt], transform)[0];
	                    transform.dx = firstPt.x - secondPt.x;
	                    transform.dy = firstPt.y - secondPt.y;
	                    transformedPoints = transformPoints(componentGlyph.points, transform);
	                }
	                glyph.points = glyph.points.concat(transformedPoints);
	            }
	        }
	    }

	    return getPath(glyph.points);
	}

	function parseGlyfTableAll(data, start, loca, font) {
	    var glyphs = new glyphset.GlyphSet(font);

	    // The last element of the loca table is invalid.
	    for (var i = 0; i < loca.length - 1; i += 1) {
	        var offset = loca[i];
	        var nextOffset = loca[i + 1];
	        if (offset !== nextOffset) {
	            glyphs.push(i, glyphset.ttfGlyphLoader(font, i, parseGlyph, data, start + offset, buildPath));
	        } else {
	            glyphs.push(i, glyphset.glyphLoader(font, i));
	        }
	    }

	    return glyphs;
	}

	function parseGlyfTableOnLowMemory(data, start, loca, font) {
	    var glyphs = new glyphset.GlyphSet(font);

	    font._push = function(i) {
	        var offset = loca[i];
	        var nextOffset = loca[i + 1];
	        if (offset !== nextOffset) {
	            glyphs.push(i, glyphset.ttfGlyphLoader(font, i, parseGlyph, data, start + offset, buildPath));
	        } else {
	            glyphs.push(i, glyphset.glyphLoader(font, i));
	        }
	    };

	    return glyphs;
	}

	// Parse all the glyphs according to the offsets from the `loca` table.
	function parseGlyfTable(data, start, loca, font, opt) {
	    if (opt.lowMemory)
	        { return parseGlyfTableOnLowMemory(data, start, loca, font); }
	    else
	        { return parseGlyfTableAll(data, start, loca, font); }
	}

	var glyf = { getPath: getPath, parse: parseGlyfTable};

	/* A TrueType font hinting interpreter.
	*
	* (c) 2017 Axel Kittenberger
	*
	* This interpreter has been implemented according to this documentation:
	* https://developer.apple.com/fonts/TrueType-Reference-Manual/RM05/Chap5.html
	*
	* According to the documentation F24DOT6 values are used for pixels.
	* That means calculation is 1/64 pixel accurate and uses integer operations.
	* However, Javascript has floating point operations by default and only
	* those are available. One could make a case to simulate the 1/64 accuracy
	* exactly by truncating after every division operation
	* (for example with << 0) to get pixel exactly results as other TrueType
	* implementations. It may make sense since some fonts are pixel optimized
	* by hand using DELTAP instructions. The current implementation doesn't
	* and rather uses full floating point precision.
	*
	* xScale, yScale and rotation is currently ignored.
	*
	* A few non-trivial instructions are missing as I didn't encounter yet
	* a font that used them to test a possible implementation.
	*
	* Some fonts seem to use undocumented features regarding the twilight zone.
	* Only some of them are implemented as they were encountered.
	*
	* The exports.DEBUG statements are removed on the minified distribution file.
	*/

	var instructionTable;
	var exec;
	var execGlyph;
	var execComponent;

	/*
	* Creates a hinting object.
	*
	* There ought to be exactly one
	* for each truetype font that is used for hinting.
	*/
	function Hinting(font) {
	    // the font this hinting object is for
	    this.font = font;

	    this.getCommands = function (hPoints) {
	        return glyf.getPath(hPoints).commands;
	    };

	    // cached states
	    this._fpgmState  =
	    this._prepState  =
	        undefined;

	    // errorState
	    // 0 ... all okay
	    // 1 ... had an error in a glyf,
	    //       continue working but stop spamming
	    //       the console
	    // 2 ... error at prep, stop hinting at this ppem
	    // 3 ... error at fpeg, stop hinting for this font at all
	    this._errorState = 0;
	}

	/*
	* Not rounding.
	*/
	function roundOff(v) {
	    return v;
	}

	/*
	* Rounding to grid.
	*/
	function roundToGrid(v) {
	    //Rounding in TT is supposed to "symmetrical around zero"
	    return Math.sign(v) * Math.round(Math.abs(v));
	}

	/*
	* Rounding to double grid.
	*/
	function roundToDoubleGrid(v) {
	    return Math.sign(v) * Math.round(Math.abs(v * 2)) / 2;
	}

	/*
	* Rounding to half grid.
	*/
	function roundToHalfGrid(v) {
	    return Math.sign(v) * (Math.round(Math.abs(v) + 0.5) - 0.5);
	}

	/*
	* Rounding to up to grid.
	*/
	function roundUpToGrid(v) {
	    return Math.sign(v) * Math.ceil(Math.abs(v));
	}

	/*
	* Rounding to down to grid.
	*/
	function roundDownToGrid(v) {
	    return Math.sign(v) * Math.floor(Math.abs(v));
	}

	/*
	* Super rounding.
	*/
	var roundSuper = function (v) {
	    var period = this.srPeriod;
	    var phase = this.srPhase;
	    var threshold = this.srThreshold;
	    var sign = 1;

	    if (v < 0) {
	        v = -v;
	        sign = -1;
	    }

	    v += threshold - phase;

	    v = Math.trunc(v / period) * period;

	    v += phase;

	    // according to http://xgridfit.sourceforge.net/round.html
	    if (v < 0) { return phase * sign; }

	    return v * sign;
	};

	/*
	* Unit vector of x-axis.
	*/
	var xUnitVector = {
	    x: 1,

	    y: 0,

	    axis: 'x',

	    // Gets the projected distance between two points.
	    // o1/o2 ... if true, respective original position is used.
	    distance: function (p1, p2, o1, o2) {
	        return (o1 ? p1.xo : p1.x) - (o2 ? p2.xo : p2.x);
	    },

	    // Moves point p so the moved position has the same relative
	    // position to the moved positions of rp1 and rp2 than the
	    // original positions had.
	    //
	    // See APPENDIX on INTERPOLATE at the bottom of this file.
	    interpolate: function (p, rp1, rp2, pv) {
	        var do1;
	        var do2;
	        var doa1;
	        var doa2;
	        var dm1;
	        var dm2;
	        var dt;

	        if (!pv || pv === this) {
	            do1 = p.xo - rp1.xo;
	            do2 = p.xo - rp2.xo;
	            dm1 = rp1.x - rp1.xo;
	            dm2 = rp2.x - rp2.xo;
	            doa1 = Math.abs(do1);
	            doa2 = Math.abs(do2);
	            dt = doa1 + doa2;

	            if (dt === 0) {
	                p.x = p.xo + (dm1 + dm2) / 2;
	                return;
	            }

	            p.x = p.xo + (dm1 * doa2 + dm2 * doa1) / dt;
	            return;
	        }

	        do1 = pv.distance(p, rp1, true, true);
	        do2 = pv.distance(p, rp2, true, true);
	        dm1 = pv.distance(rp1, rp1, false, true);
	        dm2 = pv.distance(rp2, rp2, false, true);
	        doa1 = Math.abs(do1);
	        doa2 = Math.abs(do2);
	        dt = doa1 + doa2;

	        if (dt === 0) {
	            xUnitVector.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
	            return;
	        }

	        xUnitVector.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
	    },

	    // Slope of line normal to this
	    normalSlope: Number.NEGATIVE_INFINITY,

	    // Sets the point 'p' relative to point 'rp'
	    // by the distance 'd'.
	    //
	    // See APPENDIX on SETRELATIVE at the bottom of this file.
	    //
	    // p   ... point to set
	    // rp  ... reference point
	    // d   ... distance on projection vector
	    // pv  ... projection vector (undefined = this)
	    // org ... if true, uses the original position of rp as reference.
	    setRelative: function (p, rp, d, pv, org) {
	        if (!pv || pv === this) {
	            p.x = (org ? rp.xo : rp.x) + d;
	            return;
	        }

	        var rpx = org ? rp.xo : rp.x;
	        var rpy = org ? rp.yo : rp.y;
	        var rpdx = rpx + d * pv.x;
	        var rpdy = rpy + d * pv.y;

	        p.x = rpdx + (p.y - rpdy) / pv.normalSlope;
	    },

	    // Slope of vector line.
	    slope: 0,

	    // Touches the point p.
	    touch: function (p) {
	        p.xTouched = true;
	    },

	    // Tests if a point p is touched.
	    touched: function (p) {
	        return p.xTouched;
	    },

	    // Untouches the point p.
	    untouch: function (p) {
	        p.xTouched = false;
	    }
	};

	/*
	* Unit vector of y-axis.
	*/
	var yUnitVector = {
	    x: 0,

	    y: 1,

	    axis: 'y',

	    // Gets the projected distance between two points.
	    // o1/o2 ... if true, respective original position is used.
	    distance: function (p1, p2, o1, o2) {
	        return (o1 ? p1.yo : p1.y) - (o2 ? p2.yo : p2.y);
	    },

	    // Moves point p so the moved position has the same relative
	    // position to the moved positions of rp1 and rp2 than the
	    // original positions had.
	    //
	    // See APPENDIX on INTERPOLATE at the bottom of this file.
	    interpolate: function (p, rp1, rp2, pv) {
	        var do1;
	        var do2;
	        var doa1;
	        var doa2;
	        var dm1;
	        var dm2;
	        var dt;

	        if (!pv || pv === this) {
	            do1 = p.yo - rp1.yo;
	            do2 = p.yo - rp2.yo;
	            dm1 = rp1.y - rp1.yo;
	            dm2 = rp2.y - rp2.yo;
	            doa1 = Math.abs(do1);
	            doa2 = Math.abs(do2);
	            dt = doa1 + doa2;

	            if (dt === 0) {
	                p.y = p.yo + (dm1 + dm2) / 2;
	                return;
	            }

	            p.y = p.yo + (dm1 * doa2 + dm2 * doa1) / dt;
	            return;
	        }

	        do1 = pv.distance(p, rp1, true, true);
	        do2 = pv.distance(p, rp2, true, true);
	        dm1 = pv.distance(rp1, rp1, false, true);
	        dm2 = pv.distance(rp2, rp2, false, true);
	        doa1 = Math.abs(do1);
	        doa2 = Math.abs(do2);
	        dt = doa1 + doa2;

	        if (dt === 0) {
	            yUnitVector.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
	            return;
	        }

	        yUnitVector.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
	    },

	    // Slope of line normal to this.
	    normalSlope: 0,

	    // Sets the point 'p' relative to point 'rp'
	    // by the distance 'd'
	    //
	    // See APPENDIX on SETRELATIVE at the bottom of this file.
	    //
	    // p   ... point to set
	    // rp  ... reference point
	    // d   ... distance on projection vector
	    // pv  ... projection vector (undefined = this)
	    // org ... if true, uses the original position of rp as reference.
	    setRelative: function (p, rp, d, pv, org) {
	        if (!pv || pv === this) {
	            p.y = (org ? rp.yo : rp.y) + d;
	            return;
	        }

	        var rpx = org ? rp.xo : rp.x;
	        var rpy = org ? rp.yo : rp.y;
	        var rpdx = rpx + d * pv.x;
	        var rpdy = rpy + d * pv.y;

	        p.y = rpdy + pv.normalSlope * (p.x - rpdx);
	    },

	    // Slope of vector line.
	    slope: Number.POSITIVE_INFINITY,

	    // Touches the point p.
	    touch: function (p) {
	        p.yTouched = true;
	    },

	    // Tests if a point p is touched.
	    touched: function (p) {
	        return p.yTouched;
	    },

	    // Untouches the point p.
	    untouch: function (p) {
	        p.yTouched = false;
	    }
	};

	Object.freeze(xUnitVector);
	Object.freeze(yUnitVector);

	/*
	* Creates a unit vector that is not x- or y-axis.
	*/
	function UnitVector(x, y) {
	    this.x = x;
	    this.y = y;
	    this.axis = undefined;
	    this.slope = y / x;
	    this.normalSlope = -x / y;
	    Object.freeze(this);
	}

	/*
	* Gets the projected distance between two points.
	* o1/o2 ... if true, respective original position is used.
	*/
	UnitVector.prototype.distance = function(p1, p2, o1, o2) {
	    return (
	        this.x * xUnitVector.distance(p1, p2, o1, o2) +
	        this.y * yUnitVector.distance(p1, p2, o1, o2)
	    );
	};

	/*
	* Moves point p so the moved position has the same relative
	* position to the moved positions of rp1 and rp2 than the
	* original positions had.
	*
	* See APPENDIX on INTERPOLATE at the bottom of this file.
	*/
	UnitVector.prototype.interpolate = function(p, rp1, rp2, pv) {
	    var dm1;
	    var dm2;
	    var do1;
	    var do2;
	    var doa1;
	    var doa2;
	    var dt;

	    do1 = pv.distance(p, rp1, true, true);
	    do2 = pv.distance(p, rp2, true, true);
	    dm1 = pv.distance(rp1, rp1, false, true);
	    dm2 = pv.distance(rp2, rp2, false, true);
	    doa1 = Math.abs(do1);
	    doa2 = Math.abs(do2);
	    dt = doa1 + doa2;

	    if (dt === 0) {
	        this.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
	        return;
	    }

	    this.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
	};

	/*
	* Sets the point 'p' relative to point 'rp'
	* by the distance 'd'
	*
	* See APPENDIX on SETRELATIVE at the bottom of this file.
	*
	* p   ...  point to set
	* rp  ... reference point
	* d   ... distance on projection vector
	* pv  ... projection vector (undefined = this)
	* org ... if true, uses the original position of rp as reference.
	*/
	UnitVector.prototype.setRelative = function(p, rp, d, pv, org) {
	    pv = pv || this;

	    var rpx = org ? rp.xo : rp.x;
	    var rpy = org ? rp.yo : rp.y;
	    var rpdx = rpx + d * pv.x;
	    var rpdy = rpy + d * pv.y;

	    var pvns = pv.normalSlope;
	    var fvs = this.slope;

	    var px = p.x;
	    var py = p.y;

	    p.x = (fvs * px - pvns * rpdx + rpdy - py) / (fvs - pvns);
	    p.y = fvs * (p.x - px) + py;
	};

	/*
	* Touches the point p.
	*/
	UnitVector.prototype.touch = function(p) {
	    p.xTouched = true;
	    p.yTouched = true;
	};

	/*
	* Returns a unit vector with x/y coordinates.
	*/
	function getUnitVector(x, y) {
	    var d = Math.sqrt(x * x + y * y);

	    x /= d;
	    y /= d;

	    if (x === 1 && y === 0) { return xUnitVector; }
	    else if (x === 0 && y === 1) { return yUnitVector; }
	    else { return new UnitVector(x, y); }
	}

	/*
	* Creates a point in the hinting engine.
	*/
	function HPoint(
	    x,
	    y,
	    lastPointOfContour,
	    onCurve
	) {
	    this.x = this.xo = Math.round(x * 64) / 64; // hinted x value and original x-value
	    this.y = this.yo = Math.round(y * 64) / 64; // hinted y value and original y-value

	    this.lastPointOfContour = lastPointOfContour;
	    this.onCurve = onCurve;
	    this.prevPointOnContour = undefined;
	    this.nextPointOnContour = undefined;
	    this.xTouched = false;
	    this.yTouched = false;

	    Object.preventExtensions(this);
	}

	/*
	* Returns the next touched point on the contour.
	*
	* v  ... unit vector to test touch axis.
	*/
	HPoint.prototype.nextTouched = function(v) {
	    var p = this.nextPointOnContour;

	    while (!v.touched(p) && p !== this) { p = p.nextPointOnContour; }

	    return p;
	};

	/*
	* Returns the previous touched point on the contour
	*
	* v  ... unit vector to test touch axis.
	*/
	HPoint.prototype.prevTouched = function(v) {
	    var p = this.prevPointOnContour;

	    while (!v.touched(p) && p !== this) { p = p.prevPointOnContour; }

	    return p;
	};

	/*
	* The zero point.
	*/
	var HPZero = Object.freeze(new HPoint(0, 0));

	/*
	* The default state of the interpreter.
	*
	* Note: Freezing the defaultState and then deriving from it
	* makes the V8 Javascript engine going awkward,
	* so this is avoided, albeit the defaultState shouldn't
	* ever change.
	*/
	var defaultState = {
	    cvCutIn: 17 / 16,    // control value cut in
	    deltaBase: 9,
	    deltaShift: 0.125,
	    loop: 1,             // loops some instructions
	    minDis: 1,           // minimum distance
	    autoFlip: true
	};

	/*
	* The current state of the interpreter.
	*
	* env  ... 'fpgm' or 'prep' or 'glyf'
	* prog ... the program
	*/
	function State(env, prog) {
	    this.env = env;
	    this.stack = [];
	    this.prog = prog;

	    switch (env) {
	        case 'glyf' :
	            this.zp0 = this.zp1 = this.zp2 = 1;
	            this.rp0 = this.rp1 = this.rp2 = 0;
	            /* fall through */
	        case 'prep' :
	            this.fv = this.pv = this.dpv = xUnitVector;
	            this.round = roundToGrid;
	    }
	}

	/*
	* Executes a glyph program.
	*
	* This does the hinting for each glyph.
	*
	* Returns an array of moved points.
	*
	* glyph: the glyph to hint
	* ppem: the size the glyph is rendered for
	*/
	Hinting.prototype.exec = function(glyph, ppem) {
	    if (typeof ppem !== 'number') {
	        throw new Error('Point size is not a number!');
	    }

	    // Received a fatal error, don't do any hinting anymore.
	    if (this._errorState > 2) { return; }

	    var font = this.font;
	    var prepState = this._prepState;

	    if (!prepState || prepState.ppem !== ppem) {
	        var fpgmState = this._fpgmState;

	        if (!fpgmState) {
	            // Executes the fpgm state.
	            // This is used by fonts to define functions.
	            State.prototype = defaultState;

	            fpgmState =
	            this._fpgmState =
	                new State('fpgm', font.tables.fpgm);

	            fpgmState.funcs = [ ];
	            fpgmState.font = font;

	            if (exports.DEBUG) {
	                console.log('---EXEC FPGM---');
	                fpgmState.step = -1;
	            }

	            try {
	                exec(fpgmState);
	            } catch (e) {
	                console.log('Hinting error in FPGM:' + e);
	                this._errorState = 3;
	                return;
	            }
	        }

	        // Executes the prep program for this ppem setting.
	        // This is used by fonts to set cvt values
	        // depending on to be rendered font size.

	        State.prototype = fpgmState;
	        prepState =
	        this._prepState =
	            new State('prep', font.tables.prep);

	        prepState.ppem = ppem;

	        // Creates a copy of the cvt table
	        // and scales it to the current ppem setting.
	        var oCvt = font.tables.cvt;
	        if (oCvt) {
	            var cvt = prepState.cvt = new Array(oCvt.length);
	            var scale = ppem / font.unitsPerEm;
	            for (var c = 0; c < oCvt.length; c++) {
	                cvt[c] = oCvt[c] * scale;
	            }
	        } else {
	            prepState.cvt = [];
	        }

	        if (exports.DEBUG) {
	            console.log('---EXEC PREP---');
	            prepState.step = -1;
	        }

	        try {
	            exec(prepState);
	        } catch (e) {
	            if (this._errorState < 2) {
	                console.log('Hinting error in PREP:' + e);
	            }
	            this._errorState = 2;
	        }
	    }

	    if (this._errorState > 1) { return; }

	    try {
	        return execGlyph(glyph, prepState);
	    } catch (e) {
	        if (this._errorState < 1) {
	            console.log('Hinting error:' + e);
	            console.log('Note: further hinting errors are silenced');
	        }
	        this._errorState = 1;
	        return undefined;
	    }
	};

	/*
	* Executes the hinting program for a glyph.
	*/
	execGlyph = function(glyph, prepState) {
	    // original point positions
	    var xScale = prepState.ppem / prepState.font.unitsPerEm;
	    var yScale = xScale;
	    var components = glyph.components;
	    var contours;
	    var gZone;
	    var state;

	    State.prototype = prepState;
	    if (!components) {
	        state = new State('glyf', glyph.instructions);
	        if (exports.DEBUG) {
	            console.log('---EXEC GLYPH---');
	            state.step = -1;
	        }
	        execComponent(glyph, state, xScale, yScale);
	        gZone = state.gZone;
	    } else {
	        var font = prepState.font;
	        gZone = [];
	        contours = [];
	        for (var i = 0; i < components.length; i++) {
	            var c = components[i];
	            var cg = font.glyphs.get(c.glyphIndex);

	            state = new State('glyf', cg.instructions);

	            if (exports.DEBUG) {
	                console.log('---EXEC COMP ' + i + '---');
	                state.step = -1;
	            }

	            execComponent(cg, state, xScale, yScale);
	            // appends the computed points to the result array
	            // post processes the component points
	            var dx = Math.round(c.dx * xScale);
	            var dy = Math.round(c.dy * yScale);
	            var gz = state.gZone;
	            var cc = state.contours;
	            for (var pi = 0; pi < gz.length; pi++) {
	                var p = gz[pi];
	                p.xTouched = p.yTouched = false;
	                p.xo = p.x = p.x + dx;
	                p.yo = p.y = p.y + dy;
	            }

	            var gLen = gZone.length;
	            gZone.push.apply(gZone, gz);
	            for (var j = 0; j < cc.length; j++) {
	                contours.push(cc[j] + gLen);
	            }
	        }

	        if (glyph.instructions && !state.inhibitGridFit) {
	            // the composite has instructions on its own
	            state = new State('glyf', glyph.instructions);

	            state.gZone = state.z0 = state.z1 = state.z2 = gZone;

	            state.contours = contours;

	            // note: HPZero cannot be used here, since
	            //       the point might be modified
	            gZone.push(
	                new HPoint(0, 0),
	                new HPoint(Math.round(glyph.advanceWidth * xScale), 0)
	            );

	            if (exports.DEBUG) {
	                console.log('---EXEC COMPOSITE---');
	                state.step = -1;
	            }

	            exec(state);

	            gZone.length -= 2;
	        }
	    }

	    return gZone;
	};

	/*
	* Executes the hinting program for a component of a multi-component glyph
	* or of the glyph itself for a non-component glyph.
	*/
	execComponent = function(glyph, state, xScale, yScale)
	{
	    var points = glyph.points || [];
	    var pLen = points.length;
	    var gZone = state.gZone = state.z0 = state.z1 = state.z2 = [];
	    var contours = state.contours = [];

	    // Scales the original points and
	    // makes copies for the hinted points.
	    var cp; // current point
	    for (var i = 0; i < pLen; i++) {
	        cp = points[i];

	        gZone[i] = new HPoint(
	            cp.x * xScale,
	            cp.y * yScale,
	            cp.lastPointOfContour,
	            cp.onCurve
	        );
	    }

	    // Chain links the contours.
	    var sp; // start point
	    var np; // next point

	    for (var i$1 = 0; i$1 < pLen; i$1++) {
	        cp = gZone[i$1];

	        if (!sp) {
	            sp = cp;
	            contours.push(i$1);
	        }

	        if (cp.lastPointOfContour) {
	            cp.nextPointOnContour = sp;
	            sp.prevPointOnContour = cp;
	            sp = undefined;
	        } else {
	            np = gZone[i$1 + 1];
	            cp.nextPointOnContour = np;
	            np.prevPointOnContour = cp;
	        }
	    }

	    if (state.inhibitGridFit) { return; }

	    if (exports.DEBUG) {
	        console.log('PROCESSING GLYPH', state.stack);
	        for (var i$2 = 0; i$2 < pLen; i$2++) {
	            console.log(i$2, gZone[i$2].x, gZone[i$2].y);
	        }
	    }

	    gZone.push(
	        new HPoint(0, 0),
	        new HPoint(Math.round(glyph.advanceWidth * xScale), 0)
	    );

	    exec(state);

	    // Removes the extra points.
	    gZone.length -= 2;

	    if (exports.DEBUG) {
	        console.log('FINISHED GLYPH', state.stack);
	        for (var i$3 = 0; i$3 < pLen; i$3++) {
	            console.log(i$3, gZone[i$3].x, gZone[i$3].y);
	        }
	    }
	};

	/*
	* Executes the program loaded in state.
	*/
	exec = function(state) {
	    var prog = state.prog;

	    if (!prog) { return; }

	    var pLen = prog.length;
	    var ins;

	    for (state.ip = 0; state.ip < pLen; state.ip++) {
	        if (exports.DEBUG) { state.step++; }
	        ins = instructionTable[prog[state.ip]];

	        if (!ins) {
	            throw new Error(
	                'unknown instruction: 0x' +
	                Number(prog[state.ip]).toString(16)
	            );
	        }

	        ins(state);

	        // very extensive debugging for each step
	        /*
	        if (exports.DEBUG) {
	            var da;
	            if (state.gZone) {
	                da = [];
	                for (let i = 0; i < state.gZone.length; i++)
	                {
	                    da.push(i + ' ' +
	                        state.gZone[i].x * 64 + ' ' +
	                        state.gZone[i].y * 64 + ' ' +
	                        (state.gZone[i].xTouched ? 'x' : '') +
	                        (state.gZone[i].yTouched ? 'y' : '')
	                    );
	                }
	                console.log('GZ', da);
	            }

	            if (state.tZone) {
	                da = [];
	                for (let i = 0; i < state.tZone.length; i++) {
	                    da.push(i + ' ' +
	                        state.tZone[i].x * 64 + ' ' +
	                        state.tZone[i].y * 64 + ' ' +
	                        (state.tZone[i].xTouched ? 'x' : '') +
	                        (state.tZone[i].yTouched ? 'y' : '')
	                    );
	                }
	                console.log('TZ', da);
	            }

	            if (state.stack.length > 10) {
	                console.log(
	                    state.stack.length,
	                    '...', state.stack.slice(state.stack.length - 10)
	                );
	            } else {
	                console.log(state.stack.length, state.stack);
	            }
	        }
	        */
	    }
	};

	/*
	* Initializes the twilight zone.
	*
	* This is only done if a SZPx instruction
	* refers to the twilight zone.
	*/
	function initTZone(state)
	{
	    var tZone = state.tZone = new Array(state.gZone.length);

	    // no idea if this is actually correct...
	    for (var i = 0; i < tZone.length; i++)
	    {
	        tZone[i] = new HPoint(0, 0);
	    }
	}

	/*
	* Skips the instruction pointer ahead over an IF/ELSE block.
	* handleElse .. if true breaks on matching ELSE
	*/
	function skip(state, handleElse)
	{
	    var prog = state.prog;
	    var ip = state.ip;
	    var nesting = 1;
	    var ins;

	    do {
	        ins = prog[++ip];
	        if (ins === 0x58) // IF
	            { nesting++; }
	        else if (ins === 0x59) // EIF
	            { nesting--; }
	        else if (ins === 0x40) // NPUSHB
	            { ip += prog[ip + 1] + 1; }
	        else if (ins === 0x41) // NPUSHW
	            { ip += 2 * prog[ip + 1] + 1; }
	        else if (ins >= 0xB0 && ins <= 0xB7) // PUSHB
	            { ip += ins - 0xB0 + 1; }
	        else if (ins >= 0xB8 && ins <= 0xBF) // PUSHW
	            { ip += (ins - 0xB8 + 1) * 2; }
	        else if (handleElse && nesting === 1 && ins === 0x1B) // ELSE
	            { break; }
	    } while (nesting > 0);

	    state.ip = ip;
	}

	/*----------------------------------------------------------*
	*          And then a lot of instructions...                *
	*----------------------------------------------------------*/

	// SVTCA[a] Set freedom and projection Vectors To Coordinate Axis
	// 0x00-0x01
	function SVTCA(v, state) {
	    if (exports.DEBUG) { console.log(state.step, 'SVTCA[' + v.axis + ']'); }

	    state.fv = state.pv = state.dpv = v;
	}

	// SPVTCA[a] Set Projection Vector to Coordinate Axis
	// 0x02-0x03
	function SPVTCA(v, state) {
	    if (exports.DEBUG) { console.log(state.step, 'SPVTCA[' + v.axis + ']'); }

	    state.pv = state.dpv = v;
	}

	// SFVTCA[a] Set Freedom Vector to Coordinate Axis
	// 0x04-0x05
	function SFVTCA(v, state) {
	    if (exports.DEBUG) { console.log(state.step, 'SFVTCA[' + v.axis + ']'); }

	    state.fv = v;
	}

	// SPVTL[a] Set Projection Vector To Line
	// 0x06-0x07
	function SPVTL(a, state) {
	    var stack = state.stack;
	    var p2i = stack.pop();
	    var p1i = stack.pop();
	    var p2 = state.z2[p2i];
	    var p1 = state.z1[p1i];

	    if (exports.DEBUG) { console.log('SPVTL[' + a + ']', p2i, p1i); }

	    var dx;
	    var dy;

	    if (!a) {
	        dx = p1.x - p2.x;
	        dy = p1.y - p2.y;
	    } else {
	        dx = p2.y - p1.y;
	        dy = p1.x - p2.x;
	    }

	    state.pv = state.dpv = getUnitVector(dx, dy);
	}

	// SFVTL[a] Set Freedom Vector To Line
	// 0x08-0x09
	function SFVTL(a, state) {
	    var stack = state.stack;
	    var p2i = stack.pop();
	    var p1i = stack.pop();
	    var p2 = state.z2[p2i];
	    var p1 = state.z1[p1i];

	    if (exports.DEBUG) { console.log('SFVTL[' + a + ']', p2i, p1i); }

	    var dx;
	    var dy;

	    if (!a) {
	        dx = p1.x - p2.x;
	        dy = p1.y - p2.y;
	    } else {
	        dx = p2.y - p1.y;
	        dy = p1.x - p2.x;
	    }

	    state.fv = getUnitVector(dx, dy);
	}

	// SPVFS[] Set Projection Vector From Stack
	// 0x0A
	function SPVFS(state) {
	    var stack = state.stack;
	    var y = stack.pop();
	    var x = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SPVFS[]', y, x); }

	    state.pv = state.dpv = getUnitVector(x, y);
	}

	// SFVFS[] Set Freedom Vector From Stack
	// 0x0B
	function SFVFS(state) {
	    var stack = state.stack;
	    var y = stack.pop();
	    var x = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SPVFS[]', y, x); }

	    state.fv = getUnitVector(x, y);
	}

	// GPV[] Get Projection Vector
	// 0x0C
	function GPV(state) {
	    var stack = state.stack;
	    var pv = state.pv;

	    if (exports.DEBUG) { console.log(state.step, 'GPV[]'); }

	    stack.push(pv.x * 0x4000);
	    stack.push(pv.y * 0x4000);
	}

	// GFV[] Get Freedom Vector
	// 0x0C
	function GFV(state) {
	    var stack = state.stack;
	    var fv = state.fv;

	    if (exports.DEBUG) { console.log(state.step, 'GFV[]'); }

	    stack.push(fv.x * 0x4000);
	    stack.push(fv.y * 0x4000);
	}

	// SFVTPV[] Set Freedom Vector To Projection Vector
	// 0x0E
	function SFVTPV(state) {
	    state.fv = state.pv;

	    if (exports.DEBUG) { console.log(state.step, 'SFVTPV[]'); }
	}

	// ISECT[] moves point p to the InterSECTion of two lines
	// 0x0F
	function ISECT(state)
	{
	    var stack = state.stack;
	    var pa0i = stack.pop();
	    var pa1i = stack.pop();
	    var pb0i = stack.pop();
	    var pb1i = stack.pop();
	    var pi = stack.pop();
	    var z0 = state.z0;
	    var z1 = state.z1;
	    var pa0 = z0[pa0i];
	    var pa1 = z0[pa1i];
	    var pb0 = z1[pb0i];
	    var pb1 = z1[pb1i];
	    var p = state.z2[pi];

	    if (exports.DEBUG) { console.log('ISECT[], ', pa0i, pa1i, pb0i, pb1i, pi); }

	    // math from
	    // en.wikipedia.org/wiki/Line%E2%80%93line_intersection#Given_two_points_on_each_line

	    var x1 = pa0.x;
	    var y1 = pa0.y;
	    var x2 = pa1.x;
	    var y2 = pa1.y;
	    var x3 = pb0.x;
	    var y3 = pb0.y;
	    var x4 = pb1.x;
	    var y4 = pb1.y;

	    var div = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
	    var f1 = x1 * y2 - y1 * x2;
	    var f2 = x3 * y4 - y3 * x4;

	    p.x = (f1 * (x3 - x4) - f2 * (x1 - x2)) / div;
	    p.y = (f1 * (y3 - y4) - f2 * (y1 - y2)) / div;
	}

	// SRP0[] Set Reference Point 0
	// 0x10
	function SRP0(state) {
	    state.rp0 = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SRP0[]', state.rp0); }
	}

	// SRP1[] Set Reference Point 1
	// 0x11
	function SRP1(state) {
	    state.rp1 = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SRP1[]', state.rp1); }
	}

	// SRP1[] Set Reference Point 2
	// 0x12
	function SRP2(state) {
	    state.rp2 = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SRP2[]', state.rp2); }
	}

	// SZP0[] Set Zone Pointer 0
	// 0x13
	function SZP0(state) {
	    var n = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SZP0[]', n); }

	    state.zp0 = n;

	    switch (n) {
	        case 0:
	            if (!state.tZone) { initTZone(state); }
	            state.z0 = state.tZone;
	            break;
	        case 1 :
	            state.z0 = state.gZone;
	            break;
	        default :
	            throw new Error('Invalid zone pointer');
	    }
	}

	// SZP1[] Set Zone Pointer 1
	// 0x14
	function SZP1(state) {
	    var n = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SZP1[]', n); }

	    state.zp1 = n;

	    switch (n) {
	        case 0:
	            if (!state.tZone) { initTZone(state); }
	            state.z1 = state.tZone;
	            break;
	        case 1 :
	            state.z1 = state.gZone;
	            break;
	        default :
	            throw new Error('Invalid zone pointer');
	    }
	}

	// SZP2[] Set Zone Pointer 2
	// 0x15
	function SZP2(state) {
	    var n = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SZP2[]', n); }

	    state.zp2 = n;

	    switch (n) {
	        case 0:
	            if (!state.tZone) { initTZone(state); }
	            state.z2 = state.tZone;
	            break;
	        case 1 :
	            state.z2 = state.gZone;
	            break;
	        default :
	            throw new Error('Invalid zone pointer');
	    }
	}

	// SZPS[] Set Zone PointerS
	// 0x16
	function SZPS(state) {
	    var n = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SZPS[]', n); }

	    state.zp0 = state.zp1 = state.zp2 = n;

	    switch (n) {
	        case 0:
	            if (!state.tZone) { initTZone(state); }
	            state.z0 = state.z1 = state.z2 = state.tZone;
	            break;
	        case 1 :
	            state.z0 = state.z1 = state.z2 = state.gZone;
	            break;
	        default :
	            throw new Error('Invalid zone pointer');
	    }
	}

	// SLOOP[] Set LOOP variable
	// 0x17
	function SLOOP(state) {
	    state.loop = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SLOOP[]', state.loop); }
	}

	// RTG[] Round To Grid
	// 0x18
	function RTG(state) {
	    if (exports.DEBUG) { console.log(state.step, 'RTG[]'); }

	    state.round = roundToGrid;
	}

	// RTHG[] Round To Half Grid
	// 0x19
	function RTHG(state) {
	    if (exports.DEBUG) { console.log(state.step, 'RTHG[]'); }

	    state.round = roundToHalfGrid;
	}

	// SMD[] Set Minimum Distance
	// 0x1A
	function SMD(state) {
	    var d = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SMD[]', d); }

	    state.minDis = d / 0x40;
	}

	// ELSE[] ELSE clause
	// 0x1B
	function ELSE(state) {
	    // This instruction has been reached by executing a then branch
	    // so it just skips ahead until matching EIF.
	    //
	    // In case the IF was negative the IF[] instruction already
	    // skipped forward over the ELSE[]

	    if (exports.DEBUG) { console.log(state.step, 'ELSE[]'); }

	    skip(state, false);
	}

	// JMPR[] JuMP Relative
	// 0x1C
	function JMPR(state) {
	    var o = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'JMPR[]', o); }

	    // A jump by 1 would do nothing.
	    state.ip += o - 1;
	}

	// SCVTCI[] Set Control Value Table Cut-In
	// 0x1D
	function SCVTCI(state) {
	    var n = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SCVTCI[]', n); }

	    state.cvCutIn = n / 0x40;
	}

	// DUP[] DUPlicate top stack element
	// 0x20
	function DUP(state) {
	    var stack = state.stack;

	    if (exports.DEBUG) { console.log(state.step, 'DUP[]'); }

	    stack.push(stack[stack.length - 1]);
	}

	// POP[] POP top stack element
	// 0x21
	function POP(state) {
	    if (exports.DEBUG) { console.log(state.step, 'POP[]'); }

	    state.stack.pop();
	}

	// CLEAR[] CLEAR the stack
	// 0x22
	function CLEAR(state) {
	    if (exports.DEBUG) { console.log(state.step, 'CLEAR[]'); }

	    state.stack.length = 0;
	}

	// SWAP[] SWAP the top two elements on the stack
	// 0x23
	function SWAP(state) {
	    var stack = state.stack;

	    var a = stack.pop();
	    var b = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SWAP[]'); }

	    stack.push(a);
	    stack.push(b);
	}

	// DEPTH[] DEPTH of the stack
	// 0x24
	function DEPTH(state) {
	    var stack = state.stack;

	    if (exports.DEBUG) { console.log(state.step, 'DEPTH[]'); }

	    stack.push(stack.length);
	}

	// LOOPCALL[] LOOPCALL function
	// 0x2A
	function LOOPCALL(state) {
	    var stack = state.stack;
	    var fn = stack.pop();
	    var c = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'LOOPCALL[]', fn, c); }

	    // saves callers program
	    var cip = state.ip;
	    var cprog = state.prog;

	    state.prog = state.funcs[fn];

	    // executes the function
	    for (var i = 0; i < c; i++) {
	        exec(state);

	        if (exports.DEBUG) { console.log(
	            ++state.step,
	            i + 1 < c ? 'next loopcall' : 'done loopcall',
	            i
	        ); }
	    }

	    // restores the callers program
	    state.ip = cip;
	    state.prog = cprog;
	}

	// CALL[] CALL function
	// 0x2B
	function CALL(state) {
	    var fn = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'CALL[]', fn); }

	    // saves callers program
	    var cip = state.ip;
	    var cprog = state.prog;

	    state.prog = state.funcs[fn];

	    // executes the function
	    exec(state);

	    // restores the callers program
	    state.ip = cip;
	    state.prog = cprog;

	    if (exports.DEBUG) { console.log(++state.step, 'returning from', fn); }
	}

	// CINDEX[] Copy the INDEXed element to the top of the stack
	// 0x25
	function CINDEX(state) {
	    var stack = state.stack;
	    var k = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'CINDEX[]', k); }

	    // In case of k == 1, it copies the last element after popping
	    // thus stack.length - k.
	    stack.push(stack[stack.length - k]);
	}

	// MINDEX[] Move the INDEXed element to the top of the stack
	// 0x26
	function MINDEX(state) {
	    var stack = state.stack;
	    var k = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'MINDEX[]', k); }

	    stack.push(stack.splice(stack.length - k, 1)[0]);
	}

	// FDEF[] Function DEFinition
	// 0x2C
	function FDEF(state) {
	    if (state.env !== 'fpgm') { throw new Error('FDEF not allowed here'); }
	    var stack = state.stack;
	    var prog = state.prog;
	    var ip = state.ip;

	    var fn = stack.pop();
	    var ipBegin = ip;

	    if (exports.DEBUG) { console.log(state.step, 'FDEF[]', fn); }

	    while (prog[++ip] !== 0x2D){ }

	    state.ip = ip;
	    state.funcs[fn] = prog.slice(ipBegin + 1, ip);
	}

	// MDAP[a] Move Direct Absolute Point
	// 0x2E-0x2F
	function MDAP(round, state) {
	    var pi = state.stack.pop();
	    var p = state.z0[pi];
	    var fv = state.fv;
	    var pv = state.pv;

	    if (exports.DEBUG) { console.log(state.step, 'MDAP[' + round + ']', pi); }

	    var d = pv.distance(p, HPZero);

	    if (round) { d = state.round(d); }

	    fv.setRelative(p, HPZero, d, pv);
	    fv.touch(p);

	    state.rp0 = state.rp1 = pi;
	}

	// IUP[a] Interpolate Untouched Points through the outline
	// 0x30
	function IUP(v, state) {
	    var z2 = state.z2;
	    var pLen = z2.length - 2;
	    var cp;
	    var pp;
	    var np;

	    if (exports.DEBUG) { console.log(state.step, 'IUP[' + v.axis + ']'); }

	    for (var i = 0; i < pLen; i++) {
	        cp = z2[i]; // current point

	        // if this point has been touched go on
	        if (v.touched(cp)) { continue; }

	        pp = cp.prevTouched(v);

	        // no point on the contour has been touched?
	        if (pp === cp) { continue; }

	        np = cp.nextTouched(v);

	        if (pp === np) {
	            // only one point on the contour has been touched
	            // so simply moves the point like that

	            v.setRelative(cp, cp, v.distance(pp, pp, false, true), v, true);
	        }

	        v.interpolate(cp, pp, np, v);
	    }
	}

	// SHP[] SHift Point using reference point
	// 0x32-0x33
	function SHP(a, state) {
	    var stack = state.stack;
	    var rpi = a ? state.rp1 : state.rp2;
	    var rp = (a ? state.z0 : state.z1)[rpi];
	    var fv = state.fv;
	    var pv = state.pv;
	    var loop = state.loop;
	    var z2 = state.z2;

	    while (loop--)
	    {
	        var pi = stack.pop();
	        var p = z2[pi];

	        var d = pv.distance(rp, rp, false, true);
	        fv.setRelative(p, p, d, pv);
	        fv.touch(p);

	        if (exports.DEBUG) {
	            console.log(
	                state.step,
	                (state.loop > 1 ?
	                   'loop ' + (state.loop - loop) + ': ' :
	                   ''
	                ) +
	                'SHP[' + (a ? 'rp1' : 'rp2') + ']', pi
	            );
	        }
	    }

	    state.loop = 1;
	}

	// SHC[] SHift Contour using reference point
	// 0x36-0x37
	function SHC(a, state) {
	    var stack = state.stack;
	    var rpi = a ? state.rp1 : state.rp2;
	    var rp = (a ? state.z0 : state.z1)[rpi];
	    var fv = state.fv;
	    var pv = state.pv;
	    var ci = stack.pop();
	    var sp = state.z2[state.contours[ci]];
	    var p = sp;

	    if (exports.DEBUG) { console.log(state.step, 'SHC[' + a + ']', ci); }

	    var d = pv.distance(rp, rp, false, true);

	    do {
	        if (p !== rp) { fv.setRelative(p, p, d, pv); }
	        p = p.nextPointOnContour;
	    } while (p !== sp);
	}

	// SHZ[] SHift Zone using reference point
	// 0x36-0x37
	function SHZ(a, state) {
	    var stack = state.stack;
	    var rpi = a ? state.rp1 : state.rp2;
	    var rp = (a ? state.z0 : state.z1)[rpi];
	    var fv = state.fv;
	    var pv = state.pv;

	    var e = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SHZ[' + a + ']', e); }

	    var z;
	    switch (e) {
	        case 0 : z = state.tZone; break;
	        case 1 : z = state.gZone; break;
	        default : throw new Error('Invalid zone');
	    }

	    var p;
	    var d = pv.distance(rp, rp, false, true);
	    var pLen = z.length - 2;
	    for (var i = 0; i < pLen; i++)
	    {
	        p = z[i];
	        fv.setRelative(p, p, d, pv);
	        //if (p !== rp) fv.setRelative(p, p, d, pv);
	    }
	}

	// SHPIX[] SHift point by a PIXel amount
	// 0x38
	function SHPIX(state) {
	    var stack = state.stack;
	    var loop = state.loop;
	    var fv = state.fv;
	    var d = stack.pop() / 0x40;
	    var z2 = state.z2;

	    while (loop--) {
	        var pi = stack.pop();
	        var p = z2[pi];

	        if (exports.DEBUG) {
	            console.log(
	                state.step,
	                (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') +
	                'SHPIX[]', pi, d
	            );
	        }

	        fv.setRelative(p, p, d);
	        fv.touch(p);
	    }

	    state.loop = 1;
	}

	// IP[] Interpolate Point
	// 0x39
	function IP(state) {
	    var stack = state.stack;
	    var rp1i = state.rp1;
	    var rp2i = state.rp2;
	    var loop = state.loop;
	    var rp1 = state.z0[rp1i];
	    var rp2 = state.z1[rp2i];
	    var fv = state.fv;
	    var pv = state.dpv;
	    var z2 = state.z2;

	    while (loop--) {
	        var pi = stack.pop();
	        var p = z2[pi];

	        if (exports.DEBUG) {
	            console.log(
	                state.step,
	                (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') +
	                'IP[]', pi, rp1i, '<->', rp2i
	            );
	        }

	        fv.interpolate(p, rp1, rp2, pv);

	        fv.touch(p);
	    }

	    state.loop = 1;
	}

	// MSIRP[a] Move Stack Indirect Relative Point
	// 0x3A-0x3B
	function MSIRP(a, state) {
	    var stack = state.stack;
	    var d = stack.pop() / 64;
	    var pi = stack.pop();
	    var p = state.z1[pi];
	    var rp0 = state.z0[state.rp0];
	    var fv = state.fv;
	    var pv = state.pv;

	    fv.setRelative(p, rp0, d, pv);
	    fv.touch(p);

	    if (exports.DEBUG) { console.log(state.step, 'MSIRP[' + a + ']', d, pi); }

	    state.rp1 = state.rp0;
	    state.rp2 = pi;
	    if (a) { state.rp0 = pi; }
	}

	// ALIGNRP[] Align to reference point.
	// 0x3C
	function ALIGNRP(state) {
	    var stack = state.stack;
	    var rp0i = state.rp0;
	    var rp0 = state.z0[rp0i];
	    var loop = state.loop;
	    var fv = state.fv;
	    var pv = state.pv;
	    var z1 = state.z1;

	    while (loop--) {
	        var pi = stack.pop();
	        var p = z1[pi];

	        if (exports.DEBUG) {
	            console.log(
	                state.step,
	                (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') +
	                'ALIGNRP[]', pi
	            );
	        }

	        fv.setRelative(p, rp0, 0, pv);
	        fv.touch(p);
	    }

	    state.loop = 1;
	}

	// RTG[] Round To Double Grid
	// 0x3D
	function RTDG(state) {
	    if (exports.DEBUG) { console.log(state.step, 'RTDG[]'); }

	    state.round = roundToDoubleGrid;
	}

	// MIAP[a] Move Indirect Absolute Point
	// 0x3E-0x3F
	function MIAP(round, state) {
	    var stack = state.stack;
	    var n = stack.pop();
	    var pi = stack.pop();
	    var p = state.z0[pi];
	    var fv = state.fv;
	    var pv = state.pv;
	    var cv = state.cvt[n];

	    if (exports.DEBUG) {
	        console.log(
	            state.step,
	            'MIAP[' + round + ']',
	            n, '(', cv, ')', pi
	        );
	    }

	    var d = pv.distance(p, HPZero);

	    if (round) {
	        if (Math.abs(d - cv) < state.cvCutIn) { d = cv; }

	        d = state.round(d);
	    }

	    fv.setRelative(p, HPZero, d, pv);

	    if (state.zp0 === 0) {
	        p.xo = p.x;
	        p.yo = p.y;
	    }

	    fv.touch(p);

	    state.rp0 = state.rp1 = pi;
	}

	// NPUSB[] PUSH N Bytes
	// 0x40
	function NPUSHB(state) {
	    var prog = state.prog;
	    var ip = state.ip;
	    var stack = state.stack;

	    var n = prog[++ip];

	    if (exports.DEBUG) { console.log(state.step, 'NPUSHB[]', n); }

	    for (var i = 0; i < n; i++) { stack.push(prog[++ip]); }

	    state.ip = ip;
	}

	// NPUSHW[] PUSH N Words
	// 0x41
	function NPUSHW(state) {
	    var ip = state.ip;
	    var prog = state.prog;
	    var stack = state.stack;
	    var n = prog[++ip];

	    if (exports.DEBUG) { console.log(state.step, 'NPUSHW[]', n); }

	    for (var i = 0; i < n; i++) {
	        var w = (prog[++ip] << 8) | prog[++ip];
	        if (w & 0x8000) { w = -((w ^ 0xffff) + 1); }
	        stack.push(w);
	    }

	    state.ip = ip;
	}

	// WS[] Write Store
	// 0x42
	function WS(state) {
	    var stack = state.stack;
	    var store = state.store;

	    if (!store) { store = state.store = []; }

	    var v = stack.pop();
	    var l = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'WS', v, l); }

	    store[l] = v;
	}

	// RS[] Read Store
	// 0x43
	function RS(state) {
	    var stack = state.stack;
	    var store = state.store;

	    var l = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'RS', l); }

	    var v = (store && store[l]) || 0;

	    stack.push(v);
	}

	// WCVTP[] Write Control Value Table in Pixel units
	// 0x44
	function WCVTP(state) {
	    var stack = state.stack;

	    var v = stack.pop();
	    var l = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'WCVTP', v, l); }

	    state.cvt[l] = v / 0x40;
	}

	// RCVT[] Read Control Value Table entry
	// 0x45
	function RCVT(state) {
	    var stack = state.stack;
	    var cvte = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'RCVT', cvte); }

	    stack.push(state.cvt[cvte] * 0x40);
	}

	// GC[] Get Coordinate projected onto the projection vector
	// 0x46-0x47
	function GC(a, state) {
	    var stack = state.stack;
	    var pi = stack.pop();
	    var p = state.z2[pi];

	    if (exports.DEBUG) { console.log(state.step, 'GC[' + a + ']', pi); }

	    stack.push(state.dpv.distance(p, HPZero, a, false) * 0x40);
	}

	// MD[a] Measure Distance
	// 0x49-0x4A
	function MD(a, state) {
	    var stack = state.stack;
	    var pi2 = stack.pop();
	    var pi1 = stack.pop();
	    var p2 = state.z1[pi2];
	    var p1 = state.z0[pi1];
	    var d = state.dpv.distance(p1, p2, a, a);

	    if (exports.DEBUG) { console.log(state.step, 'MD[' + a + ']', pi2, pi1, '->', d); }

	    state.stack.push(Math.round(d * 64));
	}

	// MPPEM[] Measure Pixels Per EM
	// 0x4B
	function MPPEM(state) {
	    if (exports.DEBUG) { console.log(state.step, 'MPPEM[]'); }
	    state.stack.push(state.ppem);
	}

	// FLIPON[] set the auto FLIP Boolean to ON
	// 0x4D
	function FLIPON(state) {
	    if (exports.DEBUG) { console.log(state.step, 'FLIPON[]'); }
	    state.autoFlip = true;
	}

	// LT[] Less Than
	// 0x50
	function LT(state) {
	    var stack = state.stack;
	    var e2 = stack.pop();
	    var e1 = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'LT[]', e2, e1); }

	    stack.push(e1 < e2 ? 1 : 0);
	}

	// LTEQ[] Less Than or EQual
	// 0x53
	function LTEQ(state) {
	    var stack = state.stack;
	    var e2 = stack.pop();
	    var e1 = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'LTEQ[]', e2, e1); }

	    stack.push(e1 <= e2 ? 1 : 0);
	}

	// GTEQ[] Greater Than
	// 0x52
	function GT(state) {
	    var stack = state.stack;
	    var e2 = stack.pop();
	    var e1 = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'GT[]', e2, e1); }

	    stack.push(e1 > e2 ? 1 : 0);
	}

	// GTEQ[] Greater Than or EQual
	// 0x53
	function GTEQ(state) {
	    var stack = state.stack;
	    var e2 = stack.pop();
	    var e1 = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'GTEQ[]', e2, e1); }

	    stack.push(e1 >= e2 ? 1 : 0);
	}

	// EQ[] EQual
	// 0x54
	function EQ(state) {
	    var stack = state.stack;
	    var e2 = stack.pop();
	    var e1 = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'EQ[]', e2, e1); }

	    stack.push(e2 === e1 ? 1 : 0);
	}

	// NEQ[] Not EQual
	// 0x55
	function NEQ(state) {
	    var stack = state.stack;
	    var e2 = stack.pop();
	    var e1 = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'NEQ[]', e2, e1); }

	    stack.push(e2 !== e1 ? 1 : 0);
	}

	// ODD[] ODD
	// 0x56
	function ODD(state) {
	    var stack = state.stack;
	    var n = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'ODD[]', n); }

	    stack.push(Math.trunc(n) % 2 ? 1 : 0);
	}

	// EVEN[] EVEN
	// 0x57
	function EVEN(state) {
	    var stack = state.stack;
	    var n = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'EVEN[]', n); }

	    stack.push(Math.trunc(n) % 2 ? 0 : 1);
	}

	// IF[] IF test
	// 0x58
	function IF(state) {
	    var test = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'IF[]', test); }

	    // if test is true it just continues
	    // if not the ip is skipped until matching ELSE or EIF
	    if (!test) {
	        skip(state, true);

	        if (exports.DEBUG) { console.log(state.step, 'EIF[]'); }
	    }
	}

	// EIF[] End IF
	// 0x59
	function EIF(state) {
	    // this can be reached normally when
	    // executing an else branch.
	    // -> just ignore it

	    if (exports.DEBUG) { console.log(state.step, 'EIF[]'); }
	}

	// AND[] logical AND
	// 0x5A
	function AND(state) {
	    var stack = state.stack;
	    var e2 = stack.pop();
	    var e1 = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'AND[]', e2, e1); }

	    stack.push(e2 && e1 ? 1 : 0);
	}

	// OR[] logical OR
	// 0x5B
	function OR(state) {
	    var stack = state.stack;
	    var e2 = stack.pop();
	    var e1 = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'OR[]', e2, e1); }

	    stack.push(e2 || e1 ? 1 : 0);
	}

	// NOT[] logical NOT
	// 0x5C
	function NOT(state) {
	    var stack = state.stack;
	    var e = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'NOT[]', e); }

	    stack.push(e ? 0 : 1);
	}

	// DELTAP1[] DELTA exception P1
	// DELTAP2[] DELTA exception P2
	// DELTAP3[] DELTA exception P3
	// 0x5D, 0x71, 0x72
	function DELTAP123(b, state) {
	    var stack = state.stack;
	    var n = stack.pop();
	    var fv = state.fv;
	    var pv = state.pv;
	    var ppem = state.ppem;
	    var base = state.deltaBase + (b - 1) * 16;
	    var ds = state.deltaShift;
	    var z0 = state.z0;

	    if (exports.DEBUG) { console.log(state.step, 'DELTAP[' + b + ']', n, stack); }

	    for (var i = 0; i < n; i++) {
	        var pi = stack.pop();
	        var arg = stack.pop();
	        var appem = base + ((arg & 0xF0) >> 4);
	        if (appem !== ppem) { continue; }

	        var mag = (arg & 0x0F) - 8;
	        if (mag >= 0) { mag++; }
	        if (exports.DEBUG) { console.log(state.step, 'DELTAPFIX', pi, 'by', mag * ds); }

	        var p = z0[pi];
	        fv.setRelative(p, p, mag * ds, pv);
	    }
	}

	// SDB[] Set Delta Base in the graphics state
	// 0x5E
	function SDB(state) {
	    var stack = state.stack;
	    var n = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SDB[]', n); }

	    state.deltaBase = n;
	}

	// SDS[] Set Delta Shift in the graphics state
	// 0x5F
	function SDS(state) {
	    var stack = state.stack;
	    var n = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SDS[]', n); }

	    state.deltaShift = Math.pow(0.5, n);
	}

	// ADD[] ADD
	// 0x60
	function ADD(state) {
	    var stack = state.stack;
	    var n2 = stack.pop();
	    var n1 = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'ADD[]', n2, n1); }

	    stack.push(n1 + n2);
	}

	// SUB[] SUB
	// 0x61
	function SUB(state) {
	    var stack = state.stack;
	    var n2 = stack.pop();
	    var n1 = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SUB[]', n2, n1); }

	    stack.push(n1 - n2);
	}

	// DIV[] DIV
	// 0x62
	function DIV(state) {
	    var stack = state.stack;
	    var n2 = stack.pop();
	    var n1 = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'DIV[]', n2, n1); }

	    stack.push(n1 * 64 / n2);
	}

	// MUL[] MUL
	// 0x63
	function MUL(state) {
	    var stack = state.stack;
	    var n2 = stack.pop();
	    var n1 = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'MUL[]', n2, n1); }

	    stack.push(n1 * n2 / 64);
	}

	// ABS[] ABSolute value
	// 0x64
	function ABS(state) {
	    var stack = state.stack;
	    var n = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'ABS[]', n); }

	    stack.push(Math.abs(n));
	}

	// NEG[] NEGate
	// 0x65
	function NEG(state) {
	    var stack = state.stack;
	    var n = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'NEG[]', n); }

	    stack.push(-n);
	}

	// FLOOR[] FLOOR
	// 0x66
	function FLOOR(state) {
	    var stack = state.stack;
	    var n = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'FLOOR[]', n); }

	    stack.push(Math.floor(n / 0x40) * 0x40);
	}

	// CEILING[] CEILING
	// 0x67
	function CEILING(state) {
	    var stack = state.stack;
	    var n = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'CEILING[]', n); }

	    stack.push(Math.ceil(n / 0x40) * 0x40);
	}

	// ROUND[ab] ROUND value
	// 0x68-0x6B
	function ROUND(dt, state) {
	    var stack = state.stack;
	    var n = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'ROUND[]'); }

	    stack.push(state.round(n / 0x40) * 0x40);
	}

	// WCVTF[] Write Control Value Table in Funits
	// 0x70
	function WCVTF(state) {
	    var stack = state.stack;
	    var v = stack.pop();
	    var l = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'WCVTF[]', v, l); }

	    state.cvt[l] = v * state.ppem / state.font.unitsPerEm;
	}

	// DELTAC1[] DELTA exception C1
	// DELTAC2[] DELTA exception C2
	// DELTAC3[] DELTA exception C3
	// 0x73, 0x74, 0x75
	function DELTAC123(b, state) {
	    var stack = state.stack;
	    var n = stack.pop();
	    var ppem = state.ppem;
	    var base = state.deltaBase + (b - 1) * 16;
	    var ds = state.deltaShift;

	    if (exports.DEBUG) { console.log(state.step, 'DELTAC[' + b + ']', n, stack); }

	    for (var i = 0; i < n; i++) {
	        var c = stack.pop();
	        var arg = stack.pop();
	        var appem = base + ((arg & 0xF0) >> 4);
	        if (appem !== ppem) { continue; }

	        var mag = (arg & 0x0F) - 8;
	        if (mag >= 0) { mag++; }

	        var delta = mag * ds;

	        if (exports.DEBUG) { console.log(state.step, 'DELTACFIX', c, 'by', delta); }

	        state.cvt[c] += delta;
	    }
	}

	// SROUND[] Super ROUND
	// 0x76
	function SROUND(state) {
	    var n = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'SROUND[]', n); }

	    state.round = roundSuper;

	    var period;

	    switch (n & 0xC0) {
	        case 0x00:
	            period = 0.5;
	            break;
	        case 0x40:
	            period = 1;
	            break;
	        case 0x80:
	            period = 2;
	            break;
	        default:
	            throw new Error('invalid SROUND value');
	    }

	    state.srPeriod = period;

	    switch (n & 0x30) {
	        case 0x00:
	            state.srPhase = 0;
	            break;
	        case 0x10:
	            state.srPhase = 0.25 * period;
	            break;
	        case 0x20:
	            state.srPhase = 0.5  * period;
	            break;
	        case 0x30:
	            state.srPhase = 0.75 * period;
	            break;
	        default: throw new Error('invalid SROUND value');
	    }

	    n &= 0x0F;

	    if (n === 0) { state.srThreshold = 0; }
	    else { state.srThreshold = (n / 8 - 0.5) * period; }
	}

	// S45ROUND[] Super ROUND 45 degrees
	// 0x77
	function S45ROUND(state) {
	    var n = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'S45ROUND[]', n); }

	    state.round = roundSuper;

	    var period;

	    switch (n & 0xC0) {
	        case 0x00:
	            period = Math.sqrt(2) / 2;
	            break;
	        case 0x40:
	            period = Math.sqrt(2);
	            break;
	        case 0x80:
	            period = 2 * Math.sqrt(2);
	            break;
	        default:
	            throw new Error('invalid S45ROUND value');
	    }

	    state.srPeriod = period;

	    switch (n & 0x30) {
	        case 0x00:
	            state.srPhase = 0;
	            break;
	        case 0x10:
	            state.srPhase = 0.25 * period;
	            break;
	        case 0x20:
	            state.srPhase = 0.5  * period;
	            break;
	        case 0x30:
	            state.srPhase = 0.75 * period;
	            break;
	        default:
	            throw new Error('invalid S45ROUND value');
	    }

	    n &= 0x0F;

	    if (n === 0) { state.srThreshold = 0; }
	    else { state.srThreshold = (n / 8 - 0.5) * period; }
	}

	// ROFF[] Round Off
	// 0x7A
	function ROFF(state) {
	    if (exports.DEBUG) { console.log(state.step, 'ROFF[]'); }

	    state.round = roundOff;
	}

	// RUTG[] Round Up To Grid
	// 0x7C
	function RUTG(state) {
	    if (exports.DEBUG) { console.log(state.step, 'RUTG[]'); }

	    state.round = roundUpToGrid;
	}

	// RDTG[] Round Down To Grid
	// 0x7D
	function RDTG(state) {
	    if (exports.DEBUG) { console.log(state.step, 'RDTG[]'); }

	    state.round = roundDownToGrid;
	}

	// SCANCTRL[] SCAN conversion ConTRoL
	// 0x85
	function SCANCTRL(state) {
	    var n = state.stack.pop();

	    // ignored by opentype.js

	    if (exports.DEBUG) { console.log(state.step, 'SCANCTRL[]', n); }
	}

	// SDPVTL[a] Set Dual Projection Vector To Line
	// 0x86-0x87
	function SDPVTL(a, state) {
	    var stack = state.stack;
	    var p2i = stack.pop();
	    var p1i = stack.pop();
	    var p2 = state.z2[p2i];
	    var p1 = state.z1[p1i];

	    if (exports.DEBUG) { console.log(state.step, 'SDPVTL[' + a + ']', p2i, p1i); }

	    var dx;
	    var dy;

	    if (!a) {
	        dx = p1.x - p2.x;
	        dy = p1.y - p2.y;
	    } else {
	        dx = p2.y - p1.y;
	        dy = p1.x - p2.x;
	    }

	    state.dpv = getUnitVector(dx, dy);
	}

	// GETINFO[] GET INFOrmation
	// 0x88
	function GETINFO(state) {
	    var stack = state.stack;
	    var sel = stack.pop();
	    var r = 0;

	    if (exports.DEBUG) { console.log(state.step, 'GETINFO[]', sel); }

	    // v35 as in no subpixel hinting
	    if (sel & 0x01) { r = 35; }

	    // TODO rotation and stretch currently not supported
	    // and thus those GETINFO are always 0.

	    // opentype.js is always gray scaling
	    if (sel & 0x20) { r |= 0x1000; }

	    stack.push(r);
	}

	// ROLL[] ROLL the top three stack elements
	// 0x8A
	function ROLL(state) {
	    var stack = state.stack;
	    var a = stack.pop();
	    var b = stack.pop();
	    var c = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'ROLL[]'); }

	    stack.push(b);
	    stack.push(a);
	    stack.push(c);
	}

	// MAX[] MAXimum of top two stack elements
	// 0x8B
	function MAX(state) {
	    var stack = state.stack;
	    var e2 = stack.pop();
	    var e1 = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'MAX[]', e2, e1); }

	    stack.push(Math.max(e1, e2));
	}

	// MIN[] MINimum of top two stack elements
	// 0x8C
	function MIN(state) {
	    var stack = state.stack;
	    var e2 = stack.pop();
	    var e1 = stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'MIN[]', e2, e1); }

	    stack.push(Math.min(e1, e2));
	}

	// SCANTYPE[] SCANTYPE
	// 0x8D
	function SCANTYPE(state) {
	    var n = state.stack.pop();
	    // ignored by opentype.js
	    if (exports.DEBUG) { console.log(state.step, 'SCANTYPE[]', n); }
	}

	// INSTCTRL[] INSTCTRL
	// 0x8D
	function INSTCTRL(state) {
	    var s = state.stack.pop();
	    var v = state.stack.pop();

	    if (exports.DEBUG) { console.log(state.step, 'INSTCTRL[]', s, v); }

	    switch (s) {
	        case 1 : state.inhibitGridFit = !!v; return;
	        case 2 : state.ignoreCvt = !!v; return;
	        default: throw new Error('invalid INSTCTRL[] selector');
	    }
	}

	// PUSHB[abc] PUSH Bytes
	// 0xB0-0xB7
	function PUSHB(n, state) {
	    var stack = state.stack;
	    var prog = state.prog;
	    var ip = state.ip;

	    if (exports.DEBUG) { console.log(state.step, 'PUSHB[' + n + ']'); }

	    for (var i = 0; i < n; i++) { stack.push(prog[++ip]); }

	    state.ip = ip;
	}

	// PUSHW[abc] PUSH Words
	// 0xB8-0xBF
	function PUSHW(n, state) {
	    var ip = state.ip;
	    var prog = state.prog;
	    var stack = state.stack;

	    if (exports.DEBUG) { console.log(state.ip, 'PUSHW[' + n + ']'); }

	    for (var i = 0; i < n; i++) {
	        var w = (prog[++ip] << 8) | prog[++ip];
	        if (w & 0x8000) { w = -((w ^ 0xffff) + 1); }
	        stack.push(w);
	    }

	    state.ip = ip;
	}

	// MDRP[abcde] Move Direct Relative Point
	// 0xD0-0xEF
	// (if indirect is 0)
	//
	// and
	//
	// MIRP[abcde] Move Indirect Relative Point
	// 0xE0-0xFF
	// (if indirect is 1)

	function MDRP_MIRP(indirect, setRp0, keepD, ro, dt, state) {
	    var stack = state.stack;
	    var cvte = indirect && stack.pop();
	    var pi = stack.pop();
	    var rp0i = state.rp0;
	    var rp = state.z0[rp0i];
	    var p = state.z1[pi];

	    var md = state.minDis;
	    var fv = state.fv;
	    var pv = state.dpv;
	    var od; // original distance
	    var d; // moving distance
	    var sign; // sign of distance
	    var cv;

	    d = od = pv.distance(p, rp, true, true);
	    sign = d >= 0 ? 1 : -1; // Math.sign would be 0 in case of 0

	    // TODO consider autoFlip
	    d = Math.abs(d);

	    if (indirect) {
	        cv = state.cvt[cvte];

	        if (ro && Math.abs(d - cv) < state.cvCutIn) { d = cv; }
	    }

	    if (keepD && d < md) { d = md; }

	    if (ro) { d = state.round(d); }

	    fv.setRelative(p, rp, sign * d, pv);
	    fv.touch(p);

	    if (exports.DEBUG) {
	        console.log(
	            state.step,
	            (indirect ? 'MIRP[' : 'MDRP[') +
	            (setRp0 ? 'M' : 'm') +
	            (keepD ? '>' : '_') +
	            (ro ? 'R' : '_') +
	            (dt === 0 ? 'Gr' : (dt === 1 ? 'Bl' : (dt === 2 ? 'Wh' : ''))) +
	            ']',
	            indirect ?
	                cvte + '(' + state.cvt[cvte] + ',' +  cv + ')' :
	                '',
	            pi,
	            '(d =', od, '->', sign * d, ')'
	        );
	    }

	    state.rp1 = state.rp0;
	    state.rp2 = pi;
	    if (setRp0) { state.rp0 = pi; }
	}

	/*
	* The instruction table.
	*/
	instructionTable = [
	    /* 0x00 */ SVTCA.bind(undefined, yUnitVector),
	    /* 0x01 */ SVTCA.bind(undefined, xUnitVector),
	    /* 0x02 */ SPVTCA.bind(undefined, yUnitVector),
	    /* 0x03 */ SPVTCA.bind(undefined, xUnitVector),
	    /* 0x04 */ SFVTCA.bind(undefined, yUnitVector),
	    /* 0x05 */ SFVTCA.bind(undefined, xUnitVector),
	    /* 0x06 */ SPVTL.bind(undefined, 0),
	    /* 0x07 */ SPVTL.bind(undefined, 1),
	    /* 0x08 */ SFVTL.bind(undefined, 0),
	    /* 0x09 */ SFVTL.bind(undefined, 1),
	    /* 0x0A */ SPVFS,
	    /* 0x0B */ SFVFS,
	    /* 0x0C */ GPV,
	    /* 0x0D */ GFV,
	    /* 0x0E */ SFVTPV,
	    /* 0x0F */ ISECT,
	    /* 0x10 */ SRP0,
	    /* 0x11 */ SRP1,
	    /* 0x12 */ SRP2,
	    /* 0x13 */ SZP0,
	    /* 0x14 */ SZP1,
	    /* 0x15 */ SZP2,
	    /* 0x16 */ SZPS,
	    /* 0x17 */ SLOOP,
	    /* 0x18 */ RTG,
	    /* 0x19 */ RTHG,
	    /* 0x1A */ SMD,
	    /* 0x1B */ ELSE,
	    /* 0x1C */ JMPR,
	    /* 0x1D */ SCVTCI,
	    /* 0x1E */ undefined,   // TODO SSWCI
	    /* 0x1F */ undefined,   // TODO SSW
	    /* 0x20 */ DUP,
	    /* 0x21 */ POP,
	    /* 0x22 */ CLEAR,
	    /* 0x23 */ SWAP,
	    /* 0x24 */ DEPTH,
	    /* 0x25 */ CINDEX,
	    /* 0x26 */ MINDEX,
	    /* 0x27 */ undefined,   // TODO ALIGNPTS
	    /* 0x28 */ undefined,
	    /* 0x29 */ undefined,   // TODO UTP
	    /* 0x2A */ LOOPCALL,
	    /* 0x2B */ CALL,
	    /* 0x2C */ FDEF,
	    /* 0x2D */ undefined,   // ENDF (eaten by FDEF)
	    /* 0x2E */ MDAP.bind(undefined, 0),
	    /* 0x2F */ MDAP.bind(undefined, 1),
	    /* 0x30 */ IUP.bind(undefined, yUnitVector),
	    /* 0x31 */ IUP.bind(undefined, xUnitVector),
	    /* 0x32 */ SHP.bind(undefined, 0),
	    /* 0x33 */ SHP.bind(undefined, 1),
	    /* 0x34 */ SHC.bind(undefined, 0),
	    /* 0x35 */ SHC.bind(undefined, 1),
	    /* 0x36 */ SHZ.bind(undefined, 0),
	    /* 0x37 */ SHZ.bind(undefined, 1),
	    /* 0x38 */ SHPIX,
	    /* 0x39 */ IP,
	    /* 0x3A */ MSIRP.bind(undefined, 0),
	    /* 0x3B */ MSIRP.bind(undefined, 1),
	    /* 0x3C */ ALIGNRP,
	    /* 0x3D */ RTDG,
	    /* 0x3E */ MIAP.bind(undefined, 0),
	    /* 0x3F */ MIAP.bind(undefined, 1),
	    /* 0x40 */ NPUSHB,
	    /* 0x41 */ NPUSHW,
	    /* 0x42 */ WS,
	    /* 0x43 */ RS,
	    /* 0x44 */ WCVTP,
	    /* 0x45 */ RCVT,
	    /* 0x46 */ GC.bind(undefined, 0),
	    /* 0x47 */ GC.bind(undefined, 1),
	    /* 0x48 */ undefined,   // TODO SCFS
	    /* 0x49 */ MD.bind(undefined, 0),
	    /* 0x4A */ MD.bind(undefined, 1),
	    /* 0x4B */ MPPEM,
	    /* 0x4C */ undefined,   // TODO MPS
	    /* 0x4D */ FLIPON,
	    /* 0x4E */ undefined,   // TODO FLIPOFF
	    /* 0x4F */ undefined,   // TODO DEBUG
	    /* 0x50 */ LT,
	    /* 0x51 */ LTEQ,
	    /* 0x52 */ GT,
	    /* 0x53 */ GTEQ,
	    /* 0x54 */ EQ,
	    /* 0x55 */ NEQ,
	    /* 0x56 */ ODD,
	    /* 0x57 */ EVEN,
	    /* 0x58 */ IF,
	    /* 0x59 */ EIF,
	    /* 0x5A */ AND,
	    /* 0x5B */ OR,
	    /* 0x5C */ NOT,
	    /* 0x5D */ DELTAP123.bind(undefined, 1),
	    /* 0x5E */ SDB,
	    /* 0x5F */ SDS,
	    /* 0x60 */ ADD,
	    /* 0x61 */ SUB,
	    /* 0x62 */ DIV,
	    /* 0x63 */ MUL,
	    /* 0x64 */ ABS,
	    /* 0x65 */ NEG,
	    /* 0x66 */ FLOOR,
	    /* 0x67 */ CEILING,
	    /* 0x68 */ ROUND.bind(undefined, 0),
	    /* 0x69 */ ROUND.bind(undefined, 1),
	    /* 0x6A */ ROUND.bind(undefined, 2),
	    /* 0x6B */ ROUND.bind(undefined, 3),
	    /* 0x6C */ undefined,   // TODO NROUND[ab]
	    /* 0x6D */ undefined,   // TODO NROUND[ab]
	    /* 0x6E */ undefined,   // TODO NROUND[ab]
	    /* 0x6F */ undefined,   // TODO NROUND[ab]
	    /* 0x70 */ WCVTF,
	    /* 0x71 */ DELTAP123.bind(undefined, 2),
	    /* 0x72 */ DELTAP123.bind(undefined, 3),
	    /* 0x73 */ DELTAC123.bind(undefined, 1),
	    /* 0x74 */ DELTAC123.bind(undefined, 2),
	    /* 0x75 */ DELTAC123.bind(undefined, 3),
	    /* 0x76 */ SROUND,
	    /* 0x77 */ S45ROUND,
	    /* 0x78 */ undefined,   // TODO JROT[]
	    /* 0x79 */ undefined,   // TODO JROF[]
	    /* 0x7A */ ROFF,
	    /* 0x7B */ undefined,
	    /* 0x7C */ RUTG,
	    /* 0x7D */ RDTG,
	    /* 0x7E */ POP, // actually SANGW, supposed to do only a pop though
	    /* 0x7F */ POP, // actually AA, supposed to do only a pop though
	    /* 0x80 */ undefined,   // TODO FLIPPT
	    /* 0x81 */ undefined,   // TODO FLIPRGON
	    /* 0x82 */ undefined,   // TODO FLIPRGOFF
	    /* 0x83 */ undefined,
	    /* 0x84 */ undefined,
	    /* 0x85 */ SCANCTRL,
	    /* 0x86 */ SDPVTL.bind(undefined, 0),
	    /* 0x87 */ SDPVTL.bind(undefined, 1),
	    /* 0x88 */ GETINFO,
	    /* 0x89 */ undefined,   // TODO IDEF
	    /* 0x8A */ ROLL,
	    /* 0x8B */ MAX,
	    /* 0x8C */ MIN,
	    /* 0x8D */ SCANTYPE,
	    /* 0x8E */ INSTCTRL,
	    /* 0x8F */ undefined,
	    /* 0x90 */ undefined,
	    /* 0x91 */ undefined,
	    /* 0x92 */ undefined,
	    /* 0x93 */ undefined,
	    /* 0x94 */ undefined,
	    /* 0x95 */ undefined,
	    /* 0x96 */ undefined,
	    /* 0x97 */ undefined,
	    /* 0x98 */ undefined,
	    /* 0x99 */ undefined,
	    /* 0x9A */ undefined,
	    /* 0x9B */ undefined,
	    /* 0x9C */ undefined,
	    /* 0x9D */ undefined,
	    /* 0x9E */ undefined,
	    /* 0x9F */ undefined,
	    /* 0xA0 */ undefined,
	    /* 0xA1 */ undefined,
	    /* 0xA2 */ undefined,
	    /* 0xA3 */ undefined,
	    /* 0xA4 */ undefined,
	    /* 0xA5 */ undefined,
	    /* 0xA6 */ undefined,
	    /* 0xA7 */ undefined,
	    /* 0xA8 */ undefined,
	    /* 0xA9 */ undefined,
	    /* 0xAA */ undefined,
	    /* 0xAB */ undefined,
	    /* 0xAC */ undefined,
	    /* 0xAD */ undefined,
	    /* 0xAE */ undefined,
	    /* 0xAF */ undefined,
	    /* 0xB0 */ PUSHB.bind(undefined, 1),
	    /* 0xB1 */ PUSHB.bind(undefined, 2),
	    /* 0xB2 */ PUSHB.bind(undefined, 3),
	    /* 0xB3 */ PUSHB.bind(undefined, 4),
	    /* 0xB4 */ PUSHB.bind(undefined, 5),
	    /* 0xB5 */ PUSHB.bind(undefined, 6),
	    /* 0xB6 */ PUSHB.bind(undefined, 7),
	    /* 0xB7 */ PUSHB.bind(undefined, 8),
	    /* 0xB8 */ PUSHW.bind(undefined, 1),
	    /* 0xB9 */ PUSHW.bind(undefined, 2),
	    /* 0xBA */ PUSHW.bind(undefined, 3),
	    /* 0xBB */ PUSHW.bind(undefined, 4),
	    /* 0xBC */ PUSHW.bind(undefined, 5),
	    /* 0xBD */ PUSHW.bind(undefined, 6),
	    /* 0xBE */ PUSHW.bind(undefined, 7),
	    /* 0xBF */ PUSHW.bind(undefined, 8),
	    /* 0xC0 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 0),
	    /* 0xC1 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 1),
	    /* 0xC2 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 2),
	    /* 0xC3 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 3),
	    /* 0xC4 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 0),
	    /* 0xC5 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 1),
	    /* 0xC6 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 2),
	    /* 0xC7 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 3),
	    /* 0xC8 */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 0),
	    /* 0xC9 */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 1),
	    /* 0xCA */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 2),
	    /* 0xCB */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 3),
	    /* 0xCC */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 0),
	    /* 0xCD */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 1),
	    /* 0xCE */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 2),
	    /* 0xCF */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 3),
	    /* 0xD0 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 0),
	    /* 0xD1 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 1),
	    /* 0xD2 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 2),
	    /* 0xD3 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 3),
	    /* 0xD4 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 0),
	    /* 0xD5 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 1),
	    /* 0xD6 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 2),
	    /* 0xD7 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 3),
	    /* 0xD8 */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 0),
	    /* 0xD9 */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 1),
	    /* 0xDA */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 2),
	    /* 0xDB */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 3),
	    /* 0xDC */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 0),
	    /* 0xDD */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 1),
	    /* 0xDE */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 2),
	    /* 0xDF */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 3),
	    /* 0xE0 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 0),
	    /* 0xE1 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 1),
	    /* 0xE2 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 2),
	    /* 0xE3 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 3),
	    /* 0xE4 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 0),
	    /* 0xE5 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 1),
	    /* 0xE6 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 2),
	    /* 0xE7 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 3),
	    /* 0xE8 */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 0),
	    /* 0xE9 */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 1),
	    /* 0xEA */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 2),
	    /* 0xEB */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 3),
	    /* 0xEC */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 0),
	    /* 0xED */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 1),
	    /* 0xEE */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 2),
	    /* 0xEF */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 3),
	    /* 0xF0 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 0),
	    /* 0xF1 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 1),
	    /* 0xF2 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 2),
	    /* 0xF3 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 3),
	    /* 0xF4 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 0),
	    /* 0xF5 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 1),
	    /* 0xF6 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 2),
	    /* 0xF7 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 3),
	    /* 0xF8 */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 0),
	    /* 0xF9 */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 1),
	    /* 0xFA */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 2),
	    /* 0xFB */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 3),
	    /* 0xFC */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 0),
	    /* 0xFD */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 1),
	    /* 0xFE */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 2),
	    /* 0xFF */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 3)
	];

	/*****************************
	  Mathematical Considerations
	******************************

	fv ... refers to freedom vector
	pv ... refers to projection vector
	rp ... refers to reference point
	p  ... refers to to point being operated on
	d  ... refers to distance

	SETRELATIVE:
	============

	case freedom vector == x-axis:
	------------------------------

	                        (pv)
	                     .-'
	              rpd .-'
	               .-*
	          d .-'90°'
	         .-'       '
	      .-'           '
	   *-'               ' b
	  rp                  '
	                       '
	                        '
	            p *----------*-------------- (fv)
	                          pm

	  rpdx = rpx + d * pv.x
	  rpdy = rpy + d * pv.y

	  equation of line b

	   y - rpdy = pvns * (x- rpdx)

	   y = p.y

	   x = rpdx + ( p.y - rpdy ) / pvns


	case freedom vector == y-axis:
	------------------------------

	    * pm
	    |\
	    | \
	    |  \
	    |   \
	    |    \
	    |     \
	    |      \
	    |       \
	    |        \
	    |         \ b
	    |          \
	    |           \
	    |            \    .-' (pv)
	    |         90° \.-'
	    |           .-'* rpd
	    |        .-'
	    *     *-'  d
	    p     rp

	  rpdx = rpx + d * pv.x
	  rpdy = rpy + d * pv.y

	  equation of line b:
	           pvns ... normal slope to pv

	   y - rpdy = pvns * (x - rpdx)

	   x = p.x

	   y = rpdy +  pvns * (p.x - rpdx)



	generic case:
	-------------


	                              .'(fv)
	                            .'
	                          .* pm
	                        .' !
	                      .'    .
	                    .'      !
	                  .'         . b
	                .'           !
	               *              .
	              p               !
	                         90°   .    ... (pv)
	                           ...-*-'''
	                  ...---'''    rpd
	         ...---'''   d
	   *--'''
	  rp

	    rpdx = rpx + d * pv.x
	    rpdy = rpy + d * pv.y

	 equation of line b:
	    pvns... normal slope to pv

	    y - rpdy = pvns * (x - rpdx)

	 equation of freedom vector line:
	    fvs ... slope of freedom vector (=fy/fx)

	    y - py = fvs * (x - px)


	  on pm both equations are true for same x/y

	    y - rpdy = pvns * (x - rpdx)

	    y - py = fvs * (x - px)

	  form to y and set equal:

	    pvns * (x - rpdx) + rpdy = fvs * (x - px) + py

	  expand:

	    pvns * x - pvns * rpdx + rpdy = fvs * x - fvs * px + py

	  switch:

	    fvs * x - fvs * px + py = pvns * x - pvns * rpdx + rpdy

	  solve for x:

	    fvs * x - pvns * x = fvs * px - pvns * rpdx - py + rpdy



	          fvs * px - pvns * rpdx + rpdy - py
	    x =  -----------------------------------
	                 fvs - pvns

	  and:

	    y = fvs * (x - px) + py



	INTERPOLATE:
	============

	Examples of point interpolation.

	The weight of the movement of the reference point gets bigger
	the further the other reference point is away, thus the safest
	option (that is avoiding 0/0 divisions) is to weight the
	original distance of the other point by the sum of both distances.

	If the sum of both distances is 0, then move the point by the
	arithmetic average of the movement of both reference points.




	           (+6)
	    rp1o *---->*rp1
	         .     .                          (+12)
	         .     .                  rp2o *---------->* rp2
	         .     .                       .           .
	         .     .                       .           .
	         .    10          20           .           .
	         |.........|...................|           .
	               .   .                               .
	               .   . (+8)                          .
	                po *------>*p                      .
	               .           .                       .
	               .    12     .          24           .
	               |...........|.......................|
	                                  36


	-------



	           (+10)
	    rp1o *-------->*rp1
	         .         .                      (-10)
	         .         .              rp2 *<---------* rpo2
	         .         .                   .         .
	         .         .                   .         .
	         .    10   .          30       .         .
	         |.........|.............................|
	                   .                   .
	                   . (+5)              .
	                po *--->* p            .
	                   .    .              .
	                   .    .   20         .
	                   |....|..............|
	                     5        15


	-------


	           (+10)
	    rp1o *-------->*rp1
	         .         .
	         .         .
	    rp2o *-------->*rp2


	                               (+10)
	                          po *-------->* p

	-------


	           (+10)
	    rp1o *-------->*rp1
	         .         .
	         .         .(+30)
	    rp2o *---------------------------->*rp2


	                                        (+25)
	                          po *----------------------->* p



	vim: set ts=4 sw=4 expandtab:
	*****/

	/**
	 * Converts a string into a list of tokens.
	 */

	/**
	 * Create a new token
	 * @param {string} char a single char
	 */
	function Token(char) {
	    this.char = char;
	    this.state = {};
	    this.activeState = null;
	}

	/**
	 * Create a new context range
	 * @param {number} startIndex range start index
	 * @param {number} endOffset range end index offset
	 * @param {string} contextName owner context name
	 */
	function ContextRange(startIndex, endOffset, contextName) {
	    this.contextName = contextName;
	    this.startIndex = startIndex;
	    this.endOffset = endOffset;
	}

	/**
	 * Check context start and end
	 * @param {string} contextName a unique context name
	 * @param {function} checkStart a predicate function the indicates a context's start
	 * @param {function} checkEnd a predicate function the indicates a context's end
	 */
	function ContextChecker(contextName, checkStart, checkEnd) {
	    this.contextName = contextName;
	    this.openRange = null;
	    this.ranges = [];
	    this.checkStart = checkStart;
	    this.checkEnd = checkEnd;
	}

	/**
	 * @typedef ContextParams
	 * @type Object
	 * @property {array} context context items
	 * @property {number} currentIndex current item index
	 */

	/**
	 * Create a context params
	 * @param {array} context a list of items
	 * @param {number} currentIndex current item index
	 */
	function ContextParams(context, currentIndex) {
	    this.context = context;
	    this.index = currentIndex;
	    this.length = context.length;
	    this.current = context[currentIndex];
	    this.backtrack = context.slice(0, currentIndex);
	    this.lookahead = context.slice(currentIndex + 1);
	}

	/**
	 * Create an event instance
	 * @param {string} eventId event unique id
	 */
	function Event(eventId) {
	    this.eventId = eventId;
	    this.subscribers = [];
	}

	/**
	 * Initialize a core events and auto subscribe required event handlers
	 * @param {any} events an object that enlists core events handlers
	 */
	function initializeCoreEvents(events) {
	    var this$1 = this;

	    var coreEvents = [
	        'start', 'end', 'next', 'newToken', 'contextStart',
	        'contextEnd', 'insertToken', 'removeToken', 'removeRange',
	        'replaceToken', 'replaceRange', 'composeRUD', 'updateContextsRanges'
	    ];

	    coreEvents.forEach(function (eventId) {
	        Object.defineProperty(this$1.events, eventId, {
	            value: new Event(eventId)
	        });
	    });

	    if (!!events) {
	        coreEvents.forEach(function (eventId) {
	            var event = events[eventId];
	            if (typeof event === 'function') {
	                this$1.events[eventId].subscribe(event);
	            }
	        });
	    }
	    var requiresContextUpdate = [
	        'insertToken', 'removeToken', 'removeRange',
	        'replaceToken', 'replaceRange', 'composeRUD'
	    ];
	    requiresContextUpdate.forEach(function (eventId) {
	        this$1.events[eventId].subscribe(
	            this$1.updateContextsRanges
	        );
	    });
	}

	/**
	 * Converts a string into a list of tokens
	 * @param {any} events tokenizer core events
	 */
	function Tokenizer(events) {
	    this.tokens = [];
	    this.registeredContexts = {};
	    this.contextCheckers = [];
	    this.events = {};
	    this.registeredModifiers = [];

	    initializeCoreEvents.call(this, events);
	}

	/**
	 * Sets the state of a token, usually called by a state modifier.
	 * @param {string} key state item key
	 * @param {any} value state item value
	 */
	Token.prototype.setState = function(key, value) {
	    this.state[key] = value;
	    this.activeState = { key: key, value: this.state[key] };
	    return this.activeState;
	};

	Token.prototype.getState = function (stateId) {
	    return this.state[stateId] || null;
	};

	/**
	 * Checks if an index exists in the tokens list.
	 * @param {number} index token index
	 */
	Tokenizer.prototype.inboundIndex = function(index) {
	    return index >= 0 && index < this.tokens.length;
	};

	/**
	 * Compose and apply a list of operations (replace, update, delete)
	 * @param {array} RUDs replace, update and delete operations
	 * TODO: Perf. Optimization (lengthBefore === lengthAfter ? dispatch once)
	 */
	Tokenizer.prototype.composeRUD = function (RUDs) {
	    var this$1 = this;

	    var silent = true;
	    var state = RUDs.map(function (RUD) { return (
	        this$1[RUD[0]].apply(this$1, RUD.slice(1).concat(silent))
	    ); });
	    var hasFAILObject = function (obj) { return (
	        typeof obj === 'object' &&
	        obj.hasOwnProperty('FAIL')
	    ); };
	    if (state.every(hasFAILObject)) {
	        return {
	            FAIL: "composeRUD: one or more operations hasn't completed successfully",
	            report: state.filter(hasFAILObject)
	        };
	    }
	    this.dispatch('composeRUD', [state.filter(function (op) { return !hasFAILObject(op); })]);
	};

	/**
	 * Replace a range of tokens with a list of tokens
	 * @param {number} startIndex range start index
	 * @param {number} offset range offset
	 * @param {token} tokens a list of tokens to replace
	 * @param {boolean} silent dispatch events and update context ranges
	 */
	Tokenizer.prototype.replaceRange = function (startIndex, offset, tokens, silent) {
	    offset = offset !== null ? offset : this.tokens.length;
	    var isTokenType = tokens.every(function (token) { return token instanceof Token; });
	    if (!isNaN(startIndex) && this.inboundIndex(startIndex) && isTokenType) {
	        var replaced = this.tokens.splice.apply(
	            this.tokens, [startIndex, offset].concat(tokens)
	        );
	        if (!silent) { this.dispatch('replaceToken', [startIndex, offset, tokens]); }
	        return [replaced, tokens];
	    } else {
	        return { FAIL: 'replaceRange: invalid tokens or startIndex.' };
	    }
	};

	/**
	 * Replace a token with another token
	 * @param {number} index token index
	 * @param {token} token a token to replace
	 * @param {boolean} silent dispatch events and update context ranges
	 */
	Tokenizer.prototype.replaceToken = function (index, token, silent) {
	    if (!isNaN(index) && this.inboundIndex(index) && token instanceof Token) {
	        var replaced = this.tokens.splice(index, 1, token);
	        if (!silent) { this.dispatch('replaceToken', [index, token]); }
	        return [replaced[0], token];
	    } else {
	        return { FAIL: 'replaceToken: invalid token or index.' };
	    }
	};

	/**
	 * Removes a range of tokens
	 * @param {number} startIndex range start index
	 * @param {number} offset range offset
	 * @param {boolean} silent dispatch events and update context ranges
	 */
	Tokenizer.prototype.removeRange = function(startIndex, offset, silent) {
	    offset = !isNaN(offset) ? offset : this.tokens.length;
	    var tokens = this.tokens.splice(startIndex, offset);
	    if (!silent) { this.dispatch('removeRange', [tokens, startIndex, offset]); }
	    return tokens;
	};

	/**
	 * Remove a token at a certain index
	 * @param {number} index token index
	 * @param {boolean} silent dispatch events and update context ranges
	 */
	Tokenizer.prototype.removeToken = function(index, silent) {
	    if (!isNaN(index) && this.inboundIndex(index)) {
	        var token = this.tokens.splice(index, 1);
	        if (!silent) { this.dispatch('removeToken', [token, index]); }
	        return token;
	    } else {
	        return { FAIL: 'removeToken: invalid token index.' };
	    }
	};

	/**
	 * Insert a list of tokens at a certain index
	 * @param {array} tokens a list of tokens to insert
	 * @param {number} index insert the list of tokens at index
	 * @param {boolean} silent dispatch events and update context ranges
	 */
	Tokenizer.prototype.insertToken = function (tokens, index, silent) {
	    var tokenType = tokens.every(
	        function (token) { return token instanceof Token; }
	    );
	    if (tokenType) {
	        this.tokens.splice.apply(
	            this.tokens, [index, 0].concat(tokens)
	        );
	        if (!silent) { this.dispatch('insertToken', [tokens, index]); }
	        return tokens;
	    } else {
	        return { FAIL: 'insertToken: invalid token(s).' };
	    }
	};

	/**
	 * A state modifier that is called on 'newToken' event
	 * @param {string} modifierId state modifier id
	 * @param {function} condition a predicate function that returns true or false
	 * @param {function} modifier a function to update token state
	 */
	Tokenizer.prototype.registerModifier = function(modifierId, condition, modifier) {
	    this.events.newToken.subscribe(function(token, contextParams) {
	        var conditionParams = [token, contextParams];
	        var canApplyModifier = (
	            condition === null ||
	            condition.apply(this, conditionParams) === true
	        );
	        var modifierParams = [token, contextParams];
	        if (canApplyModifier) {
	            var newStateValue = modifier.apply(this, modifierParams);
	            token.setState(modifierId, newStateValue);
	        }
	    });
	    this.registeredModifiers.push(modifierId);
	};

	/**
	 * Subscribe a handler to an event
	 * @param {function} eventHandler an event handler function
	 */
	Event.prototype.subscribe = function (eventHandler) {
	    if (typeof eventHandler === 'function') {
	        return ((this.subscribers.push(eventHandler)) - 1);
	    } else {
	        return { FAIL: ("invalid '" + (this.eventId) + "' event handler")};
	    }
	};

	/**
	 * Unsubscribe an event handler
	 * @param {string} subsId subscription id
	 */
	Event.prototype.unsubscribe = function (subsId) {
	    this.subscribers.splice(subsId, 1);
	};

	/**
	 * Sets context params current value index
	 * @param {number} index context params current value index
	 */
	ContextParams.prototype.setCurrentIndex = function(index) {
	    this.index = index;
	    this.current = this.context[index];
	    this.backtrack = this.context.slice(0, index);
	    this.lookahead = this.context.slice(index + 1);
	};

	/**
	 * Get an item at an offset from the current value
	 * example (current value is 3):
	 *  1    2   [3]   4    5   |   items values
	 * -2   -1    0    1    2   |   offset values
	 * @param {number} offset an offset from current value index
	 */
	ContextParams.prototype.get = function (offset) {
	    switch (true) {
	        case (offset === 0):
	            return this.current;
	        case (offset < 0 && Math.abs(offset) <= this.backtrack.length):
	            return this.backtrack.slice(offset)[0];
	        case (offset > 0 && offset <= this.lookahead.length):
	            return this.lookahead[offset - 1];
	        default:
	            return null;
	    }
	};

	/**
	 * Converts a context range into a string value
	 * @param {contextRange} range a context range
	 */
	Tokenizer.prototype.rangeToText = function (range) {
	    if (range instanceof ContextRange) {
	        return (
	            this.getRangeTokens(range)
	                .map(function (token) { return token.char; }).join('')
	        );
	    }
	};

	/**
	 * Converts all tokens into a string
	 */
	Tokenizer.prototype.getText = function () {
	    return this.tokens.map(function (token) { return token.char; }).join('');
	};

	/**
	 * Get a context by name
	 * @param {string} contextName context name to get
	 */
	Tokenizer.prototype.getContext = function (contextName) {
	    var context = this.registeredContexts[contextName];
	    return !!context ? context : null;
	};

	/**
	 * Subscribes a new event handler to an event
	 * @param {string} eventName event name to subscribe to
	 * @param {function} eventHandler a function to be invoked on event
	 */
	Tokenizer.prototype.on = function(eventName, eventHandler) {
	    var event = this.events[eventName];
	    if (!!event) {
	        return event.subscribe(eventHandler);
	    } else {
	        return null;
	    }
	};

	/**
	 * Dispatches an event
	 * @param {string} eventName event name
	 * @param {any} args event handler arguments
	 */
	Tokenizer.prototype.dispatch = function(eventName, args) {
	    var this$1 = this;

	    var event = this.events[eventName];
	    if (event instanceof Event) {
	        event.subscribers.forEach(function (subscriber) {
	            subscriber.apply(this$1, args || []);
	        });
	    }
	};

	/**
	 * Register a new context checker
	 * @param {string} contextName a unique context name
	 * @param {function} contextStartCheck a predicate function that returns true on context start
	 * @param {function} contextEndCheck  a predicate function that returns true on context end
	 * TODO: call tokenize on registration to update context ranges with the new context.
	 */
	Tokenizer.prototype.registerContextChecker = function(contextName, contextStartCheck, contextEndCheck) {
	    if (!!this.getContext(contextName)) { return {
	        FAIL:
	        ("context name '" + contextName + "' is already registered.")
	    }; }
	    if (typeof contextStartCheck !== 'function') { return {
	        FAIL:
	        "missing context start check."
	    }; }
	    if (typeof contextEndCheck !== 'function') { return {
	        FAIL:
	        "missing context end check."
	    }; }
	    var contextCheckers = new ContextChecker(
	        contextName, contextStartCheck, contextEndCheck
	    );
	    this.registeredContexts[contextName] = contextCheckers;
	    this.contextCheckers.push(contextCheckers);
	    return contextCheckers;
	};

	/**
	 * Gets a context range tokens
	 * @param {contextRange} range a context range
	 */
	Tokenizer.prototype.getRangeTokens = function(range) {
	    var endIndex = range.startIndex + range.endOffset;
	    return [].concat(
	        this.tokens
	            .slice(range.startIndex, endIndex)
	    );
	};

	/**
	 * Gets the ranges of a context
	 * @param {string} contextName context name
	 */
	Tokenizer.prototype.getContextRanges = function(contextName) {
	    var context = this.getContext(contextName);
	    if (!!context) {
	        return context.ranges;
	    } else {
	        return { FAIL: ("context checker '" + contextName + "' is not registered.") };
	    }
	};

	/**
	 * Resets context ranges to run context update
	 */
	Tokenizer.prototype.resetContextsRanges = function () {
	    var registeredContexts = this.registeredContexts;
	    for (var contextName in registeredContexts) {
	        if (registeredContexts.hasOwnProperty(contextName)) {
	            var context = registeredContexts[contextName];
	            context.ranges = [];
	        }
	    }
	};

	/**
	 * Updates context ranges
	 */
	Tokenizer.prototype.updateContextsRanges = function () {
	    var this$1 = this;

	    this.resetContextsRanges();
	    var chars = this.tokens.map(function (token) { return token.char; });
	    for (var i = 0; i < chars.length; i++) {
	        var contextParams = new ContextParams(chars, i);
	        this$1.runContextCheck(contextParams);
	    }
	    this.dispatch('updateContextsRanges', [this.registeredContexts]);
	};

	/**
	 * Sets the end offset of an open range
	 * @param {number} offset range end offset
	 * @param {string} contextName context name
	 */
	Tokenizer.prototype.setEndOffset = function (offset, contextName) {
	    var startIndex = this.getContext(contextName).openRange.startIndex;
	    var range = new ContextRange(startIndex, offset, contextName);
	    var ranges = this.getContext(contextName).ranges;
	    range.rangeId = contextName + "." + (ranges.length);
	    ranges.push(range);
	    this.getContext(contextName).openRange = null;
	    return range;
	};

	/**
	 * Runs a context check on the current context
	 * @param {contextParams} contextParams current context params
	 */
	Tokenizer.prototype.runContextCheck = function(contextParams) {
	    var this$1 = this;

	    var index = contextParams.index;
	    this.contextCheckers.forEach(function (contextChecker) {
	        var contextName = contextChecker.contextName;
	        var openRange = this$1.getContext(contextName).openRange;
	        if (!openRange && contextChecker.checkStart(contextParams)) {
	            openRange = new ContextRange(index, null, contextName);
	            this$1.getContext(contextName).openRange = openRange;
	            this$1.dispatch('contextStart', [contextName, index]);
	        }
	        if (!!openRange && contextChecker.checkEnd(contextParams)) {
	            var offset = (index - openRange.startIndex) + 1;
	            var range = this$1.setEndOffset(offset, contextName);
	            this$1.dispatch('contextEnd', [contextName, range]);
	        }
	    });
	};

	/**
	 * Converts a text into a list of tokens
	 * @param {string} text a text to tokenize
	 */
	Tokenizer.prototype.tokenize = function (text) {
	    var this$1 = this;

	    this.tokens = [];
	    this.resetContextsRanges();
	    var chars = Array.from(text);
	    this.dispatch('start');
	    for (var i = 0; i < chars.length; i++) {
	        var char = chars[i];
	        var contextParams = new ContextParams(chars, i);
	        this$1.dispatch('next', [contextParams]);
	        this$1.runContextCheck(contextParams);
	        var token = new Token(char);
	        this$1.tokens.push(token);
	        this$1.dispatch('newToken', [token, contextParams]);
	    }
	    this.dispatch('end', [this.tokens]);
	    return this.tokens;
	};

	// ╭─┄┄┄────────────────────────┄─────────────────────────────────────────────╮
	// ┊ Character Class Assertions ┊ Checks if a char belongs to a certain class ┊
	// ╰─╾──────────────────────────┄─────────────────────────────────────────────╯
	// jscs:disable maximumLineLength
	/**
	 * Check if a char is Arabic
	 * @param {string} c a single char
	 */
	function isArabicChar(c) {
	    return /[\u0600-\u065F\u066A-\u06D2\u06FA-\u06FF]/.test(c);
	}

	/**
	 * Check if a char is an isolated arabic char
	 * @param {string} c a single char
	 */
	function isIsolatedArabicChar(char) {
	    return /[\u0630\u0690\u0621\u0631\u0661\u0671\u0622\u0632\u0672\u0692\u06C2\u0623\u0673\u0693\u06C3\u0624\u0694\u06C4\u0625\u0675\u0695\u06C5\u06E5\u0676\u0696\u06C6\u0627\u0677\u0697\u06C7\u0648\u0688\u0698\u06C8\u0689\u0699\u06C9\u068A\u06CA\u066B\u068B\u06CB\u068C\u068D\u06CD\u06FD\u068E\u06EE\u06FE\u062F\u068F\u06CF\u06EF]/.test(char);
	}

	/**
	 * Check if a char is an Arabic Tashkeel char
	 * @param {string} c a single char
	 */
	function isTashkeelArabicChar(char) {
	    return /[\u0600-\u0605\u060C-\u060E\u0610-\u061B\u061E\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED]/.test(char);
	}

	/**
	 * Check if a char is Latin
	 * @param {string} c a single char
	 */
	function isLatinChar(c) {
	    return /[A-z]/.test(c);
	}

	/**
	 * Check if a char is whitespace char
	 * @param {string} c a single char
	 */
	function isWhiteSpace(c) {
	    return /\s/.test(c);
	}

	/**
	 * Query a feature by some of it's properties to lookup a glyph substitution.
	 */

	/**
	 * Create feature query instance
	 * @param {Font} font opentype font instance
	 */
	function FeatureQuery(font) {
	    this.font = font;
	    this.features = {};
	}

	/**
	 * @typedef SubstitutionAction
	 * @type Object
	 * @property {number} id substitution type
	 * @property {string} tag feature tag
	 * @property {any} substitution substitution value(s)
	 */

	/**
	 * Create a substitution action instance
	 * @param {SubstitutionAction} action
	 */
	function SubstitutionAction(action) {
	    this.id = action.id;
	    this.tag = action.tag;
	    this.substitution = action.substitution;
	}

	/**
	 * Lookup a coverage table
	 * @param {number} glyphIndex glyph index
	 * @param {CoverageTable} coverage coverage table
	 */
	function lookupCoverage(glyphIndex, coverage) {
	    if (!glyphIndex) { return -1; }
	    switch (coverage.format) {
	        case 1:
	            return coverage.glyphs.indexOf(glyphIndex);

	        case 2:
	            var ranges = coverage.ranges;
	            for (var i = 0; i < ranges.length; i++) {
	                var range = ranges[i];
	                if (glyphIndex >= range.start && glyphIndex <= range.end) {
	                    var offset = glyphIndex - range.start;
	                    return range.index + offset;
	                }
	            }
	            break;
	        default:
	            return -1; // not found
	    }
	    return -1;
	}

	/**
	 * Handle a single substitution - format 1
	 * @param {ContextParams} contextParams context params to lookup
	 */
	function singleSubstitutionFormat1(glyphIndex, subtable) {
	    var substituteIndex = lookupCoverage(glyphIndex, subtable.coverage);
	    if (substituteIndex === -1) { return null; }
	    return glyphIndex + subtable.deltaGlyphId;
	}

	/**
	 * Handle a single substitution - format 2
	 * @param {ContextParams} contextParams context params to lookup
	 */
	function singleSubstitutionFormat2(glyphIndex, subtable) {
	    var substituteIndex = lookupCoverage(glyphIndex, subtable.coverage);
	    if (substituteIndex === -1) { return null; }
	    return subtable.substitute[substituteIndex];
	}

	/**
	 * Lookup a list of coverage tables
	 * @param {any} coverageList a list of coverage tables
	 * @param {ContextParams} contextParams context params to lookup
	 */
	function lookupCoverageList(coverageList, contextParams) {
	    var lookupList = [];
	    for (var i = 0; i < coverageList.length; i++) {
	        var coverage = coverageList[i];
	        var glyphIndex = contextParams.current;
	        glyphIndex = Array.isArray(glyphIndex) ? glyphIndex[0] : glyphIndex;
	        var lookupIndex = lookupCoverage(glyphIndex, coverage);
	        if (lookupIndex !== -1) {
	            lookupList.push(lookupIndex);
	        }
	    }
	    if (lookupList.length !== coverageList.length) { return -1; }
	    return lookupList;
	}

	/**
	 * Handle chaining context substitution - format 3
	 * @param {ContextParams} contextParams context params to lookup
	 */
	function chainingSubstitutionFormat3(contextParams, subtable) {
	    var this$1 = this;

	    var lookupsCount = (
	        subtable.inputCoverage.length +
	        subtable.lookaheadCoverage.length +
	        subtable.backtrackCoverage.length
	    );
	    if (contextParams.context.length < lookupsCount) { return []; }
	    // INPUT LOOKUP //
	    var inputLookups = lookupCoverageList(
	        subtable.inputCoverage, contextParams
	    );
	    if (inputLookups === -1) { return []; }
	    // LOOKAHEAD LOOKUP //
	    var lookaheadOffset = subtable.inputCoverage.length - 1;
	    if (contextParams.lookahead.length < subtable.lookaheadCoverage.length) { return []; }
	    var lookaheadContext = contextParams.lookahead.slice(lookaheadOffset);
	    while (lookaheadContext.length && isTashkeelArabicChar(lookaheadContext[0].char)) {
	        lookaheadContext.shift();
	    }
	    var lookaheadParams = new ContextParams(lookaheadContext, 0);
	    var lookaheadLookups = lookupCoverageList(
	        subtable.lookaheadCoverage, lookaheadParams
	    );
	    // BACKTRACK LOOKUP //
	    var backtrackContext = [].concat(contextParams.backtrack);
	    backtrackContext.reverse();
	    while (backtrackContext.length && isTashkeelArabicChar(backtrackContext[0].char)) {
	        backtrackContext.shift();
	    }
	    if (backtrackContext.length < subtable.backtrackCoverage.length) { return []; }
	    var backtrackParams = new ContextParams(backtrackContext, 0);
	    var backtrackLookups = lookupCoverageList(
	        subtable.backtrackCoverage, backtrackParams
	    );
	    var contextRulesMatch = (
	        inputLookups.length === subtable.inputCoverage.length &&
	        lookaheadLookups.length === subtable.lookaheadCoverage.length &&
	        backtrackLookups.length === subtable.backtrackCoverage.length
	    );
	    var substitutions = [];
	    if (contextRulesMatch) {
	        for (var i = 0; i < subtable.lookupRecords.length; i++) {
	            var lookupRecord = subtable.lookupRecords[i];
	            var lookupListIndex = lookupRecord.lookupListIndex;
	            var lookupTable = this$1.getLookupByIndex(lookupListIndex);
	            for (var s = 0; s < lookupTable.subtables.length; s++) {
	                var subtable$1 = lookupTable.subtables[s];
	                var lookup = this$1.getLookupMethod(lookupTable, subtable$1);
	                var substitutionType = this$1.getSubstitutionType(lookupTable, subtable$1);
	                if (substitutionType === '12') {
	                    for (var n = 0; n < inputLookups.length; n++) {
	                        var glyphIndex = contextParams.get(n);
	                        var substitution = lookup(glyphIndex);
	                        if (substitution) { substitutions.push(substitution); }
	                    }
	                }
	            }
	        }
	    }
	    return substitutions;
	}

	/**
	 * Handle ligature substitution - format 1
	 * @param {ContextParams} contextParams context params to lookup
	 */
	function ligatureSubstitutionFormat1(contextParams, subtable) {
	    // COVERAGE LOOKUP //
	    var glyphIndex = contextParams.current;
	    var ligSetIndex = lookupCoverage(glyphIndex, subtable.coverage);
	    if (ligSetIndex === -1) { return null; }
	    // COMPONENTS LOOKUP
	    // (!) note, components are ordered in the written direction.
	    var ligature;
	    var ligatureSet = subtable.ligatureSets[ligSetIndex];
	    for (var s = 0; s < ligatureSet.length; s++) {
	        ligature = ligatureSet[s];
	        for (var l = 0; l < ligature.components.length; l++) {
	            var lookaheadItem = contextParams.lookahead[l];
	            var component = ligature.components[l];
	            if (lookaheadItem !== component) { break; }
	            if (l === ligature.components.length - 1) { return ligature; }
	        }
	    }
	    return null;
	}

	/**
	 * Handle decomposition substitution - format 1
	 * @param {number} glyphIndex glyph index
	 * @param {any} subtable subtable
	 */
	function decompositionSubstitutionFormat1(glyphIndex, subtable) {
	    var substituteIndex = lookupCoverage(glyphIndex, subtable.coverage);
	    if (substituteIndex === -1) { return null; }
	    return subtable.sequences[substituteIndex];
	}

	/**
	 * Get default script features indexes
	 */
	FeatureQuery.prototype.getDefaultScriptFeaturesIndexes = function () {
	    var scripts = this.font.tables.gsub.scripts;
	    for (var s = 0; s < scripts.length; s++) {
	        var script = scripts[s];
	        if (script.tag === 'DFLT') { return (
	            script.script.defaultLangSys.featureIndexes
	        ); }
	    }
	    return [];
	};

	/**
	 * Get feature indexes of a specific script
	 * @param {string} scriptTag script tag
	 */
	FeatureQuery.prototype.getScriptFeaturesIndexes = function(scriptTag) {
	    var tables = this.font.tables;
	    if (!tables.gsub) { return []; }
	    if (!scriptTag) { return this.getDefaultScriptFeaturesIndexes(); }
	    var scripts = this.font.tables.gsub.scripts;
	    for (var i = 0; i < scripts.length; i++) {
	        var script = scripts[i];
	        if (script.tag === scriptTag && script.script.defaultLangSys) {
	            return script.script.defaultLangSys.featureIndexes;
	        } else {
	            var langSysRecords = script.langSysRecords;
	            if (!!langSysRecords) {
	                for (var j = 0; j < langSysRecords.length; j++) {
	                    var langSysRecord = langSysRecords[j];
	                    if (langSysRecord.tag === scriptTag) {
	                        var langSys = langSysRecord.langSys;
	                        return langSys.featureIndexes;
	                    }
	                }
	            }
	        }
	    }
	    return this.getDefaultScriptFeaturesIndexes();
	};

	/**
	 * Map a feature tag to a gsub feature
	 * @param {any} features gsub features
	 * @param {string} scriptTag script tag
	 */
	FeatureQuery.prototype.mapTagsToFeatures = function (features, scriptTag) {
	    var tags = {};
	    for (var i = 0; i < features.length; i++) {
	        var tag = features[i].tag;
	        var feature = features[i].feature;
	        tags[tag] = feature;
	    }
	    this.features[scriptTag].tags = tags;
	};

	/**
	 * Get features of a specific script
	 * @param {string} scriptTag script tag
	 */
	FeatureQuery.prototype.getScriptFeatures = function (scriptTag) {
	    var features = this.features[scriptTag];
	    if (this.features.hasOwnProperty(scriptTag)) { return features; }
	    var featuresIndexes = this.getScriptFeaturesIndexes(scriptTag);
	    if (!featuresIndexes) { return null; }
	    var gsub = this.font.tables.gsub;
	    features = featuresIndexes.map(function (index) { return gsub.features[index]; });
	    this.features[scriptTag] = features;
	    this.mapTagsToFeatures(features, scriptTag);
	    return features;
	};

	/**
	 * Get substitution type
	 * @param {any} lookupTable lookup table
	 * @param {any} subtable subtable
	 */
	FeatureQuery.prototype.getSubstitutionType = function(lookupTable, subtable) {
	    var lookupType = lookupTable.lookupType.toString();
	    var substFormat = subtable.substFormat.toString();
	    return lookupType + substFormat;
	};

	/**
	 * Get lookup method
	 * @param {any} lookupTable lookup table
	 * @param {any} subtable subtable
	 */
	FeatureQuery.prototype.getLookupMethod = function(lookupTable, subtable) {
	    var this$1 = this;

	    var substitutionType = this.getSubstitutionType(lookupTable, subtable);
	    switch (substitutionType) {
	        case '11':
	            return function (glyphIndex) { return singleSubstitutionFormat1.apply(
	                this$1, [glyphIndex, subtable]
	            ); };
	        case '12':
	            return function (glyphIndex) { return singleSubstitutionFormat2.apply(
	                this$1, [glyphIndex, subtable]
	            ); };
	        case '63':
	            return function (contextParams) { return chainingSubstitutionFormat3.apply(
	                this$1, [contextParams, subtable]
	            ); };
	        case '41':
	            return function (contextParams) { return ligatureSubstitutionFormat1.apply(
	                this$1, [contextParams, subtable]
	            ); };
	        case '21':
	            return function (glyphIndex) { return decompositionSubstitutionFormat1.apply(
	                this$1, [glyphIndex, subtable]
	            ); };
	        default:
	            throw new Error(
	                "lookupType: " + (lookupTable.lookupType) + " - " +
	                "substFormat: " + (subtable.substFormat) + " " +
	                "is not yet supported"
	            );
	    }
	};

	/**
	 * [ LOOKUP TYPES ]
	 * -------------------------------
	 * Single                        1;
	 * Multiple                      2;
	 * Alternate                     3;
	 * Ligature                      4;
	 * Context                       5;
	 * ChainingContext               6;
	 * ExtensionSubstitution         7;
	 * ReverseChainingContext        8;
	 * -------------------------------
	 *
	 */

	/**
	 * @typedef FQuery
	 * @type Object
	 * @param {string} tag feature tag
	 * @param {string} script feature script
	 * @param {ContextParams} contextParams context params
	 */

	/**
	 * Lookup a feature using a query parameters
	 * @param {FQuery} query feature query
	 */
	FeatureQuery.prototype.lookupFeature = function (query) {
	    var this$1 = this;

	    var contextParams = query.contextParams;
	    var currentIndex = contextParams.index;
	    var feature = this.getFeature({
	        tag: query.tag, script: query.script
	    });
	    if (!feature) { return new Error(
	        "font '" + (this.font.names.fullName.en) + "' " +
	        "doesn't support feature '" + (query.tag) + "' " +
	        "for script '" + (query.script) + "'."
	    ); }
	    var lookups = this.getFeatureLookups(feature);
	    var substitutions = [].concat(contextParams.context);
	    for (var l = 0; l < lookups.length; l++) {
	        var lookupTable = lookups[l];
	        var subtables = this$1.getLookupSubtables(lookupTable);
	        for (var s = 0; s < subtables.length; s++) {
	            var subtable = subtables[s];
	            var substType = this$1.getSubstitutionType(lookupTable, subtable);
	            var lookup = this$1.getLookupMethod(lookupTable, subtable);
	            var substitution = (void 0);
	            switch (substType) {
	                case '11':
	                    substitution = lookup(contextParams.current);
	                    if (substitution) {
	                        substitutions.splice(currentIndex, 1, new SubstitutionAction({
	                            id: 11, tag: query.tag, substitution: substitution
	                        }));
	                    }
	                    break;
	                case '12':
	                    substitution = lookup(contextParams.current);
	                    if (substitution) {
	                        substitutions.splice(currentIndex, 1, new SubstitutionAction({
	                            id: 12, tag: query.tag, substitution: substitution
	                        }));
	                    }
	                    break;
	                case '63':
	                    substitution = lookup(contextParams);
	                    if (Array.isArray(substitution) && substitution.length) {
	                        substitutions.splice(currentIndex, 1, new SubstitutionAction({
	                            id: 63, tag: query.tag, substitution: substitution
	                        }));
	                    }
	                    break;
	                case '41':
	                    substitution = lookup(contextParams);
	                    if (substitution) {
	                        substitutions.splice(currentIndex, 1, new SubstitutionAction({
	                            id: 41, tag: query.tag, substitution: substitution
	                        }));
	                    }
	                    break;
	                case '21':
	                    substitution = lookup(contextParams.current);
	                    if (substitution) {
	                        substitutions.splice(currentIndex, 1, new SubstitutionAction({
	                            id: 21, tag: query.tag, substitution: substitution
	                        }));
	                    }
	                    break;
	            }
	            contextParams = new ContextParams(substitutions, currentIndex);
	            if (Array.isArray(substitution) && !substitution.length) { continue; }
	            substitution = null;
	        }
	    }
	    return substitutions.length ? substitutions : null;
	};

	/**
	 * Checks if a font supports a specific features
	 * @param {FQuery} query feature query object
	 */
	FeatureQuery.prototype.supports = function (query) {
	    if (!query.script) { return false; }
	    this.getScriptFeatures(query.script);
	    var supportedScript = this.features.hasOwnProperty(query.script);
	    if (!query.tag) { return supportedScript; }
	    var supportedFeature = (
	        this.features[query.script].some(function (feature) { return feature.tag === query.tag; })
	    );
	    return supportedScript && supportedFeature;
	};

	/**
	 * Get lookup table subtables
	 * @param {any} lookupTable lookup table
	 */
	FeatureQuery.prototype.getLookupSubtables = function (lookupTable) {
	    return lookupTable.subtables || null;
	};

	/**
	 * Get lookup table by index
	 * @param {number} index lookup table index
	 */
	FeatureQuery.prototype.getLookupByIndex = function (index) {
	    var lookups = this.font.tables.gsub.lookups;
	    return lookups[index] || null;
	};

	/**
	 * Get lookup tables for a feature
	 * @param {string} feature
	 */
	FeatureQuery.prototype.getFeatureLookups = function (feature) {
	    // TODO: memoize
	    return feature.lookupListIndexes.map(this.getLookupByIndex.bind(this));
	};

	/**
	 * Query a feature by it's properties
	 * @param {any} query an object that describes the properties of a query
	 */
	FeatureQuery.prototype.getFeature = function getFeature(query) {
	    if (!this.font) { return { FAIL: "No font was found"}; }
	    if (!this.features.hasOwnProperty(query.script)) {
	        this.getScriptFeatures(query.script);
	    }
	    var scriptFeatures = this.features[query.script];
	    if (!scriptFeatures) { return (
	        { FAIL: ("No feature for script " + (query.script))}
	    ); }
	    if (!scriptFeatures.tags[query.tag]) { return null; }
	    return this.features[query.script].tags[query.tag];
	};

	/**
	 * Arabic word context checkers
	 */

	function arabicWordStartCheck(contextParams) {
	    var char = contextParams.current;
	    var prevChar = contextParams.get(-1);
	    return (
	        // ? arabic first char
	        (prevChar === null && isArabicChar(char)) ||
	        // ? arabic char preceded with a non arabic char
	        (!isArabicChar(prevChar) && isArabicChar(char))
	    );
	}

	function arabicWordEndCheck(contextParams) {
	    var nextChar = contextParams.get(1);
	    return (
	        // ? last arabic char
	        (nextChar === null) ||
	        // ? next char is not arabic
	        (!isArabicChar(nextChar))
	    );
	}

	var arabicWordCheck = {
	    startCheck: arabicWordStartCheck,
	    endCheck: arabicWordEndCheck
	};

	/**
	 * Arabic sentence context checkers
	 */

	function arabicSentenceStartCheck(contextParams) {
	    var char = contextParams.current;
	    var prevChar = contextParams.get(-1);
	    return (
	        // ? an arabic char preceded with a non arabic char
	        (isArabicChar(char) || isTashkeelArabicChar(char)) &&
	        !isArabicChar(prevChar)
	    );
	}

	function arabicSentenceEndCheck(contextParams) {
	    var nextChar = contextParams.get(1);
	    switch (true) {
	        case nextChar === null:
	            return true;
	        case (!isArabicChar(nextChar) && !isTashkeelArabicChar(nextChar)):
	            var nextIsWhitespace = isWhiteSpace(nextChar);
	            if (!nextIsWhitespace) { return true; }
	            if (nextIsWhitespace) {
	                var arabicCharAhead = false;
	                arabicCharAhead = (
	                    contextParams.lookahead.some(
	                        function (c) { return isArabicChar(c) || isTashkeelArabicChar(c); }
	                    )
	                );
	                if (!arabicCharAhead) { return true; }
	            }
	            break;
	        default:
	            return false;
	    }
	}

	var arabicSentenceCheck = {
	    startCheck: arabicSentenceStartCheck,
	    endCheck: arabicSentenceEndCheck
	};

	/**
	 * Apply single substitution format 1
	 * @param {Array} substitutions substitutions
	 * @param {any} tokens a list of tokens
	 * @param {number} index token index
	 */
	function singleSubstitutionFormat1$1(action, tokens, index) {
	    tokens[index].setState(action.tag, action.substitution);
	}

	/**
	 * Apply single substitution format 2
	 * @param {Array} substitutions substitutions
	 * @param {any} tokens a list of tokens
	 * @param {number} index token index
	 */
	function singleSubstitutionFormat2$1(action, tokens, index) {
	    tokens[index].setState(action.tag, action.substitution);
	}

	/**
	 * Apply chaining context substitution format 3
	 * @param {Array} substitutions substitutions
	 * @param {any} tokens a list of tokens
	 * @param {number} index token index
	 */
	function chainingSubstitutionFormat3$1(action, tokens, index) {
	    action.substitution.forEach(function (subst, offset) {
	        var token = tokens[index + offset];
	        token.setState(action.tag, subst);
	    });
	}

	/**
	 * Apply ligature substitution format 1
	 * @param {Array} substitutions substitutions
	 * @param {any} tokens a list of tokens
	 * @param {number} index token index
	 */
	function ligatureSubstitutionFormat1$1(action, tokens, index) {
	    var token = tokens[index];
	    token.setState(action.tag, action.substitution.ligGlyph);
	    var compsCount = action.substitution.components.length;
	    for (var i = 0; i < compsCount; i++) {
	        token = tokens[index + i + 1];
	        token.setState('deleted', true);
	    }
	}

	/**
	 * Supported substitutions
	 */
	var SUBSTITUTIONS = {
	    11: singleSubstitutionFormat1$1,
	    12: singleSubstitutionFormat2$1,
	    63: chainingSubstitutionFormat3$1,
	    41: ligatureSubstitutionFormat1$1
	};

	/**
	 * Apply substitutions to a list of tokens
	 * @param {Array} substitutions substitutions
	 * @param {any} tokens a list of tokens
	 * @param {number} index token index
	 */
	function applySubstitution(action, tokens, index) {
	    if (action instanceof SubstitutionAction) {
	        SUBSTITUTIONS[action.id](action, tokens, index);
	    }
	}

	/**
	 * Apply Arabic presentation forms to a range of tokens
	 */

	/**
	 * Check if a char can be connected to it's preceding char
	 * @param {ContextParams} charContextParams context params of a char
	 */
	function willConnectPrev(charContextParams) {
	    var backtrack = [].concat(charContextParams.backtrack);
	    for (var i = backtrack.length - 1; i >= 0; i--) {
	        var prevChar = backtrack[i];
	        var isolated = isIsolatedArabicChar(prevChar);
	        var tashkeel = isTashkeelArabicChar(prevChar);
	        if (!isolated && !tashkeel) { return true; }
	        if (isolated) { return false; }
	    }
	    return false;
	}

	/**
	 * Check if a char can be connected to it's proceeding char
	 * @param {ContextParams} charContextParams context params of a char
	 */
	function willConnectNext(charContextParams) {
	    if (isIsolatedArabicChar(charContextParams.current)) { return false; }
	    for (var i = 0; i < charContextParams.lookahead.length; i++) {
	        var nextChar = charContextParams.lookahead[i];
	        var tashkeel = isTashkeelArabicChar(nextChar);
	        if (!tashkeel) { return true; }
	    }
	    return false;
	}

	/**
	 * Apply arabic presentation forms to a list of tokens
	 * @param {ContextRange} range a range of tokens
	 */
	function arabicPresentationForms(range) {
	    var this$1 = this;

	    var script = 'arab';
	    var tags = this.featuresTags[script];
	    var tokens = this.tokenizer.getRangeTokens(range);
	    if (tokens.length === 1) { return; }
	    var contextParams = new ContextParams(
	        tokens.map(function (token) { return token.getState('glyphIndex'); }
	    ), 0);
	    var charContextParams = new ContextParams(
	        tokens.map(function (token) { return token.char; }
	    ), 0);
	    tokens.forEach(function (token, index) {
	        if (isTashkeelArabicChar(token.char)) { return; }
	        contextParams.setCurrentIndex(index);
	        charContextParams.setCurrentIndex(index);
	        var CONNECT = 0; // 2 bits 00 (10: can connect next) (01: can connect prev)
	        if (willConnectPrev(charContextParams)) { CONNECT |= 1; }
	        if (willConnectNext(charContextParams)) { CONNECT |= 2; }
	        var tag;
	        switch (CONNECT) {
	            case 1: (tag = 'fina'); break;
	            case 2: (tag = 'init'); break;
	            case 3: (tag = 'medi'); break;
	        }
	        if (tags.indexOf(tag) === -1) { return; }
	        var substitutions = this$1.query.lookupFeature({
	            tag: tag, script: script, contextParams: contextParams
	        });
	        if (substitutions instanceof Error) { return console.info(substitutions.message); }
	        substitutions.forEach(function (action, index) {
	            if (action instanceof SubstitutionAction) {
	                applySubstitution(action, tokens, index);
	                contextParams.context[index] = action.substitution;
	            }
	        });
	    });
	}

	/**
	 * Apply Arabic required ligatures feature to a range of tokens
	 */

	/**
	 * Update context params
	 * @param {any} tokens a list of tokens
	 * @param {number} index current item index
	 */
	function getContextParams(tokens, index) {
	    var context = tokens.map(function (token) { return token.activeState.value; });
	    return new ContextParams(context, index || 0);
	}

	/**
	 * Apply Arabic required ligatures to a context range
	 * @param {ContextRange} range a range of tokens
	 */
	function arabicRequiredLigatures(range) {
	    var this$1 = this;

	    var script = 'arab';
	    var tokens = this.tokenizer.getRangeTokens(range);
	    var contextParams = getContextParams(tokens);
	    contextParams.context.forEach(function (glyphIndex, index) {
	        contextParams.setCurrentIndex(index);
	        var substitutions = this$1.query.lookupFeature({
	            tag: 'rlig', script: script, contextParams: contextParams
	        });
	        if (substitutions.length) {
	            substitutions.forEach(
	                function (action) { return applySubstitution(action, tokens, index); }
	            );
	            contextParams = getContextParams(tokens);
	        }
	    });
	}

	/**
	 * Latin word context checkers
	 */

	function latinWordStartCheck(contextParams) {
	    var char = contextParams.current;
	    var prevChar = contextParams.get(-1);
	    return (
	        // ? latin first char
	        (prevChar === null && isLatinChar(char)) ||
	        // ? latin char preceded with a non latin char
	        (!isLatinChar(prevChar) && isLatinChar(char))
	    );
	}

	function latinWordEndCheck(contextParams) {
	    var nextChar = contextParams.get(1);
	    return (
	        // ? last latin char
	        (nextChar === null) ||
	        // ? next char is not latin
	        (!isLatinChar(nextChar))
	    );
	}

	var latinWordCheck = {
	    startCheck: latinWordStartCheck,
	    endCheck: latinWordEndCheck
	};

	/**
	 * Apply Latin ligature feature to a range of tokens
	 */

	/**
	 * Update context params
	 * @param {any} tokens a list of tokens
	 * @param {number} index current item index
	 */
	function getContextParams$1(tokens, index) {
	    var context = tokens.map(function (token) { return token.activeState.value; });
	    return new ContextParams(context, index || 0);
	}

	/**
	 * Apply Arabic required ligatures to a context range
	 * @param {ContextRange} range a range of tokens
	 */
	function latinLigature(range) {
	    var this$1 = this;

	    var script = 'latn';
	    var tokens = this.tokenizer.getRangeTokens(range);
	    var contextParams = getContextParams$1(tokens);
	    contextParams.context.forEach(function (glyphIndex, index) {
	        contextParams.setCurrentIndex(index);
	        var substitutions = this$1.query.lookupFeature({
	            tag: 'liga', script: script, contextParams: contextParams
	        });
	        if (substitutions.length) {
	            substitutions.forEach(
	                function (action) { return applySubstitution(action, tokens, index); }
	            );
	            contextParams = getContextParams$1(tokens);
	        }
	    });
	}

	/**
	 * Infer bidirectional properties for a given text and apply
	 * the corresponding layout rules.
	 */

	/**
	 * Create Bidi. features
	 * @param {string} baseDir text base direction. value either 'ltr' or 'rtl'
	 */
	function Bidi(baseDir) {
	    this.baseDir = baseDir || 'ltr';
	    this.tokenizer = new Tokenizer();
	    this.featuresTags = {};
	}

	/**
	 * Sets Bidi text
	 * @param {string} text a text input
	 */
	Bidi.prototype.setText = function (text) {
	    this.text = text;
	};

	/**
	 * Store essential context checks:
	 * arabic word check for applying gsub features
	 * arabic sentence check for adjusting arabic layout
	 */
	Bidi.prototype.contextChecks = ({
	    latinWordCheck: latinWordCheck,
	    arabicWordCheck: arabicWordCheck,
	    arabicSentenceCheck: arabicSentenceCheck
	});

	/**
	 * Register arabic word check
	 */
	function registerContextChecker(checkId) {
	    var check = this.contextChecks[(checkId + "Check")];
	    return this.tokenizer.registerContextChecker(
	        checkId, check.startCheck, check.endCheck
	    );
	}

	/**
	 * Perform pre tokenization procedure then
	 * tokenize text input
	 */
	function tokenizeText() {
	    registerContextChecker.call(this, 'latinWord');
	    registerContextChecker.call(this, 'arabicWord');
	    registerContextChecker.call(this, 'arabicSentence');
	    return this.tokenizer.tokenize(this.text);
	}

	/**
	 * Reverse arabic sentence layout
	 * TODO: check base dir before applying adjustments - priority low
	 */
	function reverseArabicSentences() {
	    var this$1 = this;

	    var ranges = this.tokenizer.getContextRanges('arabicSentence');
	    ranges.forEach(function (range) {
	        var rangeTokens = this$1.tokenizer.getRangeTokens(range);
	        this$1.tokenizer.replaceRange(
	            range.startIndex,
	            range.endOffset,
	            rangeTokens.reverse()
	        );
	    });
	}

	/**
	 * Register supported features tags
	 * @param {script} script script tag
	 * @param {Array} tags features tags list
	 */
	Bidi.prototype.registerFeatures = function (script, tags) {
	    var this$1 = this;

	    var supportedTags = tags.filter(
	        function (tag) { return this$1.query.supports({script: script, tag: tag}); }
	    );
	    if (!this.featuresTags.hasOwnProperty(script)) {
	        this.featuresTags[script] = supportedTags;
	    } else {
	        this.featuresTags[script] =
	        this.featuresTags[script].concat(supportedTags);
	    }
	};

	/**
	 * Apply GSUB features
	 * @param {Array} tagsList a list of features tags
	 * @param {string} script a script tag
	 * @param {Font} font opentype font instance
	 */
	Bidi.prototype.applyFeatures = function (font, features) {
	    var this$1 = this;

	    if (!font) { throw new Error(
	        'No valid font was provided to apply features'
	    ); }
	    if (!this.query) { this.query = new FeatureQuery(font); }
	    for (var f = 0; f < features.length; f++) {
	        var feature = features[f];
	        if (!this$1.query.supports({script: feature.script})) { continue; }
	        this$1.registerFeatures(feature.script, feature.tags);
	    }
	};

	/**
	 * Register a state modifier
	 * @param {string} modifierId state modifier id
	 * @param {function} condition a predicate function that returns true or false
	 * @param {function} modifier a modifier function to set token state
	 */
	Bidi.prototype.registerModifier = function (modifierId, condition, modifier) {
	    this.tokenizer.registerModifier(modifierId, condition, modifier);
	};

	/**
	 * Check if 'glyphIndex' is registered
	 */
	function checkGlyphIndexStatus() {
	    if (this.tokenizer.registeredModifiers.indexOf('glyphIndex') === -1) {
	        throw new Error(
	            'glyphIndex modifier is required to apply ' +
	            'arabic presentation features.'
	        );
	    }
	}

	/**
	 * Apply arabic presentation forms features
	 */
	function applyArabicPresentationForms() {
	    var this$1 = this;

	    var script = 'arab';
	    if (!this.featuresTags.hasOwnProperty(script)) { return; }
	    checkGlyphIndexStatus.call(this);
	    var ranges = this.tokenizer.getContextRanges('arabicWord');
	    ranges.forEach(function (range) {
	        arabicPresentationForms.call(this$1, range);
	    });
	}

	/**
	 * Apply required arabic ligatures
	 */
	function applyArabicRequireLigatures() {
	    var this$1 = this;

	    var script = 'arab';
	    if (!this.featuresTags.hasOwnProperty(script)) { return; }
	    var tags = this.featuresTags[script];
	    if (tags.indexOf('rlig') === -1) { return; }
	    checkGlyphIndexStatus.call(this);
	    var ranges = this.tokenizer.getContextRanges('arabicWord');
	    ranges.forEach(function (range) {
	        arabicRequiredLigatures.call(this$1, range);
	    });
	}

	/**
	 * Apply required arabic ligatures
	 */
	function applyLatinLigatures() {
	    var this$1 = this;

	    var script = 'latn';
	    if (!this.featuresTags.hasOwnProperty(script)) { return; }
	    var tags = this.featuresTags[script];
	    if (tags.indexOf('liga') === -1) { return; }
	    checkGlyphIndexStatus.call(this);
	    var ranges = this.tokenizer.getContextRanges('latinWord');
	    ranges.forEach(function (range) {
	        latinLigature.call(this$1, range);
	    });
	}

	/**
	 * Check if a context is registered
	 * @param {string} contextId context id
	 */
	Bidi.prototype.checkContextReady = function (contextId) {
	    return !!this.tokenizer.getContext(contextId);
	};

	/**
	 * Apply features to registered contexts
	 */
	Bidi.prototype.applyFeaturesToContexts = function () {
	    if (this.checkContextReady('arabicWord')) {
	        applyArabicPresentationForms.call(this);
	        applyArabicRequireLigatures.call(this);
	    }
	    if (this.checkContextReady('latinWord')) {
	        applyLatinLigatures.call(this);
	    }
	    if (this.checkContextReady('arabicSentence')) {
	        reverseArabicSentences.call(this);
	    }
	};

	/**
	 * process text input
	 * @param {string} text an input text
	 */
	Bidi.prototype.processText = function(text) {
	    if (!this.text || this.text !== text) {
	        this.setText(text);
	        tokenizeText.call(this);
	        this.applyFeaturesToContexts();
	    }
	};

	/**
	 * Process a string of text to identify and adjust
	 * bidirectional text entities.
	 * @param {string} text input text
	 */
	Bidi.prototype.getBidiText = function (text) {
	    this.processText(text);
	    return this.tokenizer.getText();
	};

	/**
	 * Get the current state index of each token
	 * @param {text} text an input text
	 */
	Bidi.prototype.getTextGlyphs = function (text) {
	    var this$1 = this;

	    this.processText(text);
	    var indexes = [];
	    for (var i = 0; i < this.tokenizer.tokens.length; i++) {
	        var token = this$1.tokenizer.tokens[i];
	        if (token.state.deleted) { continue; }
	        var index = token.activeState.value;
	        indexes.push(Array.isArray(index) ? index[0] : index);
	    }
	    return indexes;
	};

	// The Font object

	/**
	 * @typedef FontOptions
	 * @type Object
	 * @property {Boolean} empty - whether to create a new empty font
	 * @property {string} familyName
	 * @property {string} styleName
	 * @property {string=} fullName
	 * @property {string=} postScriptName
	 * @property {string=} designer
	 * @property {string=} designerURL
	 * @property {string=} manufacturer
	 * @property {string=} manufacturerURL
	 * @property {string=} license
	 * @property {string=} licenseURL
	 * @property {string=} version
	 * @property {string=} description
	 * @property {string=} copyright
	 * @property {string=} trademark
	 * @property {Number} unitsPerEm
	 * @property {Number} ascender
	 * @property {Number} descender
	 * @property {Number} createdTimestamp
	 * @property {string=} weightClass
	 * @property {string=} widthClass
	 * @property {string=} fsSelection
	 */

	/**
	 * A Font represents a loaded OpenType font file.
	 * It contains a set of glyphs and methods to draw text on a drawing context,
	 * or to get a path representing the text.
	 * @exports opentype.Font
	 * @class
	 * @param {FontOptions}
	 * @constructor
	 */
	function Font(options) {
	    options = options || {};

	    if (!options.empty) {
	        // Check that we've provided the minimum set of names.
	        checkArgument(options.familyName, 'When creating a new Font object, familyName is required.');
	        checkArgument(options.styleName, 'When creating a new Font object, styleName is required.');
	        checkArgument(options.unitsPerEm, 'When creating a new Font object, unitsPerEm is required.');
	        checkArgument(options.ascender, 'When creating a new Font object, ascender is required.');
	        checkArgument(options.descender, 'When creating a new Font object, descender is required.');
	        checkArgument(options.descender < 0, 'Descender should be negative (e.g. -512).');

	        // OS X will complain if the names are empty, so we put a single space everywhere by default.
	        this.names = {
	            fontFamily: {en: options.familyName || ' '},
	            fontSubfamily: {en: options.styleName || ' '},
	            fullName: {en: options.fullName || options.familyName + ' ' + options.styleName},
	            // postScriptName may not contain any whitespace
	            postScriptName: {en: options.postScriptName || (options.familyName + options.styleName).replace(/\s/g, '')},
	            designer: {en: options.designer || ' '},
	            designerURL: {en: options.designerURL || ' '},
	            manufacturer: {en: options.manufacturer || ' '},
	            manufacturerURL: {en: options.manufacturerURL || ' '},
	            license: {en: options.license || ' '},
	            licenseURL: {en: options.licenseURL || ' '},
	            version: {en: options.version || 'Version 0.1'},
	            description: {en: options.description || ' '},
	            copyright: {en: options.copyright || ' '},
	            trademark: {en: options.trademark || ' '}
	        };
	        this.unitsPerEm = options.unitsPerEm || 1000;
	        this.ascender = options.ascender;
	        this.descender = options.descender;
	        this.createdTimestamp = options.createdTimestamp;
	        this.tables = { os2: {
	            usWeightClass: options.weightClass || this.usWeightClasses.MEDIUM,
	            usWidthClass: options.widthClass || this.usWidthClasses.MEDIUM,
	            fsSelection: options.fsSelection || this.fsSelectionValues.REGULAR
	        } };
	    }

	    this.supported = true; // Deprecated: parseBuffer will throw an error if font is not supported.
	    this.glyphs = new glyphset.GlyphSet(this, options.glyphs || []);
	    this.encoding = new DefaultEncoding(this);
	    this.position = new Position(this);
	    this.substitution = new Substitution(this);
	    this.tables = this.tables || {};

	    // needed for low memory mode only.
	    this._push = null;
	    this._hmtxTableData = {};

	    Object.defineProperty(this, 'hinting', {
	        get: function() {
	            if (this._hinting) { return this._hinting; }
	            if (this.outlinesFormat === 'truetype') {
	                return (this._hinting = new Hinting(this));
	            }
	        }
	    });
	}

	/**
	 * Check if the font has a glyph for the given character.
	 * @param  {string}
	 * @return {Boolean}
	 */
	Font.prototype.hasChar = function(c) {
	    return this.encoding.charToGlyphIndex(c) !== null;
	};

	/**
	 * Convert the given character to a single glyph index.
	 * Note that this function assumes that there is a one-to-one mapping between
	 * the given character and a glyph; for complex scripts this might not be the case.
	 * @param  {string}
	 * @return {Number}
	 */
	Font.prototype.charToGlyphIndex = function(s) {
	    return this.encoding.charToGlyphIndex(s);
	};

	/**
	 * Convert the given character to a single Glyph object.
	 * Note that this function assumes that there is a one-to-one mapping between
	 * the given character and a glyph; for complex scripts this might not be the case.
	 * @param  {string}
	 * @return {opentype.Glyph}
	 */
	Font.prototype.charToGlyph = function(c) {
	    var glyphIndex = this.charToGlyphIndex(c);
	    var glyph = this.glyphs.get(glyphIndex);
	    if (!glyph) {
	        // .notdef
	        glyph = this.glyphs.get(0);
	    }

	    return glyph;
	};

	/**
	 * Update features
	 * @param {any} options features options
	 */
	Font.prototype.updateFeatures = function (options) {
	    // TODO: update all features options not only 'latn'.
	    return this.defaultRenderOptions.features.map(function (feature) {
	        if (feature.script === 'latn') {
	            return {
	                script: 'latn',
	                tags: feature.tags.filter(function (tag) { return options[tag]; })
	            };
	        } else {
	            return feature;
	        }
	    });
	};

	/**
	 * Convert the given text to a list of Glyph objects.
	 * Note that there is no strict one-to-one mapping between characters and
	 * glyphs, so the list of returned glyphs can be larger or smaller than the
	 * length of the given string.
	 * @param  {string}
	 * @param  {GlyphRenderOptions} [options]
	 * @return {opentype.Glyph[]}
	 */
	Font.prototype.stringToGlyphs = function(s, options) {
	    var this$1 = this;


	    var bidi = new Bidi();

	    // Create and register 'glyphIndex' state modifier
	    var charToGlyphIndexMod = function (token) { return this$1.charToGlyphIndex(token.char); };
	    bidi.registerModifier('glyphIndex', null, charToGlyphIndexMod);

	    // roll-back to default features
	    var features = options ?
	    this.updateFeatures(options.features) :
	    this.defaultRenderOptions.features;

	    bidi.applyFeatures(this, features);

	    var indexes = bidi.getTextGlyphs(s);

	    var length = indexes.length;

	    // convert glyph indexes to glyph objects
	    var glyphs = new Array(length);
	    var notdef = this.glyphs.get(0);
	    for (var i = 0; i < length; i += 1) {
	        glyphs[i] = this$1.glyphs.get(indexes[i]) || notdef;
	    }
	    return glyphs;
	};

	/**
	 * @param  {string}
	 * @return {Number}
	 */
	Font.prototype.nameToGlyphIndex = function(name) {
	    return this.glyphNames.nameToGlyphIndex(name);
	};

	/**
	 * @param  {string}
	 * @return {opentype.Glyph}
	 */
	Font.prototype.nameToGlyph = function(name) {
	    var glyphIndex = this.nameToGlyphIndex(name);
	    var glyph = this.glyphs.get(glyphIndex);
	    if (!glyph) {
	        // .notdef
	        glyph = this.glyphs.get(0);
	    }

	    return glyph;
	};

	/**
	 * @param  {Number}
	 * @return {String}
	 */
	Font.prototype.glyphIndexToName = function(gid) {
	    if (!this.glyphNames.glyphIndexToName) {
	        return '';
	    }

	    return this.glyphNames.glyphIndexToName(gid);
	};

	/**
	 * Retrieve the value of the kerning pair between the left glyph (or its index)
	 * and the right glyph (or its index). If no kerning pair is found, return 0.
	 * The kerning value gets added to the advance width when calculating the spacing
	 * between glyphs.
	 * For GPOS kerning, this method uses the default script and language, which covers
	 * most use cases. To have greater control, use font.position.getKerningValue .
	 * @param  {opentype.Glyph} leftGlyph
	 * @param  {opentype.Glyph} rightGlyph
	 * @return {Number}
	 */
	Font.prototype.getKerningValue = function(leftGlyph, rightGlyph) {
	    leftGlyph = leftGlyph.index || leftGlyph;
	    rightGlyph = rightGlyph.index || rightGlyph;
	    var gposKerning = this.position.defaultKerningTables;
	    if (gposKerning) {
	        return this.position.getKerningValue(gposKerning, leftGlyph, rightGlyph);
	    }
	    // "kern" table
	    return this.kerningPairs[leftGlyph + ',' + rightGlyph] || 0;
	};

	/**
	 * @typedef GlyphRenderOptions
	 * @type Object
	 * @property {string} [script] - script used to determine which features to apply. By default, 'DFLT' or 'latn' is used.
	 *                               See https://www.microsoft.com/typography/otspec/scripttags.htm
	 * @property {string} [language='dflt'] - language system used to determine which features to apply.
	 *                                        See https://www.microsoft.com/typography/developers/opentype/languagetags.aspx
	 * @property {boolean} [kerning=true] - whether to include kerning values
	 * @property {object} [features] - OpenType Layout feature tags. Used to enable or disable the features of the given script/language system.
	 *                                 See https://www.microsoft.com/typography/otspec/featuretags.htm
	 */
	Font.prototype.defaultRenderOptions = {
	    kerning: true,
	    features: [
	        /**
	         * these 4 features are required to render Arabic text properly
	         * and shouldn't be turned off when rendering arabic text.
	         */
	        { script: 'arab', tags: ['init', 'medi', 'fina', 'rlig'] },
	        { script: 'latn', tags: ['liga', 'rlig'] }
	    ]
	};

	/**
	 * Helper function that invokes the given callback for each glyph in the given text.
	 * The callback gets `(glyph, x, y, fontSize, options)`.* @param  {string} text
	 * @param {string} text - The text to apply.
	 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
	 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
	 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
	 * @param  {GlyphRenderOptions=} options
	 * @param  {Function} callback
	 */
	Font.prototype.forEachGlyph = function(text, x, y, fontSize, options, callback) {
	    var this$1 = this;

	    x = x !== undefined ? x : 0;
	    y = y !== undefined ? y : 0;
	    fontSize = fontSize !== undefined ? fontSize : 72;
	    options = options || this.defaultRenderOptions;
	    var fontScale = 1 / this.unitsPerEm * fontSize;
	    var glyphs = this.stringToGlyphs(text, options);
	    var kerningLookups;
	    if (options.kerning) {
	        var script = options.script || this.position.getDefaultScriptName();
	        kerningLookups = this.position.getKerningTables(script, options.language);
	    }
	    for (var i = 0; i < glyphs.length; i += 1) {
	        var glyph = glyphs[i];
	        callback.call(this$1, glyph, x, y, fontSize, options);
	        if (glyph.advanceWidth) {
	            x += glyph.advanceWidth * fontScale;
	        }

	        if (options.kerning && i < glyphs.length - 1) {
	            // We should apply position adjustment lookups in a more generic way.
	            // Here we only use the xAdvance value.
	            var kerningValue = kerningLookups ?
	                  this$1.position.getKerningValue(kerningLookups, glyph.index, glyphs[i + 1].index) :
	                  this$1.getKerningValue(glyph, glyphs[i + 1]);
	            x += kerningValue * fontScale;
	        }

	        if (options.letterSpacing) {
	            x += options.letterSpacing * fontSize;
	        } else if (options.tracking) {
	            x += (options.tracking / 1000) * fontSize;
	        }
	    }
	    return x;
	};

	/**
	 * Create a Path object that represents the given text.
	 * @param  {string} text - The text to create.
	 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
	 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
	 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
	 * @param  {GlyphRenderOptions=} options
	 * @return {opentype.Path}
	 */
	Font.prototype.getPath = function(text, x, y, fontSize, options) {
	    var fullPath = new Path();
	    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
	        var glyphPath = glyph.getPath(gX, gY, gFontSize, options, this);
	        fullPath.extend(glyphPath);
	    });
	    return fullPath;
	};

	/**
	 * Create an array of Path objects that represent the glyphs of a given text.
	 * @param  {string} text - The text to create.
	 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
	 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
	 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
	 * @param  {GlyphRenderOptions=} options
	 * @return {opentype.Path[]}
	 */
	Font.prototype.getPaths = function(text, x, y, fontSize, options) {
	    var glyphPaths = [];
	    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
	        var glyphPath = glyph.getPath(gX, gY, gFontSize, options, this);
	        glyphPaths.push(glyphPath);
	    });

	    return glyphPaths;
	};

	/**
	 * Returns the advance width of a text.
	 *
	 * This is something different than Path.getBoundingBox() as for example a
	 * suffixed whitespace increases the advanceWidth but not the bounding box
	 * or an overhanging letter like a calligraphic 'f' might have a quite larger
	 * bounding box than its advance width.
	 *
	 * This corresponds to canvas2dContext.measureText(text).width
	 *
	 * @param  {string} text - The text to create.
	 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
	 * @param  {GlyphRenderOptions=} options
	 * @return advance width
	 */
	Font.prototype.getAdvanceWidth = function(text, fontSize, options) {
	    return this.forEachGlyph(text, 0, 0, fontSize, options, function() {});
	};

	/**
	 * Draw the text on the given drawing context.
	 * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
	 * @param  {string} text - The text to create.
	 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
	 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
	 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
	 * @param  {GlyphRenderOptions=} options
	 */
	Font.prototype.draw = function(ctx, text, x, y, fontSize, options) {
	    this.getPath(text, x, y, fontSize, options).draw(ctx);
	};

	/**
	 * Draw the points of all glyphs in the text.
	 * On-curve points will be drawn in blue, off-curve points will be drawn in red.
	 * @param {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
	 * @param {string} text - The text to create.
	 * @param {number} [x=0] - Horizontal position of the beginning of the text.
	 * @param {number} [y=0] - Vertical position of the *baseline* of the text.
	 * @param {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
	 * @param {GlyphRenderOptions=} options
	 */
	Font.prototype.drawPoints = function(ctx, text, x, y, fontSize, options) {
	    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
	        glyph.drawPoints(ctx, gX, gY, gFontSize);
	    });
	};

	/**
	 * Draw lines indicating important font measurements for all glyphs in the text.
	 * Black lines indicate the origin of the coordinate system (point 0,0).
	 * Blue lines indicate the glyph bounding box.
	 * Green line indicates the advance width of the glyph.
	 * @param {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
	 * @param {string} text - The text to create.
	 * @param {number} [x=0] - Horizontal position of the beginning of the text.
	 * @param {number} [y=0] - Vertical position of the *baseline* of the text.
	 * @param {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
	 * @param {GlyphRenderOptions=} options
	 */
	Font.prototype.drawMetrics = function(ctx, text, x, y, fontSize, options) {
	    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
	        glyph.drawMetrics(ctx, gX, gY, gFontSize);
	    });
	};

	/**
	 * @param  {string}
	 * @return {string}
	 */
	Font.prototype.getEnglishName = function(name) {
	    var translations = this.names[name];
	    if (translations) {
	        return translations.en;
	    }
	};

	/**
	 * Validate
	 */
	Font.prototype.validate = function() {
	    var _this = this;

	    function assert(predicate, message) {
	    }

	    function assertNamePresent(name) {
	        var englishName = _this.getEnglishName(name);
	        assert(englishName && englishName.trim().length > 0,
	               'No English ' + name + ' specified.');
	    }

	    // Identification information
	    assertNamePresent('fontFamily');
	    assertNamePresent('weightName');
	    assertNamePresent('manufacturer');
	    assertNamePresent('copyright');
	    assertNamePresent('version');

	    // Dimension information
	    assert(this.unitsPerEm > 0, 'No unitsPerEm specified.');
	};

	/**
	 * Convert the font object to a SFNT data structure.
	 * This structure contains all the necessary tables and metadata to create a binary OTF file.
	 * @return {opentype.Table}
	 */
	Font.prototype.toTables = function() {
	    return sfnt.fontToTable(this);
	};
	/**
	 * @deprecated Font.toBuffer is deprecated. Use Font.toArrayBuffer instead.
	 */
	Font.prototype.toBuffer = function() {
	    console.warn('Font.toBuffer is deprecated. Use Font.toArrayBuffer instead.');
	    return this.toArrayBuffer();
	};
	/**
	 * Converts a `opentype.Font` into an `ArrayBuffer`
	 * @return {ArrayBuffer}
	 */
	Font.prototype.toArrayBuffer = function() {
	    var sfntTable = this.toTables();
	    var bytes = sfntTable.encode();
	    var buffer = new ArrayBuffer(bytes.length);
	    var intArray = new Uint8Array(buffer);
	    for (var i = 0; i < bytes.length; i++) {
	        intArray[i] = bytes[i];
	    }

	    return buffer;
	};

	/**
	 * Initiate a download of the OpenType font.
	 */
	Font.prototype.download = function(fileName) {
	    var familyName = this.getEnglishName('fontFamily');
	    var styleName = this.getEnglishName('fontSubfamily');
	    fileName = fileName || familyName.replace(/\s/g, '') + '-' + styleName + '.otf';
	    var arrayBuffer = this.toArrayBuffer();

	    if (isBrowser()) {
	        window.URL = window.URL || window.webkitURL;

	        if (window.URL) {
	            var dataView = new DataView(arrayBuffer);
	            var blob = new Blob([dataView], {type: 'font/opentype'});

	            var link = document.createElement('a');
	            link.href = window.URL.createObjectURL(blob);
	            link.download = fileName;

	            var event = document.createEvent('MouseEvents');
	            event.initEvent('click', true, false);
	            link.dispatchEvent(event);
	        } else {
	            console.warn('Font file could not be downloaded. Try using a different browser.');
	        }
	    } else {
	        var fs = require('fs');
	        var buffer = arrayBufferToNodeBuffer(arrayBuffer);
	        fs.writeFileSync(fileName, buffer);
	    }
	};
	/**
	 * @private
	 */
	Font.prototype.fsSelectionValues = {
	    ITALIC:              0x001, //1
	    UNDERSCORE:          0x002, //2
	    NEGATIVE:            0x004, //4
	    OUTLINED:            0x008, //8
	    STRIKEOUT:           0x010, //16
	    BOLD:                0x020, //32
	    REGULAR:             0x040, //64
	    USER_TYPO_METRICS:   0x080, //128
	    WWS:                 0x100, //256
	    OBLIQUE:             0x200  //512
	};

	/**
	 * @private
	 */
	Font.prototype.usWidthClasses = {
	    ULTRA_CONDENSED: 1,
	    EXTRA_CONDENSED: 2,
	    CONDENSED: 3,
	    SEMI_CONDENSED: 4,
	    MEDIUM: 5,
	    SEMI_EXPANDED: 6,
	    EXPANDED: 7,
	    EXTRA_EXPANDED: 8,
	    ULTRA_EXPANDED: 9
	};

	/**
	 * @private
	 */
	Font.prototype.usWeightClasses = {
	    THIN: 100,
	    EXTRA_LIGHT: 200,
	    LIGHT: 300,
	    NORMAL: 400,
	    MEDIUM: 500,
	    SEMI_BOLD: 600,
	    BOLD: 700,
	    EXTRA_BOLD: 800,
	    BLACK:    900
	};

	// The `fvar` table stores font variation axes and instances.

	function addName(name, names) {
	    var nameString = JSON.stringify(name);
	    var nameID = 256;
	    for (var nameKey in names) {
	        var n = parseInt(nameKey);
	        if (!n || n < 256) {
	            continue;
	        }

	        if (JSON.stringify(names[nameKey]) === nameString) {
	            return n;
	        }

	        if (nameID <= n) {
	            nameID = n + 1;
	        }
	    }

	    names[nameID] = name;
	    return nameID;
	}

	function makeFvarAxis(n, axis, names) {
	    var nameID = addName(axis.name, names);
	    return [
	        {name: 'tag_' + n, type: 'TAG', value: axis.tag},
	        {name: 'minValue_' + n, type: 'FIXED', value: axis.minValue << 16},
	        {name: 'defaultValue_' + n, type: 'FIXED', value: axis.defaultValue << 16},
	        {name: 'maxValue_' + n, type: 'FIXED', value: axis.maxValue << 16},
	        {name: 'flags_' + n, type: 'USHORT', value: 0},
	        {name: 'nameID_' + n, type: 'USHORT', value: nameID}
	    ];
	}

	function parseFvarAxis(data, start, names) {
	    var axis = {};
	    var p = new parse.Parser(data, start);
	    axis.tag = p.parseTag();
	    axis.minValue = p.parseFixed();
	    axis.defaultValue = p.parseFixed();
	    axis.maxValue = p.parseFixed();
	    p.skip('uShort', 1);  // reserved for flags; no values defined
	    axis.name = names[p.parseUShort()] || {};
	    return axis;
	}

	function makeFvarInstance(n, inst, axes, names) {
	    var nameID = addName(inst.name, names);
	    var fields = [
	        {name: 'nameID_' + n, type: 'USHORT', value: nameID},
	        {name: 'flags_' + n, type: 'USHORT', value: 0}
	    ];

	    for (var i = 0; i < axes.length; ++i) {
	        var axisTag = axes[i].tag;
	        fields.push({
	            name: 'axis_' + n + ' ' + axisTag,
	            type: 'FIXED',
	            value: inst.coordinates[axisTag] << 16
	        });
	    }

	    return fields;
	}

	function parseFvarInstance(data, start, axes, names) {
	    var inst = {};
	    var p = new parse.Parser(data, start);
	    inst.name = names[p.parseUShort()] || {};
	    p.skip('uShort', 1);  // reserved for flags; no values defined

	    inst.coordinates = {};
	    for (var i = 0; i < axes.length; ++i) {
	        inst.coordinates[axes[i].tag] = p.parseFixed();
	    }

	    return inst;
	}

	function makeFvarTable(fvar, names) {
	    var result = new table.Table('fvar', [
	        {name: 'version', type: 'ULONG', value: 0x10000},
	        {name: 'offsetToData', type: 'USHORT', value: 0},
	        {name: 'countSizePairs', type: 'USHORT', value: 2},
	        {name: 'axisCount', type: 'USHORT', value: fvar.axes.length},
	        {name: 'axisSize', type: 'USHORT', value: 20},
	        {name: 'instanceCount', type: 'USHORT', value: fvar.instances.length},
	        {name: 'instanceSize', type: 'USHORT', value: 4 + fvar.axes.length * 4}
	    ]);
	    result.offsetToData = result.sizeOf();

	    for (var i = 0; i < fvar.axes.length; i++) {
	        result.fields = result.fields.concat(makeFvarAxis(i, fvar.axes[i], names));
	    }

	    for (var j = 0; j < fvar.instances.length; j++) {
	        result.fields = result.fields.concat(makeFvarInstance(j, fvar.instances[j], fvar.axes, names));
	    }

	    return result;
	}

	function parseFvarTable(data, start, names) {
	    var p = new parse.Parser(data, start);
	    var tableVersion = p.parseULong();
	    check.argument(tableVersion === 0x00010000, 'Unsupported fvar table version.');
	    var offsetToData = p.parseOffset16();
	    // Skip countSizePairs.
	    p.skip('uShort', 1);
	    var axisCount = p.parseUShort();
	    var axisSize = p.parseUShort();
	    var instanceCount = p.parseUShort();
	    var instanceSize = p.parseUShort();

	    var axes = [];
	    for (var i = 0; i < axisCount; i++) {
	        axes.push(parseFvarAxis(data, start + offsetToData + i * axisSize, names));
	    }

	    var instances = [];
	    var instanceStart = start + offsetToData + axisCount * axisSize;
	    for (var j = 0; j < instanceCount; j++) {
	        instances.push(parseFvarInstance(data, instanceStart + j * instanceSize, axes, names));
	    }

	    return {axes: axes, instances: instances};
	}

	var fvar = { make: makeFvarTable, parse: parseFvarTable };

	// The `GPOS` table contains kerning pairs, among other things.

	var subtableParsers$1 = new Array(10);         // subtableParsers[0] is unused

	// https://docs.microsoft.com/en-us/typography/opentype/spec/gpos#lookup-type-1-single-adjustment-positioning-subtable
	// this = Parser instance
	subtableParsers$1[1] = function parseLookup1() {
	    var start = this.offset + this.relativeOffset;
	    var posformat = this.parseUShort();
	    if (posformat === 1) {
	        return {
	            posFormat: 1,
	            coverage: this.parsePointer(Parser.coverage),
	            value: this.parseValueRecord()
	        };
	    } else if (posformat === 2) {
	        return {
	            posFormat: 2,
	            coverage: this.parsePointer(Parser.coverage),
	            values: this.parseValueRecordList()
	        };
	    }
	    check.assert(false, '0x' + start.toString(16) + ': GPOS lookup type 1 format must be 1 or 2.');
	};

	// https://docs.microsoft.com/en-us/typography/opentype/spec/gpos#lookup-type-2-pair-adjustment-positioning-subtable
	subtableParsers$1[2] = function parseLookup2() {
	    var start = this.offset + this.relativeOffset;
	    var posFormat = this.parseUShort();
	    check.assert(posFormat === 1 || posFormat === 2, '0x' + start.toString(16) + ': GPOS lookup type 2 format must be 1 or 2.');
	    var coverage = this.parsePointer(Parser.coverage);
	    var valueFormat1 = this.parseUShort();
	    var valueFormat2 = this.parseUShort();
	    if (posFormat === 1) {
	        // Adjustments for Glyph Pairs
	        return {
	            posFormat: posFormat,
	            coverage: coverage,
	            valueFormat1: valueFormat1,
	            valueFormat2: valueFormat2,
	            pairSets: this.parseList(Parser.pointer(Parser.list(function() {
	                return {        // pairValueRecord
	                    secondGlyph: this.parseUShort(),
	                    value1: this.parseValueRecord(valueFormat1),
	                    value2: this.parseValueRecord(valueFormat2)
	                };
	            })))
	        };
	    } else if (posFormat === 2) {
	        var classDef1 = this.parsePointer(Parser.classDef);
	        var classDef2 = this.parsePointer(Parser.classDef);
	        var class1Count = this.parseUShort();
	        var class2Count = this.parseUShort();
	        return {
	            // Class Pair Adjustment
	            posFormat: posFormat,
	            coverage: coverage,
	            valueFormat1: valueFormat1,
	            valueFormat2: valueFormat2,
	            classDef1: classDef1,
	            classDef2: classDef2,
	            class1Count: class1Count,
	            class2Count: class2Count,
	            classRecords: this.parseList(class1Count, Parser.list(class2Count, function() {
	                return {
	                    value1: this.parseValueRecord(valueFormat1),
	                    value2: this.parseValueRecord(valueFormat2)
	                };
	            }))
	        };
	    }
	};

	subtableParsers$1[3] = function parseLookup3() { return { error: 'GPOS Lookup 3 not supported' }; };
	subtableParsers$1[4] = function parseLookup4() { return { error: 'GPOS Lookup 4 not supported' }; };
	subtableParsers$1[5] = function parseLookup5() { return { error: 'GPOS Lookup 5 not supported' }; };
	subtableParsers$1[6] = function parseLookup6() { return { error: 'GPOS Lookup 6 not supported' }; };
	subtableParsers$1[7] = function parseLookup7() { return { error: 'GPOS Lookup 7 not supported' }; };
	subtableParsers$1[8] = function parseLookup8() { return { error: 'GPOS Lookup 8 not supported' }; };
	subtableParsers$1[9] = function parseLookup9() { return { error: 'GPOS Lookup 9 not supported' }; };

	// https://docs.microsoft.com/en-us/typography/opentype/spec/gpos
	function parseGposTable(data, start) {
	    start = start || 0;
	    var p = new Parser(data, start);
	    var tableVersion = p.parseVersion(1);
	    check.argument(tableVersion === 1 || tableVersion === 1.1, 'Unsupported GPOS table version ' + tableVersion);

	    if (tableVersion === 1) {
	        return {
	            version: tableVersion,
	            scripts: p.parseScriptList(),
	            features: p.parseFeatureList(),
	            lookups: p.parseLookupList(subtableParsers$1)
	        };
	    } else {
	        return {
	            version: tableVersion,
	            scripts: p.parseScriptList(),
	            features: p.parseFeatureList(),
	            lookups: p.parseLookupList(subtableParsers$1),
	            variations: p.parseFeatureVariationsList()
	        };
	    }

	}

	// GPOS Writing //////////////////////////////////////////////
	// NOT SUPPORTED
	var subtableMakers$1 = new Array(10);

	function makeGposTable(gpos) {
	    return new table.Table('GPOS', [
	        {name: 'version', type: 'ULONG', value: 0x10000},
	        {name: 'scripts', type: 'TABLE', value: new table.ScriptList(gpos.scripts)},
	        {name: 'features', type: 'TABLE', value: new table.FeatureList(gpos.features)},
	        {name: 'lookups', type: 'TABLE', value: new table.LookupList(gpos.lookups, subtableMakers$1)}
	    ]);
	}

	var gpos = { parse: parseGposTable, make: makeGposTable };

	// The `kern` table contains kerning pairs.

	function parseWindowsKernTable(p) {
	    var pairs = {};
	    // Skip nTables.
	    p.skip('uShort');
	    var subtableVersion = p.parseUShort();
	    check.argument(subtableVersion === 0, 'Unsupported kern sub-table version.');
	    // Skip subtableLength, subtableCoverage
	    p.skip('uShort', 2);
	    var nPairs = p.parseUShort();
	    // Skip searchRange, entrySelector, rangeShift.
	    p.skip('uShort', 3);
	    for (var i = 0; i < nPairs; i += 1) {
	        var leftIndex = p.parseUShort();
	        var rightIndex = p.parseUShort();
	        var value = p.parseShort();
	        pairs[leftIndex + ',' + rightIndex] = value;
	    }
	    return pairs;
	}

	function parseMacKernTable(p) {
	    var pairs = {};
	    // The Mac kern table stores the version as a fixed (32 bits) but we only loaded the first 16 bits.
	    // Skip the rest.
	    p.skip('uShort');
	    var nTables = p.parseULong();
	    //check.argument(nTables === 1, 'Only 1 subtable is supported (got ' + nTables + ').');
	    if (nTables > 1) {
	        console.warn('Only the first kern subtable is supported.');
	    }
	    p.skip('uLong');
	    var coverage = p.parseUShort();
	    var subtableVersion = coverage & 0xFF;
	    p.skip('uShort');
	    if (subtableVersion === 0) {
	        var nPairs = p.parseUShort();
	        // Skip searchRange, entrySelector, rangeShift.
	        p.skip('uShort', 3);
	        for (var i = 0; i < nPairs; i += 1) {
	            var leftIndex = p.parseUShort();
	            var rightIndex = p.parseUShort();
	            var value = p.parseShort();
	            pairs[leftIndex + ',' + rightIndex] = value;
	        }
	    }
	    return pairs;
	}

	// Parse the `kern` table which contains kerning pairs.
	function parseKernTable(data, start) {
	    var p = new parse.Parser(data, start);
	    var tableVersion = p.parseUShort();
	    if (tableVersion === 0) {
	        return parseWindowsKernTable(p);
	    } else if (tableVersion === 1) {
	        return parseMacKernTable(p);
	    } else {
	        throw new Error('Unsupported kern table version (' + tableVersion + ').');
	    }
	}

	var kern = { parse: parseKernTable };

	// The `loca` table stores the offsets to the locations of the glyphs in the font.

	// Parse the `loca` table. This table stores the offsets to the locations of the glyphs in the font,
	// relative to the beginning of the glyphData table.
	// The number of glyphs stored in the `loca` table is specified in the `maxp` table (under numGlyphs)
	// The loca table has two versions: a short version where offsets are stored as uShorts, and a long
	// version where offsets are stored as uLongs. The `head` table specifies which version to use
	// (under indexToLocFormat).
	function parseLocaTable(data, start, numGlyphs, shortVersion) {
	    var p = new parse.Parser(data, start);
	    var parseFn = shortVersion ? p.parseUShort : p.parseULong;
	    // There is an extra entry after the last index element to compute the length of the last glyph.
	    // That's why we use numGlyphs + 1.
	    var glyphOffsets = [];
	    for (var i = 0; i < numGlyphs + 1; i += 1) {
	        var glyphOffset = parseFn.call(p);
	        if (shortVersion) {
	            // The short table version stores the actual offset divided by 2.
	            glyphOffset *= 2;
	        }

	        glyphOffsets.push(glyphOffset);
	    }

	    return glyphOffsets;
	}

	var loca = { parse: parseLocaTable };

	// opentype.js

	/**
	 * The opentype library.
	 * @namespace opentype
	 */

	// File loaders /////////////////////////////////////////////////////////
	/**
	 * Loads a font from a file. The callback throws an error message as the first parameter if it fails
	 * and the font as an ArrayBuffer in the second parameter if it succeeds.
	 * @param  {string} path - The path of the file
	 * @param  {Function} callback - The function to call when the font load completes
	 */
	function loadFromFile(path, callback) {
	    var fs = require('fs');
	    fs.readFile(path, function(err, buffer) {
	        if (err) {
	            return callback(err.message);
	        }

	        callback(null, nodeBufferToArrayBuffer(buffer));
	    });
	}
	/**
	 * Loads a font from a URL. The callback throws an error message as the first parameter if it fails
	 * and the font as an ArrayBuffer in the second parameter if it succeeds.
	 * @param  {string} url - The URL of the font file.
	 * @param  {Function} callback - The function to call when the font load completes
	 */
	function loadFromUrl(url, callback) {
	    var request = new XMLHttpRequest();
	    request.open('get', url, true);
	    request.responseType = 'arraybuffer';
	    request.onload = function() {
	        if (request.response) {
	            return callback(null, request.response);
	        } else {
	            return callback('Font could not be loaded: ' + request.statusText);
	        }
	    };

	    request.onerror = function () {
	        callback('Font could not be loaded');
	    };

	    request.send();
	}

	// Table Directory Entries //////////////////////////////////////////////
	/**
	 * Parses OpenType table entries.
	 * @param  {DataView}
	 * @param  {Number}
	 * @return {Object[]}
	 */
	function parseOpenTypeTableEntries(data, numTables) {
	    var tableEntries = [];
	    var p = 12;
	    for (var i = 0; i < numTables; i += 1) {
	        var tag = parse.getTag(data, p);
	        var checksum = parse.getULong(data, p + 4);
	        var offset = parse.getULong(data, p + 8);
	        var length = parse.getULong(data, p + 12);
	        tableEntries.push({tag: tag, checksum: checksum, offset: offset, length: length, compression: false});
	        p += 16;
	    }

	    return tableEntries;
	}

	/**
	 * Parses WOFF table entries.
	 * @param  {DataView}
	 * @param  {Number}
	 * @return {Object[]}
	 */
	function parseWOFFTableEntries(data, numTables) {
	    var tableEntries = [];
	    var p = 44; // offset to the first table directory entry.
	    for (var i = 0; i < numTables; i += 1) {
	        var tag = parse.getTag(data, p);
	        var offset = parse.getULong(data, p + 4);
	        var compLength = parse.getULong(data, p + 8);
	        var origLength = parse.getULong(data, p + 12);
	        var compression = (void 0);
	        if (compLength < origLength) {
	            compression = 'WOFF';
	        } else {
	            compression = false;
	        }

	        tableEntries.push({tag: tag, offset: offset, compression: compression,
	            compressedLength: compLength, length: origLength});
	        p += 20;
	    }

	    return tableEntries;
	}

	/**
	 * @typedef TableData
	 * @type Object
	 * @property {DataView} data - The DataView
	 * @property {number} offset - The data offset.
	 */

	/**
	 * @param  {DataView}
	 * @param  {Object}
	 * @return {TableData}
	 */
	function uncompressTable(data, tableEntry) {
	    if (tableEntry.compression === 'WOFF') {
	        var inBuffer = new Uint8Array(data.buffer, tableEntry.offset + 2, tableEntry.compressedLength - 2);
	        var outBuffer = new Uint8Array(tableEntry.length);
	        tinyInflate(inBuffer, outBuffer);
	        if (outBuffer.byteLength !== tableEntry.length) {
	            throw new Error('Decompression error: ' + tableEntry.tag + ' decompressed length doesn\'t match recorded length');
	        }

	        var view = new DataView(outBuffer.buffer, 0);
	        return {data: view, offset: 0};
	    } else {
	        return {data: data, offset: tableEntry.offset};
	    }
	}

	// Public API ///////////////////////////////////////////////////////////

	/**
	 * Parse the OpenType file data (as an ArrayBuffer) and return a Font object.
	 * Throws an error if the font could not be parsed.
	 * @param  {ArrayBuffer}
	 * @param  {Object} opt - options for parsing
	 * @return {opentype.Font}
	 */
	function parseBuffer(buffer, opt) {
	    opt = (opt === undefined || opt === null) ?  {} : opt;

	    var indexToLocFormat;
	    var ltagTable;

	    // Since the constructor can also be called to create new fonts from scratch, we indicate this
	    // should be an empty font that we'll fill with our own data.
	    var font = new Font({empty: true});

	    // OpenType fonts use big endian byte ordering.
	    // We can't rely on typed array view types, because they operate with the endianness of the host computer.
	    // Instead we use DataViews where we can specify endianness.
	    var data = new DataView(buffer, 0);
	    var numTables;
	    var tableEntries = [];
	    var signature = parse.getTag(data, 0);
	    if (signature === String.fromCharCode(0, 1, 0, 0) || signature === 'true' || signature === 'typ1') {
	        font.outlinesFormat = 'truetype';
	        numTables = parse.getUShort(data, 4);
	        tableEntries = parseOpenTypeTableEntries(data, numTables);
	    } else if (signature === 'OTTO') {
	        font.outlinesFormat = 'cff';
	        numTables = parse.getUShort(data, 4);
	        tableEntries = parseOpenTypeTableEntries(data, numTables);
	    } else if (signature === 'wOFF') {
	        var flavor = parse.getTag(data, 4);
	        if (flavor === String.fromCharCode(0, 1, 0, 0)) {
	            font.outlinesFormat = 'truetype';
	        } else if (flavor === 'OTTO') {
	            font.outlinesFormat = 'cff';
	        } else {
	            throw new Error('Unsupported OpenType flavor ' + signature);
	        }

	        numTables = parse.getUShort(data, 12);
	        tableEntries = parseWOFFTableEntries(data, numTables);
	    } else {
	        throw new Error('Unsupported OpenType signature ' + signature);
	    }

	    var cffTableEntry;
	    var fvarTableEntry;
	    var glyfTableEntry;
	    var gposTableEntry;
	    var gsubTableEntry;
	    var hmtxTableEntry;
	    var kernTableEntry;
	    var locaTableEntry;
	    var nameTableEntry;
	    var metaTableEntry;
	    var p;

	    for (var i = 0; i < numTables; i += 1) {
	        var tableEntry = tableEntries[i];
	        var table = (void 0);
	        switch (tableEntry.tag) {
	            case 'cmap':
	                table = uncompressTable(data, tableEntry);
	                font.tables.cmap = cmap.parse(table.data, table.offset);
	                font.encoding = new CmapEncoding(font.tables.cmap);
	                break;
	            case 'cvt ' :
	                table = uncompressTable(data, tableEntry);
	                p = new parse.Parser(table.data, table.offset);
	                font.tables.cvt = p.parseShortList(tableEntry.length / 2);
	                break;
	            case 'fvar':
	                fvarTableEntry = tableEntry;
	                break;
	            case 'fpgm' :
	                table = uncompressTable(data, tableEntry);
	                p = new parse.Parser(table.data, table.offset);
	                font.tables.fpgm = p.parseByteList(tableEntry.length);
	                break;
	            case 'head':
	                table = uncompressTable(data, tableEntry);
	                font.tables.head = head.parse(table.data, table.offset);
	                font.unitsPerEm = font.tables.head.unitsPerEm;
	                indexToLocFormat = font.tables.head.indexToLocFormat;
	                break;
	            case 'hhea':
	                table = uncompressTable(data, tableEntry);
	                font.tables.hhea = hhea.parse(table.data, table.offset);
	                font.ascender = font.tables.hhea.ascender;
	                font.descender = font.tables.hhea.descender;
	                font.numberOfHMetrics = font.tables.hhea.numberOfHMetrics;
	                break;
	            case 'hmtx':
	                hmtxTableEntry = tableEntry;
	                break;
	            case 'ltag':
	                table = uncompressTable(data, tableEntry);
	                ltagTable = ltag.parse(table.data, table.offset);
	                break;
	            case 'maxp':
	                table = uncompressTable(data, tableEntry);
	                font.tables.maxp = maxp.parse(table.data, table.offset);
	                font.numGlyphs = font.tables.maxp.numGlyphs;
	                break;
	            case 'name':
	                nameTableEntry = tableEntry;
	                break;
	            case 'OS/2':
	                table = uncompressTable(data, tableEntry);
	                font.tables.os2 = os2.parse(table.data, table.offset);
	                break;
	            case 'post':
	                table = uncompressTable(data, tableEntry);
	                font.tables.post = post.parse(table.data, table.offset);
	                font.glyphNames = new GlyphNames(font.tables.post);
	                break;
	            case 'prep' :
	                table = uncompressTable(data, tableEntry);
	                p = new parse.Parser(table.data, table.offset);
	                font.tables.prep = p.parseByteList(tableEntry.length);
	                break;
	            case 'glyf':
	                glyfTableEntry = tableEntry;
	                break;
	            case 'loca':
	                locaTableEntry = tableEntry;
	                break;
	            case 'CFF ':
	                cffTableEntry = tableEntry;
	                break;
	            case 'kern':
	                kernTableEntry = tableEntry;
	                break;
	            case 'GPOS':
	                gposTableEntry = tableEntry;
	                break;
	            case 'GSUB':
	                gsubTableEntry = tableEntry;
	                break;
	            case 'meta':
	                metaTableEntry = tableEntry;
	                break;
	        }
	    }

	    var nameTable = uncompressTable(data, nameTableEntry);
	    font.tables.name = _name.parse(nameTable.data, nameTable.offset, ltagTable);
	    font.names = font.tables.name;

	    if (glyfTableEntry && locaTableEntry) {
	        var shortVersion = indexToLocFormat === 0;
	        var locaTable = uncompressTable(data, locaTableEntry);
	        var locaOffsets = loca.parse(locaTable.data, locaTable.offset, font.numGlyphs, shortVersion);
	        var glyfTable = uncompressTable(data, glyfTableEntry);
	        font.glyphs = glyf.parse(glyfTable.data, glyfTable.offset, locaOffsets, font, opt);
	    } else if (cffTableEntry) {
	        var cffTable = uncompressTable(data, cffTableEntry);
	        cff.parse(cffTable.data, cffTable.offset, font, opt);
	    } else {
	        throw new Error('Font doesn\'t contain TrueType or CFF outlines.');
	    }

	    var hmtxTable = uncompressTable(data, hmtxTableEntry);
	    hmtx.parse(font, hmtxTable.data, hmtxTable.offset, font.numberOfHMetrics, font.numGlyphs, font.glyphs, opt);
	    addGlyphNames(font, opt);

	    if (kernTableEntry) {
	        var kernTable = uncompressTable(data, kernTableEntry);
	        font.kerningPairs = kern.parse(kernTable.data, kernTable.offset);
	    } else {
	        font.kerningPairs = {};
	    }

	    if (gposTableEntry) {
	        var gposTable = uncompressTable(data, gposTableEntry);
	        font.tables.gpos = gpos.parse(gposTable.data, gposTable.offset);
	        font.position.init();
	    }

	    if (gsubTableEntry) {
	        var gsubTable = uncompressTable(data, gsubTableEntry);
	        font.tables.gsub = gsub.parse(gsubTable.data, gsubTable.offset);
	    }

	    if (fvarTableEntry) {
	        var fvarTable = uncompressTable(data, fvarTableEntry);
	        font.tables.fvar = fvar.parse(fvarTable.data, fvarTable.offset, font.names);
	    }

	    if (metaTableEntry) {
	        var metaTable = uncompressTable(data, metaTableEntry);
	        font.tables.meta = meta.parse(metaTable.data, metaTable.offset);
	        font.metas = font.tables.meta;
	    }

	    return font;
	}

	/**
	 * Asynchronously load the font from a URL or a filesystem. When done, call the callback
	 * with two arguments `(err, font)`. The `err` will be null on success,
	 * the `font` is a Font object.
	 * We use the node.js callback convention so that
	 * opentype.js can integrate with frameworks like async.js.
	 * @alias opentype.load
	 * @param  {string} url - The URL of the font to load.
	 * @param  {Function} callback - The callback.
	 */
	function load(url, callback, opt) {
	    var isNode$$1 = typeof window === 'undefined';
	    var loadFn = isNode$$1 ? loadFromFile : loadFromUrl;
	    loadFn(url, function(err, arrayBuffer) {
	        if (err) {
	            return callback(err);
	        }
	        var font;
	        try {
	            font = parseBuffer(arrayBuffer, opt);
	        } catch (e) {
	            return callback(e, null);
	        }
	        return callback(null, font);
	    });
	}

	/**
	 * Synchronously load the font from a URL or file.
	 * When done, returns the font object or throws an error.
	 * @alias opentype.loadSync
	 * @param  {string} url - The URL of the font to load.
	 * @param  {Object} opt - opt.lowMemory
	 * @return {opentype.Font}
	 */
	function loadSync(url, opt) {
	    var fs = require('fs');
	    var buffer = fs.readFileSync(url);
	    return parseBuffer(nodeBufferToArrayBuffer(buffer), opt);
	}

	exports.Font = Font;
	exports.Glyph = Glyph;
	exports.Path = Path;
	exports.BoundingBox = BoundingBox;
	exports._parse = parse;
	exports.parse = parseBuffer;
	exports.load = load;
	exports.loadSync = loadSync;

	Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=opentype.js.map
//# sourceMappingURL=libs.js.map
